import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * Custom scalar for exact decimal values
   * Maps to DECIMAL(14,10) in the database
   */
  Decimal: { input: string; output: string };
  /** Int64 represents a 64-bit integer */
  Int64: { input: number; output: number };
  /** Custom scalar for raw JSON values */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
  /** Time represents a timestamp */
  Time: { input: Date; output: Date };
  /** Upload represents a file upload request */
  Upload: { input: globalThis.File; output: globalThis.File };
};

export enum AchPaymentStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

/**
 * An account represents a customer of an agency. They represent either an individual or a business.
 * An agency can have a contact with multiple accounts.
 */
export type Account = {
  __typename?: 'Account';
  /** Businesses owned or operated by this account. */
  account: AccountDetails;
  /** The agency that manages this account. */
  agency: Agency;
  /** Insurance applications submitted by this account. */
  businessApplications: Array<BusinessApplication>;
  /** Active insurance policies held by this account. */
  businessPolicies: Array<BusinessPolicy>;
  /** Certificates of liability insurance held by this account. */
  certificatesOfLiabilityInsurance: Array<CertificateOfLiabilityInsurance>;
  /** Contacts associated with this account. */
  contacts: Array<AccountContact>;
  /** When the account record was created. */
  createdAt: Scalars['Time']['output'];
  /** Files associated with this account. */
  files: Array<File>;
  /** Unique identifier for the account. */
  id: Scalars['ID']['output'];
  /** Service requests submitted by this account. */
  serviceRequests: Array<ServiceRequest>;
  /** The type of account - either a business or individual account. */
  type: AccountType;
  /** When the account record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type AccountContact = {
  __typename?: 'AccountContact';
  /** Accounts associated with this contact */
  accounts: Array<Account>;
  /** When the contact record was created. */
  createdAt: Scalars['Time']['output'];
  /** The contact's email address */
  email: Scalars['String']['output'];
  /** Unique identifier for the contact */
  id: Scalars['ID']['output'];
  /** The contact's name */
  name: Scalars['String']['output'];
  /** The contact's phone number */
  phone: Scalars['String']['output'];
  /** When the contact record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

/** Interface defining the common fields required for both business and individual accounts */
export type AccountDetails = {
  /** Primary email address for contacting the account holder */
  email: Scalars['String']['output'];
  /** Mailing address for the account holder */
  mailingAddress: Address;
  /** The full name of the account holder - either legal business name or individual's name */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the account holder */
  phone: Scalars['String']['output'];
};

/** The type of account - either a business or individual account. */
export enum AccountType {
  /** Account represents a business entity */
  Business = 'BUSINESS',
  /** Account represents an individual person */
  Individual = 'INDIVIDUAL'
}

/** Account user represents an authenticated user of an account */
export type AccountUser = {
  __typename?: 'AccountUser';
  /** The account this user is associated with */
  accounts: Array<Account>;
  /** When the account user was created */
  createdAt: Scalars['Time']['output'];
  /** Email of the account user */
  email: Scalars['String']['output'];
  /** Unique identifier for the account user */
  id: Scalars['ID']['output'];
  /** Name of the account user */
  name: Scalars['String']['output'];
  /** When the account user was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Response from the account user sign in mutation */
export type AccountUserSignInResponse = {
  __typename?: 'AccountUserSignInResponse';
  /** The account user that was signed in */
  accountUser: AccountUser;
};

export type Acord24BoilerMachineryCoverage = {
  __typename?: 'Acord24BoilerMachineryCoverage';
  coverages?: Maybe<Array<Acord24CoverageWithLimitAndDesc>>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['Boolean']['output']>;
  insurerLetterCode?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
};

export type Acord24CertificateHolder = {
  __typename?: 'Acord24CertificateHolder';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
};

export type Acord24CertificateInfo = {
  __typename?: 'Acord24CertificateInfo';
  additionalRemarks?: Maybe<Scalars['String']['output']>;
  certificateNumber?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  revisionNumber?: Maybe<Scalars['Int']['output']>;
};

export type Acord24Contact = {
  __typename?: 'Acord24Contact';
  emailAddress?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type Acord24CoverageWithLimit = {
  __typename?: 'Acord24CoverageWithLimit';
  included: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['String']['output']>;
};

export type Acord24CoverageWithLimitAndDesc = {
  __typename?: 'Acord24CoverageWithLimitAndDesc';
  description?: Maybe<Scalars['String']['output']>;
  included: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
};

export type Acord24CrimeCoverage = {
  __typename?: 'Acord24CrimeCoverage';
  coverages?: Maybe<Array<Acord24CoverageWithLimitAndDesc>>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['Boolean']['output']>;
  insurerLetterCode?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['String']['output']>;
};

export type Acord24Data = {
  __typename?: 'Acord24Data';
  agency: AcordAgencyInfo;
  boilerMachineryCoverage?: Maybe<Acord24BoilerMachineryCoverage>;
  certificateHolder: Acord24CertificateHolder;
  certificateInfo: Acord24CertificateInfo;
  crimeCoverage?: Maybe<Acord24CrimeCoverage>;
  date: Scalars['String']['output'];
  inlandMarineCoverage?: Maybe<Acord24InlandMarineCoverage>;
  insurers: Array<Acord24Insurer>;
  namedInsured: Acord24NamedInsured;
  otherPolicies?: Maybe<Array<Acord24OtherPolicy>>;
  propertyCoverage?: Maybe<Acord24PropertyCoverage>;
};

export type Acord24InlandMarineCoverage = {
  __typename?: 'Acord24InlandMarineCoverage';
  coverages?: Maybe<Array<Acord24CoverageWithLimitAndDesc>>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  insurerLetterCode?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Acord24InlandMarinePolicyType>;
};

export type Acord24InlandMarinePolicyType = {
  __typename?: 'Acord24InlandMarinePolicyType';
  inlandMarine?: Maybe<Scalars['Boolean']['output']>;
  namedPerils?: Maybe<Scalars['Boolean']['output']>;
  other1?: Maybe<Scalars['String']['output']>;
  other2?: Maybe<Scalars['String']['output']>;
};

export type Acord24Insurer = {
  __typename?: 'Acord24Insurer';
  fullName: Scalars['String']['output'];
  letterCode?: Maybe<Scalars['String']['output']>;
  naicCode?: Maybe<Scalars['String']['output']>;
};

export type Acord24NamedInsured = {
  __typename?: 'Acord24NamedInsured';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
};

export type Acord24OtherPolicy = {
  __typename?: 'Acord24OtherPolicy';
  coverages?: Maybe<Array<Acord24CoverageWithLimitAndDesc>>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  insurerLetterCode?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
};

export type Acord24PropertyCoverage = {
  __typename?: 'Acord24PropertyCoverage';
  coverages?: Maybe<Acord24PropertyCoverages>;
  deductibles?: Maybe<Acord24PropertyDeductibles>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  insurerLetterCode?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Acord24PropertyPolicyType>;
};

export type Acord24PropertyCoverages = {
  __typename?: 'Acord24PropertyCoverages';
  blanketBuilding?: Maybe<Acord24CoverageWithLimit>;
  blanketBuildingAndPersonalProperty?: Maybe<Acord24CoverageWithLimit>;
  blanketPersonalProperty?: Maybe<Acord24CoverageWithLimit>;
  building?: Maybe<Acord24CoverageWithLimit>;
  businessIncome?: Maybe<Acord24CoverageWithLimit>;
  extraExpense?: Maybe<Acord24CoverageWithLimit>;
  other1?: Maybe<Acord24CoverageWithLimitAndDesc>;
  other2?: Maybe<Acord24CoverageWithLimitAndDesc>;
  personalProperty?: Maybe<Acord24CoverageWithLimit>;
  rentalValue?: Maybe<Acord24CoverageWithLimit>;
};

export type Acord24PropertyDeductibles = {
  __typename?: 'Acord24PropertyDeductibles';
  building?: Maybe<Scalars['String']['output']>;
  contents?: Maybe<Scalars['String']['output']>;
  earthquake?: Maybe<Scalars['String']['output']>;
  flood?: Maybe<Scalars['String']['output']>;
  other1?: Maybe<Scalars['String']['output']>;
  other2?: Maybe<Scalars['String']['output']>;
  wind?: Maybe<Scalars['String']['output']>;
};

export type Acord24PropertyPolicyType = {
  __typename?: 'Acord24PropertyPolicyType';
  basic?: Maybe<Scalars['Boolean']['output']>;
  broad?: Maybe<Scalars['Boolean']['output']>;
  earthquake?: Maybe<Scalars['Boolean']['output']>;
  flood?: Maybe<Scalars['Boolean']['output']>;
  other1?: Maybe<Scalars['String']['output']>;
  other2?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['Boolean']['output']>;
  special?: Maybe<Scalars['Boolean']['output']>;
  wind?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Configuration for a business's auto liability policy's Certificate of Insurance (COI).
 * Contains details about auto coverage types, limits, and policy information.
 */
export type Acord25AutoLiabilitySection = {
  __typename?: 'Acord25AutoLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** Whether coverage applies to any auto */
  anyAutoLiability: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Whether coverage applies only to hired autos */
  hiredAutosLiability: Scalars['Boolean']['output'];
  /** Coverage limit for bodily injury per accident */
  limitBodilyInjuryPerAccident: Scalars['Float']['output'];
  /** Coverage limit for bodily injury per person */
  limitBodilyInjuryPerPerson: Scalars['Float']['output'];
  /** Coverage limit for each accident */
  limitCombinedSingleLimitPerAccident: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for property damage per accident */
  limitPropertyDamagePerAccident: Scalars['Float']['output'];
  /** Whether coverage applies only to non-owned autos */
  nonOwnedAutosLiability: Scalars['Boolean']['output'];
  /** Whether coverage applies only to owned autos */
  ownedAutosLiability: Scalars['Boolean']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the auto liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether coverage applies only to scheduled autos */
  scheduledAutosLiability: Scalars['Boolean']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/** Configuration for a business's Certificate of Insurance (COI) */
export type Acord25Data = {
  __typename?: 'Acord25Data';
  /** Configuration for the agency that produced the COI */
  agency: AcordAgencyInfo;
  /** Configuration for the business's auto liability policy's Certificate of Insurance (COI) */
  autoLiability: Acord25AutoLiabilitySection;
  date: Scalars['String']['output'];
  /** Description of the business's operations, used for generating COIs */
  descriptionOfOperations: Scalars['String']['output'];
  /** The holder entity information that appears on COIs issued by this business */
  holder: CertificateEntity;
  /** The insured entity information that appears on COIs issued by this business */
  insured: CertificateEntity;
  /** Configuration for the business's liability policy's Certificate of Insurance (COI) */
  liability: Acord25LiabilitySection;
  /** Configuration for the business's other policy's Certificate of Insurance (COI) */
  other: Acord25OtherSection;
  /** Configuration for the business's umbrella or excess liability policy's Certificate of Insurance (COI) */
  umbrellaOrExcessLiability: Acord25UmbrellaOrExcessLiabilitySection;
  /** Configuration for the business's workers' compensation policy's Certificate of Insurance (COI) */
  workersCompensation: Acord25WorkersCompensationSection;
};

/**
 * Configuration for a business's liability policy's Certificate of Insurance (COI).
 * Contains details about coverage types, limits, and policy information.
 */
export type Acord25LiabilitySection = {
  __typename?: 'Acord25LiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** A reference to a file and pages that provide some relevant information */
  additionalInsuredReference: FileReference;
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Whether this coverage is claims made */
  isClaimsMade: Scalars['Boolean']['output'];
  /** Whether this coverage is occurrence based */
  isOccurrenceBased: Scalars['Boolean']['output'];
  /** Whether the general aggregate limit applies per location */
  limitAppliesPerLocation: Scalars['Boolean']['output'];
  /** Description of other general aggregate limit application if type is OTHER */
  limitAppliesPerOther: Scalars['String']['output'];
  /** How the general aggregate limit applies - per policy, project, location or other */
  limitAppliesPerPolicy: Scalars['Boolean']['output'];
  /** Whether the general aggregate limit applies per project */
  limitAppliesPerProject: Scalars['Boolean']['output'];
  /** Coverage limit for damage to rented premises per occurrence */
  limitDamageToPremisesEachOccurrence: Scalars['Float']['output'];
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerOccurrence: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerPerson: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for personal and advertising injury */
  limitPersonalAndAdvertisingInjury: Scalars['Float']['output'];
  /** Coverage limit for products and completed operations */
  limitProductsAndCompletedOperations: Scalars['Float']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/**
 * Configuration for any other type of policy's Certificate of Insurance (COI).
 * Contains details about the coverage type, limits, and policy information.
 */
export type Acord25OtherSection = {
  __typename?: 'Acord25OtherSection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Description of the type of coverage */
  coverageType: Scalars['String']['output'];
  /** Amount of the first coverage limit */
  limitAmount1: Scalars['Float']['output'];
  /** Amount of the second coverage limit */
  limitAmount2: Scalars['Float']['output'];
  /** Name of the first coverage limit */
  limitName1: Scalars['String']['output'];
  /** Name of the second coverage limit */
  limitName2: Scalars['String']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/**
 * Configuration for a business's umbrella or excess liability policy's Certificate of Insurance (COI).
 * Contains details about umbrella/excess coverage, limits, and policy information.
 */
export type Acord25UmbrellaOrExcessLiabilitySection = {
  __typename?: 'Acord25UmbrellaOrExcessLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Deductible amount for the coverage */
  deductible: Scalars['Float']['output'];
  /** Whether this is excess liability coverage */
  excessLiability: Scalars['Boolean']['output'];
  /** Whether this coverage is claims made */
  isClaimsMade: Scalars['Boolean']['output'];
  /** Whether this coverage is occurrence based */
  isOccurrenceBased: Scalars['Boolean']['output'];
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the umbrella/excess coverage */
  policyNumber: Scalars['String']['output'];
  /** Retention limit for the coverage */
  retentionLimit: Scalars['Float']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
  /** Whether this is umbrella liability coverage */
  umbrellaLiability: Scalars['Boolean']['output'];
};

/**
 * Configuration for a business's workers' compensation policy's Certificate of Insurance (COI).
 * Contains details about workers' comp coverage, limits, and policy information.
 */
export type Acord25WorkersCompensationSection = {
  __typename?: 'Acord25WorkersCompensationSection';
  /** Name of any party excluded from coverage */
  anyExcludedOwnerOfficer: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Coverage limit per accident */
  limitPerAccident: Scalars['Float']['output'];
  /** Coverage limit per employee */
  limitPerEmployee: Scalars['Float']['output'];
  /** Coverage limit per policy */
  limitPerPolicy: Scalars['Float']['output'];
  /** Whether the coverage limits are provided per statute */
  limitsStatutory: Scalars['Boolean']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the workers' compensation coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

export type Acord27AdditionalInterest = {
  __typename?: 'Acord27AdditionalInterest';
  accountNumber: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  interestType: Acord27InterestType;
  mailingAddress: Address;
};

export type Acord27Coverage = {
  __typename?: 'Acord27Coverage';
  deductibleAmount: Scalars['String']['output'];
  description: Scalars['String']['output'];
  limitAmount: Scalars['String']['output'];
};

export type Acord27Data = {
  __typename?: 'Acord27Data';
  additionalInterest: Acord27AdditionalInterest;
  /** Configuration for the agency that produced the COI */
  agency: AcordAgencyInfo;
  date: Scalars['String']['output'];
  insurer: Acord27Insurer;
  namedInsured: Acord27NamedInsured;
  policy: Acord27Policy;
  propertyEvidence: Acord27PropertyEvidence;
};

export type Acord27Insurer = {
  __typename?: 'Acord27Insurer';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
};

export type Acord27InterestType = {
  __typename?: 'Acord27InterestType';
  additionalInsured: Scalars['Boolean']['output'];
  lendersLossPayable: Scalars['Boolean']['output'];
  lossPayee: Scalars['Boolean']['output'];
  mortgagee: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
};

export type Acord27NamedInsured = {
  __typename?: 'Acord27NamedInsured';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
};

export type Acord27PhysicalAddress = {
  __typename?: 'Acord27PhysicalAddress';
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  stateCode: Scalars['String']['output'];
  streetLine1: Scalars['String']['output'];
  streetLine2: Scalars['String']['output'];
};

export type Acord27Policy = {
  __typename?: 'Acord27Policy';
  effectiveDate: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
  policyType: Acord27PolicyType;
};

export type Acord27PolicyType = {
  __typename?: 'Acord27PolicyType';
  basic: Scalars['Boolean']['output'];
  broad: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
  special: Scalars['Boolean']['output'];
};

export type Acord27PropertyEvidence = {
  __typename?: 'Acord27PropertyEvidence';
  continuousBasis: Scalars['Boolean']['output'];
  coverages: Array<Acord27Coverage>;
  physicalAddress: Acord27PhysicalAddress;
  priorEvidenceDate: Scalars['String']['output'];
  propertyDescription: Scalars['String']['output'];
  remarks: Scalars['String']['output'];
};

export type Acord28AdditionalInterest = {
  __typename?: 'Acord28AdditionalInterest';
  accountNumber: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  interestType: Acord28InterestType;
  lenderServicingAgent: Acord28LenderServicingAgent;
  mailingAddress: Address;
};

export type Acord28BlanketCoverage = {
  __typename?: 'Acord28BlanketCoverage';
  included: Scalars['Boolean']['output'];
  notApplicable: Scalars['Boolean']['output'];
  notIncluded: Scalars['Boolean']['output'];
  valueAmount: Scalars['Float']['output'];
};

export type Acord28BuildingOrdinanceLawCoverage = {
  __typename?: 'Acord28BuildingOrdinanceLawCoverage';
  demolitionCosts: Acord28CoverageWithLimit;
  increasedCostOfConstruction: Acord28CoverageWithLimit;
  undamagedPortion: Acord28CoverageWithLimit;
};

export type Acord28BusinessIncomeCoverage = {
  __typename?: 'Acord28BusinessIncomeCoverage';
  actualLossSustained: Scalars['Boolean']['output'];
  businessIncome: Scalars['Boolean']['output'];
  included: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  monthCount: Scalars['Int']['output'];
  notApplicable: Scalars['Boolean']['output'];
  notIncluded: Scalars['Boolean']['output'];
  rentalValue: Scalars['Boolean']['output'];
};

export type Acord28CoinsuranceCoverage = {
  __typename?: 'Acord28CoinsuranceCoverage';
  included: Scalars['Boolean']['output'];
  notApplicable: Scalars['Boolean']['output'];
  notIncluded: Scalars['Boolean']['output'];
  percent: Scalars['Float']['output'];
};

export type Acord28Coverage = {
  __typename?: 'Acord28Coverage';
  agreedValue: Acord28YesNoNa;
  blanket: Acord28BlanketCoverage;
  buildingOrdinanceLaw: Acord28BuildingOrdinanceLawCoverage;
  businessIncome: Acord28BusinessIncomeCoverage;
  coinsurance: Acord28CoinsuranceCoverage;
  domesticTerrorismExclusion: Acord28YesNoNa;
  earthMovement: Acord28CoverageWithLimit;
  equipmentBreakdown: Acord28CoverageWithLimit;
  flood: Acord28CoverageWithLimit;
  fungusExclusion: Acord28FungusExclusion;
  limitedFungus: Acord28CoverageWithLimit;
  namedWindstorm: Acord28WindHailCoverage;
  property: Acord28PropertyCoverage;
  replacementCost: Acord28YesNoNa;
  subrogationWaiver: Acord28YesNoNa;
  terrorism: Acord28YesNoNa;
  terrorismExclusion: Acord28YesNoNa;
  windHail: Acord28WindHailCoverage;
};

export type Acord28CoverageWithLimit = {
  __typename?: 'Acord28CoverageWithLimit';
  deductible: Scalars['String']['output'];
  included: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  notApplicable: Scalars['Boolean']['output'];
  notIncluded: Scalars['Boolean']['output'];
};

export type Acord28Data = {
  __typename?: 'Acord28Data';
  /** Additional interest information */
  additionalInterest: Acord28AdditionalInterest;
  /** Configuration for the agency that produced the COI */
  agency: AcordAgencyInfo;
  /** Coverage information */
  coverage: Acord28Coverage;
  date: Scalars['String']['output'];
  /** Insured information */
  insured: Acord28Insured;
  /** Insurer information */
  insurer: Acord28Insurer;
  /** Policy information */
  policy: Acord28Policy;
  /** Property information */
  property: Acord28Property;
};

export type Acord28Form = {
  __typename?: 'Acord28Form';
  completionDate: Scalars['String']['output'];
  editionIdentifier: Scalars['String']['output'];
  priorEvidenceDate: Scalars['String']['output'];
};

export type Acord28FungusExclusion = {
  __typename?: 'Acord28FungusExclusion';
  copyrightOwnerCode: Scalars['String']['output'];
  formDate: Scalars['String']['output'];
  formIdentifier: Scalars['String']['output'];
  included: Scalars['Boolean']['output'];
  notApplicable: Scalars['Boolean']['output'];
  notIncluded: Scalars['Boolean']['output'];
};

export type Acord28Insured = {
  __typename?: 'Acord28Insured';
  additionalNamedInsured: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
};

export type Acord28Insurer = {
  __typename?: 'Acord28Insurer';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
  naicCode: Scalars['String']['output'];
};

export type Acord28InterestType = {
  __typename?: 'Acord28InterestType';
  contractOfSale: Scalars['Boolean']['output'];
  lendersLossPayable: Scalars['Boolean']['output'];
  lossPayee: Scalars['Boolean']['output'];
  mortgagee: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
};

export type Acord28LenderServicingAgent = {
  __typename?: 'Acord28LenderServicingAgent';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
};

export type Acord28Location = {
  __typename?: 'Acord28Location';
  address: Address;
  description: Scalars['String']['output'];
};

export type Acord28Policy = {
  __typename?: 'Acord28Policy';
  continuedUntilTerminated: Scalars['Boolean']['output'];
  effectiveDate: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
  policyType: Acord28PolicyType;
  typeDescription: Scalars['String']['output'];
};

export type Acord28PolicyType = {
  __typename?: 'Acord28PolicyType';
  basic: Scalars['Boolean']['output'];
  broad: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
  special: Scalars['Boolean']['output'];
};

export type Acord28Producer = {
  __typename?: 'Acord28Producer';
  contactPerson: Scalars['String']['output'];
  customerIdentifier: Scalars['String']['output'];
  email: Scalars['String']['output'];
  faxNumber: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
  phoneNumber: Scalars['String']['output'];
  producerIdentifier: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  subProducerIdentifier: Scalars['String']['output'];
};

export type Acord28Property = {
  __typename?: 'Acord28Property';
  buildingCoverage: Scalars['Boolean']['output'];
  businessPersonalPropertyCoverage: Scalars['Boolean']['output'];
  location: Acord28Location;
};

export type Acord28PropertyCoverage = {
  __typename?: 'Acord28PropertyCoverage';
  deductible: Scalars['String']['output'];
  limit: Scalars['Float']['output'];
};

export type Acord28WindHailCoverage = {
  __typename?: 'Acord28WindHailCoverage';
  deductible: Scalars['String']['output'];
  included: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  notApplicable: Scalars['Boolean']['output'];
  notIncluded: Scalars['Boolean']['output'];
  notSubjectToProvisions: Scalars['Boolean']['output'];
  subjectToProvisions: Scalars['Boolean']['output'];
};

export type Acord28YesNoNa = {
  __typename?: 'Acord28YesNoNA';
  no: Scalars['Boolean']['output'];
  notApplicable: Scalars['Boolean']['output'];
  yes: Scalars['Boolean']['output'];
};

export type Acord35AdditionalInterest = {
  __typename?: 'Acord35AdditionalInterest';
  authorizedRepresentativeTitle: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  interestType: Acord35InterestType;
  mailingAddress: Address;
  signature: Scalars['String']['output'];
  signatureDate: Scalars['String']['output'];
};

export type Acord35CancelNonRenew = {
  __typename?: 'Acord35CancelNonRenew';
  cancelDate: Scalars['String']['output'];
  cancelTime: Scalars['String']['output'];
  distributions: Array<Acord35Distribution>;
  newInsurer: Scalars['String']['output'];
  premiumCalculation: Acord35PremiumCalculation;
  reason: Acord35CancelReason;
  remarks: Scalars['String']['output'];
  requestType: Acord35RequestType;
  timeOfDay: Acord35TimeOfDay;
};

export type Acord35CancelReason = {
  __typename?: 'Acord35CancelReason';
  insuredRequest: Scalars['Boolean']['output'];
  notTaken: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
  rewritten: Scalars['Boolean']['output'];
};

export type Acord35Data = {
  __typename?: 'Acord35Data';
  /** Additional interests */
  additionalInterests: Array<Acord35AdditionalInterest>;
  /** Configuration for the agency that produced the COI */
  agency: AcordAgencyInfo;
  /** Cancellation/Non-renewal information */
  cancelNonRenew: Acord35CancelNonRenew;
  date: Scalars['String']['output'];
  /** Form information */
  form: Acord35Form;
  /** Insurer information */
  insurer: Acord35Insurer;
  /** Named insured information */
  namedInsured: Acord35NamedInsured;
  /** Policy information */
  policy: Acord35Policy;
};

export type Acord35Distribution = {
  __typename?: 'Acord35Distribution';
  distributionType: Acord35DistributionType;
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
};

export type Acord35DistributionType = {
  __typename?: 'Acord35DistributionType';
  company: Scalars['Boolean']['output'];
  financeCompany: Scalars['Boolean']['output'];
  insured: Scalars['Boolean']['output'];
  lendersLossPayable: Scalars['Boolean']['output'];
  lienholder: Scalars['Boolean']['output'];
  lossPayee: Scalars['Boolean']['output'];
  mortgagee: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
};

export type Acord35Form = {
  __typename?: 'Acord35Form';
  completionDate: Scalars['String']['output'];
  editionIdentifier: Scalars['String']['output'];
  witnessSignatures: Array<Acord35WitnessSignature>;
};

export type Acord35Insurer = {
  __typename?: 'Acord35Insurer';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
  naicCode: Scalars['String']['output'];
};

export type Acord35InterestType = {
  __typename?: 'Acord35InterestType';
  lendersLossPayable: Scalars['Boolean']['output'];
  lienholder: Scalars['Boolean']['output'];
  lossPayee: Scalars['Boolean']['output'];
  mortgagee: Scalars['Boolean']['output'];
};

export type Acord35NamedInsured = {
  __typename?: 'Acord35NamedInsured';
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
  signatures: Array<Acord35NamedInsuredSignature>;
};

export type Acord35NamedInsuredSignature = {
  __typename?: 'Acord35NamedInsuredSignature';
  signature: Scalars['String']['output'];
  signatureDate: Scalars['String']['output'];
};

export type Acord35Policy = {
  __typename?: 'Acord35Policy';
  effectiveDate: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  fullTermPremium: Scalars['Float']['output'];
  newEffectiveDate: Scalars['String']['output'];
  newPolicyNumber: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
  policyType: Scalars['String']['output'];
};

export type Acord35PremiumCalculation = {
  __typename?: 'Acord35PremiumCalculation';
  flat: Scalars['Boolean']['output'];
  proRata: Scalars['Boolean']['output'];
  returnPremium: Scalars['Float']['output'];
  shortRate: Scalars['Boolean']['output'];
  subjectToAudit: Scalars['Boolean']['output'];
  unearnedFactor: Scalars['Float']['output'];
};

export type Acord35Producer = {
  __typename?: 'Acord35Producer';
  customerIdentifier: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  mailingAddress: Address;
  phoneNumber: Scalars['String']['output'];
  producerCode: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  signatureDate: Scalars['String']['output'];
  subProducerCode: Scalars['String']['output'];
};

export type Acord35RequestType = {
  __typename?: 'Acord35RequestType';
  cancellation: Scalars['Boolean']['output'];
  policyRelease: Scalars['Boolean']['output'];
};

export type Acord35TimeOfDay = {
  __typename?: 'Acord35TimeOfDay';
  am: Scalars['Boolean']['output'];
  pm: Scalars['Boolean']['output'];
};

export type Acord35WitnessSignature = {
  __typename?: 'Acord35WitnessSignature';
  signature: Scalars['String']['output'];
  signatureDate: Scalars['String']['output'];
};

export type Acord36Agencies = {
  __typename?: 'Acord36Agencies';
  currentAgency: Acord36CurrentAgency;
  newAgency: Acord36Agency;
};

export type Acord36Agency = {
  __typename?: 'Acord36Agency';
  address: Address;
  contactPhone: Scalars['String']['output'];
  customerIdentifier: Scalars['String']['output'];
  email: Scalars['String']['output'];
  faxNumber: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  producerCode: Scalars['String']['output'];
  subProducerCode: Scalars['String']['output'];
};

export type Acord36Authorization = {
  __typename?: 'Acord36Authorization';
  address: Acord36AuthorizationAddress;
  companyName: Scalars['String']['output'];
  effectiveDate: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  signatureDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Acord36AuthorizationAddress = {
  __typename?: 'Acord36AuthorizationAddress';
  city: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type Acord36CurrentAgency = {
  __typename?: 'Acord36CurrentAgency';
  contactPersonName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  fullNameForAuthorization: Scalars['String']['output'];
  producerCode: Scalars['String']['output'];
};

export type Acord36Data = {
  __typename?: 'Acord36Data';
  /** Agency information */
  agencies: Acord36Agencies;
  /** Authorization information */
  authorization: Acord36Authorization;
  date: Scalars['String']['output'];
  /** Insurer information */
  insurer: Acord36Insurer;
  /** Policies information */
  policies: Array<Acord36Policy>;
};

export type Acord36Insurer = {
  __typename?: 'Acord36Insurer';
  fullName: Scalars['String']['output'];
};

export type Acord36Policy = {
  __typename?: 'Acord36Policy';
  effectiveDate: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  lineOfBusiness: Scalars['String']['output'];
  namedInsured: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
};

export type Acord75AdditionalInterest = {
  __typename?: 'Acord75AdditionalInterest';
  accountNumber: Scalars['String']['output'];
  address: Address;
  fullName: Scalars['String']['output'];
  interest: Acord75Interest;
};

export type Acord75Binder = {
  __typename?: 'Acord75Binder';
  effectiveDate: Scalars['String']['output'];
  effectiveTime: Acord75Time;
  expirationDate: Scalars['String']['output'];
  expirationTime: Acord75ExpirationTime;
  expiringPolicyNumber: Scalars['String']['output'];
  extension: Scalars['Boolean']['output'];
  identifier: Scalars['String']['output'];
  operationsDescription: Scalars['String']['output'];
  specialConditions: Scalars['String']['output'];
};

export type Acord75CollisionCoverage = {
  __typename?: 'Acord75CollisionCoverage';
  coverage: Scalars['Boolean']['output'];
  deductibleAmount: Scalars['String']['output'];
};

export type Acord75CollisionOption = {
  __typename?: 'Acord75CollisionOption';
  allVehicles: Scalars['Boolean']['output'];
  scheduledVehicles: Scalars['Boolean']['output'];
};

export type Acord75ComprehensiveCoverage = {
  __typename?: 'Acord75ComprehensiveCoverage';
  coverage: Scalars['Boolean']['output'];
  deductibleAmount: Scalars['String']['output'];
};

export type Acord75Coverage = {
  __typename?: 'Acord75Coverage';
  excessUmbrella: Acord75ExcessUmbrellaCoverage;
  garageLiability: Acord75GarageLiabilityCoverage;
  generalLiability: Acord75GeneralLiabilityCoverage;
  property: Acord75PropertyCoverage;
  vehicleLiability: Acord75VehicleLiabilityCoverage;
  vehiclePhysicalDamage: Acord75VehiclePhysicalDamageCoverage;
  workersCompensation: Acord75WorkersCompensationCoverage;
};

export type Acord75Data = {
  __typename?: 'Acord75Data';
  /** Additional interest information */
  additionalInterest: Acord75AdditionalInterest;
  agency: AcordAgencyInfo;
  /** Binder information */
  binder: Acord75Binder;
  /** Coverage information */
  coverage: Acord75Coverage;
  /** The date of the application in MM/DD/YYYY format. */
  date: Scalars['String']['output'];
  /** Insurer information */
  insurer: Acord75Insurer;
  /** Named insured information */
  namedInsured: Acord75NamedInsured;
  /** Policy information */
  policy: Acord75Policy;
};

export type Acord75EmployersLiabilityLimits = {
  __typename?: 'Acord75EmployersLiabilityLimits';
  diseaseEachEmployee: Scalars['Float']['output'];
  diseasePolicy: Scalars['Float']['output'];
  eachAccident: Scalars['Float']['output'];
};

export type Acord75ExcessUmbrellaCoverage = {
  __typename?: 'Acord75ExcessUmbrellaCoverage';
  aggregateAmount: Scalars['Float']['output'];
  coverageFormsDescription: Scalars['String']['output'];
  currentRetroactiveDate: Scalars['String']['output'];
  deductibleOrRetentionAmount: Scalars['String']['output'];
  eachOccurrenceAmount: Scalars['Float']['output'];
  otherPolicyType: Scalars['Boolean']['output'];
  umbrella: Scalars['Boolean']['output'];
};

export type Acord75ExpirationTime = {
  __typename?: 'Acord75ExpirationTime';
  midnight: Scalars['Boolean']['output'];
  noon: Scalars['Boolean']['output'];
};

export type Acord75GarageLiabilityCoverage = {
  __typename?: 'Acord75GarageLiabilityCoverage';
  anyAuto: Scalars['Boolean']['output'];
  coverageFormsDescription: Scalars['String']['output'];
  liabilityAutoOnlyPerAccident: Scalars['Float']['output'];
  liabilityOtherThanAutoOnlyAggregate: Scalars['Float']['output'];
  liabilityOtherThanAutoOnlyPerAccident: Scalars['Float']['output'];
  otherSymbols: Array<Acord75OtherSymbol>;
  otherThanAutoOnlyDescription: Scalars['String']['output'];
};

export type Acord75GeneralLiabilityCoverage = {
  __typename?: 'Acord75GeneralLiabilityCoverage';
  claimsMade: Scalars['Boolean']['output'];
  coverage: Scalars['Boolean']['output'];
  coverageFormsDescription: Scalars['String']['output'];
  limits: Acord75GeneralLiabilityLimits;
  occurrence: Scalars['Boolean']['output'];
  otherCoverages: Array<Acord75OtherCoverage>;
  proposedRetroactiveDate: Scalars['String']['output'];
};

export type Acord75GeneralLiabilityLimits = {
  __typename?: 'Acord75GeneralLiabilityLimits';
  eachOccurrence: Scalars['Float']['output'];
  fireDamageRentedPremises: Scalars['Float']['output'];
  generalAggregate: Scalars['Float']['output'];
  medicalExpense: Scalars['Float']['output'];
  personalAndAdvertisingInjury: Scalars['Float']['output'];
  productsAndCompletedOperations: Scalars['Float']['output'];
};

export type Acord75Insurer = {
  __typename?: 'Acord75Insurer';
  fullName: Scalars['String']['output'];
};

export type Acord75Interest = {
  __typename?: 'Acord75Interest';
  additionalInsured: Scalars['Boolean']['output'];
  lendersLossPayable: Scalars['Boolean']['output'];
  lossPayee: Scalars['Boolean']['output'];
  mortgagee: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
};

export type Acord75NamedInsured = {
  __typename?: 'Acord75NamedInsured';
  address: Address;
  fullName: Scalars['String']['output'];
};

export type Acord75OtherCoverage = {
  __typename?: 'Acord75OtherCoverage';
  description: Scalars['String']['output'];
  indicator: Scalars['Boolean']['output'];
};

export type Acord75OtherSymbol = {
  __typename?: 'Acord75OtherSymbol';
  code: Scalars['String']['output'];
  indicator: Scalars['Boolean']['output'];
};

export type Acord75OtherVehicleCoverage = {
  __typename?: 'Acord75OtherVehicleCoverage';
  description: Scalars['String']['output'];
  limitAmount: Scalars['Float']['output'];
};

export type Acord75Payment = {
  __typename?: 'Acord75Payment';
  estimatedTotalAmount: Scalars['Float']['output'];
  feeAmount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
};

export type Acord75Policy = {
  __typename?: 'Acord75Policy';
  payment: Acord75Payment;
  type: Acord75PolicyType;
};

export type Acord75PolicyType = {
  __typename?: 'Acord75PolicyType';
  basic: Scalars['Boolean']['output'];
  broad: Scalars['Boolean']['output'];
  other1: Scalars['String']['output'];
  other2: Scalars['String']['output'];
  special: Scalars['Boolean']['output'];
};

export type Acord75PropertyCoverage = {
  __typename?: 'Acord75PropertyCoverage';
  premises: Array<Acord75PropertyPremise>;
};

export type Acord75PropertyPremise = {
  __typename?: 'Acord75PropertyPremise';
  coinsurancePercent: Scalars['Float']['output'];
  coverageFormsDescription: Scalars['String']['output'];
  deductibleAmount: Scalars['String']['output'];
  limitAmount: Scalars['Float']['output'];
  subjectOfInsuranceCode: Scalars['String']['output'];
};

export type Acord75Time = {
  __typename?: 'Acord75Time';
  afternoon: Scalars['Boolean']['output'];
  morning: Scalars['Boolean']['output'];
  time: Scalars['String']['output'];
};

export type Acord75Valuation = {
  __typename?: 'Acord75Valuation';
  actualCashValue: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
  statedAmount: Scalars['Boolean']['output'];
};

export type Acord75VehicleLiabilityCoverage = {
  __typename?: 'Acord75VehicleLiabilityCoverage';
  coverageFormsDescription: Scalars['String']['output'];
  limits: Acord75VehicleLiabilityLimits;
  otherSymbols: Array<Acord75OtherSymbol>;
  vehicleType: Acord75VehicleType;
};

export type Acord75VehicleLiabilityLimits = {
  __typename?: 'Acord75VehicleLiabilityLimits';
  bodilyInjuryPerAccident: Scalars['Float']['output'];
  bodilyInjuryPerPerson: Scalars['Float']['output'];
  combinedSingleLimit: Scalars['Float']['output'];
  medicalPaymentsPerPerson: Scalars['Float']['output'];
  otherCoverage: Acord75OtherVehicleCoverage;
  pip: Scalars['Float']['output'];
  propertyDamagePerAccident: Scalars['Float']['output'];
  uninsuredMotoristsCombinedSingle: Scalars['Float']['output'];
};

export type Acord75VehiclePhysicalDamageCoverage = {
  __typename?: 'Acord75VehiclePhysicalDamageCoverage';
  collision: Acord75CollisionCoverage;
  collisionOption: Acord75CollisionOption;
  comprehensive: Acord75ComprehensiveCoverage;
  coverageFormsDescription: Scalars['String']['output'];
  statedLimitAmount: Scalars['Float']['output'];
  valuation: Acord75Valuation;
};

export type Acord75VehicleType = {
  __typename?: 'Acord75VehicleType';
  allOwnedAutos: Scalars['Boolean']['output'];
  anyAuto: Scalars['Boolean']['output'];
  hiredAutos: Scalars['Boolean']['output'];
  nonOwnedAutos: Scalars['Boolean']['output'];
  scheduledAutos: Scalars['Boolean']['output'];
};

export type Acord75WorkersCompensationCoverage = {
  __typename?: 'Acord75WorkersCompensationCoverage';
  coverageFormsDescription: Scalars['String']['output'];
  employersLiability: Acord75EmployersLiabilityLimits;
  otherCoverageDescription: Scalars['String']['output'];
  statutoryLimit: Scalars['Boolean']['output'];
};

export type Acord125Applicant = {
  __typename?: 'Acord125Applicant';
  address: Address;
  dba: Scalars['String']['output'];
  feinOrSsn: Scalars['String']['output'];
  glCode: Scalars['String']['output'];
  legalEntityType: Scalars['String']['output'];
  naicsCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  sicCode: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export type Acord125Contact = {
  __typename?: 'Acord125Contact';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

/** ACORD 125 is the general application form for commercial insurance. */
export type Acord125Data = {
  __typename?: 'Acord125Data';
  agency: AcordAgencyInfo;
  applicant1: Acord125Applicant;
  applicant2: Acord125Applicant;
  applicant3: Acord125Applicant;
  carrier: AcordCarrierInfo;
  contact1: Acord125Contact;
  contact2: Acord125Contact;
  /** The date of the application in MM/DD/YYYY format. */
  date: Scalars['String']['output'];
  generalApplication: Acord125GeneralApplication;
  linesOfBusiness: Acord125LinesOfBusiness;
  location1: Acord125Location;
  location2: Acord125Location;
  location3: Acord125Location;
  location4: Acord125Location;
  lossHistory: Acord125LossHistory;
  natureOfBusiness: Acord125NatureOfBusiness;
  policyInfo: Acord125PolicyInformation;
  priorCarrierInfo: Acord125PriorCarrierInformation;
  remarksOrProcessingInstructions: Scalars['String']['output'];
};

export type Acord125GeneralApplication = {
  __typename?: 'Acord125GeneralApplication';
  applicantHasSubsidiaries: Scalars['Boolean']['output'];
  codeViolations1: Acord125GeneralApplicationOccurrenceInfo;
  codeViolations2: Acord125GeneralApplicationOccurrenceInfo;
  coverageDeclinedNonPayment: Scalars['Boolean']['output'];
  coverageDeclinedNonRenewal: Scalars['Boolean']['output'];
  coverageDeclinedNotWritingCarrier: Scalars['Boolean']['output'];
  coverageDeclinedUnderwriting: Scalars['Boolean']['output'];
  dronesHiring: Scalars['String']['output'];
  dronesUse: Scalars['String']['output'];
  exposureToFlammablesExplosives: Scalars['String']['output'];
  foreclosureRepoBankruptcy1: Acord125GeneralApplicationOccurrenceInfo;
  foreclosureRepoBankruptcy2: Acord125GeneralApplicationOccurrenceInfo;
  foreignOperationsProducts: Scalars['Boolean']['output'];
  hasOtherSafetyProgram: Scalars['Boolean']['output'];
  hasSafetyManual: Scalars['Boolean']['output'];
  hasSafetyMonthlyMeetings: Scalars['Boolean']['output'];
  hasSafetyOSHA: Scalars['Boolean']['output'];
  hasSafetyPosition: Scalars['Boolean']['output'];
  indictmentsConvictions: Scalars['String']['output'];
  isApplicantSubsidiary: Scalars['Boolean']['output'];
  judgmentLien1: Acord125GeneralApplicationOccurrenceInfo;
  judgmentLien2: Acord125GeneralApplicationOccurrenceInfo;
  otherBusinessVentures: Scalars['String']['output'];
  otherEntityName: Scalars['String']['output'];
  otherEntityRelationship: Scalars['String']['output'];
  otherSafetyProgramDescription: Scalars['String']['output'];
  pastLossesHiringMisconduct: Scalars['String']['output'];
  percentOwnedByOtherEntity: Scalars['Float']['output'];
  percentOwnershipInSubsidiary: Scalars['Float']['output'];
  subsidiaryNames: Scalars['String']['output'];
  subsidiaryRelationship: Scalars['String']['output'];
  trustName: Scalars['String']['output'];
};

export type Acord125GeneralApplicationOccurrenceInfo = {
  __typename?: 'Acord125GeneralApplicationOccurrenceInfo';
  explanation: Scalars['String']['output'];
  occurrenceDate: Scalars['String']['output'];
  resolution: Scalars['String']['output'];
  resolutionDate: Scalars['String']['output'];
};

export type Acord125LinesOfBusiness = {
  __typename?: 'Acord125LinesOfBusiness';
  boilerAndMachinery: Scalars['Boolean']['output'];
  businessAuto: Scalars['Boolean']['output'];
  businessOwners: Scalars['Boolean']['output'];
  commercialGeneralLiability: Scalars['Boolean']['output'];
  commercialInlandMarine: Scalars['Boolean']['output'];
  commercialProperty: Scalars['Boolean']['output'];
  crime: Scalars['Boolean']['output'];
  cyberAndPrivacy: Scalars['Boolean']['output'];
  fiduciaryLiability: Scalars['Boolean']['output'];
  garageAndDealers: Scalars['Boolean']['output'];
  liquorLiability: Scalars['Boolean']['output'];
  motorCarrier: Scalars['Boolean']['output'];
  other1: Scalars['String']['output'];
  other2: Scalars['String']['output'];
  other3: Scalars['String']['output'];
  other4: Scalars['String']['output'];
  other5: Scalars['String']['output'];
  truckers: Scalars['Boolean']['output'];
  umbrella: Scalars['Boolean']['output'];
  yacht: Scalars['Boolean']['output'];
};

export type Acord125Location = {
  __typename?: 'Acord125Location';
  address: Address;
  annualRevenue: Scalars['Float']['output'];
  areaLeasedToOthers: Scalars['Float']['output'];
  descriptionOfOperations: Scalars['String']['output'];
  isOwner: Scalars['Boolean']['output'];
  numFullTime: Scalars['Int']['output'];
  numPartTime: Scalars['Int']['output'];
  occupiedArea: Scalars['Float']['output'];
  openToPublicArea: Scalars['Float']['output'];
  totalBuildingArea: Scalars['Float']['output'];
};

export type Acord125Loss = {
  __typename?: 'Acord125Loss';
  amountPaid: Scalars['Float']['output'];
  amountReserved: Scalars['Float']['output'];
  dateOfClaim: Scalars['String']['output'];
  dateOfOccurrence: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isClaimOpen: Scalars['Boolean']['output'];
  isSubrogation: Scalars['Boolean']['output'];
  lineOfBusiness: Scalars['String']['output'];
};

export type Acord125LossHistory = {
  __typename?: 'Acord125LossHistory';
  loss1: Acord125Loss;
  loss2: Acord125Loss;
  loss3: Acord125Loss;
  timeFrame: Scalars['Int']['output'];
};

export type Acord125NatureOfBusiness = {
  __typename?: 'Acord125NatureOfBusiness';
  dateBusinessStarted: Scalars['String']['output'];
  descriptionOfOperations: Scalars['String']['output'];
  isApartments: Scalars['Boolean']['output'];
  isCondominiums: Scalars['Boolean']['output'];
  isContractor: Scalars['Boolean']['output'];
  isInstitutional: Scalars['Boolean']['output'];
  isManufacturing: Scalars['Boolean']['output'];
  isOffice: Scalars['Boolean']['output'];
  isRestaurant: Scalars['Boolean']['output'];
  isRetail: Scalars['Boolean']['output'];
  isService: Scalars['Boolean']['output'];
  isWholesale: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
  retailOrServicePercentOfSales: Scalars['Float']['output'];
};

export type Acord125PolicyInformation = {
  __typename?: 'Acord125PolicyInformation';
  effectiveDate: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
};

export type Acord125PriorCarrier = {
  __typename?: 'Acord125PriorCarrier';
  autoCarrier: Scalars['String']['output'];
  autoEffectiveDate: Scalars['String']['output'];
  autoExpirationDate: Scalars['String']['output'];
  autoPolicyNumber: Scalars['String']['output'];
  autoPremium: Scalars['Float']['output'];
  cpCarrier: Scalars['String']['output'];
  cpEffectiveDate: Scalars['String']['output'];
  cpExpirationDate: Scalars['String']['output'];
  cpPolicyNumber: Scalars['String']['output'];
  cpPremium: Scalars['Float']['output'];
  glCarrier: Scalars['String']['output'];
  glEffectiveDate: Scalars['String']['output'];
  glExpirationDate: Scalars['String']['output'];
  glPolicyNumber: Scalars['String']['output'];
  glPremium: Scalars['Float']['output'];
  otherCarrier: Scalars['String']['output'];
  otherEffectiveDate: Scalars['String']['output'];
  otherExpirationDate: Scalars['String']['output'];
  otherPolicyNumber: Scalars['String']['output'];
  otherPremium: Scalars['Float']['output'];
  year: Scalars['String']['output'];
};

export type Acord125PriorCarrierInformation = {
  __typename?: 'Acord125PriorCarrierInformation';
  carrier1: Acord125PriorCarrier;
  carrier2: Acord125PriorCarrier;
  carrier3: Acord125PriorCarrier;
};

export type Acord126ClaimsMade = {
  __typename?: 'Acord126ClaimsMade';
  anyPriorExclusions: Scalars['String']['output'];
  priorPolicyRetroactiveDate: Scalars['String']['output'];
  proposedRetroactiveDate: Scalars['String']['output'];
  tailCoveragePurchased: Scalars['String']['output'];
};

export type Acord126ContractorsInfo = {
  __typename?: 'Acord126ContractorsInfo';
  drawsPlansForOthers: Scalars['String']['output'];
  leasesEquipment: Scalars['String']['output'];
  subcontractorsCarryLowerLimits: Scalars['String']['output'];
  subcontractorsWorkWithoutProofOfInsurance: Scalars['String']['output'];
  undergroundWork: Scalars['String']['output'];
  usesExplosiveMaterials: Scalars['String']['output'];
};

export type Acord126CoverageInfo = {
  __typename?: 'Acord126CoverageInfo';
  bodilyInjuryDeductible: Scalars['Boolean']['output'];
  bodilyInjuryDeductibleAmount: Scalars['Float']['output'];
  deductiblePerClaim: Scalars['Boolean']['output'];
  deductiblePerOccurrence: Scalars['Boolean']['output'];
  generalLiability: Scalars['Boolean']['output'];
  generalLiabilityClaimsMade: Scalars['Boolean']['output'];
  generalLiabilityOccurrence: Scalars['Boolean']['output'];
  limitAppliesPerLocation: Scalars['Boolean']['output'];
  limitAppliesPerOther: Scalars['String']['output'];
  limitAppliesPerPolicy: Scalars['Boolean']['output'];
  limitAppliesPerProject: Scalars['Boolean']['output'];
  limitDamageToPremisesEachOccurrence: Scalars['Float']['output'];
  limitEmployeeBenefits: Scalars['Float']['output'];
  limitGeneralAggregate: Scalars['Float']['output'];
  limitMedicalExpensePerPerson: Scalars['Float']['output'];
  limitOtherAmount: Scalars['Float']['output'];
  limitOtherName: Scalars['String']['output'];
  limitPerOccurrence: Scalars['Float']['output'];
  limitPersonalAndAdvertisingInjury: Scalars['Float']['output'];
  limitProductsAndCompletedOperations: Scalars['Float']['output'];
  otherDeductibleAmount: Scalars['Float']['output'];
  otherDeductibleDescription: Scalars['String']['output'];
  otherLiabilityCoverage: Scalars['Boolean']['output'];
  otherLiabilityCoverageDescription: Scalars['String']['output'];
  ownersAndContractorsProtective: Scalars['Boolean']['output'];
  propertyDamageDeductible: Scalars['Boolean']['output'];
  propertyDamageDeductibleAmount: Scalars['Float']['output'];
};

export type Acord126Data = {
  __typename?: 'Acord126Data';
  /** Configuration for the agency that produced the document */
  agency: AcordAgencyInfo;
  claimsMade: Acord126ClaimsMade;
  contractors: Acord126ContractorsInfo;
  coverage: Acord126CoverageInfo;
  date: Scalars['String']['output'];
  employeeBenefitsLiability: Acord126EmployeeBenefitsLiability;
  general: Acord126GeneralInfo;
  hazards: Acord126Hazards;
  namedInsured: Scalars['String']['output'];
  pco: Acord126ProductsAndCompletedOperationsInfo;
};

export type Acord126EmployeeBenefitsLiability = {
  __typename?: 'Acord126EmployeeBenefitsLiability';
  employeeCount: Scalars['Int']['output'];
  employeesCoveredCount: Scalars['Int']['output'];
  perClaimDeductibleAmount: Scalars['Float']['output'];
  retroactiveDate: Scalars['String']['output'];
};

export type Acord126GeneralInfo = {
  __typename?: 'Acord126GeneralInfo';
  anyOperationsRegardingHazardousMaterials: Scalars['String']['output'];
  crimesOnPremises: Scalars['String']['output'];
  dayCareFacilities: Scalars['String']['output'];
  demolition: Scalars['String']['output'];
  exposureToRadioactiveMaterials: Scalars['String']['output'];
  formalSafetyPolicy: Scalars['String']['output'];
  hasSwimmingPool: Scalars['Boolean']['output'];
  jointVentures: Scalars['String']['output'];
  laborInterchange: Scalars['String']['output'];
  leaseEmployeesFrom1: Acord126LeaseEmployees;
  leaseEmployeesFrom2: Acord126LeaseEmployees;
  leaseEmployeesTo1: Acord126LeaseEmployees;
  leaseEmployeesTo2: Acord126LeaseEmployees;
  lodgingOperations: Scalars['String']['output'];
  lodgingOperationsApartmentArea: Scalars['Float']['output'];
  lodgingOperationsApartmentCount: Scalars['Int']['output'];
  medicalFacilitiesProvidedOrEmployeesEmployed: Scalars['String']['output'];
  operationsSoldAcquiredDiscontinued: Scalars['String']['output'];
  parkingFacilities: Scalars['String']['output'];
  parkingFees: Scalars['String']['output'];
  publicizesSafetyPolicy: Scalars['String']['output'];
  recreationFacilities: Scalars['String']['output'];
  rentOrLoanEquipment1: Acord126RentOrLoanEquipment;
  rentOrLoanEquipment2: Acord126RentOrLoanEquipment;
  sponsoredAthleticTeam1: Acord126SponsoredAthleticTeam;
  sponsoredAthleticTeam2: Acord126SponsoredAthleticTeam;
  sponsorsSocialEvents: Scalars['String']['output'];
  structuralAlterations: Scalars['String']['output'];
  swimmingPoolAboveGround: Scalars['Boolean']['output'];
  swimmingPoolApprovedFence: Scalars['Boolean']['output'];
  swimmingPoolDivingBoard: Scalars['Boolean']['output'];
  swimmingPoolInGround: Scalars['Boolean']['output'];
  swimmingPoolLifeGuard: Scalars['Boolean']['output'];
  swimmingPoolLimitedAccess: Scalars['Boolean']['output'];
  swimmingPoolSlide: Scalars['Boolean']['output'];
  watercraftHiredOrOwned: Scalars['String']['output'];
};

export type Acord126Hazard = {
  __typename?: 'Acord126Hazard';
  address: Address;
  classificationDescription: Scalars['String']['output'];
  glCode: Scalars['String']['output'];
  glExposure: Scalars['String']['output'];
  glPremiumBasisCode: Scalars['String']['output'];
};

export type Acord126Hazards = {
  __typename?: 'Acord126Hazards';
  hazard1: Acord126Hazard;
  hazard2: Acord126Hazard;
  hazard3: Acord126Hazard;
};

export type Acord126LeaseEmployees = {
  __typename?: 'Acord126LeaseEmployees';
  hasWorkersCompensation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Acord126Product = {
  __typename?: 'Acord126Product';
  description: Scalars['String']['output'];
  expectedLife: Scalars['Int']['output'];
  grossSales: Scalars['Float']['output'];
  grossUnits: Scalars['Int']['output'];
  intendedUse: Scalars['String']['output'];
  principalComponents: Scalars['String']['output'];
  timeInMarket: Scalars['Int']['output'];
};

export type Acord126Products = {
  __typename?: 'Acord126Products';
  product1: Acord126Product;
  product2: Acord126Product;
  product3: Acord126Product;
};

export type Acord126ProductsAndCompletedOperationsInfo = {
  __typename?: 'Acord126ProductsAndCompletedOperationsInfo';
  aircraftSpaceIndustry: Scalars['String']['output'];
  anyNamedInsuredSellsToAnotherNamedInsured: Scalars['String']['output'];
  holdHarmlessAgreements: Scalars['String']['output'];
  installationServicingOrDemo: Scalars['String']['output'];
  newProductsPlanned: Scalars['String']['output'];
  products: Acord126Products;
  recalledOrDiscontinuedProducts: Scalars['String']['output'];
  soldOthersUnderOwnLabel: Scalars['String']['output'];
  soldUnderOtherLabels: Scalars['String']['output'];
  vendorsCoverageRequired: Scalars['String']['output'];
};

export type Acord126RentOrLoanEquipment = {
  __typename?: 'Acord126RentOrLoanEquipment';
  description: Scalars['String']['output'];
  instructionsGiven: Scalars['Boolean']['output'];
  isLargeEquipment: Scalars['Boolean']['output'];
  isSmallTools: Scalars['Boolean']['output'];
};

export type Acord126SponsoredAthleticTeam = {
  __typename?: 'Acord126SponsoredAthleticTeam';
  ageGroup12AndUnder: Scalars['Boolean']['output'];
  ageGroup13To18: Scalars['Boolean']['output'];
  ageGroup19AndOver: Scalars['Boolean']['output'];
  extentOfSponsorship: Scalars['String']['output'];
  isContactSport: Scalars['Boolean']['output'];
  sportDescription: Scalars['String']['output'];
};

export type Acord130AdditionalCoverages = {
  __typename?: 'Acord130AdditionalCoverages';
  foreignCoverage: Scalars['Boolean']['output'];
  managedCareOption: Scalars['Boolean']['output'];
  other1: Scalars['String']['output'];
  other2: Scalars['String']['output'];
  uslh: Scalars['Boolean']['output'];
  voluntaryCompensation: Scalars['Boolean']['output'];
};

export type Acord130Contact = {
  __typename?: 'Acord130Contact';
  cellPhoneNumber: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type Acord130Contacts = {
  __typename?: 'Acord130Contacts';
  accounting: Acord130Contact;
  claims: Acord130Contact;
  inspection: Acord130Contact;
};

export type Acord130Data = {
  __typename?: 'Acord130Data';
  agency: AcordAgencyInfo;
  date: Scalars['String']['output'];
  /** General questions about the business */
  generalQuestions: Acord130GeneralQuestions;
  /** Location information */
  locations: Array<Acord130Location>;
  /** Named insured information */
  namedInsured: Acord130NamedInsured;
  /** Policy information */
  policy: Acord130Policy;
  /** Prior coverage and loss history */
  priorCoverage: Acord130PriorCoverage;
  /** Rating information */
  rating: Acord130Rating;
  /** Workers compensation coverage information */
  wcCoverage: Acord130WorkersCompCoverage;
};

export type Acord130Deductible = {
  __typename?: 'Acord130Deductible';
  amount: Scalars['Float']['output'];
  indemnity: Scalars['Boolean']['output'];
  medical: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
};

export type Acord130EmployersLiabilityLimits = {
  __typename?: 'Acord130EmployersLiabilityLimits';
  diseaseEachEmployeeLimit: Scalars['Float']['output'];
  diseasePolicyLimit: Scalars['Float']['output'];
  eachAccidentLimit: Scalars['Float']['output'];
};

export type Acord130GeneralQuestions = {
  __typename?: 'Acord130GeneralQuestions';
  athleticTeamsSponsored: Scalars['String']['output'];
  employeeHealthPlan: Scalars['String']['output'];
  employeesPerformWorkForOtherBusinesses: Scalars['String']['output'];
  employeesTravelOutOfState: Scalars['String']['output'];
  employeesUnder16OrOver60: Scalars['String']['output'];
  employeesWithPhysicalHandicaps: Scalars['String']['output'];
  employeesWorkFromHome: Scalars['String']['output'];
  employeesWorkFromHomeCount: Scalars['Int']['output'];
  groupTransportation: Scalars['String']['output'];
  hazardousMaterialOperations: Scalars['String']['output'];
  leaseEmployeesToOrFromOtherEmployers: Scalars['String']['output'];
  otherBusinessEngagement: Scalars['String']['output'];
  otherInsuranceWithThisInsurer: Scalars['String']['output'];
  ownOperateAircraftWatercraft: Scalars['String']['output'];
  physicalsRequired: Scalars['String']['output'];
  priorCoverageDeclined: Scalars['String']['output'];
  seasonalEmployees: Scalars['String']['output'];
  subcontractorsUsed: Scalars['String']['output'];
  taxLiensOrBankruptcy: Scalars['String']['output'];
  unpaidWorkersCompPremium: Scalars['String']['output'];
  volunteerOrDonatedLabor: Scalars['String']['output'];
  workOnVesselsDocksBridges: Scalars['String']['output'];
  workSubletWithoutCertificates: Scalars['String']['output'];
  workUndergroundOrAbove15Feet: Scalars['String']['output'];
  writtenSafetyProgram: Scalars['String']['output'];
};

export type Acord130Individual = {
  __typename?: 'Acord130Individual';
  birthDate: Scalars['String']['output'];
  dutiesDescription: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  includedExcludedCode: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  ownershipPercent: Scalars['Float']['output'];
  ratingClassificationCode: Scalars['String']['output'];
  remunerationAmount: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  titleRelationshipCode: Scalars['String']['output'];
};

export type Acord130LegalEntity = {
  __typename?: 'Acord130LegalEntity';
  corporation: Scalars['Boolean']['output'];
  jointVenture: Scalars['Boolean']['output'];
  llc: Scalars['Boolean']['output'];
  other: Scalars['String']['output'];
  partnership: Scalars['Boolean']['output'];
  soleProprietor: Scalars['Boolean']['output'];
  subchapterSCorp: Scalars['Boolean']['output'];
  trust: Scalars['Boolean']['output'];
  unincorporatedAssociation: Scalars['Boolean']['output'];
};

export type Acord130Location = {
  __typename?: 'Acord130Location';
  address: Address;
  highestFloorCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type Acord130NamedInsured = {
  __typename?: 'Acord130NamedInsured';
  cellPhoneNumber: Scalars['String']['output'];
  contacts: Acord130Contacts;
  creditBureauId: Scalars['String']['output'];
  creditBureauName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  legalEntity: Acord130LegalEntity;
  mailingAddress: Address;
  naicsCode: Scalars['String']['output'];
  ncciRiskId: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  ratingBureauId: Scalars['String']['output'];
  sicCode: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
  website: Scalars['String']['output'];
  yearsInBusiness: Scalars['Int']['output'];
};

export type Acord130NamedPremiumFactor = {
  __typename?: 'Acord130NamedPremiumFactor';
  description: Scalars['String']['output'];
  factor: Scalars['Float']['output'];
  factoredPremium: Scalars['Float']['output'];
};

export type Acord130Policy = {
  __typename?: 'Acord130Policy';
  audit: Acord130PolicyAudit;
  effectiveDate: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  nonParticipating: Scalars['Boolean']['output'];
  normalAnniversaryRatingDate: Scalars['String']['output'];
  operationsDescription: Scalars['String']['output'];
  participating: Scalars['Boolean']['output'];
  payment: Acord130PolicyPayment;
  ratingEffectiveDate: Scalars['String']['output'];
  retrospectiveRatingPlan: Scalars['String']['output'];
  status: Acord130PolicyStatus;
};

export type Acord130PolicyAudit = {
  __typename?: 'Acord130PolicyAudit';
  atExpiration: Scalars['Boolean']['output'];
  frequencyCode: Scalars['String']['output'];
  monthly: Scalars['Boolean']['output'];
  other: Scalars['Boolean']['output'];
  quarterly: Scalars['Boolean']['output'];
  semiAnnual: Scalars['Boolean']['output'];
};

export type Acord130PolicyPayment = {
  __typename?: 'Acord130PolicyPayment';
  annual: Scalars['Boolean']['output'];
  directBill: Scalars['Boolean']['output'];
  downPaymentPercent: Scalars['Float']['output'];
  other: Scalars['Boolean']['output'];
  paymentScheduleCode: Scalars['String']['output'];
  producerBill: Scalars['Boolean']['output'];
  quarterly: Scalars['Boolean']['output'];
  semiAnnual: Scalars['Boolean']['output'];
};

export type Acord130PolicyStatus = {
  __typename?: 'Acord130PolicyStatus';
  assignedRisk: Scalars['Boolean']['output'];
  bindEffectiveDate: Scalars['String']['output'];
  bound: Scalars['Boolean']['output'];
  issue: Scalars['Boolean']['output'];
  quote: Scalars['Boolean']['output'];
};

export type Acord130PremiumFactor = {
  __typename?: 'Acord130PremiumFactor';
  factor: Scalars['Float']['output'];
  factoredPremium: Scalars['Float']['output'];
};

export type Acord130PremiumFactors = {
  __typename?: 'Acord130PremiumFactors';
  assignedRiskAdditionalPremium: Acord130PremiumFactor;
  assignedRiskSurcharge: Acord130PremiumFactor;
  catastrophe: Scalars['Float']['output'];
  contractingClassPremium: Acord130PremiumFactor;
  deductible: Acord130PremiumFactor;
  expenseConstant: Scalars['Float']['output'];
  experienceOrMerit: Acord130PremiumFactor;
  increasedLimits: Acord130PremiumFactor;
  other1: Acord130NamedPremiumFactor;
  other2: Acord130NamedPremiumFactor;
  premiumDiscount: Acord130PremiumFactor;
  scheduleRating: Acord130PremiumFactor;
  standardPremium: Acord130PremiumFactor;
  taxesFeeAssessment: Scalars['Float']['output'];
  terrorism: Scalars['Float']['output'];
  totalFactoredPremium: Scalars['Float']['output'];
};

export type Acord130PriorCoverage = {
  __typename?: 'Acord130PriorCoverage';
  lossRunAttached: Scalars['Boolean']['output'];
  priorPolicies: Array<Acord130PriorPolicy>;
};

export type Acord130PriorPolicy = {
  __typename?: 'Acord130PriorPolicy';
  claimCount: Scalars['Int']['output'];
  effectiveYear: Scalars['String']['output'];
  insurerName: Scalars['String']['output'];
  modificationFactor: Scalars['Float']['output'];
  paidAmount: Scalars['Float']['output'];
  policyNumber: Scalars['String']['output'];
  reservedAmount: Scalars['Float']['output'];
  totalPremium: Scalars['Float']['output'];
};

export type Acord130Rating = {
  __typename?: 'Acord130Rating';
  individuals: Array<Acord130Individual>;
  stateRating: Array<Acord130StateRating>;
};

export type Acord130RatingClass = {
  __typename?: 'Acord130RatingClass';
  classificationCode: Scalars['String']['output'];
  descriptionCode: Scalars['String']['output'];
  dutiesDescription: Scalars['String']['output'];
  estimatedManualPremium: Scalars['Float']['output'];
  fullTimeEmployeeCount: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  naicsCode: Scalars['String']['output'];
  partTimeEmployeeCount: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  remunerationAmount: Scalars['Float']['output'];
  sicCode: Scalars['String']['output'];
};

export type Acord130StateRating = {
  __typename?: 'Acord130StateRating';
  classes: Array<Acord130RatingClass>;
  depositPremium: Scalars['Float']['output'];
  minimumPremium: Scalars['Float']['output'];
  pageNumber: Scalars['Int']['output'];
  premiumFactors: Acord130PremiumFactors;
  remarks: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
  totalEstimatedAnnualPremium: Scalars['Float']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Acord130WorkersCompCoverage = {
  __typename?: 'Acord130WorkersCompCoverage';
  additionalCompanyInfo: Scalars['String']['output'];
  additionalCoverageEndorsementDesc: Scalars['String']['output'];
  coverages: Acord130AdditionalCoverages;
  deductible: Acord130Deductible;
  dividendOrSafetyPlan: Scalars['String']['output'];
  employersLiabilityLimits: Acord130EmployersLiabilityLimits;
  partOneStates: Array<Scalars['String']['output']>;
  partThreeStates: Array<Scalars['String']['output']>;
  totalDepositPremium: Scalars['Float']['output'];
  totalEstimatedAnnualPremium: Scalars['Float']['output'];
  totalMinimumPremium: Scalars['Float']['output'];
};

export type Acord131AdditionalExposures = {
  __typename?: 'Acord131AdditionalExposures';
  advertisersLiabilityAnnualCost: Scalars['Float']['output'];
  advertisersLiabilityMediaUsed: Scalars['String']['output'];
  advertisingAgencyUsed: Scalars['String']['output'];
  advertisingCoverageProvided: Scalars['String']['output'];
  anyForeignOperationsOrProducts: Scalars['String']['output'];
  anyProductsUsedOrInstalledInAircraft: Scalars['String']['output'];
  anyUninsuredAutos: Scalars['String']['output'];
  bridgeDamMarineWorkPerformed: Scalars['String']['output'];
  coveragesProvidedForDoctorsOrNurses: Scalars['String']['output'];
  dangerousCargoHauled: Scalars['String']['output'];
  describeAgreement: Scalars['String']['output'];
  describeIndependentContractors: Scalars['String']['output'];
  describeTypicalJobs: Scalars['String']['output'];
  grossSalesLastYear: Scalars['Float']['output'];
  grossSalesThreeYearsAgo: Scalars['Float']['output'];
  grossSalesTwoYearsAgo: Scalars['Float']['output'];
  hiredAndNonOwnedAutoCoverage: Scalars['String']['output'];
  hospitalOrFirstAidFacilityMaintained: Scalars['String']['output'];
  numberOfBeds: Scalars['Int']['output'];
  numberOfDoctors: Scalars['Int']['output'];
  numberOfNurses: Scalars['Int']['output'];
  ownLeaseOperateAircraft: Scalars['String']['output'];
  ownRentOrUseCranes: Scalars['String']['output'];
  passengersCarried: Scalars['String']['output'];
  pollutionLiabilityEpaNumber: Scalars['String']['output'];
  productLiabilityLoss: Scalars['String']['output'];
  productsContainHazardousMaterials: Scalars['String']['output'];
  selfInsured: Scalars['String']['output'];
  subcontractorsUnderinsured: Scalars['String']['output'];
  vehiclesRentedOrLeasedToOthers: Scalars['String']['output'];
};

export type Acord131AutoLiability = {
  __typename?: 'Acord131AutoLiability';
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Coverage limit for bodily injury per accident */
  limitBodilyInjuryPerAccident: Scalars['Float']['output'];
  /** Coverage limit for bodily injury per person */
  limitBodilyInjuryPerPerson: Scalars['Float']['output'];
  /** Coverage limit for each accident */
  limitCombinedSingleLimitPerAccident: Scalars['Float']['output'];
  /** Coverage limit for property damage per accident */
  limitPropertyDamagePerAccident: Scalars['Float']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the auto liability coverage */
  policyNumber: Scalars['String']['output'];
};

export type Acord131Data = {
  __typename?: 'Acord131Data';
  additionalExposures: Acord131AdditionalExposures;
  additionalRemarks: Scalars['String']['output'];
  /** Configuration for the agency that produced the document */
  agency: AcordAgencyInfo;
  date: Scalars['String']['output'];
  employeeBenefitsLiability: Acord131EmployeeBenefitsLiability;
  insurance: Acord131Insurance;
  location1: Acord131LocationInfo;
  location2: Acord131LocationInfo;
  location3: Acord131LocationInfo;
  location4: Acord131LocationInfo;
  location5: Acord131LocationInfo;
  namedInsured: Scalars['String']['output'];
};

export type Acord131EmployeeBenefitsLiability = {
  __typename?: 'Acord131EmployeeBenefitsLiability';
  aggregateLimit: Scalars['Float']['output'];
  limit: Scalars['Float']['output'];
  programName: Scalars['String']['output'];
  programType: Scalars['String']['output'];
  retainedLimit: Scalars['Float']['output'];
  retroactiveDate: Scalars['String']['output'];
  retroactiveLimit: Scalars['Float']['output'];
};

export type Acord131EmployersLiability = {
  __typename?: 'Acord131EmployersLiability';
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Coverage limit for each accident */
  limitEachAccident: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitEachEmployee: Scalars['Float']['output'];
  /** Coverage limit for damage to rented premises per occurrence */
  limitPerPolicy: Scalars['Float']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the employers liability coverage */
  policyNumber: Scalars['String']['output'];
};

export type Acord131GeneralLiability = {
  __typename?: 'Acord131GeneralLiability';
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  claimsMadeCoverageEntryDate: Scalars['String']['output'];
  claimsMadeRetroactiveDate: Scalars['String']['output'];
  claimsMadeTailCoverageEffectiveDate: Scalars['String']['output'];
  claimsMadeTailCoverageExplanation: Scalars['String']['output'];
  defenseCostsSeparateLimits: Scalars['Boolean']['output'];
  defenseCostsUnlimited: Scalars['Boolean']['output'];
  defenseCostsWithinLimits: Scalars['Boolean']['output'];
  excludedFromPrevCoverage: Scalars['String']['output'];
  formEdition: Scalars['String']['output'];
  /** Whether this coverage is claims made */
  isClaimsMade: Scalars['Boolean']['output'];
  /** Whether this coverage is occurrence based */
  isOccurrenceBased: Scalars['Boolean']['output'];
  /** Coverage limit for damage to rented premises per occurrence */
  limitDamageToPremisesEachOccurrence: Scalars['Float']['output'];
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpense: Scalars['Float']['output'];
  /** Coverage limit for personal and advertising injury */
  limitPersonalAndAdvertisingInjury: Scalars['Float']['output'];
  /** Coverage limit for products and completed operations */
  limitProductsAndCompletedOperations: Scalars['Float']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the liability coverage */
  policyNumber: Scalars['String']['output'];
};

export type Acord131Insurance = {
  __typename?: 'Acord131Insurance';
  autoLiability: Acord131AutoLiability;
  employersLiability: Acord131EmployersLiability;
  generalLiability: Acord131GeneralLiability;
  hasAdditionalInterests: Scalars['Boolean']['output'];
  hasAircraftLiability: Scalars['Boolean']['output'];
  hasAircraftPassengerLiability: Scalars['Boolean']['output'];
  hasCareCustodyOrControl: Scalars['Boolean']['output'];
  hasEmployeeBenefitsLiability: Scalars['Boolean']['output'];
  hasForeignOrTravelLiability: Scalars['Boolean']['output'];
  hasGaragekeepersLiability: Scalars['Boolean']['output'];
  hasLiquorLiability: Scalars['Boolean']['output'];
  hasMedicalMalpracticeLiability: Scalars['Boolean']['output'];
  hasPollutionLiability: Scalars['Boolean']['output'];
  hasProfessionalLiability: Scalars['Boolean']['output'];
  hasVendorsLiability: Scalars['Boolean']['output'];
  hasWatercraftLiability: Scalars['Boolean']['output'];
  otherLiability1: Acord131OtherLiability;
  otherLiability2: Acord131OtherLiability;
  restrictions: Scalars['String']['output'];
};

export type Acord131LocationInfo = {
  __typename?: 'Acord131LocationInfo';
  address: Address;
  annualGrossSales: Scalars['Float']['output'];
  annualPayroll: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  foreignGrossSales: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numEmployees: Scalars['Int']['output'];
};

export type Acord131OtherLiability = {
  __typename?: 'Acord131OtherLiability';
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Coverage limit for each occurrence */
  limitName: Scalars['String']['output'];
  /** Coverage limit for each occurrence */
  limitValue: Scalars['Float']['output'];
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['String']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['String']['output'];
  /** Policy number for the employers liability coverage */
  policyNumber: Scalars['String']['output'];
};

export type Acord140BlanketInfo = {
  __typename?: 'Acord140BlanketInfo';
  amount: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Acord140Data = {
  __typename?: 'Acord140Data';
  /** Configuration for the agency that produced the document */
  agency: AcordAgencyInfo;
  blanket1: Acord140BlanketInfo;
  blanket2: Acord140BlanketInfo;
  blanket3: Acord140BlanketInfo;
  blanket4: Acord140BlanketInfo;
  date: Scalars['String']['output'];
  namedInsured: Scalars['String']['output'];
  premise1: Acord140PremiseInfo;
  premise2: Acord140PremiseInfo;
};

export type Acord140PremiseAlarmsInfo = {
  __typename?: 'Acord140PremiseAlarmsInfo';
  burglarAlarmCompany: Scalars['String']['output'];
  burglarAlarmDescription: Scalars['String']['output'];
  burglarCentralAlarm: Scalars['Boolean']['output'];
  burglarCentralAlarmCompanyHasKeys: Scalars['Boolean']['output'];
  burglarLocalGong: Scalars['Boolean']['output'];
  fireCentralAlarm: Scalars['Boolean']['output'];
  fireLocalGong: Scalars['Boolean']['output'];
  guardCount: Scalars['Int']['output'];
  sprinklerPercentage: Scalars['Float']['output'];
  sprinklerSystemDescription: Scalars['String']['output'];
};

export type Acord140PremiseConstructionInfo = {
  __typename?: 'Acord140PremiseConstructionInfo';
  basementCount: Scalars['Int']['output'];
  buildingArea: Scalars['Float']['output'];
  constructionType: Scalars['String']['output'];
  distanceFromFireHydrant: Scalars['Float']['output'];
  distanceFromFireStation: Scalars['Float']['output'];
  heatingYear: Scalars['String']['output'];
  historialProperty: Scalars['Boolean']['output'];
  plumbingYear: Scalars['String']['output'];
  protectionClassCode: Scalars['String']['output'];
  roofType: Scalars['String']['output'];
  roofingYear: Scalars['String']['output'];
  storyCount: Scalars['Int']['output'];
  wiringYear: Scalars['String']['output'];
  yearBuilt: Scalars['String']['output'];
  yearRenovated: Scalars['String']['output'];
};

export type Acord140PremiseCoverageInfo = {
  __typename?: 'Acord140PremiseCoverageInfo';
  amount: Scalars['Float']['output'];
  blanketNumber: Scalars['Int']['output'];
  causeOfLoss: Scalars['String']['output'];
  coinsurancePercentage: Scalars['Float']['output'];
  deductibleAmount: Scalars['Float']['output'];
  deductibleType: Scalars['String']['output'];
  formsAndConditions: Scalars['String']['output'];
  inflationGuardPercentage: Scalars['Float']['output'];
  subjectOfInsurance: Scalars['String']['output'];
  valuation: Scalars['String']['output'];
};

export type Acord140PremiseInfo = {
  __typename?: 'Acord140PremiseInfo';
  address: Address;
  alarms: Acord140PremiseAlarmsInfo;
  construction: Acord140PremiseConstructionInfo;
  coverage1: Acord140PremiseCoverageInfo;
  coverage2: Acord140PremiseCoverageInfo;
  coverage3: Acord140PremiseCoverageInfo;
  coverage4: Acord140PremiseCoverageInfo;
  coverage5: Acord140PremiseCoverageInfo;
  description: Scalars['String']['output'];
  spoilage: Acord140PremiseSpoilageInfo;
};

export type Acord140PremiseSpoilageInfo = {
  __typename?: 'Acord140PremiseSpoilageInfo';
  amount: Scalars['Float']['output'];
  breakdownOrContamination: Scalars['Boolean']['output'];
  coverageApplies: Scalars['Boolean']['output'];
  deductibleAmount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  other: Scalars['Boolean']['output'];
  otherDescription: Scalars['String']['output'];
  powerOutage: Scalars['Boolean']['output'];
  refrigeratorMaintenance: Scalars['Boolean']['output'];
  sellingPrice: Scalars['Boolean']['output'];
};

export type AcordAgencyInfo = {
  __typename?: 'AcordAgencyInfo';
  address: Address;
  authorizedRepresentative: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  contactFax: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  name: Scalars['String']['output'];
  producerName: Scalars['String']['output'];
  useAuthorizedRepresentativeSignature: Scalars['Boolean']['output'];
};

export type AcordCarrierInfo = {
  __typename?: 'AcordCarrierInfo';
  naic: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Details for a request to add an additional insured to a policy */
export type AddAdditionalInsuredRequest = {
  __typename?: 'AddAdditionalInsuredRequest';
  /** Address of the additional insured */
  address: Address;
  /** Name of the additional insured */
  name: Scalars['String']['output'];
  /** Relationship between the policyholder and additional insured */
  relationship: Scalars['String']['output'];
};

/** Input type for adding an additional insured request */
export type AddAdditionalInsuredRequestInput = {
  /** Address of the additional insured */
  address: AddressInput;
  /** Name of the additional insured */
  name: Scalars['String']['input'];
  /** Relationship between the policyholder and additional insured */
  relationship: Scalars['String']['input'];
};

/** Input type for adding a comment to a service request */
export type AddServiceRequestCommentInput = {
  /** The content of the comment */
  content: Scalars['String']['input'];
};

/** Describes an address that can be accepted as input */
export type Address = {
  __typename?: 'Address';
  /**
   *  Level 3 administrative division depending on country. For example, this is
   * the city in the U.S., a muncipality in Austria, a ward in Singapore, etc.
   */
  city: Scalars['String']['output'];
  /** First line of the address. */
  line1: Scalars['String']['output'];
  /** Optional second line of the address. */
  line2?: Maybe<Scalars['String']['output']>;
  /**
   *  Country-specific mailing identifier, e.g. ZIP Code in the U.S., Post Code
   * in the U.K., etc.
   */
  postalCode: Scalars['String']['output'];
  /**
   *  Level 2 administrative division depending on country. For example, this is
   * the county in the U.S., prefectural city in China, division in India, etc.
   */
  subZone?: Maybe<Scalars['String']['output']>;
  /**
   *  Level 1 administrative division depending on country. For example, this is
   * the state in the U.S., the province in Canada, etc.
   */
  zone: Scalars['String']['output'];
};

/** Describes an address that can be accepted as input */
export type AddressInput = {
  /**
   *  Level 3 administrative division depending on country. For example, this is
   * the city in the U.S., a muncipality in Austria, a ward in Singapore, etc.
   */
  city: Scalars['String']['input'];
  /** First line of the address. */
  line1: Scalars['String']['input'];
  /** Optional second line of the address. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Country-specific mailing identifier, e.g. ZIP Code in the U.S., Post Code
   * in the U.K., etc.
   */
  postalCode: Scalars['String']['input'];
  /**
   *  Level 2 administrative division depending on country. For example, this is
   * the county in the U.S., prefectural city in China, division in India, etc.
   */
  subZone?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Level 1 administrative division depending on country. For example, this is
   * the state in the U.S., the province in Canada, etc.
   */
  zone: Scalars['String']['input'];
};

/** Agency represents an insurance agency that works with Oyster. */
export type Agency = {
  __typename?: 'Agency';
  /** Agency-wide configuration and settings */
  configuration: AgencyConfiguration;
  /** Timestamp the agency was created */
  createdAt: Scalars['Time']['output'];
  /** Display name of the agency */
  displayName: Scalars['String']['output'];
  /** Unique identifier for the agency */
  id: Scalars['ID']['output'];
  /** URL of the agency's logo */
  logoUrl: Scalars['String']['output'];
  /** Mailing address of the agency */
  mailingAddress: Address;
  /** Legal name of the agency */
  name: Scalars['String']['output'];
  /** Phone number of the agency */
  phone: Scalars['String']['output'];
  /** The subscription information for the agency user */
  subscription?: Maybe<AgencySubscription>;
  /** Timestamp the agency was last updated */
  updatedAt: Scalars['Time']['output'];
  /** URL of the agency's wordmark */
  wordmarkUrl: Scalars['String']['output'];
};

/** Agency-wide configuration and settings */
export type AgencyConfiguration = {
  __typename?: 'AgencyConfiguration';
  /** The default COI configuration for the agency */
  liabilityCOIConfiguration: CertificateOfLiabilityAgencyConfiguration;
  /** Notification settings for the agency */
  notifications: NotificationSettings;
};

/** Input for Agency-wide configuration and settings */
export type AgencyConfigurationInput = {
  /** The default COI configuration for the agency */
  liabilityCOIConfiguration: CertificateOfLiabilityAgencyConfigurationInput;
  /** Notification settings for the agency */
  notifications: NotificationSettingsInput;
};

/** Input for creating a new agency */
export type AgencyInput = {
  /** Agency-wide configuration and settings */
  configuration: AgencyConfigurationInput;
  /** Display name of the agency */
  displayName: Scalars['String']['input'];
  /** URL of the agency's logo */
  logoUrl: Scalars['String']['input'];
  /** Mailing address of the agency */
  mailingAddress: AddressInput;
  /** Legal name of the agency */
  name: Scalars['String']['input'];
  /** Phone number of the agency */
  phone: Scalars['String']['input'];
  /** URL of the agency's wordmark */
  wordmarkUrl: Scalars['String']['input'];
};

/** Response from the agency sign in mutation */
export type AgencySignInResponse = {
  __typename?: 'AgencySignInResponse';
  /** The agency user that was signed in */
  agencyUser: AgencyUser;
};

/** Subscription information for the agency */
export type AgencySubscription = {
  __typename?: 'AgencySubscription';
  /** The amount due for the next billing period */
  nextBillingAmount?: Maybe<Scalars['Float']['output']>;
  /** The date the next billing period for the subscription will start */
  nextBillingDate?: Maybe<Scalars['Time']['output']>;
  /** The number of seats purchased for the agency */
  numSeats: Scalars['Int']['output'];
  /** The number of seats currently in use for the agency */
  numSeatsActive: Scalars['Int']['output'];
  /** The period of the subscription */
  period?: Maybe<SubscriptionPeriod>;
  /** The plan that the agency is subscribed to */
  plan?: Maybe<SubscriptionPlan>;
  /** The state of the subscription for the agency */
  state: SubscriptionState;
  /** The date the trial period for the subscription will end */
  trialEndDate?: Maybe<Scalars['Time']['output']>;
};

export type AgencyUser = {
  __typename?: 'AgencyUser';
  /** Agency the user is associated with */
  agency: Agency;
  /** Timestamp the agency user was created */
  createdAt: Scalars['Time']['output'];
  /** Email of the user */
  email: Scalars['String']['output'];
  /** ID of the user */
  id: Scalars['ID']['output'];
  /** Name of the user */
  name: Scalars['String']['output'];
  /** Preferences for the agency user */
  preferences: AgencyUserPreferences;
  /** State of the agency user */
  state: AgencyUserState;
  /** Timestamp the agency user was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Input for creating a new agency user */
export type AgencyUserInput = {
  /** Email of the agency user */
  email: Scalars['String']['input'];
  /** Name of the agency user */
  name: Scalars['String']['input'];
};

/** Preferences for the agency user */
export type AgencyUserPreferences = {
  __typename?: 'AgencyUserPreferences';
  /** Favorite presets for the agency user */
  favoritePresets: AgencyUserPreferencesFavoritePresets;
};

/** Favorite presets for the agency user */
export type AgencyUserPreferencesFavoritePresets = {
  __typename?: 'AgencyUserPreferencesFavoritePresets';
  /** The custom presets that the agency user has favorited */
  customPresets: Array<CustomPreset>;
  /** The custom presets that the agency user has favorited */
  presets: Array<CaraWorkspacePreset>;
};

/** Input for Favorite presets for the agency user */
export type AgencyUserPreferencesFavoritePresetsInput = {
  /** The custom presets that the agency user has favorited */
  customPresetIds: Array<Scalars['String']['input']>;
  /** The custom presets that the agency user has favorited */
  presets: Array<CaraWorkspacePreset>;
};

/** Input for preferences for the agency user */
export type AgencyUserPreferencesInput = {
  /** The custom presets that the agency user has favorited */
  favoritePresets?: InputMaybe<AgencyUserPreferencesFavoritePresetsInput>;
};

export enum AgencyUserState {
  /** The user is active and can access the agency */
  Active = 'ACTIVE',
  /** The user is disabled and cannot access the agency */
  Disabled = 'DISABLED'
}

/**
 * Describes the Ascend billable that this policy is associated with. This
 * type represents the response from the Ascend /v1/billables API
 */
export type AscendBillable = {
  __typename?: 'AscendBillable';
  /** Fee collected by your agency (dollars). Fully earned, not financeable, and funded directly to your agency. */
  agencyFees: Scalars['Float']['output'];
  /** The identifier assigned to the quote/endorsement by the issuing carrier or wholesaler. */
  billableIdentifier: Scalars['String']['output'];
  /** Fee collected by the wholesaler (dollars). Fully earned, not financeable, and funded directly to the wholesaler. */
  brokerFees: Scalars['Float']['output'];
  /** An insurance company. */
  carrier: AscendCarrier;
  /** A type of coverage. */
  coverageType: AscendCoverage;
  /** A short description to explain to the insured what they are purchasing. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the billable */
  id: Scalars['String']['output'];
  /** Determines if the carrier can audit customer raising premium significantly. */
  isAuditable: Scalars['Boolean']['output'];
  /** Determines if specific lines of business are filed with other bureaus which they have to notify on cancelation. */
  isFiled: Scalars['Boolean']['output'];
  /** Determines if the policy is fined by 10% on top of earned premium when insured cancels */
  isShortRate: Scalars['Boolean']['output'];
  /** Set state determined extended cancelation period for the policy. */
  minDaysToCancel: Scalars['Int']['output'];
  /** The minimum rate to charge insureds when they decide to finance. */
  minEarnedRate: Scalars['Float']['output'];
  /** Any additional fees that come with the policy (dollars). This fee is treated as non-refundable & fully earned. */
  otherFees: Scalars['Float']['output'];
  /** Payouts created for this program, if any. This corresponds to the data returned from the /v1/payouts endpoint */
  payouts: Array<AscendPayout>;
  /** Any policy fees that come with the billable (dollars). This fee is treated as non-refundable & fully earned. */
  policyFees: Scalars['Float']['output'];
  /** The amount to pay for the insurance policy (dollars). */
  premium: Scalars['Float']['output'];
  /** Your commission rate for this policy. */
  sellerCommissionRate?: Maybe<Scalars['Float']['output']>;
  /** The amount of surplus lines tax to be collected (dollars). */
  surplusLinesTax: Scalars['Float']['output'];
  /** Any taxes & unearned fees (dollars). Taxes and fees are financed. */
  taxesAndFees: Scalars['Float']['output'];
  /** An insurance wholesaler or MGA. */
  wholesaler?: Maybe<AscendWholesaler>;
};

/** An insurance company. */
export type AscendCarrier = {
  __typename?: 'AscendCarrier';
  /** A human readable unique identifier. */
  id: Scalars['String']['output'];
  /** The carrier display name. */
  title: Scalars['String']['output'];
};

/** A type of coverage. */
export type AscendCoverage = {
  __typename?: 'AscendCoverage';
  /** A human readable unique identifier. */
  id: Scalars['String']['output'];
  /** The coverage type display name. */
  title: Scalars['String']['output'];
};

/** A document representing a transaction between the insured and Ascend. */
export type AscendInvoice = {
  __typename?: 'AscendInvoice';
  /** The checkout url of the invoice. */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** The date by which the invoice should be paid. */
  dueDate?: Maybe<Scalars['Time']['output']>;
  /** The invoice unique identifier. */
  id: Scalars['String']['output'];
  /** The unique identifier of the insured invoice is attached to. */
  insuredID: Scalars['String']['output'];
  /** A number assigned to uniquely identify the invoice. */
  invoiceNumber: Scalars['String']['output'];
  /** The url of the invoice document. */
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  /** The date when the invoice was shared with the insured. */
  issuedAt?: Maybe<Scalars['Time']['output']>;
  /** The date when the invoice was paid by the insured. */
  paidAt?: Maybe<Scalars['Time']['output']>;
  /** The name of the insured/business paying for the invoice. */
  payerName: Scalars['String']['output'];
  /** It represents the payment instrument used by an insured. */
  paymentMethod?: Maybe<AscendPaymentMethod>;
  /** The unique identifier of the program invoice is attached to. */
  programID?: Maybe<Scalars['String']['output']>;
  /** The current state of the invoice. */
  status: Scalars['String']['output'];
  /** The total amount charged, in dollars. */
  totalAmount: Scalars['Float']['output'];
};

/** A loan associated with an Ascend program */
export type AscendLoan = {
  __typename?: 'AscendLoan';
  /** The amount financed through the loan represented in dollars. */
  amountFinanced: Scalars['Float']['output'];
  /** The total annual rate charged. */
  apr: Scalars['Float']['output'];
  /** The date when the loan was created. The date uses UTC and is represented in the ISO8601 format. */
  createdAt: Scalars['Time']['output'];
  /** The initial up-front payment represented in dollars. */
  downPayment: Scalars['Float']['output'];
  /** The loan unique identifier. */
  id: Scalars['String']['output'];
  /** The number of payments that will be made to repay the loan. */
  numberOfPayments: Scalars['Int']['output'];
  /** The current state of the loan. */
  status: Scalars['String']['output'];
  /** The amount that will be payed in each payment in dollars. */
  termPayment: Scalars['Float']['output'];
  /** The date when the loan was last updated. The date uses UTC and is represented in the ISO8601 format. */
  updatedAt: Scalars['Time']['output'];
};

/** The account the Ascend payout was made to */
export type AscendPayableAccount = {
  __typename?: 'AscendPayableAccount';
  /** The ID of the payable account */
  id: Scalars['String']['output'];
  /** The last four digits of the bank account */
  lastFour: Scalars['String']['output'];
  /** The owner name of the bank account */
  ownerName: Scalars['String']['output'];
  /** The routing number of the bank account */
  routingNumber: Scalars['String']['output'];
  /** The usage type of the bank account */
  usageType: AscendPayableAccountUsageType;
};

export enum AscendPayableAccountUsageType {
  /** Organization's bank account we transfer commissions to. */
  CommissionAccount = 'COMMISSION_ACCOUNT',
  /** Paid out to carrier/wholesaler */
  SupplierAccount = 'SUPPLIER_ACCOUNT',
  /** Organization's bank account we transfer full premium to. */
  TrustAccount = 'TRUST_ACCOUNT'
}

export type AscendPaymentMethod = {
  __typename?: 'AscendPaymentMethod';
  type: AscendPaymentMethodType;
};

export enum AscendPaymentMethodType {
  AchCreditTransfer = 'ACH_CREDIT_TRANSFER',
  AchDebit = 'ACH_DEBIT',
  Card = 'CARD'
}

/** A payout from Ascend to an entity */
export type AscendPayout = {
  __typename?: 'AscendPayout';
  /** The date the payout was created */
  createdAt: Scalars['Time']['output'];
  /** The date that the payout failed */
  failedAt?: Maybe<Scalars['Time']['output']>;
  /** The gross amount paid out, in dollars. */
  grossPayoutAmount: Scalars['Float']['output'];
  /** The payout unique identifier */
  id: Scalars['String']['output'];
  /** If found, the details of the bank transaction on Oyster's side */
  linkedBankTransaction?: Maybe<LinkedBankTransaction>;
  /** The net amount paid out, in dollars. */
  netPayoutAmount: Scalars['Float']['output'];
  /** The date that the payout was paid */
  paidAt?: Maybe<Scalars['Time']['output']>;
  /** The account that the payout was made to */
  payableAccount: AscendPayableAccount;
  /** The date that the payout will be paid */
  payingAt?: Maybe<Scalars['Time']['output']>;
  /** The type of the recipient */
  recipientType: AscendRecipientType;
  /** The reference number included in the bank memo associated with this payout */
  reference?: Maybe<Scalars['String']['output']>;
  /** The current state of the payout */
  status: AscendPayoutStatus;
  /** The type of the payout */
  type: AscendPayoutType;
};

/** The status of the payout */
export enum AscendPayoutStatus {
  /** The payout has been canceled */
  Canceled = 'CANCELED',
  /** The payout has failed to reach the payable account. */
  Failed = 'FAILED',
  /** The payout is blocked until the invoice release_date when funds can be paid to the payable account. */
  OnHold = 'ON_HOLD',
  /** The payout has been paid to designated PayableAccount */
  Paid = 'PAID',
  /** The payout has been initiated but we have not received confirmation that it has cleared. */
  Paying = 'PAYING',
  /** The payout is waiting for confirmation from servicer indicating it has been funded. */
  Transferred = 'TRANSFERRED',
  /** Initial state, no action has been taken on the payout. */
  Unpaid = 'UNPAID'
}

/** The type of the payout */
export enum AscendPayoutType {
  /** Transfer cumulative supplier funding to org so that they can pay out to supplier - paid to the organization's trust account */
  AgentSupplierFunding = 'AGENT_SUPPLIER_FUNDING',
  /** Policy's commission paid to organization's commission account */
  Commission = 'COMMISSION',
  /** Policy's full premium (premium w/ commission) paid to organization's trust account */
  FullPremium = 'FULL_PREMIUM',
  /** Policy's net premium (full premium - commission) paid out to org's trust account (direct bill) */
  NetPremium = 'NET_PREMIUM',
  /** Payout to agency's commission account for one-off invoice */
  OneOff = 'ONE_OFF',
  /** Payout to org for additional funds they have transferred to us - paid to the organization's commission account */
  Overpayment = 'OVERPAYMENT',
  /** Policy's premium paid out to supplier's honor_supplier_account or supplier_account (agency bill) */
  Supplier = 'SUPPLIER',
  /** Payout to agency's trust account for surplus line taxes */
  SurplusLinesTax = 'SURPLUS_LINES_TAX',
  /** Financed policy's downpayment paid to honor's downpayment account */
  TakeRate = 'TAKE_RATE'
}

/** A collection of insurance quotes pooled to produce 1 checkout link. */
export type AscendProgram = {
  __typename?: 'AscendProgram';
  /** The date the program was archived. The date uses UTC and is represented in the ISO8601 format. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The date the program was checked out. The date uses UTC and is represented in the ISO8601 format. */
  checkedOutAt?: Maybe<Scalars['Time']['output']>;
  /** The date the program was created. The date uses UTC and is represented in the ISO8601 format. */
  createdAt: Scalars['Time']['output'];
  /** The unique identifier for the program */
  id: Scalars['String']['output'];
  /** Invoices created for this program, if any. This corresponds to the data returned from the /v1/invoices endpoint */
  invoices: Array<AscendInvoice>;
  /** Financing details for this program, if any. This corresponds to the data returned from the /v1/loans endpoint */
  loans: Array<AscendLoan>;
  /** A URL to complete the checkout process. */
  programUrl: Scalars['String']['output'];
  /** The payment option chosen by the insured during the checkout process. */
  selectedPaymentOptionType?: Maybe<PaymentOptionType>;
  /** The state of the program */
  status: AscendProgramStatus;
  /** The date the program was last updated. The date uses UTC and is represented in the ISO8601 format. */
  updatedAt: Scalars['Time']['output'];
};

/** Mode for creating an Ascend program */
export enum AscendProgramCreationMode {
  /** Bundle with an existing quote */
  BundleWithExistingQuote = 'BUNDLE_WITH_EXISTING_QUOTE',
  /** Create a new program */
  CreateProgram = 'CREATE_PROGRAM',
  /** Use a specific program ID */
  UseSpecificProgramId = 'USE_SPECIFIC_PROGRAM_ID'
}

/** The status of a program */
export enum AscendProgramStatus {
  Archived = 'ARCHIVED',
  CheckedOut = 'CHECKED_OUT',
  Created = 'CREATED',
  Elected = 'ELECTED',
  Purchased = 'PURCHASED',
  ReadyForCheckout = 'READY_FOR_CHECKOUT'
}

/** The type of the Ascend recipient */
export enum AscendRecipientType {
  Account = 'ACCOUNT',
  Carrier = 'CARRIER',
  Organization = 'ORGANIZATION',
  Wholesaler = 'WHOLESALER'
}

/** An insurance wholesaler or MGA. */
export type AscendWholesaler = {
  __typename?: 'AscendWholesaler';
  /** A human readable unique identifier. */
  id: Scalars['String']['output'];
  /** The wholesaler display name. */
  title: Scalars['String']['output'];
};

export type AvailableCoverageLimit = {
  __typename?: 'AvailableCoverageLimit';
  insuranceType: InsuranceType;
  limits: BusinessApplicationInsuranceLimits;
};

/** BasicAuth contains username/password credentials */
export type BasicAuth = {
  __typename?: 'BasicAuth';
  /** Password for basic authentication */
  password: Scalars['String']['output'];
  /** Username for basic authentication */
  username: Scalars['String']['output'];
};

/** BearerAuth contains a bearer token for authentication */
export type BearerAuth = {
  __typename?: 'BearerAuth';
  /** Bearer token for authentication */
  token: Scalars['String']['output'];
};

/** A blanket additional insured for the certificate */
export type BlanketAdditionalInsuredCertificateOption = {
  __typename?: 'BlanketAdditionalInsuredCertificateOption';
  /** The description of the blanket additional insured */
  description: Scalars['String']['output'];
  /** The ID of the blanket additional insured */
  id: Scalars['ID']['output'];
  /** The policy this blanket additional insured is associated with */
  policy: BusinessPolicy;
  /** The type of the blanket additional insured */
  type: Scalars['String']['output'];
};

/** Represents the construction type of a building. */
export enum BuildingConstructionType {
  /** A fire resistive construction type. */
  FireResistive = 'FIRE_RESISTIVE',
  /** A frame construction type. */
  Frame = 'FRAME',
  /** A joisted masonry construction type. */
  JoistedMasonry = 'JOISTED_MASONRY',
  /** A masonry non-combustible construction type. */
  MasonryNonCombustible = 'MASONRY_NON_COMBUSTIBLE',
  /** A modified fire resistive construction type. */
  ModifiedFireResistive = 'MODIFIED_FIRE_RESISTIVE',
  /** A non-combustible construction type. */
  NonCombustible = 'NON_COMBUSTIBLE'
}

/** Represents the building location ownership type */
export enum BuildingOwnershipType {
  /** The building is a home that is owned by the business. */
  Home = 'HOME',
  /** The building is leased by the business. */
  Leased = 'LEASED',
  /** The building is owned by the business. */
  Owned = 'OWNED'
}

/** Represents the type of roof on a building. */
export enum BuildingRoofType {
  /** Asphalt shingles roof type. */
  AsphaltShingles = 'ASPHALT_SHINGLES',
  /** Built-up gravel roof type. */
  BuiltUpGravel = 'BUILT_UP_GRAVEL',
  /** Built-up without gravel roof type. */
  BuiltUpWithoutGravel = 'BUILT_UP_WITHOUT_GRAVEL',
  /** Clay tiles roof type. */
  ClayTiles = 'CLAY_TILES',
  /** Foam roof type. */
  Foam = 'FOAM',
  /** Metal roof type. */
  Metal = 'METAL',
  /** Modified bitumen roof type. */
  ModifiedBitumen = 'MODIFIED_BITUMEN',
  /** Single-ply ballasted roof type. */
  SinglePlyBallasted = 'SINGLE_PLY_BALLASTED',
  /** Single-ply PVC TPO roof type. */
  SinglePlyPvcTpo = 'SINGLE_PLY_PVC_TPO',
  /** Single-ply SPDM rubber roof type. */
  SinglePlySpdmRubber = 'SINGLE_PLY_SPDM_RUBBER',
  /** Wood shingles roof type. */
  WoodShingles = 'WOOD_SHINGLES'
}

/** Represents the type of burglar alarm installed at a business location. */
export enum BurglarAlarmType {
  /** A central burglar alarm type. */
  BurglarCentral = 'BURGLAR_CENTRAL',
  /** A local burglar alarm type. */
  BurglarLocal = 'BURGLAR_LOCAL',
  /** No burglar alarm. */
  BurglarNone = 'BURGLAR_NONE',
  /** A police and fire burglar alarm type. */
  BurglarPoliceFire = 'BURGLAR_POLICE_FIRE'
}

/** A business entity associated with a client */
export type Business = {
  __typename?: 'Business';
  /** The business category that determines risk classification and insurance requirements */
  category?: Maybe<BusinessCategory>;
  /** When the business record was created */
  createdAt: Scalars['Time']['output'];
  /** The 'Doing Business As' (DBA) name if different from legal name */
  dba: Scalars['String']['output'];
  /** Unique identifier for the business */
  id: Scalars['ID']['output'];
  /** The business's mailing address for correspondence */
  mailingAddress: Address;
  /** The NAICS code for the business */
  naics: Scalars['String']['output'];
  /** The legal name of the business */
  name: Scalars['String']['output'];
  /** When the business record was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The business's website URL */
  website: Scalars['String']['output'];
};

/** Account details specific to a business account */
export type BusinessAccount = AccountDetails & {
  __typename?: 'BusinessAccount';
  /** The 'Doing Business As' (DBA) name if different from legal name */
  dba: Scalars['String']['output'];
  /** Primary email address for contacting the business */
  email: Scalars['String']['output'];
  /** Mailing address for the business */
  mailingAddress: Address;
  /** The legal name of the business */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the business */
  phone: Scalars['String']['output'];
  /** Website URL for the business */
  website: Scalars['String']['output'];
};

/** BusinessApplication represents an application */
export type BusinessApplication = {
  __typename?: 'BusinessApplication';
  /** The annual revenue of the business. */
  annualRevenue: Scalars['Float']['output'];
  /** The 'doing business as' name of the business. */
  businessDba: Scalars['String']['output'];
  /** The name of the business. */
  businessName: Scalars['String']['output'];
  /** The primary contact information for the business. */
  contact: BusinessContact;
  /** CoverForce applications associated with this application */
  coverforceApplications: Array<CoverforceApplication>;
  /** The date the application was originally created */
  createdAt: Scalars['Time']['output'];
  /** Information about the employees at the business */
  employeeInfo: BusinessEmployeeInfo;
  /** The Federal Employer Identification Number of the business. */
  fein: Scalars['String']['output'];
  /** SHA-256 hash of the application data */
  fingerprint: Scalars['String']['output'];
  /** The ID of the business application */
  id: Scalars['ID']['output'];
  /** The desired effective date of the insurance. */
  insuranceEffectiveAt?: Maybe<Scalars['Time']['output']>;
  /** The types of insurance the business is applying for. */
  insuranceTypes: Array<InsuranceType>;
  /** Indicates whether the business is a non-profit organization. */
  isNonProfit: Scalars['Boolean']['output'];
  /** The legal entity type of the business. */
  legalEntityType?: Maybe<BusinessLegalEntityType>;
  /** List of locations associated with the business. */
  locations: Array<BusinessLocation>;
  /** The mailing address of the business. */
  mailingAddress: Address;
  /** The North American Industry Classification System code of the business. */
  naicsCode: Scalars['String']['output'];
  /** A description of the nature of the business. */
  natureOfBusiness: Scalars['String']['output'];
  /** Information about the business owners. */
  owners: Array<BusinessOwner>;
  /** Any past policy losses */
  pastPolicyLosses: Array<PastPolicyLoss>;
  /**
   * Carriers that will quote one or more coverages for this application.
   * Can only be queried after the application has been completed.
   */
  quotableCarriers: Array<InsuranceCarrier>;
  /** Current quotes for this application, if any are available. */
  quotes: Array<BusinessApplicationQuote>;
  /** Carriers selected by the customer to generate quotes for. */
  selectedCarriers: Array<BusinessApplicationCarrier>;
  /** The selected insurance limits for the application. */
  selectedLimits: BusinessApplicationInsuranceLimits;
  /** State of the application */
  state: BusinessApplicationState;
  /** Answers to underwriting questions. */
  underwritingAnswers: Array<UnderwritingAnswer>;
  /** Underwriting questions needed on this application. */
  underwritingQuestions: Array<UnderwritingQuestion>;
  /** Underwriting statements and disclosures that the insured needs to acknowledge. */
  underwritingStatements: Array<UnderwritingStatement>;
  /** The date this application was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this application */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this application, subject to the specified limit and offset.
   * The first version in this list will be this version (i.e. identical to the current application), followed by the version before that, and so-forth.
   */
  versionHistory: Array<BusinessApplicationVersion>;
  /** The website of the business. */
  website: Scalars['String']['output'];
  /** The year the business was founded. */
  yearOfFounding: Scalars['String']['output'];
  /** The number of years of management experience the business has. */
  yearsOfManagementExperience: Scalars['Int']['output'];
};

/** BusinessApplication represents an application */
export type BusinessApplicationVersionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum BusinessApplicationCarrier {
  Amtrust = 'AMTRUST',
  Biberk = 'BIBERK',
  Chubb = 'CHUBB',
  Cna = 'CNA',
  Coalition = 'COALITION',
  Coterie = 'COTERIE',
  Employers = 'EMPLOYERS',
  Gaig = 'GAIG',
  Guard = 'GUARD',
  Hiscox = 'HISCOX',
  Libertymutual = 'LIBERTYMUTUAL',
  Markel = 'MARKEL',
  Nationwide = 'NATIONWIDE',
  Next = 'NEXT',
  Progressive = 'PROGRESSIVE',
  Travelers = 'TRAVELERS'
}

export type BusinessApplicationInsuranceLimits = {
  __typename?: 'BusinessApplicationInsuranceLimits';
  bopAggregateLimit?: Maybe<Scalars['Float']['output']>;
  bopPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  coverageState: Scalars['String']['output'];
  cyberAggregateLimit?: Maybe<Scalars['Float']['output']>;
  cyberRetentionLimit?: Maybe<Scalars['Float']['output']>;
  glAggregateLimit?: Maybe<Scalars['Float']['output']>;
  glPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  wcPerAccidentLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseaseEmployeeLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseasePolicyLimit?: Maybe<Scalars['Float']['output']>;
};

export type BusinessApplicationInsuranceLimitsInput = {
  bopAggregateLimit?: InputMaybe<Scalars['Float']['input']>;
  bopPerOccurrenceLimit?: InputMaybe<Scalars['Float']['input']>;
  coverageState: Scalars['String']['input'];
  cyberAggregateLimit?: InputMaybe<Scalars['Float']['input']>;
  cyberRetentionLimit?: InputMaybe<Scalars['Float']['input']>;
  glAggregateLimit?: InputMaybe<Scalars['Float']['input']>;
  glPerOccurrenceLimit?: InputMaybe<Scalars['Float']['input']>;
  wcPerAccidentLimit?: InputMaybe<Scalars['Float']['input']>;
  wcPerDiseaseEmployeeLimit?: InputMaybe<Scalars['Float']['input']>;
  wcPerDiseasePolicyLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type BusinessApplicationQuote = {
  __typename?: 'BusinessApplicationQuote';
  /** The carrier that has offered this quote */
  carrier: BusinessApplicationCarrier;
  /** The link to the carrier portal to view and modify the quote */
  carrierBridgingLink?: Maybe<Scalars['String']['output']>;
  /** The link to the carrier portal to bind and claim the policy */
  carrierPurchaseLink?: Maybe<Scalars['String']['output']>;
  /** The ID of the quote in the carrier system */
  carrierQuoteId: Scalars['String']['output'];
  /** The ID of the quote */
  id: Scalars['String']['output'];
  /** The effective date of the insurance */
  insuranceEffectiveDate: Scalars['Time']['output'];
  /** The expiration date of the insurance */
  insuranceExpiryDate: Scalars['Time']['output'];
  /** List of payment plans available for this quote if the quote is bindable */
  paymentPlans: Array<BusinessApplicationQuotePaymentPlan>;
  /** If this policy is binding, the policy ID from the carrier system. */
  policyId?: Maybe<Scalars['String']['output']>;
  /** The type of insurance policy */
  policyType: InsuranceType;
  /** The premium amount for the policy */
  premiumAmount: Scalars['Float']['output'];
  /** The URL of the quote proposal PDF */
  quoteProposalUrl?: Maybe<Scalars['String']['output']>;
  /** The state of the quote */
  state: BusinessApplicationQuoteState;
  /** The tax amount for the policy */
  taxAmount: Scalars['Float']['output'];
  /** The total amount for the policy */
  totalAmount: Scalars['Float']['output'];
  /** The type of quote */
  type: BusinessApplicationQuoteType;
};

/** Type representing a payment plan for a business application quote */
export type BusinessApplicationQuotePaymentPlan = {
  __typename?: 'BusinessApplicationQuotePaymentPlan';
  /** Description of the payment plan */
  description: Scalars['String']['output'];
  /** Initial down payment amount */
  downAmount: Scalars['Float']['output'];
  /** Due date for the down payment */
  downDueAt?: Maybe<Scalars['Time']['output']>;
  /** Amount for each installment */
  installmentAmount: Scalars['Float']['output'];
  /** Number of installments */
  installmentCount: Scalars['Int']['output'];
  /** Due date for the installments */
  installmentDueAt?: Maybe<Scalars['Time']['output']>;
  /** Fee charged for each installment */
  installmentFee: Scalars['Float']['output'];
  /** Frequency of the installments */
  installmentFrequency: PaymentPlanInstallmentFrequency;
  /** Method of payment for the plan */
  paymentMethod: PaymentPlanPaymentMethodType;
  /** Unique identifier for the payment plan */
  paymentPlanId: Scalars['String']['output'];
  /** Title of the payment plan */
  title: Scalars['String']['output'];
  /** Total amount to be paid */
  totalAmount: Scalars['Float']['output'];
  /** Total fees associated with the payment plan */
  totalFees: Scalars['Float']['output'];
};

/** Enum representing the possible states of a business application quote */
export enum BusinessApplicationQuoteState {
  /** The quote is in the process of being bound */
  Binding = 'BINDING',
  /** The quote has been created */
  Created = 'CREATED'
}

/** Enum representing the different types of quotes for a business application */
export enum BusinessApplicationQuoteType {
  /** Quote that can be bound online */
  BindOnline = 'BIND_ONLINE',
  /** Quote that serves as a bridge between different stages */
  Bridge = 'BRIDGE',
  /** Quote that has been declined */
  Decline = 'DECLINE',
  /** Quote that has failed for some reason */
  Failed = 'FAILED',
  /** Quote that needs to be referred for further review */
  Refer = 'REFER'
}

/** The state of business application */
export enum BusinessApplicationState {
  /** The application has been canceled and is no longer active */
  Canceled = 'CANCELED',
  /** The application has been created but no further action has been taken */
  Created = 'CREATED',
  /** A quote has been generated for the application */
  Quoted = 'QUOTED',
  /** The application is in the process of being quoted */
  Quoting = 'QUOTING',
  /** The application has been submitted for review or processing */
  Submitted = 'SUBMITTED'
}

/** Describes the reason why an application was updated */
export enum BusinessApplicationUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a application */
export enum BusinessApplicationUpdateType {
  /** The application was canceled and is no longer active */
  CancelApplication = 'CANCEL_APPLICATION',
  /** The application was created, either directely or by completing an offer */
  CreateApplication = 'CREATE_APPLICATION',
  /** The application was completed and submitted, and is now ready to be reviewed by the carrier */
  SubmitApplication = 'SUBMIT_APPLICATION',
  /** The application was updated. Requires manual inspection of the application to determine the actual update */
  UpdateApplication = 'UPDATE_APPLICATION'
}

/** Describes a particular version of an application */
export type BusinessApplicationVersion = {
  __typename?: 'BusinessApplicationVersion';
  /** The full application object that includes all of the updates made in this version and all previous versions */
  businessApplication: BusinessApplication;
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another application version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous application version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<BusinessApplicationVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<BusinessApplicationUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<BusinessApplicationUpdateType>;
  /** The version number of this application version */
  version: Scalars['Int64']['output'];
};

/** A business category */
export type BusinessCategory = {
  __typename?: 'BusinessCategory';
  /** The category */
  category: Scalars['String']['output'];
  /** The full path of the category, starting with the root category and including the category itself */
  categoryPath: Array<Scalars['String']['output']>;
  /** The ID of the category */
  id: Scalars['ID']['output'];
  /** The parent category */
  parent?: Maybe<BusinessCategory>;
  /** The risk score of the category */
  riskScore: Scalars['Float']['output'];
};

/** Represents a contact person for the business. */
export type BusinessContact = {
  __typename?: 'BusinessContact';
  /** The email address of the contact person. */
  email: Scalars['String']['output'];
  /** The name of the contact person. */
  fullName: Scalars['String']['output'];
  /** The phone number of the contact person. */
  phone: Scalars['String']['output'];
};

/** Represents a contact person for the business. */
export type BusinessContactInput = {
  /** The email address of the contact person. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The name of the contact person. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the contact person. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Represents information about the employees at a business location. */
export type BusinessEmployeeInfo = {
  __typename?: 'BusinessEmployeeInfo';
  /** The job code ID associated with the employees. */
  jobCode: Scalars['String']['output'];
  /** The number of full-time employees at the business location. */
  numFullTimeEmployees: Scalars['Int']['output'];
  /** The number of part-time employees at the business location. */
  numPartTimeEmployees: Scalars['Int']['output'];
  /** The total payroll amount for all employees at the business location. */
  totalEmployeePayroll: Scalars['Float']['output'];
};

/** Represents information about the employees at a business location. */
export type BusinessEmployeeInfoInput = {
  /** The job code ID associated with the employees. */
  jobCode?: InputMaybe<Scalars['String']['input']>;
  /** The number of full-time employees at the business location. */
  numFullTimeEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** The number of part-time employees at the business location. */
  numPartTimeEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** The total payroll amount for all employees at the business location. */
  totalEmployeePayroll?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents the legal entity type of a business. */
export enum BusinessLegalEntityType {
  /** An association. */
  Association = 'ASSOCIATION',
  /** A corporation. */
  Corporation = 'CORPORATION',
  /** An estate. */
  Estate = 'ESTATE',
  /** An executor. */
  Executor = 'EXECUTOR',
  /** A general partnership. */
  GeneralPartnership = 'GENERAL_PARTNERSHIP',
  /** A government entity. */
  GovernmentEntity = 'GOVERNMENT_ENTITY',
  /** An individual. */
  Individual = 'INDIVIDUAL',
  /** Joint employers. */
  JointEmployers = 'JOINT_EMPLOYERS',
  /** A joint venture. */
  JointVenture = 'JOINT_VENTURE',
  /** A labor union. */
  LaborUnion = 'LABOR_UNION',
  /** A limited liability company. */
  LimitedLiabilityCompany = 'LIMITED_LIABILITY_COMPANY',
  /** A limited liability partnership. */
  LimitedLiabilityPartnership = 'LIMITED_LIABILITY_PARTNERSHIP',
  /** A limited partnership. */
  LimitedPartnership = 'LIMITED_PARTNERSHIP',
  /** Multiple statuses. */
  MultipleStatus = 'MULTIPLE_STATUS',
  /** A non-profit association. */
  NonProfitAssociation = 'NON_PROFIT_ASSOCIATION',
  /** A non-profit corporation. */
  NonProfitCorporation = 'NON_PROFIT_CORPORATION',
  /** An S corporation. */
  SCorporation = 'S_CORPORATION',
  /** Tenants in common. */
  TenantsInCommon = 'TENANTS_IN_COMMON',
  /** A trust. */
  Trust = 'TRUST'
}

/** Represents a business location. */
export type BusinessLocation = {
  __typename?: 'BusinessLocation';
  /** The address of the business location. */
  address: Address;
  /** Information about the building of the business location. */
  buildingInfo: BusinessLocationBuildingInfo;
  /** Information about the employees at the business location. */
  employeeInfo: BusinessEmployeeInfo;
  /** The unique identifier of the business location. */
  id: Scalars['ID']['output'];
  /** Indicates whether this is the primary business location. */
  isPrimary: Scalars['Boolean']['output'];
};

/** Represents information about the building of a business location. */
export type BusinessLocationBuildingInfo = {
  __typename?: 'BusinessLocationBuildingInfo';
  /** The annual sales of the business location. */
  annualSales: Scalars['Float']['output'];
  /** The area occupied by the business. */
  areaOccupiedByBusiness: Scalars['Float']['output'];
  /** The building coverage amount. */
  buildingCoverage: Scalars['Float']['output'];
  /** The type of burglar alarm installed at the business location. */
  burglarAlarmType?: Maybe<BurglarAlarmType>;
  /** The construction type of the building. */
  constructionType?: Maybe<BuildingConstructionType>;
  /** The year the electrical wiring was last updated. */
  electricalWiringUpdateYear: Scalars['String']['output'];
  /** The year the heating system was last updated. */
  heatingUpdateYear: Scalars['String']['output'];
  /** The type of ownership of this business location. */
  ownershipType?: Maybe<BuildingOwnershipType>;
  /** The personal property coverage amount. */
  personalPropertyCoverage: Scalars['Float']['output'];
  /** The year the plumbing system was last updated. */
  plumbingUpdateYear: Scalars['String']['output'];
  /** The type of roof on the building. */
  roofType?: Maybe<BuildingRoofType>;
  /** The year the roof was last updated. */
  roofUpdateYear: Scalars['String']['output'];
  /** The percentage of the building that is sprinklered. */
  sprinkleredPercentage: Scalars['Float']['output'];
  /** The total area of the building. */
  totalArea: Scalars['Float']['output'];
  /** The total number of stories in the building. */
  totalStories: Scalars['Int']['output'];
  /** The year the building was built. */
  yearBuilt: Scalars['String']['output'];
};

/** Represents information about the building of a business location. */
export type BusinessLocationBuildingInfoInput = {
  /** The annual sales of the business location. */
  annualSales?: InputMaybe<Scalars['Float']['input']>;
  /** The area occupied by the business. */
  areaOccupiedByBusiness?: InputMaybe<Scalars['Float']['input']>;
  /** The building coverage amount. */
  buildingCoverage?: InputMaybe<Scalars['Float']['input']>;
  /** The type of burglar alarm installed at the business location. */
  burglarAlarmType?: InputMaybe<BurglarAlarmType>;
  /** The construction type of the building. */
  constructionType?: InputMaybe<BuildingConstructionType>;
  /** The year the electrical wiring was last updated. */
  electricalWiringUpdateYear?: InputMaybe<Scalars['String']['input']>;
  /** The year the heating system was last updated. */
  heatingUpdateYear?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the business owns the building. */
  ownershipType?: InputMaybe<BuildingOwnershipType>;
  /** The personal property coverage amount. */
  personalPropertyCoverage?: InputMaybe<Scalars['Float']['input']>;
  /** The year the plumbing system was last updated. */
  plumbingUpdateYear?: InputMaybe<Scalars['String']['input']>;
  /** The type of roof on the building. */
  roofType?: InputMaybe<BuildingRoofType>;
  /** The year the roof was last updated. */
  roofUpdateYear?: InputMaybe<Scalars['String']['input']>;
  /** The percentage of the building that is sprinklered. */
  sprinkleredPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** The total area of the building. */
  totalArea?: InputMaybe<Scalars['Float']['input']>;
  /** The total number of stories in the building. */
  totalStories?: InputMaybe<Scalars['Int']['input']>;
  /** The year the building was built. */
  yearBuilt?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating or updating a business location. */
export type BusinessLocationInput = {
  /** The physical address of the business location. */
  address: AddressInput;
  /** Information about the building at this location. */
  buildingInfo: BusinessLocationBuildingInfoInput;
  /** Information about employees at this location. */
  employeeInfo: BusinessEmployeeInfoInput;
  /** Unique identifier for the business location. */
  id: Scalars['String']['input'];
  /** Whether this is the primary business location. */
  isPrimary: Scalars['Boolean']['input'];
};

/** Represents an owner of the business. */
export type BusinessOwner = {
  __typename?: 'BusinessOwner';
  /** The annual payroll of the business owner. */
  annualPayroll: Scalars['Float']['output'];
  /** The date of birth of the business owner. */
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  /** The full name of the business owner. */
  fullName: Scalars['String']['output'];
  /** The job code associated with the business owner. */
  jobCode?: Maybe<Scalars['String']['output']>;
  /** The location ID associated with the business owner. */
  locationId: Scalars['String']['output'];
};

/** Represents an owner of the business. */
export type BusinessOwnerInput = {
  /** The annual payroll of the business owner. */
  annualPayroll: Scalars['Float']['input'];
  /** The date of birth of the business owner. */
  dateOfBirth: Scalars['String']['input'];
  /** The full name of the business owner. */
  fullName: Scalars['String']['input'];
  /** The job code of the business owner. */
  jobCode: Scalars['String']['input'];
};

/** Business Policy represents the business or commercial insurance policy */
export type BusinessPolicy = {
  __typename?: 'BusinessPolicy';
  /** The account this policy is associated with */
  account: Account;
  /** The agency user that sources or owns the policy */
  agencyUser: AgencyUser;
  /** The broker providing this policy, if any */
  broker?: Maybe<InsuranceCarrier>;
  /** If the policy was canceled or nonrenewed, information about the latest instance of cancellation or nonrenewal */
  cancellation?: Maybe<BusinessPolicyCancellation>;
  /** The carrier providing this policy */
  carrier: InsuranceCarrier;
  /** The date the policy object was originally created */
  createdAt: Scalars['Time']['output'];
  /** Detailed information extracted from the policy document, if available */
  details?: Maybe<BusinessPolicyExtractedDetails>;
  /** The timestamp when this policy expires */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /** All attached files for this policy */
  files: Array<File>;
  /** The internal ID of the policy */
  id: Scalars['ID']['output'];
  /** The timestamp when this policy is inforce */
  inforceAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when this policy was issued */
  issuedAt?: Maybe<Scalars['Time']['output']>;
  /** The market this policy was written in */
  market: InsuranceMarket;
  /** The number or external identifier associated with this policy within the carrier system */
  policyNumber: Scalars['String']['output'];
  /** The pricing information for this policy */
  pricing: BusinessPolicyPricing;
  /** The number or external identifier associated with this quote within the carrier system */
  quoteNumber: Scalars['String']['output'];
  /** If the policy was reinstated, information about the latest instance of when it was reinstated */
  reinstatement?: Maybe<BusinessPolicyReinstatement>;
  /** If this policy was renewed from another policy, information about the renewal and its previous versions */
  renewal?: Maybe<BusinessPolicyRenewal>;
  /** The current state of the policy */
  state: PolicyState;
  /** The type of insurance this policy represents */
  type: InsuranceType;
  /** The date this policy object was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this policy */
  version: Scalars['Int64']['output'];
  /** The previous versions of this policy. The first version in this list will be this version (i.e. identical to the current policy), followed by the version before that, and so-forth. */
  versionHistory?: Maybe<Array<BusinessPolicyVersion>>;
};

/** Details about agency billing for a business policy */
export type BusinessPolicyAgencyBilling = {
  __typename?: 'BusinessPolicyAgencyBilling';
  /** Details about Ascend billable, if applicable */
  ascendBillable?: Maybe<AscendBillable>;
  /** Details about Ascend program, if applicable */
  ascendProgram?: Maybe<AscendProgram>;
  /** The type of agency billing used */
  type: BusinessPolicyAgencyBillingType;
};

/** The type of agency billing used for the policy */
export enum BusinessPolicyAgencyBillingType {
  /** Billing is handled through Ascend */
  Ascend = 'ASCEND',
  /** Billing is handled manually */
  Manual = 'MANUAL'
}

/** The billing type of policy, indicating how the policy is billed */
export enum BusinessPolicyBillingType {
  /** Policy is billed by the agency and then paid to the carrier */
  Agency = 'AGENCY',
  /** Policy is billed directly by the carrier */
  Direct = 'DIRECT',
  /** Billing type is unknown or not specified */
  Unknown = 'UNKNOWN'
}

/** A blanket additional insured for the policy */
export type BusinessPolicyBlanketAdditionalInsured = {
  __typename?: 'BusinessPolicyBlanketAdditionalInsured';
  /** The description of the blanket additional insured */
  description: Scalars['String']['output'];
  /** The form numbers that reference the blanket additional insured */
  formNumbers: Array<Scalars['String']['output']>;
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the blanket additional insured is included */
  reasoning: Scalars['String']['output'];
  /** The type of the blanket additional insured */
  type: Scalars['String']['output'];
};

/** Detailed information about a policy cancellation */
export type BusinessPolicyCancellation = {
  __typename?: 'BusinessPolicyCancellation';
  /** The date and time when the cancellation was initiated */
  canceledAt: Scalars['Time']['output'];
  /** The entity that initiated the cancellation */
  canceledBy: BusinessPolicyCancellationSource;
  /** The date and time when the cancellation becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** The reason for the cancellation */
  reason: BusinessPolicyCancellationReason;
  /** A detailed description of the cancellation reason */
  reasonDescription: Scalars['String']['output'];
  /** The commission that the agency will return to the carrier or broker */
  returnCommission: Scalars['Float']['output'];
  /** The premium that the agency will return to the customer */
  returnPremium: Scalars['Float']['output'];
  /** The type of cancellation */
  type: BusinessPolicyCancellationType;
};

/** The reason for policy cancellation */
export enum BusinessPolicyCancellationReason {
  /** Agency found better coverage for the insured */
  AgencyFoundBetterCoverage = 'AGENCY_FOUND_BETTER_COVERAGE',
  /** Agency found a better price for the insured */
  AgencyFoundBetterPrice = 'AGENCY_FOUND_BETTER_PRICE',
  /** Carrier closed the insurance class */
  CarrierClosedClass = 'CARRIER_CLOSED_CLASS',
  /** Cancellation due to loss history */
  CarrierLossHistory = 'CARRIER_LOSS_HISTORY',
  /** Carrier cancelled due to non-payment */
  CarrierNonpayment = 'CARRIER_NONPAYMENT',
  /** Carrier's underwriting decision */
  CarrierUnderwritingReason = 'CARRIER_UNDERWRITING_REASON',
  /** Insured closed their business */
  InsuredClosedBusiness = 'INSURED_CLOSED_BUSINESS',
  /** Insured found better coverage elsewhere */
  InsuredFoundBetterCoverage = 'INSURED_FOUND_BETTER_COVERAGE',
  /** Insured found a better price elsewhere */
  InsuredFoundBetterPrice = 'INSURED_FOUND_BETTER_PRICE',
  /** Insured failed to make payments */
  InsuredNonpayment = 'INSURED_NONPAYMENT',
  /** Insured no longer has exposure requiring coverage */
  InsuredNoExposure = 'INSURED_NO_EXPOSURE',
  /** Other unspecified reason */
  Other = 'OTHER'
}

/** The source of the policy cancellation */
export enum BusinessPolicyCancellationSource {
  /** Cancellation initiated by the agency */
  Agency = 'AGENCY',
  /** Cancellation initiated by the carrier */
  Carrier = 'CARRIER',
  /** Cancellation initiated by the insured */
  Insured = 'INSURED'
}

/** The type of policy cancellation */
export enum BusinessPolicyCancellationType {
  /** Standard cancellation of the policy */
  Cancellation = 'CANCELLATION',
  /** Non-renewal of the policy */
  Nonrenewal = 'NONRENEWAL',
  /** Expiration of the quote without conversion to a policy */
  QuoteExpired = 'QUOTE_EXPIRED'
}

/** Description of a policy coverage or exclusion */
export type BusinessPolicyCoverageOrExclusionDescription = {
  __typename?: 'BusinessPolicyCoverageOrExclusionDescription';
  /** The description of the coverage or exclusion */
  description: Scalars['String']['output'];
  /** Supporting quotes from the policy document */
  policyQuotes: Array<Scalars['String']['output']>;
  /** The title of the coverage or exclusion */
  title: Scalars['String']['output'];
};

/** An endorsement for the policy */
export type BusinessPolicyEndorsement = {
  __typename?: 'BusinessPolicyEndorsement';
  /** The form numbers that reference the endorsement */
  formNumbers: Array<Scalars['String']['output']>;
  /** Whether the endorsement is included */
  included: Scalars['Boolean']['output'];
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the endorsement is included */
  reasoning: Scalars['String']['output'];
};

/** The endorsements for the policy */
export type BusinessPolicyEndorsements = {
  __typename?: 'BusinessPolicyEndorsements';
  /** Whether the primary and non-contributory coverage endorsement is included */
  primaryAndNonContributoryCoverage: BusinessPolicyEndorsement;
  /** Whether the waiver of subrogation endorsement is included */
  waiverOfSubrogation: BusinessPolicyEndorsement;
};

/** Entity involved in the policy */
export type BusinessPolicyEntity = {
  __typename?: 'BusinessPolicyEntity';
  /** The address of the entity */
  address: Address;
  /** The name of the entity */
  name: Scalars['String']['output'];
};

/** Extra limits for the policy, not covered by the standard limits */
export type BusinessPolicyExtraInsuranceLimit = {
  __typename?: 'BusinessPolicyExtraInsuranceLimit';
  /** The limit for the extra coverage */
  limit: Scalars['Float']['output'];
  /** The name of the limit */
  name: Scalars['String']['output'];
};

/** Policy details extracted from the policy document */
export type BusinessPolicyExtractedDetails = {
  __typename?: 'BusinessPolicyExtractedDetails';
  /** The blanket additional insureds for the policy */
  blanketAdditionalInsureds: Array<BusinessPolicyBlanketAdditionalInsured>;
  /** The carrier on the policy */
  carrier?: Maybe<BusinessPolicyEntity>;
  /** The carrier's NAIC code */
  carrierNaic?: Maybe<Scalars['String']['output']>;
  /** The coverage descriptions for the policy */
  coverageDescriptions: Array<BusinessPolicyCoverageOrExclusionDescription>;
  /** The deductible for the policy */
  deductible?: Maybe<Scalars['Float']['output']>;
  /** The endorsements for the policy */
  endorsements: BusinessPolicyEndorsements;
  /** The exclusion descriptions for the policy */
  exclusionDescriptions: Array<BusinessPolicyCoverageOrExclusionDescription>;
  /** Extra limits for the policy, not covered by the standard limits */
  extraLimits: Array<BusinessPolicyExtraInsuranceLimit>;
  /** The insured on the policy */
  insured?: Maybe<BusinessPolicyEntity>;
  /** The limits for the policy */
  limits: BusinessPolicyInsuranceLimits;
  /** The insured locations for the policy */
  locations: Array<BusinessPolicyLocation>;
  /** The named additional insureds for the policy */
  namedAdditionalInsureds: Array<BusinessPolicyNamedAdditionalInsured>;
  /** The policy number */
  policyNumber?: Maybe<Scalars['String']['output']>;
  /** A summary of the policy details */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Limits for the policy. The policy has the coverage and associated limit if the value is non null or zero. */
export type BusinessPolicyInsuranceLimits = {
  __typename?: 'BusinessPolicyInsuranceLimits';
  cyberAggregateLimit?: Maybe<Scalars['Float']['output']>;
  cyberRetentionLimit?: Maybe<Scalars['Float']['output']>;
  glAggregateLimit?: Maybe<Scalars['Float']['output']>;
  glMedicalPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  glMedicalPerPersonLimit?: Maybe<Scalars['Float']['output']>;
  glPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  glPersonalAndAdvertisingInjuryLimit?: Maybe<Scalars['Float']['output']>;
  glProductsAndCompletedOperationsLimit?: Maybe<Scalars['Float']['output']>;
  glRentedPremisesDamageLimit?: Maybe<Scalars['Float']['output']>;
  propertyBuildingLimit?: Maybe<Scalars['Float']['output']>;
  propertyContentsLimit?: Maybe<Scalars['Float']['output']>;
  umbrellaOrExcessAggregateLimit?: Maybe<Scalars['Float']['output']>;
  umbrellaOrExcessPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  wcPerAccidentLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseaseEmployeeLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseasePolicyLimit?: Maybe<Scalars['Float']['output']>;
};

/** A location covered by the business policy */
export type BusinessPolicyLocation = {
  __typename?: 'BusinessPolicyLocation';
  /** The address of the location */
  address: Address;
  /** The limits for the location */
  limits: BusinessPolicyInsuranceLimits;
};

/** A named additional insured for the policy */
export type BusinessPolicyNamedAdditionalInsured = {
  __typename?: 'BusinessPolicyNamedAdditionalInsured';
  /** The address of the named additional insured */
  address: Address;
  /** The form numbers that reference the named additional insured */
  formNumbers: Array<Scalars['String']['output']>;
  /** The type of the named additional insured */
  name: Scalars['String']['output'];
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the named additional insured is included */
  reasoning: Scalars['String']['output'];
};

/** Represents all pricing information for a policy */
export type BusinessPolicyPricing = {
  __typename?: 'BusinessPolicyPricing';
  /** The adjusted commission that the agency will receive for this policy, which is the estimated commission minus any returns to the carrier or broker. If the policy is not canceled, this will be nil. */
  adjustedCommission?: Maybe<Scalars['Float']['output']>;
  /** The adjusted premium that the agency will receive for this policy, which is the premium minus any returns to the customer. If the policy is not canceled, this will be nil. */
  adjustedPremium?: Maybe<Scalars['Float']['output']>;
  /** The adjusted revenue that the agency will receive for this policy, which is the estimated revenue minus any returns to the customer. If the policy is not canceled, this will be the same as estimatedRevenue */
  adjustedRevenue: Scalars['Float']['output'];
  /** If billing type is AGENCY, this specifies information about the agency bill */
  agencyBilling?: Maybe<BusinessPolicyAgencyBilling>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['output'];
  /** The billing type */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['output'];
  /** Estimate of the commission the agency will receive for this policy */
  estimatedCommission: Scalars['Float']['output'];
  /** Estimate of the revenue the agency will receive for this policy */
  estimatedRevenue: Scalars['Float']['output'];
  /** The interval type of payment plan. Required if this is a direct-billed policy */
  intervalType?: Maybe<PaymentIntervalType>;
  /** The minimum premium that must be paid for policy, regardless of cancellation, if any */
  minimumEarnedPremium: Scalars['Float']['output'];
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['output'];
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['output'];
  /** The premium for this policy */
  premium: Scalars['Float']['output'];
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['output'];
  /** The total price paid for this policy */
  total: Scalars['Float']['output'];
};

/** Information about a policy reinstatement */
export type BusinessPolicyReinstatement = {
  __typename?: 'BusinessPolicyReinstatement';
  /** The date and time when the reinstatement becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** A description of the reason for reinstatement */
  reasonDescription: Scalars['String']['output'];
  /** The date and time when the reinstatement was processed */
  reinstatedAt: Scalars['Time']['output'];
};

/** Information about policy renewals */
export type BusinessPolicyRenewal = {
  __typename?: 'BusinessPolicyRenewal';
  /** List of policies that renew this policy */
  nextPolicies: Array<BusinessPolicy>;
  /** List of previous policies that this policy renews */
  previousPolicies: Array<BusinessPolicy>;
};

/** Describes the reason why an application was updated */
export enum BusinessPolicyUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a policy */
export enum BusinessPolicyUpdateType {
  /** The policy was canceled and is no longer active */
  CancelPolicy = 'CANCEL_POLICY',
  /** The policy was created */
  CreatePolicy = 'CREATE_POLICY',
  /** The policy expired and its no longer active */
  ExpirePolicy = 'EXPIRE_POLICY',
  /** The policy was set to inforce */
  InforcePolicy = 'INFORCE_POLICY',
  /** The policy was reinstated after previously being canceled */
  ReinstatePolicy = 'REINSTATE_POLICY',
  /** The policy was created as a renewal */
  RenewPolicy = 'RENEW_POLICY',
  /** The policy was updated with new details extracted from the policy document */
  UpdateExtractedDetails = 'UPDATE_EXTRACTED_DETAILS',
  /** The policy was updated. Requires manual inspection of the policy to determine the actual update */
  UpdatePolicy = 'UPDATE_POLICY'
}

/** Describes a particular version of a policy */
export type BusinessPolicyVersion = {
  __typename?: 'BusinessPolicyVersion';
  /** The full policy object that includes all of the updates made in this version and all previous versions */
  businessPolicy: BusinessPolicy;
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another policy version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous policy version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<BusinessPolicyVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<BusinessPolicyUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<BusinessPolicyUpdateType>;
  /** The version number of this policy version */
  version: Scalars['Int64']['output'];
};

/** Represents a phone call recorded through the Retell system */
export type Call = {
  __typename?: 'Call';
  /** The account associated with this call, if any */
  account?: Maybe<Account>;
  /** The agency associated with this call */
  agency: Agency;
  /** The reason the call was disconnected, available once the call has ended */
  disconnectionReason?: Maybe<CallDisconnectionReason>;
  /** The timestamp when the call ended, if completed */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the call in the external call system (currently this is always Retell) */
  externalId: Scalars['String']['output'];
  /** The name of the caller, available once the call has ended */
  fromName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call was from */
  fromNumber: Scalars['String']['output'];
  /** Unique identifier for the call */
  id: Scalars['ID']['output'];
  /** The URL of the recording of the call, available once the call has ended */
  recordingUrl?: Maybe<Scalars['String']['output']>;
  /** The sentiment of the call, available once the call has ended */
  sentiment?: Maybe<CallSentiment>;
  /** The service requests associated with this call, if any */
  serviceRequests: Array<ServiceRequest>;
  /** The timestamp when the call started */
  startedAt: Scalars['Time']['output'];
  /** The status of the call */
  status: CallStatus;
  /** Whether the call was successful, available once the call has ended */
  successful?: Maybe<Scalars['Boolean']['output']>;
  /** A summary of the call, available once the call has ended */
  summary?: Maybe<Scalars['String']['output']>;
  /** The phone number the call was to */
  toNumber: Scalars['String']['output'];
  /** The transcript of the call, available once the call has ended */
  transcript: Array<CallTranscriptObject>;
};

/** The reason why a call was disconnected */
export enum CallDisconnectionReason {
  /** Expected behavior where AI agent hangs up the call */
  AgentHangup = 'AGENT_HANGUP',
  /** Expected behavior where AI agent transferred the call */
  CallTransfer = 'CALL_TRANSFER',
  /** Error where concurrency limit reached - add a retry with exponential backoff or consider enterprise plan */
  ConcurrencyLimitReached = 'CONCURRENCY_LIMIT_REACHED',
  /** The number dialed is busy */
  DialBusy = 'DIAL_BUSY',
  /** Dialing failed, might be due to callee number being non-existent, or the agent number is marked as spam and got blocked */
  DialFailed = 'DIAL_FAILED',
  /** The number dialed did not answer */
  DialNoAnswer = 'DIAL_NO_ANSWER',
  /** Error where Retell's ASR encountered a problem */
  ErrorAsr = 'ERROR_ASR',
  /** Error where frontend audio websocket received unspecified payload */
  ErrorFrontendCorruptedPayload = 'ERROR_FRONTEND_CORRUPTED_PAYLOAD',
  /** Error where system failed to retrieve dynamic variables for inbound phone call */
  ErrorInboundWebhook = 'ERROR_INBOUND_WEBHOOK',
  /** Error where LLM websocket received unspecified payload */
  ErrorLlmWebsocketCorruptPayload = 'ERROR_LLM_WEBSOCKET_CORRUPT_PAYLOAD',
  /** Error where LLM websocket connection broke during the call */
  ErrorLlmWebsocketLostConnection = 'ERROR_LLM_WEBSOCKET_LOST_CONNECTION',
  /** Error where LLM websocket did not open between Retell server and backend, likely because the Custom LLM URL is incorrect or LLM server is not reachable */
  ErrorLlmWebsocketOpen = 'ERROR_LLM_WEBSOCKET_OPEN',
  /** Error where LLM websocket received a closing signal other than 1000 from your server */
  ErrorLlmWebsocketRuntime = 'ERROR_LLM_WEBSOCKET_RUNTIME',
  /** Error where system has not received audio from Twilio or web frontend for a while after connection has established */
  ErrorNoAudioReceived = 'ERROR_NO_AUDIO_RECEIVED',
  /** Error, unspecified Retell side problem */
  ErrorRetell = 'ERROR_RETELL',
  /** Error where Twilio websocket connection between Retell server encountered an error */
  ErrorTwilio = 'ERROR_TWILIO',
  /** Error, unknown error */
  ErrorUnknown = 'ERROR_UNKNOWN',
  /** Error where user did not join web call within 30s after calling startWebCall */
  ErrorUserNotJoined = 'ERROR_USER_NOT_JOINED',
  /** Expected behavior where call was terminated due to the "end_call_after_silence_ms" setting reached after long inactivity */
  Inactivity = 'INACTIVITY',
  /** Expected behavior where call was terminated due to the "drop_call_if_machine_detected" setting triggering when a voicemail or similar is detected */
  MachineDetected = 'MACHINE_DETECTED',
  /** Expected behavior where call was terminated due to maximum duration reached */
  MaxDurationReached = 'MAX_DURATION_REACHED',
  /** Error where no valid payment registered on file, or service shut down due to bill overdue */
  NoValidPayment = 'NO_VALID_PAYMENT',
  /** Error where phone call is 30s or more apart from registering */
  RegisteredCallTimeout = 'REGISTERED_CALL_TIMEOUT',
  /** Error where scam was detected for that particular agent */
  ScamDetected = 'SCAM_DETECTED',
  /** Expected behavior where user hangs up the call */
  UserHangup = 'USER_HANGUP',
  /** Expected behavior where AI agent reached voicemail when voicemail settings were configured */
  VoicemailReached = 'VOICEMAIL_REACHED'
}

/** The sentiment analysis result for a call */
export enum CallSentiment {
  /** The call had an overall negative tone/sentiment */
  Negative = 'NEGATIVE',
  /** The call had a neutral or mixed tone/sentiment */
  Neutral = 'NEUTRAL',
  /** The call had an overall positive tone/sentiment */
  Positive = 'POSITIVE'
}

/** The current status of a call */
export enum CallStatus {
  /** The call has ended */
  Completed = 'COMPLETED',
  /** The call has ended with an error */
  Error = 'ERROR',
  /** The call is in progress */
  InProgress = 'IN_PROGRESS',
  /** The call has been registered with Retell */
  Registered = 'REGISTERED'
}

/** Represents a single utterance or action in the call transcript */
export type CallTranscriptObject = {
  __typename?: 'CallTranscriptObject';
  /** The content of the utterance or tool result */
  content: Scalars['String']['output'];
  /** The duration in seconds of the utterance or tool result */
  durationSeconds: Scalars['Float']['output'];
  /** The role of the participant or action in the transcript */
  role: CallTranscriptRole;
  /** The offset in seconds from the start of the call when the utterance or tool result was spoken or executed */
  startTimeOffsetSeconds: Scalars['Float']['output'];
  /** The arguments passed to the tool in JSON format if this is a tool invocation */
  toolArgumentsJson?: Maybe<Scalars['String']['output']>;
  /** The ID of the tool call if this is a tool invocation or result */
  toolCallId?: Maybe<Scalars['String']['output']>;
  /** The name of the tool being called if this is a tool invocation */
  toolName?: Maybe<Scalars['String']['output']>;
};

/** The role of a participant or action in the call transcript */
export enum CallTranscriptRole {
  /** Represents speech from the AI agent */
  Agent = 'AGENT',
  /** Represents a tool being called by the agent */
  ToolInvocation = 'TOOL_INVOCATION',
  /** Represents the result returned from a tool call */
  ToolResult = 'TOOL_RESULT',
  /** Represents speech from the human user */
  User = 'USER'
}

/** Input for canceling a business policy */
export type CancelBusinessPolicyInput = {
  /** Who initiated the cancellation */
  canceledBy: BusinessPolicyCancellationSource;
  /** When the cancellation becomes effective */
  effectiveAt: Scalars['Time']['input'];
  /** The reason for cancellation */
  reason: BusinessPolicyCancellationReason;
  /** A description of the cancellation reason */
  reasonDescription: Scalars['String']['input'];
  /** The commission amount to be returned */
  returnCommission: Scalars['Float']['input'];
  /** The premium amount to be returned */
  returnPremium: Scalars['Float']['input'];
  /** The type of cancellation */
  type: BusinessPolicyCancellationType;
};

/** Details for a request to cancel a policy */
export type CancelPolicyRequest = {
  __typename?: 'CancelPolicyRequest';
  /** ID of the policy to be cancelled */
  policyId: Scalars['String']['output'];
  /** Reason for cancelling the policy */
  reason: Scalars['String']['output'];
};

/** Input type for canceling a policy request */
export type CancelPolicyRequestInput = {
  /** ID of the policy to be cancelled */
  policyId: Scalars['String']['input'];
  /** Reason for cancelling the policy */
  reason: Scalars['String']['input'];
};

/** A workspace for Cara to execute tasks and produce artifacts */
export type CaraWorkspace = {
  __typename?: 'CaraWorkspace';
  /** The agency user the created this workspace */
  agencyUser: AgencyUser;
  /** The timestamp when this workspace was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The artifacts produced in this workspace */
  artifacts: Array<CaraWorkspaceArtifact>;
  /** The timestamp when this workspace was created */
  createdAt: Scalars['Time']['output'];
  /** The custom preset used for this workspace, if any */
  customPreset?: Maybe<CustomPreset>;
  /** The files associated with this workspace */
  files: Array<File>;
  /** The unique identifier for this workspace */
  id: Scalars['ID']['output'];
  /** The messages exchanged in this workspace */
  messages: Array<CaraWorkspaceMessage>;
  /**
   * The metadata for this workspace, usable for searching and filtering. These are usually
   * automatically generated by AI, but can be overridden by the agent.
   */
  metadata: CaraWorkspaceMetadata;
  /** The plan stages in this workspace */
  planStages: Array<CaraWorkspacePlanStage>;
  /**
   * The preset for this workspace, if any. This indicates a specific task or goal for the workspace
   * and can be used to guide the AI in its execution.
   */
  preset?: Maybe<CaraWorkspacePreset>;
  /** The schema version of the Cara workspace */
  schemaVersion: CaraWorkspaceSchemaVersion;
  /** The service request this workspace is handling, if any */
  serviceRequest?: Maybe<ServiceRequest>;
  /** The current state of this workspace */
  state: CaraWorkspaceState;
  /** A brief title describing this workspace, initially set by AI but can be overridden by the agent */
  title: Scalars['String']['output'];
  /** The timestamp when this workspace was last modified */
  updatedAt: Scalars['Time']['output'];
};

/** An artifact produced during execution of a Cara workspace */
export type CaraWorkspaceArtifact = {
  __typename?: 'CaraWorkspaceArtifact';
  /** The timestamp when the artifact was created */
  createdAt: Scalars['Time']['output'];
  /** The document details if this is a document artifact */
  document?: Maybe<Document>;
  /** The email details if this is an email artifact */
  email?: Maybe<EmailDraft>;
  /** The HTML document details if this is an HTML document artifact */
  htmlDocument?: Maybe<HtmlDocument>;
  /** The ID of the artifact */
  id: Scalars['ID']['output'];
  /** The type of artifact (document or email) */
  type: CaraWorkspaceArtifactType;
};

export enum CaraWorkspaceArtifactType {
  /** A document artifact like a report or analysis */
  Document = 'DOCUMENT',
  /** An email artifact for communication */
  Email = 'EMAIL',
  /** A HTML document artifact */
  HtmlDocument = 'HTML_DOCUMENT'
}

/** A message exchanged between a user and agent in a Cara workspace */
export type CaraWorkspaceMessage = {
  __typename?: 'CaraWorkspaceMessage';
  /** The content of the message */
  content: Scalars['String']['output'];
  /** The ID of the message in the external system */
  externalId: Scalars['String']['output'];
  /** The files associated with this message */
  files: Array<File>;
  /** The ID of the message */
  id: Scalars['ID']['output'];
  /** The role of the message sender (user or agent) */
  role: CaraWorkspaceMessageRole;
  /** The timestamp when the message was created */
  timestamp: Scalars['Time']['output'];
};

export type CaraWorkspaceMessageInput = {
  /** The ID of the custom preset to use for this workspace */
  customPresetId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The IDs of the documents for which templates should be generated. This should only be specified
   * when the preset is GENERATE_TEMPLATE.
   */
  documentIds?: InputMaybe<Array<DocumentType>>;
  /** Any files to add to the message */
  files: Array<Scalars['Upload']['input']>;
  /** The content of the message to add */
  message: Scalars['String']['input'];
  /**
   * The preset for this workspace, if any. This indicates a specific task or goal for the workspace
   * and can be used to guide the AI in its execution.
   */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** The ID of the service request this workspace is associated with, if any */
  serviceRequestId?: InputMaybe<Scalars['String']['input']>;
};

/** The role of a message in a Cara workspace conversation */
export enum CaraWorkspaceMessageRole {
  /** A message from the AI agent */
  Agent = 'AGENT',
  /** A message from the human user */
  User = 'USER'
}

/** The metadata for a Cara workspace */
export type CaraWorkspaceMetadata = {
  __typename?: 'CaraWorkspaceMetadata';
  /** The name of the client that this workspace is for */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Keywords that can be used to search and filter this workspace */
  keywords: Array<Scalars['String']['output']>;
};

/** A stage in the execution plan of a Cara workspace task */
export type CaraWorkspacePlanStage = {
  __typename?: 'CaraWorkspacePlanStage';
  /** The timestamp when the plan stage was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp when execution of the plan stage completed */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The sequence of events that occurred during stage execution */
  events: Array<CaraWorkspacePlanStageEvent>;
  /** The ID of the plan stage */
  id: Scalars['ID']['output'];
  /** The ID of the message that initiated this plan stage */
  initiatedByMessageId: Scalars['String']['output'];
  /** The details of the process attachments plan stage */
  processAttachmentsDetails?: Maybe<CaraWorkspacePlanStageProcessAttachmentDetails>;
  /** The prompt that was computed to start execution of this stage (human message) */
  prompt: Scalars['String']['output'];
  /** The outcome or findings from executing this plan stage */
  result: Scalars['String']['output'];
  /** The timestamp when execution of the plan stage began */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The current execution state of the plan stage */
  state: CaraWorkspacePlanStageState;
  /** The type of plan stage */
  type: CaraWorkspacePlanStageType;
};

/** An event that occurs during the execution of a plan stage */
export type CaraWorkspacePlanStageEvent = {
  __typename?: 'CaraWorkspacePlanStageEvent';
  /** The content or description of the event */
  content?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the event ended */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The error message if the tool call failed */
  error?: Maybe<Scalars['String']['output']>;
  /** The ID of the event in the external system */
  externalId: Scalars['String']['output'];
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The timestamp when the event was created */
  startedAt: Scalars['Time']['output'];
  /** A brief title of the event */
  title?: Maybe<Scalars['String']['output']>;
  /** The tool call details if this event is a tool invocation */
  toolCall?: Maybe<CaraWorkspaceToolCall>;
  /** The type of the event (thought or tool call) */
  type: CaraWorkspacePlanStageEventType;
};

/** The type of event that can occur during a plan stage execution */
export enum CaraWorkspacePlanStageEventType {
  /** An internal reasoning step by the agent */
  Thought = 'THOUGHT',
  /** An invocation of an external tool or API */
  ToolCall = 'TOOL_CALL'
}

/** The details of the process attachments plan stage */
export type CaraWorkspacePlanStageProcessAttachmentDetails = {
  __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
  /** The progress of each file being processed */
  progress: Array<CaraWorkspacePlanStageProcessAttachmentFileProgress>;
};

export type CaraWorkspacePlanStageProcessAttachmentFileProgress = {
  __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
  /** The file being processed */
  file: File;
  /** The progress of the file being processed (as a decimal between 0 and 1) */
  progress: Scalars['Float']['output'];
};

/** The state of a plan stage in a Cara workspace */
export enum CaraWorkspacePlanStageState {
  /** The stage has failed to complete */
  Failed = 'FAILED',
  /** The stage is actively processing a task */
  InProgress = 'IN_PROGRESS',
  /** The stage is planned but not yet started */
  Planned = 'PLANNED',
  /** The stage has been completed successfully */
  Success = 'SUCCESS'
}

/** The type of plan stage in a Cara workspace */
export enum CaraWorkspacePlanStageType {
  /** A plan stage that processes attached files */
  ProcessAttachments = 'PROCESS_ATTACHMENTS',
  /** A plan stage that performs a task */
  Task = 'TASK'
}

/** A preset for Cara to execute tasks and produce artifacts */
export enum CaraWorkspacePreset {
  /** A preset for reviewing a certificate of liability insurance for correctness */
  CertificateReview = 'CERTIFICATE_REVIEW',
  /** A preset for reviewing a contract and comparing its requirements to a quote or policy */
  ContractReview = 'CONTRACT_REVIEW',
  /** A preset for comparing insurance coverage between two policies or quotes */
  CoverageComparison = 'COVERAGE_COMPARISON',
  /** A preset for exploring a document and asking questions about it */
  DocumentExploration = 'DOCUMENT_EXPLORATION',
  /**
   * A preset for generating a certificate of liability insurance
   * @deprecated Use GENERATE_TEMPLATE instead
   */
  GenerateCertificateOfLiabilityInsurance = 'GENERATE_CERTIFICATE_OF_LIABILITY_INSURANCE',
  /**
   * A preset for generating evidence of property insurance
   * @deprecated Use GENERATE_TEMPLATE instead
   */
  GenerateEvidenceOfPropertyInsurance = 'GENERATE_EVIDENCE_OF_PROPERTY_INSURANCE',
  /** A preset for generating a quote proposal */
  GenerateQuoteProposal = 'GENERATE_QUOTE_PROPOSAL',
  /** A preset for generating a template for a document */
  GenerateTemplate = 'GENERATE_TEMPLATE',
  /** A preset for analyzing commercial underwriting documents and providing comprehensive analysis */
  UnderwritingAnalysis = 'UNDERWRITING_ANALYSIS'
}

export enum CaraWorkspaceSchemaVersion {
  /**
   * The initial version of the Cara workspace schema, based in the Python codebase.
   * These workspaces are now deprecated.
   */
  V0 = 'V0',
  /** The current version of the Cara workspace schema, based in the Go codebase. */
  V1 = 'V1'
}

/** The state of a Cara workspace, indicating its current execution status */
export enum CaraWorkspaceState {
  /** The workspace is created but not yet started */
  Created = 'CREATED',
  /** The workspace has finished processing the task and is idle */
  Idle = 'IDLE',
  /** The workspace is waiting for user input to continue */
  WaitingForInput = 'WAITING_FOR_INPUT',
  /** The workspace is actively processing a task */
  Working = 'WORKING'
}

/** Represents the different types of tools that can be called within a Cara workspace. */
export enum CaraWorkspaceTool {
  /** Used to mark a task as completed and record its outcome. */
  CompleteTask = 'COMPLETE_TASK',
  /** Used to create document drafts like reports, proposals, or other written content. */
  DraftDocument = 'DRAFT_DOCUMENT',
  /** Used to draft email messages based on given context and requirements. */
  DraftEmail = 'DRAFT_EMAIL',
  /** Used to fill out a template such as an ACORD form. */
  FillTemplate = 'FILL_TEMPLATE',
  /** Use to peek at files to get a sense for their content textually or visually */
  PeekFile = 'PEEK_FILE',
  /** Used to request a list of tools that can be used to fill out a template. */
  RequestTemplateTools = 'REQUEST_TEMPLATE_TOOLS',
  /** Used to search through files and documents within the workspace. */
  SearchFile = 'SEARCH_FILE',
  /** Used to search through the organization's knowledge base for relevant information. */
  SearchKnowledgeBase = 'SEARCH_KNOWLEDGE_BASE',
  /** Used to search through entities stored and related to the organization, such as synced accounts and policies. */
  SearchKnowledgeGraph = 'SEARCH_KNOWLEDGE_GRAPH',
  /** Used to search the internet for relevant information. */
  SearchWeb = 'SEARCH_WEB',
  /** Used when the LLM needs to process information or make decisions by thinking through a problem. */
  Think = 'THINK',
  /** Used to write to an integration. */
  WriteIntegration = 'WRITE_INTEGRATION'
}

/**
 * Represents a tool call that was made in the context of a Cara workspace.
 * This is the base type that tracks all tool invocations made by the LLM.
 */
export type CaraWorkspaceToolCall = {
  __typename?: 'CaraWorkspaceToolCall';
  /**
   * DEPRECATED: The arguments passed to the tool in JSON format.
   * This field is deprecated in favor of strongly-typed argument fields in specific tool types.
   */
  argumentsJson: Scalars['String']['output'];
  completeTaskTool?: Maybe<CompleteTaskTool>;
  draftDocumentTool?: Maybe<DraftDocumentTool>;
  draftEmailTool?: Maybe<DraftEmailTool>;
  fillTemplateTool?: Maybe<FillTemplateTool>;
  /**
   * The unique identifier for this tool call instance.
   * Used for tracking and referencing specific tool invocations.
   */
  id: Scalars['String']['output'];
  /**
   * DEPRECATED: The name of the tool being called.
   * This field is deprecated in favor of using specific tool types.
   */
  name: Scalars['String']['output'];
  peekFileTool?: Maybe<PeekFileTool>;
  requestTemplateToolsTool?: Maybe<RequestTemplateToolsTool>;
  /**
   * DEPRECATED: The result of the tool call in JSON format.
   * This field is deprecated in favor of strongly-typed result fields in specific tool types.
   */
  result: Scalars['String']['output'];
  searchFileTool?: Maybe<SearchFileTool>;
  searchKnowledgeBaseTool?: Maybe<SearchKnowledgeBaseTool>;
  searchKnowledgeGraphTool?: Maybe<SearchKnowledgeGraphTool>;
  searchWebTool?: Maybe<SearchWebTool>;
  thinkTool?: Maybe<ThinkTool>;
  /**
   * The exact timestamp when this tool call was made.
   * Used for auditing and tracking the sequence of tool calls.
   */
  timestamp: Scalars['Time']['output'];
  /** The type of tool call. */
  type?: Maybe<CaraWorkspaceTool>;
  writeIntegrationTool?: Maybe<WriteIntegrationTool>;
};

/**
 * Configuration for a business's auto liability policy's Certificate of Insurance (COI).
 * Contains details about auto coverage types, limits, and policy information.
 */
export type CertificateAutoLiabilitySection = {
  __typename?: 'CertificateAutoLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** Whether coverage applies to any auto */
  anyAutoLiability: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Whether coverage applies only to hired autos */
  hiredAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Coverage limit for bodily injury per accident */
  limitBodilyInjuryPerAccident: Scalars['Float']['output'];
  /** Coverage limit for bodily injury per person */
  limitBodilyInjuryPerPerson: Scalars['Float']['output'];
  /** Coverage limit for each accident */
  limitCombinedSingleLimitPerAccident: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for property damage per accident */
  limitPropertyDamagePerAccident: Scalars['Float']['output'];
  /** Whether coverage applies only to non-owned autos */
  nonOwnedAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Whether coverage applies only to owned autos */
  ownedAutosOnlyLiability: Scalars['Boolean']['output'];
  /** The auto liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the auto liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether coverage applies only to scheduled autos */
  scheduledAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/** CertificateEntity represents an entity involved in the insurance certificate. */
export type CertificateEntity = {
  __typename?: 'CertificateEntity';
  /** The address of the entity */
  address: Address;
  /** The name of the entity */
  name: Scalars['String']['output'];
};

/** Input for a certificate entity */
export type CertificateEntityInput = {
  /** The address of the entity */
  address: AddressInput;
  /** The name of the entity */
  name: Scalars['String']['input'];
};

/** Input for the holder of the certificate */
export type CertificateHolderInput = {
  /** The address of the holder */
  address: AddressInput;
  /** The name of the holder */
  name: Scalars['String']['input'];
};

/**
 * Configuration for a business's liability policy's Certificate of Insurance (COI).
 * Contains details about coverage types, limits, and policy information.
 */
export type CertificateLiabilitySection = {
  __typename?: 'CertificateLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** How the general aggregate limit applies - per policy, project, location or other */
  generalAggregateLimitAppliesPer: GeneralAggregateLimitAppliesPerType;
  /** Description of other general aggregate limit application if type is OTHER */
  generalAggregateLimitAppliesPerOther?: Maybe<Scalars['String']['output']>;
  /** Type of liability coverage - either claims made or occurrence based */
  liabilityCoverageType: LiabilityCoverageType;
  /** Coverage limit for damage to rented premises per occurrence */
  limitDamageToPremisesEachOccurrence: Scalars['Float']['output'];
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerOccurrence: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerPerson: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for personal and advertising injury */
  limitPersonalAndAdvertisingInjury: Scalars['Float']['output'];
  /** Coverage limit for products and completed operations */
  limitProductsAndCompletedOperations: Scalars['Float']['output'];
  /** The liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/** CertificateLimit represents a limit associated with an insurance certificate. */
export type CertificateLimit = {
  __typename?: 'CertificateLimit';
  /** The amount of the limit */
  amount: Scalars['Float']['output'];
  /** The name of the limit */
  name: Scalars['String']['output'];
};

/** Configuration for an agency's Certificate of Insurance (COI) settings */
export type CertificateOfLiabilityAgencyConfiguration = {
  __typename?: 'CertificateOfLiabilityAgencyConfiguration';
  /** The name of the authorized representative */
  authorizedRepName: Scalars['String']['output'];
  /** Base64-encoded signature image data used for signing COIs */
  authorizedRepSignatureBase64Data: Scalars['String']['output'];
  /** Email address of the agency contact person for COI-related inquiries */
  contactEmail: Scalars['String']['output'];
  /** Name of the agency contact person for COI-related inquiries */
  contactName: Scalars['String']['output'];
  /** Phone number of the agency contact person for COI-related inquiries */
  contactPhone: Scalars['String']['output'];
  /** The producer entity information that appears on COIs issued by this agency */
  producer: CertificateEntity;
  /** Whether to render the COI fields in all caps */
  renderAllCaps: Scalars['Boolean']['output'];
};

/** Input configuration for an agency's Certificate of Insurance (COI) settings */
export type CertificateOfLiabilityAgencyConfigurationInput = {
  /** The name of the authorized representative */
  authorizedRepName: Scalars['String']['input'];
  /** Base64-encoded signature image data used for signing COIs */
  authorizedRepSignatureBase64Data?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the agency contact person for COI-related inquiries */
  contactEmail: Scalars['String']['input'];
  /** Name of the agency contact person for COI-related inquiries */
  contactName: Scalars['String']['input'];
  /** Phone number of the agency contact person for COI-related inquiries */
  contactPhone: Scalars['String']['input'];
  /** The producer entity information that appears on COIs issued by this agency */
  producer: CertificateEntityInput;
  /** Whether to render the COI fields in all caps */
  renderAllCaps: Scalars['Boolean']['input'];
};

/** Configuration for a business's Certificate of Insurance (COI) */
export type CertificateOfLiabilityInsurance = {
  __typename?: 'CertificateOfLiabilityInsurance';
  /** Configuration for the agency that produced the COI */
  agency: CertificateOfLiabilityAgencyConfiguration;
  /** Configuration for the business's auto liability policy's Certificate of Insurance (COI) */
  autoLiability?: Maybe<CertificateAutoLiabilitySection>;
  /** The certificate number for the COI */
  certificateNumber: Scalars['String']['output'];
  /** The date the COI was created */
  createdAt: Scalars['Time']['output'];
  /** Description of the business's operations, used for generating COIs */
  descriptionOfOperations: Scalars['String']['output'];
  /** The URL that the COI can be downloaded at */
  downloadUrl: Scalars['String']['output'];
  /** The holder entity information that appears on COIs issued by this business */
  holder: CertificateEntity;
  /** The unique identifier for the certificate */
  id: Scalars['ID']['output'];
  /** The insured entity information that appears on COIs issued by this business */
  insured: CertificateEntity;
  /** Configuration for the business's liability policy's Certificate of Insurance (COI) */
  liability?: Maybe<CertificateLiabilitySection>;
  /** Configuration for the business's other policy's Certificate of Insurance (COI) */
  other?: Maybe<CertificateOtherSection>;
  /** Configuration for the business's umbrella or excess liability policy's Certificate of Insurance (COI) */
  umbrellaOrExcessLiability?: Maybe<CertificateUmbrellaOrExcessLiabilitySection>;
  /** The date the COI was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The URL that the COI can be viewed at */
  viewUrl: Scalars['String']['output'];
  /** Configuration for the business's workers' compensation policy's Certificate of Insurance (COI) */
  workersCompensation?: Maybe<CertificateWorkersCompensationSection>;
};

/**
 * Configuration for any other type of policy's Certificate of Insurance (COI).
 * Contains details about the coverage type, limits, and policy information.
 */
export type CertificateOtherSection = {
  __typename?: 'CertificateOtherSection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Description of the type of coverage */
  coverageType: Scalars['String']['output'];
  /** List of coverage limits and their amounts */
  limits: Array<CertificateLimit>;
  /** The other policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

export enum CertificateType {
  /** Certificate of Liability Insurance */
  Liability = 'LIABILITY',
  /** Certificate of Property Insurance */
  Property = 'PROPERTY'
}

/**
 * Configuration for a business's umbrella or excess liability policy's Certificate of Insurance (COI).
 * Contains details about umbrella/excess coverage, limits, and policy information.
 */
export type CertificateUmbrellaOrExcessLiabilitySection = {
  __typename?: 'CertificateUmbrellaOrExcessLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Deductible amount for the coverage */
  deductible: Scalars['Float']['output'];
  /** Whether this is excess liability coverage */
  excessLiability: Scalars['Boolean']['output'];
  /** Type of liability coverage - either claims made or occurrence based */
  liabilityCoverageType: LiabilityCoverageType;
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** The umbrella or excess liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the umbrella/excess coverage */
  policyNumber: Scalars['String']['output'];
  /** Retention limit for the coverage */
  retentionLimit: Scalars['Float']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
  /** Whether this is umbrella liability coverage */
  umbrellaLiability: Scalars['Boolean']['output'];
};

/**
 * Configuration for a business's workers' compensation policy's Certificate of Insurance (COI).
 * Contains details about workers' comp coverage, limits, and policy information.
 */
export type CertificateWorkersCompensationSection = {
  __typename?: 'CertificateWorkersCompensationSection';
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Name of any party excluded from coverage */
  excludedPartyName?: Maybe<Scalars['String']['output']>;
  /** Coverage limit per accident */
  limitPerAccident: Scalars['Float']['output'];
  /** Coverage limit per employee */
  limitPerEmployee: Scalars['Float']['output'];
  /** Coverage limit per policy */
  limitPerPolicy: Scalars['Float']['output'];
  /** Whether the coverage limits are provided per statute */
  limitsStatutory: Scalars['Boolean']['output'];
  /** The workers' compensation policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the workers' compensation coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/**
 * A client represents a customer of an agency. They can have multiple businesses,
 * business applications, policies and service requests associated with them.
 */
export type Client = {
  __typename?: 'Client';
  /** The agency that manages this client. Only accessible by agency users. */
  agency: Agency;
  /** Insurance applications submitted by this client. */
  businessApplications: Array<BusinessApplication>;
  /** Active insurance policies held by this client. */
  businessPolicies: Array<BusinessPolicy>;
  /** Businesses owned or operated by this client. */
  businesses: Array<Business>;
  /** When the client record was created. */
  createdAt: Scalars['Time']['output'];
  /** Primary email address for contacting the client. */
  email: Scalars['String']['output'];
  /** Unique identifier for the client. */
  id: Scalars['ID']['output'];
  /** Full name of the client. */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the client. */
  phone: Scalars['String']['output'];
  /** Service requests submitted by this client. */
  serviceRequests: Array<ServiceRequest>;
  /** When the client record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

/** Input for creating a certificate of insurance on the client side */
export type ClientCreateCertificateInput = {
  /**
   * If the holder is an additional insured, and is one of the allowed blanket or named insureds,
   * then this is the ID of the additional insured.
   */
  additionalInsuredId?: InputMaybe<Scalars['String']['input']>;
  /** The holder of the certificate. */
  holder: CertificateHolderInput;
  /** Whether the holder is an additional insured. */
  isAdditionalInsured: Scalars['Boolean']['input'];
  /** Whether the holder is an additional insured, but not an allowed blanket or named insured. */
  isOtherAdditionalInsured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any additional notes for the agency to review when creating the certificate. */
  notes: Scalars['String']['input'];
  /**
   * If the holder is an additional insured, but not an allowed blanket or named insured,
   * then this is the relationship of the additional insured to the holder.
   */
  otherAdditionalInsuredRelationship?: InputMaybe<Scalars['String']['input']>;
};

/** Result of creating a certificate of insurance on the client side */
export type ClientCreateCertificateResult = {
  __typename?: 'ClientCreateCertificateResult';
  /** The certificate of insurance that was created, if successful. */
  certificate?: Maybe<CertificateOfLiabilityInsurance>;
  /** The result code of the client create certificate result */
  code: ClientCreateCertificateResultCode;
  /** If the certificate was not created, the service request that was created for the agency to review. */
  serviceRequest?: Maybe<ServiceRequest>;
};

/** The result code of the client create certificate result */
export enum ClientCreateCertificateResultCode {
  /** There was an error creating the certificate, and a service request was created for the agency to review. */
  Error = 'ERROR',
  /** A policy may need to be endorsed prior to certificate creation, and a service request was created for the agency to handle. */
  RequiresEndorsement = 'REQUIRES_ENDORSEMENT',
  /** The certificate request needs to be reviewed prior to creation, and a service request was created for the agency to review. */
  RequiresReview = 'REQUIRES_REVIEW',
  /** The certificate was successfully created. */
  Success = 'SUCCESS'
}

/** Code block style */
export type CodeStyle = {
  __typename?: 'CodeStyle';
  /** Background color in hex format (e.g. '#f1f5f9') */
  backgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Border radius in pixels (e.g. 3.0) */
  borderRadiusPx?: Maybe<Scalars['Float']['output']>;
  /** Text color in hex format (e.g. '#1e293b') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font family name (e.g. 'Courier New', 'Roboto Mono') */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 9.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Padding in em units (e.g. 0.2) */
  paddingEm?: Maybe<Scalars['Float']['output']>;
};

/**
 * Represents a tool for completing a specific task or action.
 * Used when the LLM needs to perform a concrete action based on its analysis.
 */
export type CompleteTaskTool = {
  __typename?: 'CompleteTaskTool';
  /** The input arguments for the task completion */
  input: CompleteTaskToolInput;
  /** The result of the task completion attempt */
  output: CompleteTaskToolOutput;
};

/**
 * Input arguments for the CompleteTaskTool.
 * Contains all necessary information to complete a specific task.
 */
export type CompleteTaskToolInput = {
  __typename?: 'CompleteTaskToolInput';
  /** The name of the client or entity the task is for */
  clientName: Scalars['String']['output'];
  /** Keywords associated with the task for categorization and search */
  keywords: Array<Scalars['String']['output']>;
  /** Whether the task requires additional input from a human agent */
  needsAgentInput: Scalars['Boolean']['output'];
};

/**
 * Result of a CompleteTaskTool operation.
 * Indicates whether the task was completed successfully.
 */
export type CompleteTaskToolOutput = {
  __typename?: 'CompleteTaskToolOutput';
  /** Whether the task completion was successful */
  success: Scalars['Boolean']['output'];
};

/** Represents an action required for compliance */
export type ComplianceAction = {
  __typename?: 'ComplianceAction';
  /** The person assigned to complete this action */
  assignee?: Maybe<ComplianceActionAssignee>;
  /** The person who completed this action, if applicable */
  completedBy?: Maybe<ComplianceActionAssignee>;
  /** The date when this action was completed, if applicable */
  completionDate?: Maybe<Scalars['Time']['output']>;
  /** List of requirements for completing this action */
  completionRequirements: Array<ComplianceActionCompletionRequirement>;
  /** List of compliance items associated with this action */
  complianceItems: Array<ComplianceItem>;
  /** Detailed description of the compliance action */
  description: Scalars['String']['output'];
  /** The date by which this action should be completed */
  dueDate: Scalars['Time']['output'];
  /** Unique identifier for the compliance action */
  id: Scalars['ID']['output'];
  /** Current status of the compliance action */
  status: ComplianceActionStatus;
  /** Title of the compliance action */
  title: Scalars['String']['output'];
};

/** Represents a person assigned to or who completed a compliance action */
export type ComplianceActionAssignee = {
  __typename?: 'ComplianceActionAssignee';
  /** Email address of the assignee */
  email: Scalars['String']['output'];
  /** Unique identifier for the assignee */
  id: Scalars['ID']['output'];
  /** Full name of the assignee */
  name: Scalars['String']['output'];
};

/** Represents a requirement for completing a compliance action */
export type ComplianceActionCompletionRequirement = {
  __typename?: 'ComplianceActionCompletionRequirement';
  /** Detailed description of the completion requirement */
  description: Scalars['String']['output'];
  /** Unique identifier for the completion requirement */
  id: Scalars['ID']['output'];
  /** Title of the completion requirement */
  title: Scalars['String']['output'];
};

/** Represents the status of a compliance action */
export enum ComplianceActionStatus {
  /** The action has been completed */
  Closed = 'CLOSED',
  /** The action is still pending completion */
  Open = 'OPEN'
}

/** Represents a group of compliance items */
export type ComplianceGroup = {
  __typename?: 'ComplianceGroup';
  /** Detailed description of the compliance group */
  description: Scalars['String']['output'];
  /** List of compliance items within this group */
  items: Array<ComplianceItem>;
  /** Unique identifier for the compliance group */
  slug: Scalars['ID']['output'];
  /** Title of the compliance group */
  title: Scalars['String']['output'];
};

/** Represents a specific compliance item */
export type ComplianceItem = {
  __typename?: 'ComplianceItem';
  /** List of actions associated with this compliance item */
  actions: Array<ComplianceAction>;
  /** Detailed description of the compliance item */
  description: Scalars['String']['output'];
  /** Unique identifier for the compliance item */
  id: Scalars['ID']['output'];
  /** List of reference materials related to this compliance item */
  referenceMaterials: Array<ComplianceReferenceMaterial>;
  /** List of requirements for this compliance item */
  requirements: Array<ComplianceRequirement>;
  /** Slug identifier for the compliance item */
  slug: Scalars['String']['output'];
  /** List of standards associated with this compliance item */
  standards: Array<ComplianceStandard>;
  /** Title of the compliance item */
  title: Scalars['String']['output'];
};

/** Represents reference material for compliance */
export type ComplianceReferenceMaterial = {
  __typename?: 'ComplianceReferenceMaterial';
  /** Detailed description of the reference material */
  description: Scalars['String']['output'];
  /** Title of the reference material */
  title: Scalars['String']['output'];
  /** URL to access the reference material */
  url: Scalars['String']['output'];
};

/** Represents a specific requirement for compliance */
export type ComplianceRequirement = {
  __typename?: 'ComplianceRequirement';
  /** Detailed description of the compliance requirement */
  description: Scalars['String']['output'];
  /** Title of the compliance requirement */
  title: Scalars['String']['output'];
};

/** Represents a compliance standard */
export type ComplianceStandard = {
  __typename?: 'ComplianceStandard';
  /** Detailed description of the compliance standard */
  description: Scalars['String']['output'];
  /** Title of the compliance standard */
  title: Scalars['String']['output'];
  /** URL for more information about the standard */
  url: Scalars['String']['output'];
};

/** A cost event represents a single cost incurred in the system */
export type CostEvent = {
  __typename?: 'CostEvent';
  /** When this record was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the cost event */
  id: Scalars['ID']['output'];
  /**
   * Additional metadata about the cost event
   * e.g. {"workspace_id": "ws_123", "stage_id": "stage_456", "tool_call_id": "tool_789"}
   */
  metadata: CostEventMetadata;
  /** When this cost event occurred */
  occurredAt: Scalars['Time']['output'];
  /** The quantity of units consumed */
  quantity: Scalars['Int']['output'];
  /** The total cost in dollars */
  totalCostDollars: Scalars['Decimal']['output'];
  /** The type of cost event */
  type: CostEventType;
  /** The unit of the quantity (e.g. 'seconds', 'tokens', 'bytes') */
  unit: CostEventUnit;
  /** The cost per unit in dollars */
  unitCostDollars: Scalars['Decimal']['output'];
  /** When this record was last updated */
  updatedAt: Scalars['Time']['output'];
};

export type CostEventMetadata = {
  __typename?: 'CostEventMetadata';
  /** If this cost event is related to a call, the ID of the call */
  callId?: Maybe<Scalars['String']['output']>;
  /** The ID of the email thread this cost event belongs to */
  emailThreadId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a file chunk, the index of the chunk */
  fileChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** If this cost event is related to a file, the ID of the file */
  fileId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a knowledge base document chunk, the index of the chunk */
  knowledgeBaseDocumentChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** If this cost event is related to a knowledge base document, the ID of the document */
  knowledgeBaseDocumentId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a knowledge base policy, the ID of the policy */
  knowledgeBasePolicyId?: Maybe<Scalars['String']['output']>;
  /** The search context size used for the perplexity search */
  perplexitySearchContextSize?: Maybe<Scalars['String']['output']>;
  /** The model used for the perplexity search */
  perplexitySearchModel?: Maybe<Scalars['String']['output']>;
  /** The ID of the stage event this cost event belongs to */
  stageEventId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the stage this cost event belongs to */
  stageId?: Maybe<Scalars['ID']['output']>;
  /** The tag for this cost event, indicating the context that the cost event was incurred in */
  tag: CostEventMetadataTag;
  /** The ID of the stage event this cost event belongs to, if specifically invoked by a tool call */
  toolCallId?: Maybe<Scalars['ID']['output']>;
  /** The type of the tool call this cost event belongs to */
  toolCallType?: Maybe<CaraWorkspaceTool>;
  /** The ID of the workspace this cost event belongs to */
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

/** Tags that indicate the context in which a cost event was incurred */
export enum CostEventMetadataTag {
  /** Cost incurred while classifying an email thread */
  EmailThreadClassify = 'EMAIL_THREAD_CLASSIFY',
  /** Cost incurred while formatting an email thread */
  EmailThreadFormat = 'EMAIL_THREAD_FORMAT',
  /** Cost incurred while generating an email response */
  EmailThreadGenerateResponse = 'EMAIL_THREAD_GENERATE_RESPONSE',
  /** Cost incurred while parsing service requests from an email thread */
  EmailThreadParseServiceRequests = 'EMAIL_THREAD_PARSE_SERVICE_REQUESTS',
  /** Cost incurred while indexing a document in a knowledge base */
  KnowledgeBaseIndexDocument = 'KNOWLEDGE_BASE_INDEX_DOCUMENT',
  /** Cost incurred while indexing a policy in the accounts and policies section of the knowlege module */
  KnowledgeBaseIndexPolicy = 'KNOWLEDGE_BASE_INDEX_POLICY',
  /** Cost incurred while searching a file in a workspace */
  PerplexityWebSearch = 'PERPLEXITY_WEB_SEARCH',
  /** Cost incurred while analyzing a phone conversation */
  PhoneCallAnalyzeConversation = 'PHONE_CALL_ANALYZE_CONVERSATION',
  /** Cost incurred while answering a question on inbound phone call */
  PhoneCallAnswerPolicyQuestion = 'PHONE_CALL_ANSWER_POLICY_QUESTION',
  /** Cost incurred while handling an inbound phone call */
  PhoneCallHandleInbound = 'PHONE_CALL_HANDLE_INBOUND',
  /** Cost incurred while generating a title for a workspace */
  WorkspaceGenerateTitle = 'WORKSPACE_GENERATE_TITLE',
  /** Cost incurred while indexing a file in a workspace */
  WorkspaceIndexFile = 'WORKSPACE_INDEX_FILE',
  /** Cost incurred while generating a response in a workspace */
  WorkspaceResponse = 'WORKSPACE_RESPONSE',
  /** Cost incurred while searching a knowledge base from a workspace */
  WorkspaceSearchKnowledgeBase = 'WORKSPACE_SEARCH_KNOWLEDGE_BASE',
  /** Cost incurred while thinking in a workspace */
  WorkspaceThought = 'WORKSPACE_THOUGHT',
  /** Cost incurred while making a tool call from a workspace */
  WorkspaceToolCall = 'WORKSPACE_TOOL_CALL'
}

/** Cost event types that can occur in the system */
export enum CostEventType {
  /** Cost event for call duration, measured in seconds */
  CallDuration = 'CALL_DURATION',
  /** Cost event for embedding input tokens */
  EmbeddingInput = 'EMBEDDING_INPUT',
  /** Cost event for HTTP requests */
  HttpRequest = 'HTTP_REQUEST',
  /** Cost event for LLM cache read operations */
  LlmCacheRead = 'LLM_CACHE_READ',
  /** Cost event for LLM cache write operations */
  LlmCacheWrite = 'LLM_CACHE_WRITE',
  /** Cost event for LLM input tokens */
  LlmInput = 'LLM_INPUT',
  /** Cost event for LLM output tokens */
  LlmOutput = 'LLM_OUTPUT',
  /** Cost event for Reducto service credit usage */
  ReductoCredit = 'REDUCTO_CREDIT',
  /** Cost event for reranking input tokens */
  RerankInput = 'RERANK_INPUT'
}

/** Units for cost events */
export enum CostEventUnit {
  /** Nominal unit, used to represent a discrete count (e.g. number of files, number of requests, etc.) */
  Nominal = 'NOMINAL',
  /** Time-based unit */
  Second = 'SECOND',
  /** Token-based unit */
  Token = 'TOKEN'
}

/** Represents information about the associated CoverForce application. */
export type CoverforceApplication = {
  __typename?: 'CoverforceApplication';
  /** The ID of the policy that is binding, if any was selected */
  bindingPolicyId?: Maybe<Scalars['String']['output']>;
  /** The ID of the quote that is binding, if any was selected */
  bindingQuoteId?: Maybe<Scalars['String']['output']>;
  /** The ID of the associated CoverForce application. */
  id: Scalars['ID']['output'];
  /** The fingerprint of the application last submitted for quotes. */
  lastApplicationFingerprint: Scalars['String']['output'];
  /** The timestamp that the Coverforce application was last submitted for quotes */
  lastQuotesRefreshedAt?: Maybe<Scalars['Time']['output']>;
  /** The type of insurance the CoverForce application is for. */
  type: InsuranceType;
};

/** Input for creating a new account contact */
export type CreateAccountContactInput = {
  /** The contact's email address */
  email: Scalars['String']['input'];
  /** The contact's name */
  name: Scalars['String']['input'];
  /** The contact's phone number */
  phone: Scalars['String']['input'];
};

/** Input for creating a new agency account */
export type CreateAccountInput = {
  /** If provided, ID of an existing contact to associate with the account */
  associateContactId?: InputMaybe<Scalars['String']['input']>;
  /** Business account details */
  business?: InputMaybe<CreateBusinessAccountInput>;
  /** Contact details for the account, if a new contact should be created */
  contact?: InputMaybe<CreateAccountContactInput>;
  /** Individual account details */
  individual?: InputMaybe<CreateIndividualAccountInput>;
  /** The type of account - either a business or individual account. */
  type: AccountType;
};

/** Input for creating a new agency */
export type CreateAgencyInput = {
  /** Agency details */
  agency: AgencyInput;
  /** Users to create for the agency */
  users: Array<AgencyUserInput>;
};

export type CreateApplicationInput = {
  /** The legal name of the business applying for insurance. */
  businessName: Scalars['String']['input'];
  /** The email address of the contact person for the business application. */
  email: Scalars['String']['input'];
  /** The name of the contact person for the business application. */
  fullName: Scalars['String']['input'];
  /** The phone number of the contact person for the business application. */
  phone: Scalars['String']['input'];
};

/** Input for creating a new business record */
export type CreateBusinessAccountInput = {
  /** Doing Business As (DBA) name, if different from legal name */
  dba: Scalars['String']['input'];
  /** Primary email address for contacting the business */
  email: Scalars['String']['input'];
  /** Mailing address for the business */
  mailingAddress: AddressInput;
  /** Legal name of the business */
  name: Scalars['String']['input'];
  /** Primary phone number for contacting the business */
  phone: Scalars['String']['input'];
  /** Website URL for the business */
  website: Scalars['String']['input'];
};

/** Input for creating a new business record */
export type CreateBusinessInput = {
  /** Doing Business As (DBA) name, if different from legal name */
  dba: Scalars['String']['input'];
  /** Mailing address for the business */
  mailingAddress: AddressInput;
  /** ID of the business category this business belongs to */
  naics: Scalars['String']['input'];
  /** Legal name of the business */
  name: Scalars['String']['input'];
  /** Website URL for the business */
  website: Scalars['String']['input'];
};

/** Input for creating multiple business policies */
export type CreateBusinessPoliciesInput = {
  /** ID of the account to create policies for */
  accountId: Scalars['String']['input'];
  /** List of policies to create */
  policies: Array<CreateBusinessPolicyInput>;
};

/** Input for creating a single business policy */
export type CreateBusinessPolicyInput = {
  /** Type of agency billing */
  agencyBillingType?: InputMaybe<BusinessPolicyAgencyBillingType>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['input'];
  /** ID of the agency user who sourced the policy */
  agencyUserId: Scalars['String']['input'];
  /** Reference ID for existing Ascend quote */
  ascendExistingQuoteRefId?: InputMaybe<Scalars['String']['input']>;
  /** Mode for creating Ascend program */
  ascendProgramCreationMode?: InputMaybe<AscendProgramCreationMode>;
  /** ID of the Ascend program */
  ascendProgramId?: InputMaybe<Scalars['String']['input']>;
  /** Type of billing for the policy */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['input'];
  /** ID of the broker, if applicable */
  brokerId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the insurance carrier */
  carrierId: Scalars['String']['input'];
  /** Estimated commission percentage */
  estimatedCommission: Scalars['Float']['input'];
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** Unique identifier for the policy, used only for Ascend program referencing (an ID is actually generated by the server) */
  id: Scalars['String']['input'];
  /** When the policy goes into effect */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Insurance market the policy is written in */
  market: InsuranceMarket;
  /** Minimum earned premium for the policy */
  minimumEarnedPremium: Scalars['Float']['input'];
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['input'];
  /** Payment interval of the policy. If billed via ASCEND, leave this blank */
  paymentIntervalType?: InputMaybe<PaymentIntervalType>;
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['input'];
  /** Policy number once issued */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium: Scalars['Float']['input'];
  /** Quote number from carrier */
  quoteNumber: Scalars['String']['input'];
  /** Current state of the policy */
  state: PolicyState;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['input'];
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total: Scalars['Float']['input'];
  /** Type of insurance policy */
  type: InsuranceType;
};

/** Input for creating a certificate of insurance */
export type CreateCertificateInput = {
  accountId: Scalars['ID']['input'];
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['input'];
  /** Description of the operations covered by the certificate */
  descriptionOfOperations: Scalars['String']['input'];
  /** The holder of the certificate */
  holder: CertificateHolderInput;
};

/** Options for creating a certificate of insurance on the client side */
export type CreateCertificateOptions = {
  __typename?: 'CreateCertificateOptions';
  /** The allowed blanket additional insureds for this certificate */
  allowedBlanketAdditionalInsureds: Array<BlanketAdditionalInsuredCertificateOption>;
  /** The allowed named additional insureds for this certificate */
  allowedNamedAdditionalInsureds: Array<NamedAdditionalInsuredCertificateOption>;
};

/** Details for a request to create a Certificate of Insurance */
export type CreateCertificateRequest = {
  __typename?: 'CreateCertificateRequest';
  /** Whether the certificate holder should be listed as additional insured */
  additionalInsured: Scalars['Boolean']['output'];
  /** Relationship between policyholder and additional insured, if applicable */
  additionalInsuredRelationship?: Maybe<Scalars['String']['output']>;
  /** Additional details about the relationship, if applicable */
  additionalInsuredRelationshipDescription?: Maybe<Scalars['String']['output']>;
  /** Address of the certificate holder */
  address: Address;
  /** Name of the certificate holder */
  name: Scalars['String']['output'];
};

/** Input type for creating a Certificate of Insurance request */
export type CreateCertificateRequestInput = {
  /** Whether the certificate holder should be listed as additional insured */
  additionalInsured: Scalars['Boolean']['input'];
  /** Relationship between policyholder and additional insured, if applicable */
  additionalInsuredRelationship?: InputMaybe<Scalars['String']['input']>;
  /** Additional details about the relationship, if applicable */
  additionalInsuredRelationshipDescription?: InputMaybe<Scalars['String']['input']>;
  /** Address of the certificate holder */
  address: AddressInput;
  /** Name of the certificate holder */
  name: Scalars['String']['input'];
};

/** Input for creating a new client record */
export type CreateClientInput = {
  /** The initial business details for the client */
  business?: InputMaybe<CreateBusinessInput>;
  /** Primary email address for contacting the client */
  email: Scalars['String']['input'];
  /** Full name of the client */
  name: Scalars['String']['input'];
  /** Primary phone number for contacting the client */
  phone: Scalars['String']['input'];
};

/** CreateHawksoftIntegrationInput contains the input for creating a Hawksoft integration */
export type CreateHawksoftIntegrationInput = {
  /** Hawksoft agency ID */
  agencyId: Scalars['String']['input'];
};

/** CreateHubSpotIntegrationInput contains the input for creating a HubSpot integration */
export type CreateHubSpotIntegrationInput = {
  /** Personal Access Token for HubSpot API authentication */
  accessToken: Scalars['String']['input'];
  /** Field mappings for call syncing */
  callFieldMappings?: InputMaybe<HubSpotCallFieldMappingsInput>;
  /** The pipeline ID to use when syncing calls as tickets or deals */
  callPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing calls as tickets or deals */
  callStageId?: InputMaybe<Scalars['String']['input']>;
  /** Field mappings for task syncing */
  taskFieldMappings?: InputMaybe<HubSpotTaskFieldMappingsInput>;
  /** The pipeline ID to use when syncing tasks as tickets or deals */
  taskPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing tasks as tickets or deals */
  taskStageId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new business record */
export type CreateIndividualAccountInput = {
  /** Primary email address for contacting the individual */
  email: Scalars['String']['input'];
  /** Mailing address for the individual */
  mailingAddress: AddressInput;
  /** Full name of the individual */
  name: Scalars['String']['input'];
  /** Primary phone number for contacting the individual */
  phone: Scalars['String']['input'];
};

/** CreateIntegrationInput contains the input for creating an integration */
export type CreateIntegrationInput = {
  /** Configuration for the Hawksoft integration */
  hawksoft?: InputMaybe<CreateHawksoftIntegrationInput>;
  /** Configuration for the HubSpot integration */
  hubspot?: InputMaybe<CreateHubSpotIntegrationInput>;
  /** Configuration for the NowCerts integration */
  nowcerts?: InputMaybe<CreateNowCertsIntegrationInput>;
  /** Type of integration */
  type: IntegrationType;
};

/** Input for creating a new text document in the knowledge base */
export type CreateKnowledgeBaseTextDocumentInput = {
  /** The text of the document */
  content: Scalars['String']['input'];
  /** The title of the document */
  title: Scalars['String']['input'];
};

/** CreateNowCertsIntegrationInput contains the input for creating a NowCerts integration */
export type CreateNowCertsIntegrationInput = {
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls: Scalars['Boolean']['input'];
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks: Scalars['Boolean']['input'];
  /** NowCerts password for basic authentication */
  password: Scalars['String']['input'];
  /** NowCerts username for basic authentication */
  username: Scalars['String']['input'];
};

/** Input type for creating a new service request */
export type CreateServiceRequestInput = {
  /** The ID of the account to associate this service request with */
  accountId: Scalars['String']['input'];
  /** Details specific to additional insured requests */
  addAdditionalInsured?: InputMaybe<AddAdditionalInsuredRequestInput>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: InputMaybe<CancelPolicyRequestInput>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: InputMaybe<CreateCertificateRequestInput>;
  /** Additional details about the request */
  details: Scalars['String']['input'];
  /** Details specific to document requests */
  documentRequest?: InputMaybe<DocumentRequestInput>;
  /** Details specific to question requests */
  question?: InputMaybe<QuestionRequestInput>;
  /** Type of service request */
  type: ServiceRequestType;
};

/** A custom preset for Cara to execute tasks and produce artifacts */
export type CustomPreset = {
  __typename?: 'CustomPreset';
  /** The agency this custom preset is associated with */
  agency: Agency;
  /** Whether the custom preset allows file uploads */
  allowFileUpload: Scalars['Boolean']['output'];
  /** The base prompt for the custom preset */
  basePrompt: Scalars['String']['output'];
  /** The timestamp when this custom preset was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this custom preset */
  createdBy: AgencyUser;
  /** The description of the custom preset */
  description: Scalars['String']['output'];
  /** The files that are used as context for the custom preset */
  files: Array<File>;
  /** The ID of the custom preset */
  id: Scalars['ID']['output'];
  /** The preset that this custom preset inherits from, if any */
  inheritFromPreset?: Maybe<CaraWorkspacePreset>;
  /** The title of the custom preset */
  title: Scalars['String']['output'];
  /** The timestamp when this custom preset was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this custom preset */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this custom preset. The first version in this list will be this version
   * (i.e. identical to the current custom preset), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<CustomPresetVersion>>;
};

export type CustomPresetInput = {
  /** Whether the custom preset allows file uploads */
  allowFileUpload: Scalars['Boolean']['input'];
  /** The base prompt for the custom preset */
  basePrompt: Scalars['String']['input'];
  /** The description of the custom preset */
  description: Scalars['String']['input'];
  /** The IDs of the existing files that should be kept as context for the custom preset */
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The preset that this custom preset inherits from, if any */
  inheritFromPreset?: InputMaybe<CaraWorkspacePreset>;
  /** The title of the custom preset */
  title: Scalars['String']['input'];
  /** The files to upload if an existing file is not provided */
  uploadFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
};

/** Describes the reason why a custom preset was updated */
export enum CustomPresetUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a custom preset */
export enum CustomPresetUpdateType {
  /** The custom preset was archived */
  ArchiveCustomPreset = 'ARCHIVE_CUSTOM_PRESET',
  /** The custom preset was created */
  CreateCustomPreset = 'CREATE_CUSTOM_PRESET',
  /** The custom preset was unarchived */
  UnarchiveCustomPreset = 'UNARCHIVE_CUSTOM_PRESET',
  /** The custom preset was updated */
  UpdateCustomPreset = 'UPDATE_CUSTOM_PRESET'
}

/** Describes a particular version of a custom preset */
export type CustomPresetVersion = {
  __typename?: 'CustomPresetVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The full custom preset object that includes all of the updates made in this version and all previous versions */
  customPreset: CustomPreset;
  /** Produces a human-readable string that can be used to diff against another custom preset version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous custom preset version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<CustomPresetVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<CustomPresetUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<CustomPresetUpdateType>;
  /** The version number of this custom preset version */
  version: Scalars['Int64']['output'];
};

/** Custom CSS property that doesn't fit into the structured schema */
export type CustomStyle = {
  __typename?: 'CustomStyle';
  /** CSS properties to apply to the selector */
  properties: Array<CustomStyleProperty>;
  /** CSS selector (e.g. '.header', '#footer') */
  selector: Scalars['String']['output'];
};

/** Custom CSS property */
export type CustomStyleProperty = {
  __typename?: 'CustomStyleProperty';
  /** CSS property name (e.g. 'margin', 'padding', 'border') */
  name: Scalars['String']['output'];
  /** CSS property value (e.g. '2em 0', '1px solid #cbd5e1') */
  value: Scalars['String']['output'];
};

/**
 * A document that has been generated by the agency. This contains the raw data that populates a document
 * and is generated dynamically when the download URL is visited.
 */
export type Document = {
  __typename?: 'Document';
  createdAt: Scalars['Time']['output'];
  data: DocumentData;
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: DocumentType;
  updatedAt: Scalars['Time']['output'];
};

/**
 * Data used to generated the document. The fields in here must map to the fields
 * required by the document type.
 */
export type DocumentData = {
  __typename?: 'DocumentData';
  acord24?: Maybe<Acord24Data>;
  acord25?: Maybe<Acord25Data>;
  acord27?: Maybe<Acord27Data>;
  acord28?: Maybe<Acord28Data>;
  acord35?: Maybe<Acord35Data>;
  acord36?: Maybe<Acord36Data>;
  acord75?: Maybe<Acord75Data>;
  acord125?: Maybe<Acord125Data>;
  acord126?: Maybe<Acord126Data>;
  acord130?: Maybe<Acord130Data>;
  acord131?: Maybe<Acord131Data>;
  acord140?: Maybe<Acord140Data>;
};

/** Details for a request for policy-related documents */
export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  /** Type of document being requested */
  type: DocumentRequestType;
};

/** Input type for requesting policy-related documents */
export type DocumentRequestInput = {
  /** Type of document being requested */
  type?: InputMaybe<DocumentRequestType>;
};

/** Types of documents that can be requested */
export enum DocumentRequestType {
  /** Insurance binder document */
  Binder = 'BINDER',
  /** Certificate of Insurance */
  Certificate = 'CERTIFICATE',
  /** Policy endorsement document */
  Endorsement = 'ENDORSEMENT',
  /** Other document types */
  Other = 'OTHER',
  /** Full policy documentation */
  PolicyDocument = 'POLICY_DOCUMENT'
}

/** The type of document depending on which different fields in `Document` are populated */
export enum DocumentType {
  Acord_24 = 'ACORD_24',
  Acord_25 = 'ACORD_25',
  Acord_27 = 'ACORD_27',
  Acord_28 = 'ACORD_28',
  Acord_35 = 'ACORD_35',
  Acord_36 = 'ACORD_36',
  Acord_75 = 'ACORD_75',
  Acord_125 = 'ACORD_125',
  Acord_126 = 'ACORD_126',
  Acord_130 = 'ACORD_130',
  Acord_131 = 'ACORD_131',
  Acord_140 = 'ACORD_140'
}

/**
 * Represents a tool for drafting documents.
 * Used when the LLM needs to create or modify documents.
 */
export type DraftDocumentTool = {
  __typename?: 'DraftDocumentTool';
  /** The input arguments for document drafting */
  input: DraftDocumentToolInput;
  /** The result of the document drafting operation */
  output: DraftDocumentToolOutput;
};

/**
 * Input arguments for the DraftDocumentTool.
 * Contains all necessary information to draft a document.
 */
export type DraftDocumentToolInput = {
  __typename?: 'DraftDocumentToolInput';
  /** The ID of the document artifact being created */
  artifactId: Scalars['String']['output'];
  /** The HTML content of the document */
  htmlContent: Scalars['String']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/**
 * Result of a DraftDocumentTool operation.
 * Contains information about the created document artifact.
 */
export type DraftDocumentToolOutput = {
  __typename?: 'DraftDocumentToolOutput';
  /** The ID of the created document artifact */
  artifactId: Scalars['String']['output'];
};

/**
 * Represents a tool for drafting email messages.
 * Used when the LLM needs to compose and send emails.
 */
export type DraftEmailTool = {
  __typename?: 'DraftEmailTool';
  /** The input arguments for email drafting */
  input: DraftEmailToolInput;
  /** The result of the email drafting operation */
  output: DraftEmailToolOutput;
};

/**
 * Input arguments for the DraftEmailTool.
 * Contains all necessary information to draft an email.
 */
export type DraftEmailToolInput = {
  __typename?: 'DraftEmailToolInput';
  /** The ID of the artifact (email) being created */
  artifactId: Scalars['String']['output'];
  /** The body content of the email */
  body: Scalars['String']['output'];
  /** The subject line of the email */
  subject: Scalars['String']['output'];
  /** The recipient's email address */
  toEmail: Scalars['String']['output'];
  /** The recipient's name */
  toName: Scalars['String']['output'];
};

/**
 * Result of a DraftEmailTool operation.
 * Contains information about the created email artifact.
 */
export type DraftEmailToolOutput = {
  __typename?: 'DraftEmailToolOutput';
  /** The ID of the created email artifact */
  artifactId: Scalars['String']['output'];
};

/** Element-specific styles */
export type ElementStyles = {
  __typename?: 'ElementStyles';
  /** Code block styles */
  code: CodeStyle;
  /** Heading styles */
  headings: HeadingStyles;
  /** Image styles */
  image: ImageStyle;
  /** Link styles */
  link: LinkStyle;
  /** List styles */
  list: ListStyle;
  /** Paragraph styles */
  paragraph: ParagraphStyle;
  /** Table styles */
  table: TableStyle;
};

/** Represents an email message in a thread */
export type Email = {
  __typename?: 'Email';
  /** Body content of the email */
  body: Scalars['String']['output'];
  /** Carbon copy recipients of the email */
  cc: Array<EmailParticipant>;
  /** Timestamp when this record was created */
  createdAt: Scalars['Time']['output'];
  /** Sender of the email */
  from: EmailParticipant;
  /** Hash of the email content for deduplication */
  hash: Scalars['String']['output'];
  /** Unique identifier for the email */
  id: Scalars['ID']['output'];
  /** Message-ID this email is replying to, if any */
  inReplyToMessageId?: Maybe<Scalars['String']['output']>;
  /** Unique Message-ID header value from the email */
  messageId: Scalars['String']['output'];
  /** Role of the sender (agent, Cara, or participant) */
  senderRole: EmailSenderRole;
  /** Timestamp when the email was sent */
  sentAt: Scalars['Time']['output'];
  /** Subject line of the email */
  subject: Scalars['String']['output'];
  /** ID of the thread this email belongs to */
  threadId: Scalars['String']['output'];
  /** Primary recipients of the email */
  to: Array<EmailParticipant>;
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Represents a draft of an email message in a thread */
export type EmailDraft = {
  __typename?: 'EmailDraft';
  /** Body content of the email */
  body: Scalars['String']['output'];
  /** Sender of the email */
  from: EmailParticipant;
  /** Subject line of the email */
  subject: Scalars['String']['output'];
  /** Primary recipients of the email */
  to: Array<EmailParticipant>;
};

/** Represents a participant (sender or recipient) of an email */
export type EmailParticipant = {
  __typename?: 'EmailParticipant';
  /** Email address of the participant */
  email: Scalars['String']['output'];
  /** Display name of the participant */
  name: Scalars['String']['output'];
};

/** Role of an email sender in the context of the system */
export enum EmailSenderRole {
  /** Message sent by an agency agent */
  Agent = 'AGENT',
  /** Message sent by the Cara AI assistant */
  Cara = 'CARA',
  /** Message sent by a known client */
  Client = 'CLIENT',
  /** Message sent by any other participant */
  Participant = 'PARTICIPANT'
}

/** Represents an email thread */
export type EmailThread = {
  __typename?: 'EmailThread';
  /** The account associated with this email, if any */
  account?: Maybe<Account>;
  /** The agency associated with this email */
  agency: Agency;
  /** Attachments in the email thread */
  attachments: Array<File>;
  /** Timestamp when this record was created */
  createdAt: Scalars['Time']['output'];
  /** The email address of the participant who initiated the thread */
  fromEmail: Scalars['String']['output'];
  /** The name of the participant who initiated the thread */
  fromName: Scalars['String']['output'];
  /** Unique identifier for the thread */
  id: Scalars['ID']['output'];
  /** Emails in the thread from participants, clients, and agents */
  participantEmails: Array<Email>;
  /** Service requests associated with this thread */
  serviceRequests: Array<ServiceRequest>;
  /** State of the thread */
  state: EmailThreadState;
  /** The subject of the thread */
  subject: Scalars['String']['output'];
  /** The summary of the thread */
  summary: Scalars['String']['output'];
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The role of the participant that the email thread is waiting for in order to proceed */
  waitingFor?: Maybe<EmailSenderRole>;
  /** The Cara workspace this email thread is associated with, if any */
  workspace?: Maybe<CaraWorkspace>;
};

/** Represents the state of an email thread */
export enum EmailThreadState {
  /** The thread is active and waiting for a response */
  Active = 'ACTIVE',
  /** The invocation has ended */
  Ended = 'ENDED'
}

/** Details for a request to endorse a policy */
export type EndorsePolicyRequest = {
  __typename?: 'EndorsePolicyRequest';
  /** ID of the policy to be endorsed */
  policyId: Scalars['String']['output'];
};

/** Input type for endorsing a policy request */
export type EndorsePolicyRequestInput = {
  /** ID of the policy to be endorsed */
  policyId: Scalars['String']['input'];
};

/**
 * A file describes a document that is attached to an object, with
 * metadata and URLs to fetch it.
 */
export type File = {
  __typename?: 'File';
  /** The timestamp this file was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp this file was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the entity that this file is associated with */
  entityRefId: Scalars['String']['output'];
  /** The type of entity that this file is associated with */
  entityRefType: FileEntityRefType;
  /** The SHA256 hash of the file bytes */
  hash: Scalars['String']['output'];
  /** The unique identifier of the file */
  id: Scalars['ID']['output'];
  /** The file MIME type */
  mimeType: Scalars['String']['output'];
  /** The file name, for display and download purposes */
  name: Scalars['String']['output'];
  /** The notes associated with the file */
  notes: Scalars['String']['output'];
  /** The size of the file in bytes */
  size: Scalars['Int']['output'];
  /** The type of the file */
  type: FileType;
  /** The timestamp this file was updated */
  updatedAt: Scalars['Time']['output'];
  /** The public URL to fetch the file, if the file is visible to the user */
  url?: Maybe<Scalars['String']['output']>;
  /** Whether the file is visible to the user */
  visible: Scalars['Boolean']['output'];
};

/** FileEntityRefType describes the type of entity that a file is associated with. */
export enum FileEntityRefType {
  /** The file is associated with an account */
  Account = 'ACCOUNT',
  /** The file is associated with a Cara workspace */
  CaraWorkspace = 'CARA_WORKSPACE',
  /** The file is associated with a custom preset */
  CustomPreset = 'CUSTOM_PRESET',
  /** The file is associated with an email thread */
  EmailThread = 'EMAIL_THREAD',
  /** The file is associated with an HTML document template */
  HtmlDocumentTemplate = 'HTML_DOCUMENT_TEMPLATE',
  /** The file is associated with a policy */
  Policy = 'POLICY',
  /** The file is associated with a service request */
  ServiceRequest = 'SERVICE_REQUEST'
}

/** A reference to a file and pages that provide some relevant information */
export type FileReference = {
  __typename?: 'FileReference';
  /** The form number of the file */
  formNumber: Scalars['String']['output'];
  /** The ID of the file */
  id: Scalars['String']['output'];
  /** The page index of the file. Formatted as page numbers or ranges separated by commas. */
  pageIndexes: Scalars['String']['output'];
  /** The quotes from the file. */
  quotes: Scalars['String']['output'];
};

/** File role describes a type of file related to an object */
export enum FileType {
  /** The file is a form generated as part of an application */
  ApplicationForm = 'APPLICATION_FORM',
  /** The file is a binder, a pre-coverage confirmation document */
  Binder = 'BINDER',
  /** The file is a certificate of insurance */
  Certificate = 'CERTIFICATE',
  /** The file is an endorsement, affixed to the policy document */
  Endorsement = 'ENDORSEMENT',
  /** The file is an invoice, generally for internal tracking purposes */
  Invoice = 'INVOICE',
  /** The file is a lost policy release, issued when a policy is canceled by the customer */
  LostPolicyRelease = 'LOST_POLICY_RELEASE',
  /** The file is a notice of cancellation, issued when a policy is being canceled or nonrenewed by the carrier */
  NoticeOfCancellation = 'NOTICE_OF_CANCELLATION',
  /** The file is of another type */
  Other = 'OTHER',
  /** The file is a policy document */
  PolicyDocument = 'POLICY_DOCUMENT',
  /** The file is a quote document */
  QuoteDocument = 'QUOTE_DOCUMENT'
}

/**
 * Represents a tool for filling out a template.
 * Used when the LLM needs to fill out a template such as an ACORD form.
 */
export type FillTemplateTool = {
  __typename?: 'FillTemplateTool';
  /** The input arguments for the template filling */
  input: FillTemplateToolInput;
  /** The result of the template filling */
  output: FillTemplateToolOutput;
};

/**
 * Input arguments for the FillTemplateTool.
 * Contains all necessary information to fill out a template.
 */
export type FillTemplateToolInput = {
  __typename?: 'FillTemplateToolInput';
  /** The data for the template being filled out */
  acord24?: Maybe<Acord24Data>;
  acord25?: Maybe<Acord25Data>;
  acord27?: Maybe<Acord27Data>;
  acord28?: Maybe<Acord28Data>;
  acord35?: Maybe<Acord35Data>;
  acord36?: Maybe<Acord36Data>;
  acord75?: Maybe<Acord75Data>;
  acord125?: Maybe<Acord125Data>;
  acord126?: Maybe<Acord126Data>;
  acord130?: Maybe<Acord130Data>;
  acord131?: Maybe<Acord131Data>;
  acord140?: Maybe<Acord140Data>;
  /** The ID of the template being filled out */
  templateId: DocumentType;
};

/**
 * Result of a FillTemplateTool operation.
 * Contains information about the filled template.
 */
export type FillTemplateToolOutput = {
  __typename?: 'FillTemplateToolOutput';
  /** The ID of the filled template */
  artifactId: Scalars['String']['output'];
};

/** A font to load in the HTML document template */
export type Font = {
  __typename?: 'Font';
  /** The name of the font */
  name: Scalars['String']['output'];
  /** The variants of the font */
  variants: Array<FontVariant>;
};

/** A variant of a font */
export type FontVariant = {
  __typename?: 'FontVariant';
  /** The source of the font variant */
  src: Scalars['String']['output'];
  /** The style of the font variant */
  style: Scalars['String']['output'];
  /** The weight of the font variant */
  weight: Scalars['Int']['output'];
};

/** How the general aggregate limit applies to a liability policy */
export enum GeneralAggregateLimitAppliesPerType {
  /** Limit applies in some other way */
  Other = 'OTHER',
  /** Limit applies per location */
  PerLocation = 'PER_LOCATION',
  /** Limit applies per policy */
  PerPolicy = 'PER_POLICY',
  /** Limit applies per project */
  PerProject = 'PER_PROJECT'
}

/** HawksoftConfiguration contains configuration for the Hawksoft integration */
export type HawksoftConfiguration = {
  __typename?: 'HawksoftConfiguration';
  /** Hawksoft agency ID */
  agencyId: Scalars['String']['output'];
  /** If enabled, will sync call notes to the appropriate contact based on the caller's number. */
  enableSyncCallNotes: Scalars['Boolean']['output'];
  /** If enabled, will allow Cara to write attachments to Hawksoft in Copilot workspaces. */
  enableSyncCopilotAttachments: Scalars['Boolean']['output'];
  /** If enabled, will sync service requests as tasks to the agent. */
  enableSyncServiceRequests: Scalars['Boolean']['output'];
};

/** Individual heading style */
export type HeadingStyle = {
  __typename?: 'HeadingStyle';
  /** Text color in hex format (e.g. '#0f172a') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 18.0 for h1, 15.0 for h2) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font weight as a number (e.g. 600 for semi-bold) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Bottom margin in em units (e.g. 0.4) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Top margin in em units (e.g. 1.2) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
};

/** Heading styles for all levels */
export type HeadingStyles = {
  __typename?: 'HeadingStyles';
  /** H1 styles */
  h1: HeadingStyle;
  /** H2 styles */
  h2: HeadingStyle;
  /** H3 styles */
  h3: HeadingStyle;
  /** H4 styles */
  h4: HeadingStyle;
  /** H5 styles */
  h5: HeadingStyle;
  /** H6 styles */
  h6: HeadingStyle;
};

/** A HTML document artifact */
export type HtmlDocument = {
  __typename?: 'HtmlDocument';
  /** The HTML content of the document */
  content: Scalars['String']['output'];
  /** The ID of the document */
  id: Scalars['ID']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/** A custom preset for Cara to execute tasks and produce artifacts */
export type HtmlDocumentTemplate = {
  __typename?: 'HtmlDocumentTemplate';
  /** The agency this HTML document template is associated with */
  agency: Agency;
  /**
   * The base style to inherit from. Can be a built-in style or another custom style.
   * Built-in styles are prefixed with 'builtin:' (e.g. 'builtin:classic-professional')
   */
  baseStyleId?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this HTML document template was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this HTML document template */
  createdBy: AgencyUser;
  /** The description of the HTML document template */
  description: Scalars['String']['output'];
  /** The ID of the HTML document template */
  id: Scalars['ID']['output'];
  /** The files that are used as prefixes for the HTML document template */
  prefixFiles: Array<File>;
  /** The style of the HTML document template */
  style: HtmlDocumentTemplateStyle;
  /** The files that are used as suffixes for the HTML document template */
  suffixFiles: Array<File>;
  /** The title of the HTML document template */
  title: Scalars['String']['output'];
  /** The timestamp when this HTML document template was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this HTML document template */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this HTML document template. The first version in this list will be this version
   * (i.e. identical to the current HTML document template), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<HtmlDocumentTemplateVersion>>;
};

export type HtmlDocumentTemplateInput = {
  /** The base style ID that should be used as fallback styles. */
  baseStyleId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the HTML document template */
  description: Scalars['String']['input'];
  /** The ID of the existing prefix file to keep */
  prefixFileId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the existing suffix file to keep */
  suffixFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the HTML document template */
  title: Scalars['String']['input'];
  /** The prefix file to upload if an existing prefix file is not provided */
  uploadPrefixFile?: InputMaybe<Scalars['Upload']['input']>;
  /** The suffix file to upload if an existing suffix file is not provided */
  uploadSuffixFile?: InputMaybe<Scalars['Upload']['input']>;
};

/** The style of a HTML document template */
export type HtmlDocumentTemplateStyle = {
  __typename?: 'HtmlDocumentTemplateStyle';
  /** Custom CSS properties that don't fit into the structured schema */
  customStyles?: Maybe<Array<CustomStyle>>;
  /** Element-specific styles */
  elements: ElementStyles;
  /** The fonts to load in the HTML document template */
  fonts: Array<Font>;
  /** Page layout settings */
  page: PageStyle;
  /** Typography settings */
  typography: TypographyStyle;
};

/** Describes the reason why a HTML document template was updated */
export enum HtmlDocumentTemplateUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a HTML document template */
export enum HtmlDocumentTemplateUpdateType {
  /** The HTML document template was archived */
  ArchiveHtmlDocumentTemplate = 'ARCHIVE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was created */
  CreateHtmlDocumentTemplate = 'CREATE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was unarchived */
  UnarchiveHtmlDocumentTemplate = 'UNARCHIVE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was updated */
  UpdateHtmlDocumentTemplate = 'UPDATE_HTML_DOCUMENT_TEMPLATE'
}

/** Describes a particular version of a HTML document template */
export type HtmlDocumentTemplateVersion = {
  __typename?: 'HtmlDocumentTemplateVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another HTML document template version. */
  diffableJson: Scalars['String']['output'];
  /** The full HTML document template object that includes all of the updates made in this version and all previous versions */
  htmlDocumentTemplate: HtmlDocumentTemplate;
  /** The version number of the previous HTML document template version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<HtmlDocumentTemplateVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<HtmlDocumentTemplateUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<HtmlDocumentTemplateUpdateType>;
  /** The version number of this HTML document template version */
  version: Scalars['Int64']['output'];
};

/** HubSpotCallFieldMappings defines field mappings for call syncing */
export type HubSpotCallFieldMappings = {
  __typename?: 'HubSpotCallFieldMappings';
  /** Field mappings when syncing calls as deals */
  dealFields: Array<HubSpotFieldMapping>;
  /** Field mappings when syncing calls as tickets */
  ticketFields: Array<HubSpotFieldMapping>;
};

/** HubSpotCallFieldMappingsInput defines field mappings for call syncing. Only one of ticketFields or dealFields should be provided, based on callSyncType. */
export type HubSpotCallFieldMappingsInput = {
  /** Field mappings when syncing calls as deals. Required when callSyncType is DEAL, must not be provided otherwise. */
  dealFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
  /** Field mappings when syncing calls as tickets. Required when callSyncType is TICKET, must not be provided otherwise. */
  ticketFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
};

/** HubSpotCallSyncType defines how calls are synced to HubSpot */
export enum HubSpotCallSyncType {
  /** Sync calls as deals */
  Deal = 'DEAL',
  /** Sync calls as engagement calls */
  EngagementCall = 'ENGAGEMENT_CALL',
  /** Sync calls as engagement notes */
  EngagementNote = 'ENGAGEMENT_NOTE',
  /** Sync calls as tickets */
  Ticket = 'TICKET'
}

/** HubSpotConfiguration contains configuration for the HubSpot integration */
export type HubSpotConfiguration = {
  __typename?: 'HubSpotConfiguration';
  /** Personal Access Token for HubSpot API authentication */
  accessToken: Scalars['String']['output'];
  /** Field mappings for call syncing */
  callFieldMappings?: Maybe<HubSpotCallFieldMappings>;
  /** The pipeline ID to use when syncing calls as tickets or deals */
  callPipelineId?: Maybe<Scalars['String']['output']>;
  /** The stage ID to use when syncing calls as tickets or deals */
  callStageId?: Maybe<Scalars['String']['output']>;
  /** How calls should be synced to HubSpot */
  callSyncType?: Maybe<HubSpotCallSyncType>;
  /** If enabled, will sync calls from Cara to HubSpot */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to HubSpot */
  enableSyncTasks: Scalars['Boolean']['output'];
  /** Field mappings for task syncing */
  taskFieldMappings?: Maybe<HubSpotTaskFieldMappings>;
  /** The pipeline ID to use when syncing tasks as tickets or deals */
  taskPipelineId?: Maybe<Scalars['String']['output']>;
  /** The stage ID to use when syncing tasks as tickets or deals */
  taskStageId?: Maybe<Scalars['String']['output']>;
  /** How tasks should be synced to HubSpot */
  taskSyncType?: Maybe<HubSpotTaskSyncType>;
};

/** HubSpotFieldMapping defines how a Cara field maps to a HubSpot field */
export type HubSpotFieldMapping = {
  __typename?: 'HubSpotFieldMapping';
  /** The name of the field in Cara */
  caraField: Scalars['String']['output'];
  /** The name of the field in HubSpot */
  hubspotField: Scalars['String']['output'];
};

/** HubSpotFieldMappingInput defines how a Cara field maps to a HubSpot field */
export type HubSpotFieldMappingInput = {
  /** The name of the field in Cara */
  caraField: Scalars['String']['input'];
  /** The name of the field in HubSpot */
  hubspotField: Scalars['String']['input'];
};

export type HubSpotPipeline = {
  __typename?: 'HubSpotPipeline';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  stages: Array<HubSpotPipelineStage>;
  updatedAt: Scalars['String']['output'];
};

export type HubSpotPipelineStage = {
  __typename?: 'HubSpotPipelineStage';
  archived: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/** HubSpotTaskFieldMappings defines field mappings for task syncing */
export type HubSpotTaskFieldMappings = {
  __typename?: 'HubSpotTaskFieldMappings';
  /** Field mappings when syncing tasks as deals */
  dealFields: Array<HubSpotFieldMapping>;
  /** Field mappings when syncing tasks as tickets */
  ticketFields: Array<HubSpotFieldMapping>;
};

/** HubSpotTaskFieldMappingsInput defines field mappings for task syncing. Only one of ticketFields or dealFields should be provided, based on taskSyncType. */
export type HubSpotTaskFieldMappingsInput = {
  /** Field mappings when syncing tasks as deals. Required when taskSyncType is DEAL, must not be provided otherwise. */
  dealFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
  /** Field mappings when syncing tasks as tickets. Required when taskSyncType is TICKET, must not be provided otherwise. */
  ticketFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
};

/** HubSpotTaskSyncType defines how tasks are synced to HubSpot */
export enum HubSpotTaskSyncType {
  /** Sync tasks as deals */
  Deal = 'DEAL',
  /** Sync tasks as engagement tasks */
  EngagementTask = 'ENGAGEMENT_TASK',
  /** Sync tasks as tickets */
  Ticket = 'TICKET'
}

export type HubSpotTicketPipeline = {
  __typename?: 'HubSpotTicketPipeline';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  stages: Array<HubSpotTicketPipelineStage>;
  updatedAt: Scalars['String']['output'];
};

export type HubSpotTicketPipelineStage = {
  __typename?: 'HubSpotTicketPipelineStage';
  archived: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  ticketState: Scalars['String']['output'];
};

/** Image style */
export type ImageStyle = {
  __typename?: 'ImageStyle';
  /** Whether height should be automatically calculated */
  heightAuto: Scalars['Boolean']['output'];
  /** Maximum width as a percentage (e.g. 100.0) */
  maxWidthPct?: Maybe<Scalars['Float']['output']>;
  /** Page break behavior (e.g. 'avoid') */
  pageBreakInside?: Maybe<Scalars['String']['output']>;
};

export enum IndexingStatus {
  /** The document has been indexed */
  Completed = 'COMPLETED',
  /** The document failed to index */
  Failed = 'FAILED',
  /** The document is being indexed */
  Indexing = 'INDEXING',
  /** The document has not started indexing yet */
  Unknown = 'UNKNOWN'
}

/** Account details specific to an individual account holder */
export type IndividualAccount = AccountDetails & {
  __typename?: 'IndividualAccount';
  /** Primary email address for contacting the individual */
  email: Scalars['String']['output'];
  /** Mailing address for the individual */
  mailingAddress: Address;
  /** The full name of the individual */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the individual */
  phone: Scalars['String']['output'];
};

/** Represents an insurance carrier or broker that can provide policies */
export type InsuranceCarrier = {
  __typename?: 'InsuranceCarrier';
  /** If available, the ID of this carrier in Ascend */
  ascendId?: Maybe<Scalars['String']['output']>;
  /** Human readable short identifier of this carrier */
  id: Scalars['String']['output'];
  /** True if this insurance entity is a broker which we use to access a carrier */
  isBroker: Scalars['Boolean']['output'];
  /** True if this insurance entity is a carrier with binding authority */
  isCarrier: Scalars['Boolean']['output'];
  /** Legal name of this carrier */
  name: Scalars['String']['output'];
  /** The types of insurance policies supported by this carrier */
  supportedPolicies?: Maybe<Array<InsuranceType>>;
};

/** Describes the market the insurance policy was written in. */
export enum InsuranceMarket {
  /** The admitted market */
  Admitted = 'ADMITTED',
  /** The Excess and Surplus (E&S) market */
  ExcessAndSurplus = 'EXCESS_AND_SURPLUS'
}

/** Insurance type for business insurance */
export enum InsuranceType {
  /** Insurance coverage for accidents and health-related incidents */
  AccidentAndHealth = 'ACCIDENT_AND_HEALTH',
  /** Comprehensive coverage package for business owners */
  BusinessOwners = 'BUSINESS_OWNERS',
  /** Coverage for vehicles used in commercial operations */
  CommercialAuto = 'COMMERCIAL_AUTO',
  /** Protection against cyber risks and data breaches */
  Cyber = 'CYBER',
  /** Coverage for directors and officers against liability claims */
  DirectorsAndOfficers = 'DIRECTORS_AND_OFFICERS',
  /** Protection against employment-related claims */
  EmploymentPracticesLiability = 'EMPLOYMENT_PRACTICES_LIABILITY',
  /** Coverage for professional mistakes and oversights */
  ErrorsAndOmission = 'ERRORS_AND_OMISSION',
  /** Additional liability coverage beyond standard policies */
  Excess = 'EXCESS',
  /** Basic liability coverage for business operations */
  GeneralLiability = 'GENERAL_LIABILITY',
  /** Specialized coverage for jewelry businesses */
  JewelersBlock = 'JEWELERS_BLOCK',
  /** Other types of insurance coverage not listed */
  Other = 'OTHER',
  /** Combined package of multiple insurance coverages */
  Package = 'PACKAGE',
  /** Coverage for product-related liability claims */
  ProductLiability = 'PRODUCT_LIABILITY',
  /** Coverage for professional services liability */
  ProfessionalLiability = 'PROFESSIONAL_LIABILITY',
  /** Coverage for business property and assets */
  Property = 'PROPERTY',
  /** Insurance for rental properties or equipment */
  Rental = 'RENTAL',
  /** Coverage for goods in transit and transportation risks */
  ShippingAndTransportation = 'SHIPPING_AND_TRANSPORTATION',
  /** Umbrella liability coverage */
  Umbrella = 'UMBRELLA',
  /** Coverage for employee work-related injuries */
  WorkersCompensation = 'WORKERS_COMPENSATION'
}

/** Integration represents a connection to an external system */
export type Integration = {
  __typename?: 'Integration';
  /** Authorization credentials for the integration */
  authorization?: Maybe<IntegrationAuthorization>;
  /** Configuration for the integration */
  configuration: IntegrationConfiguration;
  /** Timestamp of when the integration was created */
  createdAt: Scalars['Time']['output'];
  /** Timestamp of when the integration was deleted, if applicable */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** Unique identifier for the integration */
  id: Scalars['ID']['output'];
  /** Timestamp of when the integration last synced data */
  lastSyncedAt?: Maybe<Scalars['Time']['output']>;
  /** Current state of the integration */
  state: IntegrationState;
  /** Sync logs for the integration */
  syncLogs: Array<IntegrationSyncLog>;
  /** Type of integration */
  type: IntegrationType;
  /** Timestamp of when the integration was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** IntegrationAuthorization contains credentials for authenticating with the integration */
export type IntegrationAuthorization = {
  __typename?: 'IntegrationAuthorization';
  /** Basic authentication credentials */
  basicAuth?: Maybe<BasicAuth>;
  /** Bearer token authentication credentials */
  bearerAuth?: Maybe<BearerAuth>;
};

/** IntegrationConfiguration contains configuration for the integration */
export type IntegrationConfiguration = {
  __typename?: 'IntegrationConfiguration';
  /** Configuration for the Hawksoft integration */
  hawksoft?: Maybe<HawksoftConfiguration>;
  /** Configuration for the HubSpot integration */
  hubspot?: Maybe<HubSpotConfiguration>;
  /** Configuration for the NowCerts integration */
  nowcerts?: Maybe<NowCertsConfiguration>;
};

/** IntegrationState defines the current state of an integration */
export enum IntegrationState {
  /** Integration is active and functioning */
  Active = 'ACTIVE',
  /** Integration has been created but not yet configured */
  Created = 'CREATED',
  /** Integration has been disabled */
  Disabled = 'DISABLED',
  /** Integration is in process of being configured */
  Pending = 'PENDING'
}

/** A record of a sync operation for an integration */
export type IntegrationSyncLog = {
  __typename?: 'IntegrationSyncLog';
  /** Timestamp of when the sync operation completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** Progress of the sync operation */
  entitiesSynced: Scalars['Int']['output'];
  /** Entities written to the external system during this sync. */
  entitiesWritten: Array<IntegrationWrittenEntity>;
  /** Unique identifier for the sync log */
  id: Scalars['ID']['output'];
  /** The ID of the entity that initiated the sync operation */
  initiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the sync operation */
  initiatorType: UpdateInitiatorType;
  /** Last error message from the sync operation */
  lastError?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the sync operation started */
  startedAt: Scalars['Time']['output'];
  /** State of the sync operation */
  state: IntegrationSyncState;
  /** The type of the sync operation */
  type: IntegrationSyncType;
};

/** IntegrationSyncState defines the current state of a sync operation */
export enum IntegrationSyncState {
  /** Sync operation has completed */
  Completed = 'COMPLETED',
  /** Sync operation has failed */
  Failed = 'FAILED',
  /** Sync operation is in progress */
  InProgress = 'IN_PROGRESS'
}

/** IntegrationSyncType defines the type of sync operation */
export enum IntegrationSyncType {
  /** Sync operation is a full sync */
  Full = 'FULL',
  /** Sync operation is a read operation */
  Read = 'READ',
  /** Sync operation is an update sync */
  Update = 'UPDATE',
  /** Sync operation is a write operation */
  Write = 'WRITE'
}

/** IntegrationType defines the type of integration, including AMS, CRM, and more. */
export enum IntegrationType {
  /** Applied Epic agency management system integration */
  AmsAppliedEpic = 'AMS_APPLIED_EPIC',
  /** Hawksoft agency management system integration */
  AmsHawksoft = 'AMS_HAWKSOFT',
  /** NowCerts agency management system integration */
  AmsNowcerts = 'AMS_NOWCERTS',
  /** HubSpot CRM integration */
  CrmHubspot = 'CRM_HUBSPOT'
}

/** Represents an entity written to the external system during a sync. */
export type IntegrationWrittenEntity = {
  __typename?: 'IntegrationWrittenEntity';
  /** A human-readable description of the entity */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the entity */
  id: Scalars['String']['output'];
  /** The type of the entity (e.g., CALL, TASK) */
  type: Scalars['String']['output'];
};

export type KnowledgeBase = {
  __typename?: 'KnowledgeBase';
  /** The timestamp when this knowledge base was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp when this knowledge base was deleted, if it was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The documents in this knowledge base */
  documents: Array<KnowledgeBaseDocument>;
  /** The unique identifier for this knowledge base */
  id: Scalars['ID']['output'];
  /** The title of this knowledge base */
  title: Scalars['String']['output'];
  /** The timestamp when this knowledge base was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** A document that is part of a knowledge base */
export type KnowledgeBaseDocument = {
  __typename?: 'KnowledgeBaseDocument';
  /** The timestamp when this document was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this document */
  createdBy: AgencyUser;
  /** The timestamp when this document was deleted, if it was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The description of this document */
  description: Scalars['String']['output'];
  /** The file underlying a FILE-type document in the knowledge base */
  file?: Maybe<KnowledgeBaseDocumentFile>;
  /** The unique identifier for this document */
  id: Scalars['ID']['output'];
  /** The status of the document indexing */
  indexingStatus: KnowledgeBaseDocumentIndexingStatus;
  /** The metadata of the document if it has been generated */
  metadata?: Maybe<KnowledgeBaseDocumentMetadata>;
  /** The data underlying a TEXT-type document in the knowledge base */
  text?: Maybe<KnowledgeBaseDocumentText>;
  /** The title of this document */
  title: Scalars['String']['output'];
  /** The type of document in this knowledge base */
  type: KnowledgeBaseDocumentType;
  /** The timestamp when this document was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** An embedding of a document in the knowledge base */
export type KnowledgeBaseDocumentEmbedding = {
  __typename?: 'KnowledgeBaseDocumentEmbedding';
  /** The data underlying this chunk */
  chunkData: Scalars['String']['output'];
  /** The hash of the chunk */
  chunkHash: Scalars['String']['output'];
  /** The end position of the chunk in the document */
  chunkPosEnd: Scalars['Int']['output'];
  /** The start position of the chunk in the document */
  chunkPosStart: Scalars['Int']['output'];
  /** The sequence number of the chunk in the document */
  chunkSeq: Scalars['Int']['output'];
  /** The timestamp when this chunk was created */
  createdAt: Scalars['Time']['output'];
  /** The embedding of the chunk */
  embedding?: Maybe<Array<Scalars['Float']['output']>>;
  /** The metadata of the chunk */
  metadata?: Maybe<KnowledgeBaseDocumentMetadata>;
  /** The name of the embedding model used */
  modelName: Scalars['String']['output'];
  /** The revision of the embedding model used */
  modelRevision: Scalars['String']['output'];
  /** The timestamp when this chunk was updated */
  updatedAt: Scalars['Time']['output'];
};

/** File metadata underlying a FILE-type document in the knowledge base */
export type KnowledgeBaseDocumentFile = {
  __typename?: 'KnowledgeBaseDocumentFile';
  /** The timestamp this file was created */
  createdAt: Scalars['Time']['output'];
  /** The SHA256 hash of the file bytes */
  hash: Scalars['String']['output'];
  /** The MIME type of the uploaded file */
  mimeType: Scalars['String']['output'];
  /** The name of the uploaded file */
  name: Scalars['String']['output'];
  /** The size of the uploaded file in bytes */
  size: Scalars['Int']['output'];
  /** The public URL to fetch the file, if the file is visible to the user */
  url?: Maybe<Scalars['String']['output']>;
};

/** The status of the document indexing */
export type KnowledgeBaseDocumentIndexingStatus = {
  __typename?: 'KnowledgeBaseDocumentIndexingStatus';
  /** The timestamp when the indexing was completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** The error that occurred during the indexing, if any */
  error?: Maybe<Scalars['String']['output']>;
  /** The progress of the indexing */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the indexing was started */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The status of the indexing */
  status: IndexingStatus;
};

/** The metadata of a document in the knowledge base */
export type KnowledgeBaseDocumentMetadata = {
  __typename?: 'KnowledgeBaseDocumentMetadata';
  /** The keywords of the document */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /** The purpose of the document */
  purpose: Scalars['String']['output'];
  /** The summary of the document */
  summary: Scalars['String']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/** Content underlying a TEXT-type document in the knowledge base */
export type KnowledgeBaseDocumentText = {
  __typename?: 'KnowledgeBaseDocumentText';
  /** The content of this document */
  content: Scalars['String']['output'];
};

/** The type of document in a knowledge base */
export enum KnowledgeBaseDocumentType {
  /** A file that was uploaded into the knowledge base */
  File = 'FILE',
  /** A document that was written as part of the knowledge base */
  Text = 'TEXT'
}

/** KnowledgeGraphEntity represents an entity in the knowledge graph */
export type KnowledgeGraphEntity = {
  __typename?: 'KnowledgeGraphEntity';
  /** The timestamp of when the entity was created */
  createdAt: Scalars['Time']['output'];
  /** The display name of the entity (like full name, company name, ticket title, etc.) */
  displayName: Scalars['String']['output'];
  /** The ID of the entity in the external system */
  externalId: Scalars['String']['output'];
  /** Unique identifier for the entity */
  id: Scalars['ID']['output'];
  /** The integration this entity is associated with */
  integration: Integration;
  /** The ID of the entity in the internal system */
  internalId: Scalars['String']['output'];
  /** The timestamp of when the entity was last modified */
  modifiedAt: Scalars['Time']['output'];
  /** The properties of the entity as a JSON object */
  properties: Scalars['JSON']['output'];
  /** The schema of the entity */
  schema?: Maybe<KnowledgeGraphEntitySchema>;
  /** The search metadata of the entity */
  searchMetadata: KnowledgeGraphEntitySearchMetadata;
  /** The secondary information of the entity (like email, status, etc.) */
  secondaryInfo?: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the entity was last synced */
  syncedAt: Scalars['Time']['output'];
  /** The type of entity */
  type: KnowledgeGraphEntityType;
  /** The timestamp of when the entity was last modified */
  updatedAt: Scalars['Time']['output'];
};

/** KnowledgeGraphEntityFilter represents the filter for the entities */
export type KnowledgeGraphEntityFilter = {
  /** The search query to filter by */
  search?: InputMaybe<Scalars['String']['input']>;
  /** The types of entities to filter by */
  types?: InputMaybe<Array<KnowledgeGraphEntityType>>;
};

/** KnowledgeGraphEntitySchema represents the schema of the entity */
export type KnowledgeGraphEntitySchema = {
  __typename?: 'KnowledgeGraphEntitySchema';
  /** The type of entity this schema is for */
  entityType: KnowledgeGraphEntityType;
  /** Unique identifier for the schema */
  id: Scalars['ID']['output'];
  /** The integration this schema is associated with */
  integration: Integration;
  /** The properties of the schema */
  properties: Array<KnowledgeGraphEntitySchemaProperty>;
  /** The version of the schema */
  version: Scalars['Int']['output'];
};

export type KnowledgeGraphEntitySchemaProperty = {
  __typename?: 'KnowledgeGraphEntitySchemaProperty';
  /** The description of the schema */
  description?: Maybe<Scalars['String']['output']>;
  /** The display name of the schema */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The schema of the array items */
  items?: Maybe<KnowledgeGraphEntitySchemaProperty>;
  /** The name of the schema */
  name: Scalars['String']['output'];
  /** The properties of the entity schema */
  properties?: Maybe<Array<KnowledgeGraphEntitySchemaProperty>>;
  /** The type of the schema */
  type: KnowledgeGraphEntitySchemaPropertyType;
};

/** KnowledgeGraphEntitySchemaType represents the type of the schema */
export enum KnowledgeGraphEntitySchemaPropertyType {
  Array = 'ARRAY',
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Object = 'OBJECT',
  String = 'STRING'
}

/**
 * KnowledgeGraphEntitySearchMetadata represents the search metadata of the entity. It can be used to store
 * structured data that can be used to search for the entity. The metadata that is stored depends on the
 * type of the entity.
 */
export type KnowledgeGraphEntitySearchMetadata = {
  __typename?: 'KnowledgeGraphEntitySearchMetadata';
  /** The account metadata of the entity */
  account?: Maybe<KnowledgeGraphEntitySearchMetadataAccount>;
  /** The call log metadata of the entity */
  call?: Maybe<KnowledgeGraphEntitySearchMetadataCall>;
  /** The contact metadata of the entity */
  contact?: Maybe<KnowledgeGraphEntitySearchMetadataContact>;
  /** The note metadata of the entity */
  note?: Maybe<KnowledgeGraphEntitySearchMetadataNote>;
  /** The policy metadata of the entity */
  policy?: Maybe<KnowledgeGraphEntitySearchMetadataPolicy>;
  /** The task metadata of the entity */
  task?: Maybe<KnowledgeGraphEntitySearchMetadataTask>;
};

/** KnowledgeGraphEntitySearchMetadataAccount represents the account metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataAccount = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataAccount';
  /** The type of the account */
  dba?: Maybe<Scalars['String']['output']>;
  /** The email of the account */
  email?: Maybe<Scalars['String']['output']>;
  /** The address of the account */
  mailingAddress?: Maybe<Address>;
  /** The NAICS code of the account */
  naics?: Maybe<Scalars['String']['output']>;
  /** The name of the account */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the account */
  phone?: Maybe<Scalars['String']['output']>;
  /** The website of the account */
  website?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataCall represents the call metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataCall = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataCall';
  /** The action taken during the call */
  action?: Maybe<Scalars['String']['output']>;
  /** The name of the caller */
  fromName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call is from */
  fromNumber?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the call */
  id: Scalars['String']['output'];
  /** The result of the call */
  result?: Maybe<Scalars['String']['output']>;
  /** The start date and time of the call */
  startDate?: Maybe<Scalars['Time']['output']>;
  /** The name of the recipient */
  toName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call is to */
  toNumber?: Maybe<Scalars['String']['output']>;
  /** The type of the call (e.g., inbound, outbound) */
  type?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataContact represents the contact metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataContact = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataContact';
  /** The email of the contact */
  email?: Maybe<Scalars['String']['output']>;
  /** The name of the contact */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the contact */
  phone?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataNote represents the note metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataNote = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataNote';
  /** The create date of the note */
  createDate?: Maybe<Scalars['Time']['output']>;
  /** The created by of the note */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The subject of the note */
  subject?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataPolicy represents the policy metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataPolicy = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataPolicy';
  /** The expiration date of the policy */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /** The inforce date of the policy */
  inforceAt?: Maybe<Scalars['Time']['output']>;
  /** The policy number of the entity */
  policyNumber?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataTask represents the task metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataTask = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataTask';
  /** The description of the task */
  description?: Maybe<Scalars['String']['output']>;
  /** The title of the task */
  title?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntityType represents the type of entity in the knowledge graph */
export enum KnowledgeGraphEntityType {
  /** The entity represents a client or an account */
  Account = 'ACCOUNT',
  /** The entity represents an activity, or a log of something that happened */
  Activity = 'ACTIVITY',
  /** The entity represents a call with a client */
  Call = 'CALL',
  /** The entity represents a contact or individual */
  Contact = 'CONTACT',
  /** The entity represents an email sent to or received from a client */
  Email = 'EMAIL',
  /** The entity represents a note left by a user */
  Note = 'NOTE',
  /** The entity represents a policy */
  Policy = 'POLICY',
  /** The entity represents an SMS sent to or received from a client */
  Sms = 'SMS',
  /** The entity represents a ticket or issue */
  Ticket = 'TICKET'
}

/** Type of liability coverage for a policy */
export enum LiabilityCoverageType {
  /** Claims-made coverage applies to claims made during the policy period */
  ClaimsMade = 'CLAIMS_MADE',
  /** Occurrence coverage applies to incidents that occur during the policy period */
  Occurrence = 'OCCURRENCE'
}

/** Link style */
export type LinkStyle = {
  __typename?: 'LinkStyle';
  /** Text color in hex format (e.g. '#475569') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Text decoration (e.g. 'none', 'underline') */
  textDecoration?: Maybe<Scalars['String']['output']>;
};

/** Details of a bank transaction linked to a payout */
export type LinkedBankTransaction = {
  __typename?: 'LinkedBankTransaction';
  /** The amount of the transaction in dollars */
  amount: Scalars['Float']['output'];
  /** The ID of the counterparty in the bank account's system */
  counterPartyId: Scalars['String']['output'];
  /** The name of the counterparty */
  counterPartyName: Scalars['String']['output'];
  /** The date the transaction was created */
  createdAt: Scalars['Time']['output'];
  /** The link to the transaction in the partner bank's system */
  dashboardLink: Scalars['String']['output'];
  /** The bank description of the transaction */
  description: Scalars['String']['output'];
  /** The ID of the transaction in the bank account */
  id: Scalars['String']['output'];
  /** The memo line of the transaction */
  memo: Scalars['String']['output'];
  /** The status of the transaction in the bank account */
  status: AchPaymentStatus;
};

/** List style */
export type ListStyle = {
  __typename?: 'ListStyle';
  /** List item bottom margin in em units (e.g. 0.3) */
  itemMarginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Bottom margin in em units (e.g. 1.0) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Left margin in em units (e.g. 1.5) */
  marginLeftEm?: Maybe<Scalars['Float']['output']>;
};

/** Margin settings for all sides */
export type MarginStyle = {
  __typename?: 'MarginStyle';
  /** Bottom margin in inches (e.g. 0.75) */
  bottomIn?: Maybe<Scalars['Float']['output']>;
  /** Left margin in inches (e.g. 0.75) */
  leftIn?: Maybe<Scalars['Float']['output']>;
  /** Right margin in inches (e.g. 0.75) */
  rightIn?: Maybe<Scalars['Float']['output']>;
  /** Top margin in inches (e.g. 0.75) */
  topIn?: Maybe<Scalars['Float']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Account user sign in to the Oyster platform */
  accountUserSignIn?: Maybe<AccountUserSignInResponse>;
  /** Account user sign out of the Oyster platform */
  accountUserSignOut: Scalars['Boolean']['output'];
  /**
   * Adds a new business location to an existing business application.
   *
   * Arguments:
   *   applicationId: The unique identifier of the business application.
   *   location: The input data required to add a new business location.
   *
   * Returns:
   *   The updated BusinessApplication object with the new location added.
   */
  addBusinessLocation: BusinessApplication;
  /** Update a Cara workspace */
  addCaraWorkspaceMessage: CaraWorkspace;
  /** Associates an existing contact with an account */
  addContactAssociation: AccountContact;
  /** Add a message to the policy AI conversation */
  addPolicyExplorerConversationMessage: Array<PolicyExplorerConversationMessage>;
  /** Add a comment to a service request */
  addServiceRequestComment: ServiceRequest;
  /** Agency sign in to the Oyster platform */
  agencySignIn?: Maybe<AgencySignInResponse>;
  /** Agency sign out of the Oyster platform */
  agencySignOut: Scalars['Boolean']['output'];
  /**
   * Binds a quote to a business application.
   *
   * Arguments:
   *   applicationId: The unique identifier of the business application.
   *   quoteId: The unique identifier of the quote to bind.
   *   paymentPlanId: The ID of the payment plan to use.
   *   paymentMethod: The payment method to use.
   *
   * Returns:
   *   The updated BusinessApplication object with the quote bound.
   */
  bindQuote: BusinessApplication;
  /** Cancel the specified business insurance policy */
  cancelBusinessPolicy: BusinessPolicy;
  /** Create a certificate of insurance on the client side */
  clientCreateCertificate?: Maybe<ClientCreateCertificateResult>;
  /** Creates a new account */
  createAccount: Account;
  /** Creates a new agency */
  createAgency: Agency;
  /** Adds an agency user to an agency */
  createAgencyUser: AgencyUser;
  /**
   * Creates a new business application.
   *
   * Arguments:
   *   application: The input data required to create a new business application.
   *
   * Returns:
   *   The created BusinessApplication object.
   */
  createBusinessApplication: BusinessApplication;
  /** Create business insurance policies according to specification */
  createBusinessPolicies: Array<BusinessPolicy>;
  /** Create a new Cara workspace */
  createCaraWorkspace: CaraWorkspace;
  /** Create a certificate of insurance */
  createCertificate?: Maybe<CertificateOfLiabilityInsurance>;
  /** Creates a new client */
  createClient: Client;
  /** Creates a new account contact */
  createContact: AccountContact;
  /** Create a new custom preset */
  createCustomPreset: CustomPreset;
  /** Create a new HTML document template */
  createHtmlDocumentTemplate: HtmlDocumentTemplate;
  /** Create a new integration */
  createIntegration?: Maybe<Integration>;
  /** Create a new document in the knowledge base */
  createKnowledgeBaseTextDocument: KnowledgeBaseDocument;
  /** Create a service request */
  createServiceRequest: ServiceRequest;
  /** Deletes the specified business insurance policy */
  deleteBusinessPolicy?: Maybe<BusinessPolicy>;
  /** Delete a file. Returns the deleted file, if successful. */
  deleteFile?: Maybe<File>;
  /** Delete a document by its ID */
  deleteKnowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Disable an agency user from the current account */
  disableAgencyUser: AgencyUser;
  /** Enable an agency user from the current account */
  enableAgencyUser: AgencyUser;
  /**
   * Starts the quote process for a business application if it's not already quoting
   *
   * Arguments:
   *   applicationId: The unique identifier of the business application.
   *
   * Returns:
   *   The updated BusinessApplication object.
   */
  quoteBusinessApplication: BusinessApplication;
  /** Reinstate the specified business insurance policy */
  reinstateBusinessPolicy: BusinessPolicy;
  /**
   * Removes a business location from an existing business application.
   *
   * Arguments:
   *   applicationId: The unique identifier of the business application.
   *   locationId: The unique identifier of the business location to remove.
   *
   * Returns:
   *   The updated BusinessApplication object with the location removed.
   */
  removeBusinessLocation: BusinessApplication;
  /** Removes an association between an account and a contact */
  removeContactAssociation: AccountContact;
  /** Renew the specified business insurance policy */
  renewBusinessPolicy: BusinessPolicy;
  /** Resolve a service request */
  resolveServiceRequest: ServiceRequest;
  /** Add a message to the policy AI conversation */
  riskManagementAddPolicyConversationMessage: Array<PolicyConversationMessage>;
  /** Mark an action item as complete */
  riskManagementMarkActionItemComplete: ComplianceAction;
  /** Update the assignee of an action item */
  riskManagementSetActionItemAssignee: ComplianceAction;
  /** Update the due date of an action item */
  riskManagementSetActionItemDueDate: ComplianceAction;
  /** Set up the risk management data for a merchant */
  riskManagementSetup: RiskManagementData;
  /**
   * Submits and finalizes the business application if not already submitted. This
   * indicates that a customer has finished submitting their information and is
   * ready to be reviewed by an agent.
   *
   * Arguments:
   *   applicationId: The unique identifier of the business application.
   *
   * Returns:
   *   The updated BusinessApplication object.
   */
  submitBusinessApplication: BusinessApplication;
  /** Sync an integration */
  syncIntegration?: Maybe<Integration>;
  /** Updates an existing account */
  updateAccount: Account;
  /** Updates the preferences for the current agency user */
  updateAgencyUserPreferences: AgencyUser;
  /**
   * Updates an existing business application.
   *
   * Arguments:
   *   id: The unique identifier of the business application to update.
   *   application: The input data required to update the business application.
   *
   * Returns:
   *   The updated BusinessApplication object.
   */
  updateBusinessApplication: BusinessApplication;
  /**
   * Updates an existing business location in a business application.
   *
   * Arguments:
   *   applicationId: The unique identifier of the business application.
   *   locationId: The unique identifier of the business location to update.
   *   location: The input data required to update the business location.
   *
   * Returns:
   *   The updated BusinessApplication object with the updated location.
   */
  updateBusinessLocation: BusinessApplication;
  /** Update the specified business insurance policy */
  updateBusinessPolicy: BusinessPolicy;
  /** Update multiple Cara workspaces */
  updateCaraWorkspaces: Array<CaraWorkspace>;
  /** Updates an existing client */
  updateClient: Client;
  /** Updates an existing account contact */
  updateContact: AccountContact;
  /** Update a custom preset */
  updateCustomPreset: CustomPreset;
  /** Update a HTML document template */
  updateHtmlDocumentTemplate: HtmlDocumentTemplate;
  /** Update an integration */
  updateIntegration?: Maybe<Integration>;
  /** Update a document by its ID */
  updateKnowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Update a service request */
  updateServiceRequest: ServiceRequest;
  /** Upload a file associated with an account */
  uploadAccountFile: File;
  /** Update a document by its ID */
  uploadKnowledgeBaseFileDocument: Array<KnowledgeBaseDocument>;
  /** Upload a file associated with a policy */
  uploadPolicyFile: File;
};

export type MutationAccountUserSignInArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type MutationAddBusinessLocationArgs = {
  applicationId: Scalars['ID']['input'];
  location: BusinessLocationInput;
};

export type MutationAddCaraWorkspaceMessageArgs = {
  id: Scalars['ID']['input'];
  input: CaraWorkspaceMessageInput;
};

export type MutationAddContactAssociationArgs = {
  accountId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};

export type MutationAddPolicyExplorerConversationMessageArgs = {
  message: Scalars['String']['input'];
  policyId: Scalars['ID']['input'];
};

export type MutationAddServiceRequestCommentArgs = {
  id: Scalars['ID']['input'];
  input: AddServiceRequestCommentInput;
};

export type MutationAgencySignInArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type MutationBindQuoteArgs = {
  applicationId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentPlanPaymentMethodType>;
  paymentPlanId?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['ID']['input'];
};

export type MutationCancelBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: CancelBusinessPolicyInput;
};

export type MutationClientCreateCertificateArgs = {
  accountId: Scalars['ID']['input'];
  input: ClientCreateCertificateInput;
};

export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};

export type MutationCreateAgencyArgs = {
  input: CreateAgencyInput;
};

export type MutationCreateAgencyUserArgs = {
  agencyId: Scalars['ID']['input'];
  input: AgencyUserInput;
};

export type MutationCreateBusinessApplicationArgs = {
  application: CreateApplicationInput;
};

export type MutationCreateBusinessPoliciesArgs = {
  req: CreateBusinessPoliciesInput;
};

export type MutationCreateCaraWorkspaceArgs = {
  input: CaraWorkspaceMessageInput;
};

export type MutationCreateCertificateArgs = {
  input: CreateCertificateInput;
};

export type MutationCreateClientArgs = {
  input: CreateClientInput;
};

export type MutationCreateContactArgs = {
  input: CreateAccountContactInput;
};

export type MutationCreateCustomPresetArgs = {
  input: CustomPresetInput;
};

export type MutationCreateHtmlDocumentTemplateArgs = {
  input: HtmlDocumentTemplateInput;
};

export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};

export type MutationCreateKnowledgeBaseTextDocumentArgs = {
  input: CreateKnowledgeBaseTextDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};

export type MutationCreateServiceRequestArgs = {
  input: CreateServiceRequestInput;
};

export type MutationDeleteBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFileArgs = {
  fileId: Scalars['ID']['input'];
};

export type MutationDeleteKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisableAgencyUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEnableAgencyUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationQuoteBusinessApplicationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReinstateBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: ReinstateBusinessPolicyInput;
};

export type MutationRemoveBusinessLocationArgs = {
  applicationId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};

export type MutationRemoveContactAssociationArgs = {
  accountId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};

export type MutationRenewBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: RenewBusinessPolicyInput;
};

export type MutationResolveServiceRequestArgs = {
  id: Scalars['ID']['input'];
  input: ResolveServiceRequestInput;
};

export type MutationRiskManagementAddPolicyConversationMessageArgs = {
  message: Scalars['String']['input'];
  policyId: Scalars['ID']['input'];
};

export type MutationRiskManagementMarkActionItemCompleteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRiskManagementSetActionItemAssigneeArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRiskManagementSetActionItemDueDateArgs = {
  dueDate: Scalars['Time']['input'];
  id: Scalars['ID']['input'];
};

export type MutationRiskManagementSetupArgs = {
  input: RiskManagementSetupInput;
};

export type MutationSubmitBusinessApplicationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSyncIntegrationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
};

export type MutationUpdateAgencyUserPreferencesArgs = {
  input: AgencyUserPreferencesInput;
};

export type MutationUpdateBusinessApplicationArgs = {
  application: UpdateApplicationInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateBusinessLocationArgs = {
  applicationId: Scalars['ID']['input'];
  location: BusinessLocationInput;
  locationId: Scalars['ID']['input'];
};

export type MutationUpdateBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: UpdateBusinessPolicyInput;
};

export type MutationUpdateCaraWorkspacesArgs = {
  input: UpdateCaraWorkspaceInput;
  workspaceIds: Array<Scalars['ID']['input']>;
};

export type MutationUpdateClientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientInput;
};

export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: CreateAccountContactInput;
};

export type MutationUpdateCustomPresetArgs = {
  id: Scalars['ID']['input'];
  input: CustomPresetInput;
};

export type MutationUpdateHtmlDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
  input: HtmlDocumentTemplateInput;
};

export type MutationUpdateIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIntegrationInput;
};

export type MutationUpdateKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseDocumentInput;
};

export type MutationUpdateServiceRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceRequestInput;
};

export type MutationUploadAccountFileArgs = {
  accountId: Scalars['ID']['input'];
  file: UploadFileInput;
};

export type MutationUploadKnowledgeBaseFileDocumentArgs = {
  input: UploadKnowledgeBaseFileDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};

export type MutationUploadPolicyFileArgs = {
  file: UploadFileInput;
  policyId: Scalars['ID']['input'];
};

/** A named additional insured for the certificate */
export type NamedAdditionalInsuredCertificateOption = {
  __typename?: 'NamedAdditionalInsuredCertificateOption';
  /** The address of the named additional insured */
  address: Address;
  /** The ID of the named additional insured */
  id: Scalars['ID']['output'];
  /** The name of the named additional insured */
  name: Scalars['String']['output'];
  /** The policy this named additional insured is associated with */
  policy: BusinessPolicy;
};

/** Notification settings for the agency */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** Whether to send notifications when a new call is created */
  enableNewCallNotifications: Scalars['Boolean']['output'];
  /** Email addresses to send new call notifications to */
  newCallNotificationEmailRecipients: Array<Scalars['String']['output']>;
};

/** Input for Notification settings for the agency */
export type NotificationSettingsInput = {
  /** Whether to send notifications when a new call is created */
  enableNewCallNotifications: Scalars['Boolean']['input'];
  /** Email addresses to send new call notifications to */
  newCallNotificationEmailRecipients: Array<Scalars['String']['input']>;
};

/** NowCertsConfiguration contains configuration for the NowCerts integration */
export type NowCertsConfiguration = {
  __typename?: 'NowCertsConfiguration';
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /** NowCerts username for basic authentication */
  username: Scalars['String']['output'];
};

export type PageStyle = {
  __typename?: 'PageStyle';
  /** Page background color in hex format (e.g. '#ffffff') */
  backgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Page margins in inches */
  margin: MarginStyle;
  /** Page size in standard paper sizes (e.g. 'A4', 'Letter', 'Legal') */
  size?: Maybe<Scalars['String']['output']>;
};

/** Paragraph style */
export type ParagraphStyle = {
  __typename?: 'ParagraphStyle';
  /** Bottom margin in em units (e.g. 0.9) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Top margin in em units (e.g. 0.0) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** Minimum number of lines at the bottom of a page (e.g. 3) */
  orphans?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of lines at the top of a page (e.g. 3) */
  widows?: Maybe<Scalars['Int']['output']>;
};

export type PastPolicyLoss = {
  __typename?: 'PastPolicyLoss';
  /** The date when the claim was made. */
  claimDate?: Maybe<Scalars['Time']['output']>;
  /** The status of the claim. */
  claimStatus?: Maybe<PastPolicyLossClaimStatus>;
  /** The date when the loss occurred. */
  lossDate?: Maybe<Scalars['Time']['output']>;
  /** A description of the loss. */
  lossDescription: Scalars['String']['output'];
  /** The 2-letter state code where the loss occurred. */
  lossState: Scalars['String']['output'];
  /** The type of loss that occurred. */
  lossType?: Maybe<PastPolicyLossType>;
  /** The date when the policy became effective. */
  policyEffectiveDate?: Maybe<Scalars['Time']['output']>;
  /** The date when the policy expired. */
  policyExpirationDate?: Maybe<Scalars['Time']['output']>;
  /** The type of insurance policy. */
  policyType?: Maybe<InsuranceType>;
  /** The total amount paid for the claim. */
  totalPaidAmount: Scalars['Float']['output'];
  /** The total amount reserved for the claim. */
  totalReservedAmount: Scalars['Float']['output'];
};

export enum PastPolicyLossClaimStatus {
  /** The claim has been closed. */
  Closed = 'CLOSED',
  /** The claim is currently open. */
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type PastPolicyLossInput = {
  /** The date when the claim was made. */
  claimDate: Scalars['String']['input'];
  /** The status of the claim. */
  claimStatus?: InputMaybe<PastPolicyLossClaimStatus>;
  /** The date when the loss occurred. */
  lossDate: Scalars['String']['input'];
  /** A description of the loss. */
  lossDescription: Scalars['String']['input'];
  /** The 2-letter state code where the loss occurred. */
  lossState: Scalars['String']['input'];
  /** The type of loss that occurred. */
  lossType?: InputMaybe<PastPolicyLossType>;
  /** The date when the policy became effective. */
  policyEffectiveDate: Scalars['String']['input'];
  /** The date when the policy expired. */
  policyExpirationDate: Scalars['String']['input'];
  /** The type of insurance policy. */
  policyType?: InputMaybe<InsuranceType>;
  /** The total amount paid for the claim. */
  totalPaidAmount: Scalars['Float']['input'];
  /** The total amount reserved for the claim. */
  totalReservedAmount: Scalars['Float']['input'];
};

export enum PastPolicyLossType {
  BodilyInjuryOther = 'BODILY_INJURY_OTHER',
  BusinessInterruption = 'BUSINESS_INTERRUPTION',
  ComputerFraud = 'COMPUTER_FRAUD',
  ContingentBusinessInterruption = 'CONTINGENT_BUSINESS_INTERRUPTION',
  CyberIncident = 'CYBER_INCIDENT',
  DigitalData = 'DIGITAL_DATA',
  EmployeePractices = 'EMPLOYEE_PRACTICES',
  ErrorsAndOmissions = 'ERRORS_AND_OMISSIONS',
  Fire = 'FIRE',
  FoodSpoilage = 'FOOD_SPOILAGE',
  FundTransferFraud = 'FUND_TRANSFER_FRAUD',
  GeneralLiabilityProducts = 'GENERAL_LIABILITY_PRODUCTS',
  GlPropertyDamage = 'GL_PROPERTY_DAMAGE',
  Hail = 'HAIL',
  Indemnity = 'INDEMNITY',
  InlandMarine = 'INLAND_MARINE',
  LiabilityMedicalPayments = 'LIABILITY_MEDICAL_PAYMENTS',
  MediaLiability = 'MEDIA_LIABILITY',
  Medical = 'MEDICAL',
  MedicalAndIndemnity = 'MEDICAL_AND_INDEMNITY',
  NetworkExtortion = 'NETWORK_EXTORTION',
  Other = 'OTHER',
  PaymentCard = 'PAYMENT_CARD',
  PersonalInjury = 'PERSONAL_INJURY',
  PrivacyAndNetworkSecurity = 'PRIVACY_AND_NETWORK_SECURITY',
  ProfessionalLiability = 'PROFESSIONAL_LIABILITY',
  PropertyDamageCollapse = 'PROPERTY_DAMAGE_COLLAPSE',
  PropertyDamageOther = 'PROPERTY_DAMAGE_OTHER',
  RegulatoryProceeding = 'REGULATORY_PROCEEDING',
  SlipFallInside = 'SLIP_FALL_INSIDE',
  SlipFallOutside = 'SLIP_FALL_OUTSIDE',
  SocialEngineeringFraud = 'SOCIAL_ENGINEERING_FRAUD',
  TechnologyErrorsAndOmissions = 'TECHNOLOGY_ERRORS_AND_OMISSIONS',
  Theft = 'THEFT',
  Unknown = 'UNKNOWN',
  Vandalism = 'VANDALISM',
  WaterNonWeatherRelated = 'WATER_NON_WEATHER_RELATED',
  Windstorm = 'WINDSTORM'
}

/** PaymentIntervalType enumerates the interval of a fee occurrence */
export enum PaymentIntervalType {
  /** Describes an annual payment */
  Annual = 'ANNUAL',
  /** Describes a monthly payment */
  Monthly = 'MONTHLY',
  /** Describes a non-recurring payment */
  None = 'NONE',
  /** Describes a quarterly payment */
  Quarterly = 'QUARTERLY'
}

/** How the customer chose to pay */
export enum PaymentOptionType {
  AnnualPayInFull = 'ANNUAL_PAY_IN_FULL',
  MonthlyFinanced = 'MONTHLY_FINANCED'
}

/** Enum representing the frequency of installments for a payment plan */
export enum PaymentPlanInstallmentFrequency {
  /** Monthly installments */
  Monthly = 'MONTHLY',
  /** No recurring installments */
  None = 'NONE',
  /** Quarterly installments */
  Quarterly = 'QUARTERLY'
}

/** Enum representing the different payment methods available for a payment plan */
export enum PaymentPlanPaymentMethodType {
  /** Payment via credit card */
  CreditCard = 'CREDIT_CARD',
  /** Payment via direct debit */
  DirectDebit = 'DIRECT_DEBIT',
  /** Payment via electronic fund transfer */
  ElectronicFundTransfer = 'ELECTRONIC_FUND_TRANSFER'
}

/**
 * Represents a tool for peeking at files.
 * Used when the LLM needs to get a sense for the content of a file.
 */
export type PeekFileTool = {
  __typename?: 'PeekFileTool';
  /** The input arguments for the file peeking */
  input: PeekFileToolInput;
  /** The result of the file peeking operation */
  output: PeekFileToolOutput;
};

/**
 * Input arguments for the PeekFileTool.
 * Contains the file ID to peek at.
 */
export type PeekFileToolInput = {
  __typename?: 'PeekFileToolInput';
  /** The ID of the file to peek at */
  fileId: Scalars['String']['output'];
  /** The type of output to return */
  outputType: Scalars['String']['output'];
};

/**
 * Result of a PeekFileTool operation.
 * Contains the peeked file content.
 */
export type PeekFileToolOutput = {
  __typename?: 'PeekFileToolOutput';
  /** Any comments to the LLM about the peeked file */
  comment: Scalars['String']['output'];
  /** The peeked file content */
  content: Scalars['String']['output'];
  /** Whether the file was truncated */
  truncated: Scalars['Boolean']['output'];
};

/** Represents the policy AI conversation for a policy */
export type PolicyConversationMessage = {
  __typename?: 'PolicyConversationMessage';
  /** List of attachments for the message */
  attachments: Array<PolicyConversationMessageAttachment>;
  /** The content of the message */
  content: Scalars['String']['output'];
  /** The ID of the message */
  id: Scalars['ID']['output'];
  /** The role of the message */
  role: PolicyConversationMessageRole;
  /** The timestamp of the message */
  timestamp: Scalars['Time']['output'];
};

/** Represents an attachment for a policy AI conversation message */
export type PolicyConversationMessageAttachment = {
  __typename?: 'PolicyConversationMessageAttachment';
  /** The content of the attachment */
  content: Scalars['String']['output'];
  /** The type of the attachment */
  type: PolicyConversationMessageAttachmentType;
};

/** Represents the type of an attachment for a policy AI conversation message */
export enum PolicyConversationMessageAttachmentType {
  /** A quote from a document */
  Quote = 'QUOTE'
}

/** Represents the role of a policy AI conversation message */
export enum PolicyConversationMessageRole {
  /** The message is from the AI */
  Ai = 'AI',
  /** The message is from the user */
  User = 'USER'
}

/** Represents the policy AI conversation for a policy */
export type PolicyExplorerConversationMessage = {
  __typename?: 'PolicyExplorerConversationMessage';
  /** List of attachments for the message */
  attachments: Array<PolicyExplorerConversationMessageAttachment>;
  /** The content of the message */
  content: Scalars['String']['output'];
  /** The ID of the message */
  id: Scalars['ID']['output'];
  /** The role of the message */
  role: PolicyExplorerConversationMessageRole;
  /** The timestamp of the message */
  timestamp: Scalars['Time']['output'];
};

/** Represents an attachment for a policy AI conversation message */
export type PolicyExplorerConversationMessageAttachment = {
  __typename?: 'PolicyExplorerConversationMessageAttachment';
  /** The content of the attachment */
  content: Scalars['String']['output'];
  /** The type of the attachment */
  type: PolicyExplorerConversationMessageAttachmentType;
};

/** Represents the type of an attachment for a policy AI conversation message */
export enum PolicyExplorerConversationMessageAttachmentType {
  /** A quote from a document */
  Quote = 'QUOTE'
}

/** Represents the role of a policy AI conversation message */
export enum PolicyExplorerConversationMessageRole {
  /** The message is from the AI */
  Ai = 'AI',
  /** The message is from the user */
  User = 'USER'
}

/** The enumeration of states for business policy */
export enum PolicyState {
  /** The policy is in the process of being bound or finalized */
  Binding = 'BINDING',
  /** The policy has been terminated or canceled before its expiration date */
  Canceled = 'CANCELED',
  /** The policy has reached its expiration date and is no longer active */
  Expired = 'EXPIRED',
  /** The policy is currently active and in force */
  Inforce = 'INFORCE',
  /** The policy is in a pending state, awaiting further action or information */
  Pending = 'PENDING',
  /** The state of the policy is unknown or not determined */
  Unknown = 'UNKNOWN'
}

export type Query = {
  __typename?: 'Query';
  /**
   * Returns a single account by ID. This endpoint verifies that the caller is
   * associated with the requested account.
   */
  account?: Maybe<Account>;
  /** Get the current client account user */
  accountUser?: Maybe<AccountUser>;
  /**
   * Returns a list of all accounts. This endpoint returns only accounts that the
   * caller is associated with (either as an agency user or as a client user).
   */
  accounts: Array<Account>;
  /** Get an agency by its unique identifier */
  agency?: Maybe<Agency>;
  /** Get the current agency user */
  agencyUser?: Maybe<AgencyUser>;
  /** Get all agency users for the current account */
  agencyUsers: Array<AgencyUser>;
  /** Retrieve a business application by ID */
  businessApplication: BusinessApplication;
  /** Retrieve all business applications */
  businessApplications: Array<BusinessApplication>;
  /** Returns a list of all business categories. Only accessible by agency users. */
  businessCategories: Array<BusinessCategory>;
  businessPolicies: Array<BusinessPolicy>;
  /** Get a single business policy by ID */
  businessPolicy?: Maybe<BusinessPolicy>;
  /** Get a call by its ID */
  call: Call;
  /** Get a list of calls */
  calls: Array<Call>;
  /** Get a Cara workspace by its ID */
  caraWorkspace: CaraWorkspace;
  /** Get Cara workspaces for the agency */
  caraWorkspaces: Array<CaraWorkspace>;
  carriers: Array<InsuranceCarrier>;
  /** Get a certificate of insurance by its certificate number */
  certificate?: Maybe<CertificateOfLiabilityInsurance>;
  /** Returns a single client by ID. Only accessible by agency users. */
  client?: Maybe<Client>;
  /** Returns a list of all clients. Only accessible by agency users. */
  clients: Array<Client>;
  /** Returns a single account contact by ID. Only accessible by agency users. */
  contact?: Maybe<AccountContact>;
  /** Returns a list of all account contacts. Only accessible by agency users. */
  contacts: Array<AccountContact>;
  /**
   * Returns the available limits for a particular application and state.
   *
   * Arguments:
   *   applicationId: The unique identifier of the business application.
   *   state: The state for which to retrieve the available limits.
   *
   * Returns:
   *   A list of AvailableCoverageLimit objects representing the available coverage limits.
   */
  coverageLimits: Array<AvailableCoverageLimit>;
  /** Get the options for creating a certificate of insurance */
  createCertificateOptions?: Maybe<CreateCertificateOptions>;
  /** Get a custom preset by its ID */
  customPreset: CustomPreset;
  /** Get custom presets for the agency */
  customPresets: Array<CustomPreset>;
  /** Get a thread by its ID */
  emailThread: EmailThread;
  /** Get a list of threads */
  emailThreads: Array<EmailThread>;
  /** Get a HTML document template by its ID */
  htmlDocumentTemplate: HtmlDocumentTemplate;
  /** Get HTML document templates for the agency */
  htmlDocumentTemplates: Array<HtmlDocumentTemplate>;
  /** Get all deal pipelines from HubSpot */
  hubspotDealPipelines: Array<HubSpotPipeline>;
  /** Get all ticket pipelines from HubSpot */
  hubspotTicketPipelines: Array<HubSpotTicketPipeline>;
  /** Get an integration by its ID */
  integration?: Maybe<Integration>;
  /** Get all integrations */
  integrations: Array<Integration>;
  /** Get a knowledge base by its ID */
  knowledgeBase?: Maybe<KnowledgeBase>;
  /** Get a document by its ID */
  knowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Get all knowledge bases */
  knowledgeBases: Array<KnowledgeBase>;
  /** Get all entities with optional filtering */
  knowledgeGraphEntities: Array<KnowledgeGraphEntity>;
  /** Get single entity by ID */
  knowledgeGraphEntity?: Maybe<KnowledgeGraphEntity>;
  /** Get the policy AI conversation for a policy ID */
  policyConversation: Array<PolicyConversationMessage>;
  /** Get the policy AI conversation for a policy ID */
  policyExplorerConversation: Array<PolicyExplorerConversationMessage>;
  /** Get the risk management data for a merchant */
  riskManagement?: Maybe<RiskManagementData>;
  /** Get a service request by ID, if the current user is associated with the service request */
  serviceRequest?: Maybe<ServiceRequest>;
  /**
   * Get all service requests associated with any accounts that belong to the agency of the
   * currently logged in agency user, or the account ID if specified and if the user has
   * permission to view them.
   */
  serviceRequests: Array<ServiceRequest>;
  /** Returns a link to the subscription management page for the current account */
  subscriptionManagementLinks?: Maybe<SubscriptionManagementLinks>;
};

export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryBusinessApplicationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCallArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCertificateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};

export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCoverageLimitsArgs = {
  applicationId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};

export type QueryCreateCertificateOptionsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryCustomPresetArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEmailThreadArgs = {
  id: Scalars['ID']['input'];
};

export type QueryHtmlDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryHubspotDealPipelinesArgs = {
  integrationId: Scalars['ID']['input'];
};

export type QueryHubspotTicketPipelinesArgs = {
  integrationId: Scalars['ID']['input'];
};

export type QueryIntegrationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryKnowledgeGraphEntitiesArgs = {
  filter?: InputMaybe<KnowledgeGraphEntityFilter>;
};

export type QueryKnowledgeGraphEntityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPolicyConversationArgs = {
  policyId: Scalars['ID']['input'];
};

export type QueryPolicyExplorerConversationArgs = {
  policyId: Scalars['ID']['input'];
};

export type QueryServiceRequestArgs = {
  id: Scalars['ID']['input'];
};

export type QueryServiceRequestsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
};

/** Details for a request for questions about policies, account, or billing, etc. */
export type QuestionRequest = {
  __typename?: 'QuestionRequest';
  /** ID of the policy related to the question, if applicable */
  policyId?: Maybe<Scalars['String']['output']>;
  /** Question from the customer */
  question: Scalars['String']['output'];
  /** Type of question */
  type: QuestionRequestType;
};

/** Input type for requesting questions */
export type QuestionRequestInput = {
  /** ID of the policy related to the question, if applicable */
  policyId?: InputMaybe<Scalars['String']['input']>;
  /** Question from the customer */
  question: Scalars['String']['input'];
  /** Type of question */
  type?: InputMaybe<QuestionRequestType>;
};

/** Types of questions that can be requested */
export enum QuestionRequestType {
  /** Question about account management */
  Account = 'ACCOUNT',
  /** Question about billing and payments */
  Billing = 'BILLING',
  /** Other questions */
  Other = 'OTHER',
  /** Question about policies */
  Policy = 'POLICY'
}

/** Input for reinstating a business policy */
export type ReinstateBusinessPolicyInput = {
  /** When the reinstatement becomes effective */
  effectiveAt: Scalars['Time']['input'];
  /** A description of why the policy is being reinstated */
  reasonDescription: Scalars['String']['input'];
};

/** Input for renewing a business policy */
export type RenewBusinessPolicyInput = {
  /** The agency billing type, if applicable */
  agencyBillingType?: InputMaybe<BusinessPolicyAgencyBillingType>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['input'];
  /** How to create the Ascend program */
  ascendProgramCreationMode?: InputMaybe<AscendProgramCreationMode>;
  /** ID of specific Ascend program to use */
  ascendProgramId?: InputMaybe<Scalars['String']['input']>;
  /** The billing type for the policy */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['input'];
  /** The estimated commission the agency earns on this policy */
  estimatedCommission: Scalars['Float']['input'];
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy goes into force */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['input'];
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['input'];
  /** The policy number, if available */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium: Scalars['Float']['input'];
  /** The quote number associated with the renewal */
  quoteNumber: Scalars['String']['input'];
  /** The state of the policy */
  state: PolicyState;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['input'];
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total: Scalars['Float']['input'];
};

/**
 * Represents a tool for requesting a list of tools that can be used to fill out a template.
 * Used when the LLM needs to request a list of tools that can be used to fill out a template.
 */
export type RequestTemplateToolsTool = {
  __typename?: 'RequestTemplateToolsTool';
  /** The input arguments for the template tool request */
  input: RequestTemplateToolsToolInput;
  /** The result of the template tool request */
  output: RequestTemplateToolsToolOutput;
};

/**
 * Input arguments for the RequestTemplateToolsTool.
 * Contains the template ID to request tools for.
 */
export type RequestTemplateToolsToolInput = {
  __typename?: 'RequestTemplateToolsToolInput';
  /** The ID of the template to request tools for */
  templateIds: Array<Scalars['String']['output']>;
};

/**
 * Result of a RequestTemplateToolsTool operation.
 * Contains the list of tools that can be used to fill out the template.
 */
export type RequestTemplateToolsToolOutput = {
  __typename?: 'RequestTemplateToolsToolOutput';
  /** The list of tools that can be used to fill out the template */
  availableTools: Array<Scalars['String']['output']>;
};

/** Input type for resolving a service request */
export type ResolveServiceRequestInput = {
  /** Files attached to the resolution */
  files: Array<Scalars['Upload']['input']>;
  /** Internal notes about the resolution */
  notes: Scalars['String']['input'];
};

/** Represents the risk management data for a merchant */
export type RiskManagementData = {
  __typename?: 'RiskManagementData';
  /** List of action items related to the merchant's risk management */
  actionItems: Array<ComplianceAction>;
  /** List of compliance groups associated with the merchant */
  compliance: Array<ComplianceGroup>;
};

export type RiskManagementSetupInput = {
  /** Description of any upcoming changes to the business */
  changeDescription: Scalars['String']['input'];
  /** List of compliance frameworks that the merchant is subject to */
  complianceFrameworks: Scalars['String']['input'];
  /** Description of the business */
  description: Scalars['String']['input'];
};

/** Role mapped to auth model values */
export enum Role {
  Admin = 'ADMIN',
  AgencyClient = 'AGENCY_CLIENT',
  AgencyUser = 'AGENCY_USER',
  Anonymous = 'ANONYMOUS',
  Bpo = 'BPO',
  User = 'USER'
}

/**
 *   Represents a tool for searching through files.
 * Used when the LLM needs to find information in specific files.
 */
export type SearchFileTool = {
  __typename?: 'SearchFileTool';
  /** The input arguments for the file search */
  input: SearchFileToolInput;
  /** The result of the file search operation */
  output: SearchFileToolOutput;
};

/**
 * Input arguments for the SearchFileTool.
 * Contains the search queries to be executed.
 */
export type SearchFileToolInput = {
  __typename?: 'SearchFileToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchFileToolQuery>;
};

/**
 * Result of a SearchFileTool operation.
 * Contains the search results and their citations.
 */
export type SearchFileToolOutput = {
  __typename?: 'SearchFileToolOutput';
  /** List of answers found in the files */
  results: Array<SearchFileToolResult>;
};

/**
 * Individual search query for the SearchFileTool.
 * Contains all parameters needed for a single file search.
 */
export type SearchFileToolQuery = {
  __typename?: 'SearchFileToolQuery';
  /** The ID of the file to search in */
  fileId: Scalars['String']['output'];
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Individual answer from a file search.
 * Contains the answer and its supporting citations.
 */
export type SearchFileToolResult = {
  __typename?: 'SearchFileToolResult';
  /** The answer text found in the file */
  answer: Scalars['String']['output'];
  /** Citations supporting the answer */
  citations: Array<SearchFileToolResultCitation>;
  /** The ID of the file containing the answer */
  fileId: Scalars['String']['output'];
  /** The original query that produced this answer */
  query: Scalars['String']['output'];
};

/**
 * Citation for a file search result.
 * Provides specific location and context for the answer.
 */
export type SearchFileToolResultCitation = {
  __typename?: 'SearchFileToolResultCitation';
  /** A link to the specific location in the file */
  link: Scalars['String']['output'];
};

/**
 * Represents a tool for searching the knowledge base.
 * Used when the LLM needs to find information from the internal knowledge base.
 */
export type SearchKnowledgeBaseTool = {
  __typename?: 'SearchKnowledgeBaseTool';
  /** The input arguments for the knowledge base search */
  input: SearchKnowledgeBaseToolInput;
  /** The result of the knowledge base search operation */
  output: SearchKnowledgeBaseToolOutput;
};

/**
 * Input arguments for the SearchKnowledgeBaseTool.
 * Contains the search queries to be executed.
 */
export type SearchKnowledgeBaseToolInput = {
  __typename?: 'SearchKnowledgeBaseToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchKnowledgeBaseToolQuery>;
};

/**
 * Result of a SearchKnowledgeBaseTool operation.
 * Contains the search results and their citations.
 */
export type SearchKnowledgeBaseToolOutput = {
  __typename?: 'SearchKnowledgeBaseToolOutput';
  /** List of answers found in the knowledge base */
  documents: Array<SearchKnowledgeBaseToolResultDocument>;
};

/**
 * Individual search query for the SearchKnowledgeBaseTool.
 * Contains the query to be executed against the knowledge base.
 */
export type SearchKnowledgeBaseToolQuery = {
  __typename?: 'SearchKnowledgeBaseToolQuery';
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Citation for a knowledge base search result.
 * Provides specific location and context for the answer.
 */
export type SearchKnowledgeBaseToolResultCitation = {
  __typename?: 'SearchKnowledgeBaseToolResultCitation';
  /** A link to the specific location in the knowledge base */
  link: Scalars['String']['output'];
};

/**
 * Individual answer from a knowledge base search.
 * Contains the answer and its supporting citations.
 */
export type SearchKnowledgeBaseToolResultDocument = {
  __typename?: 'SearchKnowledgeBaseToolResultDocument';
  /** The ID of the document */
  id: Scalars['String']['output'];
  /** The metadata for the document */
  metadata: KnowledgeBaseDocumentMetadata;
  /** The relevant pages of the document */
  relevantPages: Array<SearchKnowledgeBaseToolResultPage>;
};

/** Represents a page from a knowledge base document. */
export type SearchKnowledgeBaseToolResultPage = {
  __typename?: 'SearchKnowledgeBaseToolResultPage';
  /** The citation for the page */
  citation: SearchKnowledgeBaseToolResultCitation;
  /** The content of the page */
  content: Scalars['String']['output'];
  /** The index of the page */
  pageIndex: Scalars['Int']['output'];
};

/**
 * Represents a tool for searching the knowledge graph.
 * Used when the LLM needs to find information from the internal knowledge graph.
 */
export type SearchKnowledgeGraphTool = {
  __typename?: 'SearchKnowledgeGraphTool';
  /** The input arguments for the knowledge graph search */
  input: SearchKnowledgeGraphToolInput;
  /** The result of the knowledge graph search operation */
  output: SearchKnowledgeGraphToolOutput;
};

/**
 * Input arguments for the SearchKnowledgeGraphTool.
 * Contains the search queries to be executed.
 */
export type SearchKnowledgeGraphToolInput = {
  __typename?: 'SearchKnowledgeGraphToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchKnowledgeGraphToolQuery>;
};

/**
 * Result of a SearchKnowledgeGraphTool operation.
 * Contains the search results and their citations.
 */
export type SearchKnowledgeGraphToolOutput = {
  __typename?: 'SearchKnowledgeGraphToolOutput';
  /** List of answers found in the knowledge graph */
  entities: Array<KnowledgeGraphEntity>;
};

/**
 * Individual search query for the SearchKnowledgeGraphTool.
 * Contains the query to be executed against the knowledge graph.
 */
export type SearchKnowledgeGraphToolQuery = {
  __typename?: 'SearchKnowledgeGraphToolQuery';
  /** List of fields to include in the search */
  includeFields: Array<Scalars['String']['output']>;
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Represents a tool for searching the web.
 * Used when the LLM needs to find information from the internet.
 */
export type SearchWebTool = {
  __typename?: 'SearchWebTool';
  /** The input arguments for the web search */
  input: SearchWebToolInput;
  /** The result of the web search operation */
  output: SearchWebToolOutput;
};

/**
 * Input arguments for the SearchWebTool.
 * Contains the search queries to be executed.
 */
export type SearchWebToolInput = {
  __typename?: 'SearchWebToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchWebToolQuery>;
};

/**
 * Result of a SearchWebTool operation.
 * Contains the search results and their citations.
 */
export type SearchWebToolOutput = {
  __typename?: 'SearchWebToolOutput';
  /** List of search results */
  results: Array<SearchWebToolResult>;
};

/**
 * Individual search query for the SearchWebTool.
 * Contains all parameters needed for a single web search.
 */
export type SearchWebToolQuery = {
  __typename?: 'SearchWebToolQuery';
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Individual result from a web search.
 * Contains the answer and its supporting citations.
 */
export type SearchWebToolResult = {
  __typename?: 'SearchWebToolResult';
  /** The answer text found from web sources */
  answer: Scalars['String']['output'];
  /** Citations supporting the answer */
  citations: Array<SearchWebToolResultCitation>;
  /** The original query that produced this result */
  query: Scalars['String']['output'];
};

/**
 * Citation for a web search result.
 * Provides specific source information for the answer.
 */
export type SearchWebToolResultCitation = {
  __typename?: 'SearchWebToolResultCitation';
  /** The title of the web page */
  title: Scalars['String']['output'];
  /** The URL of the web page containing the citation */
  url: Scalars['String']['output'];
};

/** Represents a service request submitted by a merchant */
export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  /** The account associated with the service request */
  account?: Maybe<Account>;
  /** Details specific to additional insured requests */
  addAdditionalInsured?: Maybe<AddAdditionalInsuredRequest>;
  /** The agency user that is assigned to this service request */
  assignee?: Maybe<AgencyUser>;
  /** The business policy associated with the service request, if any */
  businessPolicy?: Maybe<BusinessPolicy>;
  /** The calls that this service request was created from, if any */
  calls: Array<Call>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: Maybe<CancelPolicyRequest>;
  /** The email of the client that this service request is associated with, if not associated with an account */
  clientEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the client that this service request is associated with, if not associated with an account */
  clientName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the client that this service request is associated with, if not associated with an account */
  clientPhone?: Maybe<Scalars['String']['output']>;
  /** When the request was closed, if applicable */
  closedAt?: Maybe<Scalars['Time']['output']>;
  /** The comments associated with this service request */
  comments: Array<ServiceRequestComment>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: Maybe<CreateCertificateRequest>;
  /** When the request was created */
  createdAt: Scalars['Time']['output'];
  /** Additional details about the request */
  details: Scalars['String']['output'];
  /** Details specific to document requests */
  documentRequest?: Maybe<DocumentRequest>;
  /** The date and time that this service request is due, if any */
  dueAt?: Maybe<Scalars['Time']['output']>;
  /** The email thread that this service request was created from, if any */
  emailThreads: Array<EmailThread>;
  /** Details specific to policy endorsement requests */
  endorsePolicy?: Maybe<EndorsePolicyRequest>;
  /** Unique identifier for the service request */
  id: Scalars['ID']['output'];
  /** Details specific to question requests */
  question?: Maybe<QuestionRequest>;
  /** Resolution of the service request, if applicable */
  resolution?: Maybe<ServiceRequestResolution>;
  /** Files attached to the service request's resolution */
  resolutionFiles: Array<File>;
  /** Current state of the request */
  state: ServiceRequestState;
  /** Type of service request */
  type: ServiceRequestType;
  /** When the request was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this policy */
  version: Scalars['Int64']['output'];
  /** The previous versions of this policy. The first version in this list will be this version (i.e. identical to the current policy), followed by the version before that, and so-forth. */
  versionHistory?: Maybe<Array<ServiceRequestVersion>>;
};

export type ServiceRequestComment = {
  __typename?: 'ServiceRequestComment';
  /** The agency user that created the comment */
  agencyUser: AgencyUser;
  /** The content of the comment */
  content: Scalars['String']['output'];
  /** The date and time that the comment was created */
  createdAt: Scalars['Time']['output'];
  /** The ID of the comment */
  id: Scalars['ID']['output'];
  /** The date and time that the comment was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Describes the resolution of a service request */
export type ServiceRequestResolution = {
  __typename?: 'ServiceRequestResolution';
  /** Internal notes about the resolution */
  notes: Scalars['String']['output'];
};

/** Current state of a service request */
export enum ServiceRequestState {
  /** Request has been completed */
  Closed = 'CLOSED',
  /** Request is still being processed */
  Open = 'OPEN'
}

/** Type of service request that can be created */
export enum ServiceRequestType {
  /** Request to add an additional insured to a policy */
  AddAdditionalInsured = 'ADD_ADDITIONAL_INSURED',
  /** Request to cancel an existing policy */
  CancelPolicy = 'CANCEL_POLICY',
  /** Request to create a Certificate of Insurance */
  CreateCertificate = 'CREATE_CERTIFICATE',
  /** Request for policy-related documents */
  DocumentRequest = 'DOCUMENT_REQUEST',
  /** Request to modify/endorse an existing policy */
  EndorsePolicy = 'ENDORSE_POLICY',
  /** Other miscellaneous requests */
  Other = 'OTHER',
  /** Question about policies, account, or billing, etc. */
  Question = 'QUESTION',
  /** Request to get a new quote for insurance */
  QuoteRequest = 'QUOTE_REQUEST'
}

/** Describes the reason why an application was updated */
export enum ServiceRequestUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a policy */
export enum ServiceRequestUpdateType {
  /** A comment was added to the service request */
  AddServiceRequestComment = 'ADD_SERVICE_REQUEST_COMMENT',
  /** The service request was assigned to an agency user */
  AssignServiceRequest = 'ASSIGN_SERVICE_REQUEST',
  /** The service request was closed */
  CloseServiceRequest = 'CLOSE_SERVICE_REQUEST',
  /** The service request was created */
  CreateServiceRequest = 'CREATE_SERVICE_REQUEST',
  /** The service request was enriched */
  EnrichServiceRequest = 'ENRICH_SERVICE_REQUEST',
  /** The service request was updated */
  UpdateServiceRequest = 'UPDATE_SERVICE_REQUEST',
  /** The due date of the service request was updated */
  UpdateServiceRequestDueAt = 'UPDATE_SERVICE_REQUEST_DUE_AT'
}

/** Describes a particular version of a service request */
export type ServiceRequestVersion = {
  __typename?: 'ServiceRequestVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another service request version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous service request version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<ServiceRequestVersion>;
  /** The full service request object that includes all of the updates made in this version and all previous versions */
  serviceRequest: ServiceRequest;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<ServiceRequestUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<ServiceRequestUpdateType>;
  /** The version number of this service request version */
  version: Scalars['Int64']['output'];
};

/** The Stripe invoice information used to bill a policy */
export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  id: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to Cara workspace updates */
  watchCaraWorkspace: CaraWorkspace;
};

export type SubscriptionWatchCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};

export type SubscriptionManagementLinks = {
  __typename?: 'SubscriptionManagementLinks';
  /** The link to the billing portal for the agency */
  billingPortalUrl: Scalars['String']['output'];
  /** The link to the update payment method page for the agency */
  updatePaymentMethodUrl: Scalars['String']['output'];
  /** The link to the update subscription page for the agency */
  updateSubscriptionUrl: Scalars['String']['output'];
};

/** The period of the subscription */
export enum SubscriptionPeriod {
  /** The subscription is yearly */
  Annual = 'ANNUAL',
  /** The subscription is monthly */
  Monthly = 'MONTHLY'
}

/** The plan that the agency is subscribed to */
export enum SubscriptionPlan {
  /** The premium subscription plan */
  Enterprise = 'ENTERPRISE',
  /** The standard subscription plan */
  Standard = 'STANDARD'
}

/** The state of the subscription for the agency */
export enum SubscriptionState {
  /** The subscription is active and paid */
  Active = 'ACTIVE',
  /** The subscription has expired due to cancellation or nonpayment */
  Expired = 'EXPIRED',
  /** The subscription is active but unpaid */
  Overdue = 'OVERDUE',
  /** The subscription is currently paused */
  Paused = 'PAUSED',
  /** The subscription is currently in a trial period and active */
  Trial = 'TRIAL'
}

/** Table style */
export type TableStyle = {
  __typename?: 'TableStyle';
  /** Border collapse setting (e.g. 'collapse') */
  borderCollapse?: Maybe<Scalars['String']['output']>;
  /** Cell border style (e.g. '1px solid #cbd5e1') */
  cellBorder?: Maybe<Scalars['String']['output']>;
  /** Cell padding in em units (e.g. 0.4) */
  cellPaddingEm?: Maybe<Scalars['Float']['output']>;
  /** Font size in points (e.g. 10.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Header background color in hex format (e.g. '#e2e8f0') */
  headerBackgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Header text color in hex format (e.g. '#0f172a') */
  headerColorHex?: Maybe<Scalars['String']['output']>;
  /** Header font weight as a number (e.g. 600) */
  headerFontWeight?: Maybe<Scalars['Int']['output']>;
  /** Top margin in em units (e.g. 1.0) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** Width as a percentage (e.g. 100.0) */
  widthPct?: Maybe<Scalars['Float']['output']>;
};

/**
 * Represents a tool that allows the LLM to think through a problem or task.
 * This tool is used when the LLM needs to process information or make decisions.
 */
export type ThinkTool = {
  __typename?: 'ThinkTool';
  /** The input arguments for the think operation */
  input: ThinkToolInput;
  /** The result of the thinking operation */
  output: ThinkToolOutput;
};

/**
 * Input arguments for the ThinkTool.
 * Used to provide context and purpose for the thinking operation.
 */
export type ThinkToolInput = {
  __typename?: 'ThinkToolInput';
  /** The detailed thought process */
  thought: Scalars['String']['output'];
  /** A brief title describing the thinking task */
  title: Scalars['String']['output'];
};

/**
 * Result of a ThinkTool operation.
 * Indicates whether the thinking process was successful.
 */
export type ThinkToolOutput = {
  __typename?: 'ThinkToolOutput';
  /** Whether the thinking operation completed successfully */
  success: Scalars['Boolean']['output'];
};

/** Represents a tool call that was made in the context of an email conversation */
export type ToolCall = {
  __typename?: 'ToolCall';
  /** The arguments passed to the tool in JSON format */
  argumentsJson: Scalars['String']['output'];
  /** The ID of the tool call */
  id: Scalars['String']['output'];
  /** The name of the tool being called */
  name: Scalars['String']['output'];
  /** The result of the tool call */
  result: Scalars['String']['output'];
  /** Timestamp when this tool call was made */
  timestamp: Scalars['Time']['output'];
};

/** Typography settings */
export type TypographyStyle = {
  __typename?: 'TypographyStyle';
  /** Text color in hex format (e.g. '#334155') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Base font family name (e.g. 'Charter ITC TT', 'Inter', 'Source Serif Pro') */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Base font size in points (e.g. 11.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font weight as a number (e.g. 400 for normal, 600 for semi-bold, 700 for bold) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Line height as a unitless multiplier (e.g. 1.6) */
  lineHeight?: Maybe<Scalars['Float']['output']>;
};

/** Represents an answer to an underwriting question. */
export type UnderwritingAnswer = {
  __typename?: 'UnderwritingAnswer';
  /** The answer to the question. */
  answer: Scalars['String']['output'];
  /** The ID of the location associated with the answer. */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the question associated with the answer. */
  questionId: Scalars['ID']['output'];
};

export type UnderwritingAnswerInput = {
  answer: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

/** Represents an answer option for an underwriting question. */
export type UnderwritingAnswerOption = {
  __typename?: 'UnderwritingAnswerOption';
  /** The display text of the answer option. */
  displayText: Scalars['String']['output'];
  /** The value of the answer option. */
  value: Scalars['String']['output'];
};

/** Represents an underwriting question. */
export type UnderwritingQuestion = {
  __typename?: 'UnderwritingQuestion';
  /** The possible answer options for the question. */
  answerOptions?: Maybe<Array<UnderwritingAnswerOption>>;
  /** Carriers that require an answer to this question" */
  carriers: Array<BusinessApplicationCarrier>;
  /** The default answer to the question, if any. */
  defaultAnswer?: Maybe<Scalars['String']['output']>;
  /** Question IDs that are dependent on this question. */
  dependentQuestions: Array<UnderwritingQuestionDependency>;
  /** Indicates whether the question has a parent question. */
  hasParentQuestion: Scalars['Boolean']['output'];
  /** The unique identifier of the underwriting question. */
  id: Scalars['ID']['output'];
  /** The ID of the location associated with the question. */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** The text of the underwriting question. */
  question: Scalars['String']['output'];
  /** The tooltip providing additional information about the question. */
  tooltip: Scalars['String']['output'];
  /** The type of the underwriting question. */
  type: UnderwritingQuestionType;
};

/** Represents a dependency between underwriting questions. */
export type UnderwritingQuestionDependency = {
  __typename?: 'UnderwritingQuestionDependency';
  /** The condition that must be met for the dependent questions to be shown. */
  condition?: Maybe<Scalars['String']['output']>;
  /** The IDs of the questions that are dependent on the parent question. */
  dependentQuestionIds: Array<Scalars['ID']['output']>;
  /** The type of the dependency. */
  type: UnderwritingQuestionDependencyType;
};

export enum UnderwritingQuestionDependencyType {
  /** Indicates that a question should be shown if the condition matches */
  Conditional = 'CONDITIONAL',
  /** Indicates that a question should always be shown */
  Direct = 'DIRECT'
}

/** Represents the type of an underwriting question. */
export enum UnderwritingQuestionType {
  /** A date question. */
  Date = 'DATE',
  /** An email question. */
  Email = 'EMAIL',
  /** A multi-select dropdown question. */
  Multiselectdropdown = 'MULTISELECTDROPDOWN',
  /** A number question. */
  Number = 'NUMBER',
  /** A phone number question. */
  Phonenumber = 'PHONENUMBER',
  /** A radio button question. */
  Radio = 'RADIO',
  /** A single-select dropdown question. */
  Singleselectdropdown = 'SINGLESELECTDROPDOWN',
  /** A text question. */
  Text = 'TEXT',
  /** A year question. */
  Year = 'YEAR'
}

/** Represents an underwriting statement. */
export type UnderwritingStatement = {
  __typename?: 'UnderwritingStatement';
  /** The carrier that the underwriting statement is associated with. */
  carrier: BusinessApplicationCarrier;
  /** Formatted markdown string with the underwriting statement. */
  markdown: Scalars['String']['output'];
};

/** Represents the type of an underwriting statement. */
export enum UnderwritingStatementType {
  /** A payment statement. */
  Payment = 'PAYMENT',
  /** An underwriting statement. */
  Underwriting = 'UNDERWRITING'
}

/** Input for updating an existing account record */
export type UpdateAccountInput = {
  /** Business account details to update, if the account is a business */
  business?: InputMaybe<CreateBusinessAccountInput>;
  /** Individual account details to update, if the account is an individual */
  individual?: InputMaybe<CreateIndividualAccountInput>;
};

export type UpdateApplicationInput = {
  /** The annual revenue of the business. */
  annualRevenue?: InputMaybe<Scalars['Float']['input']>;
  /** The "Doing Business As" name of the business. */
  businessDba?: InputMaybe<Scalars['String']['input']>;
  /** The legal name of the business. */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** The information for the the contact person on the business application. */
  contact?: InputMaybe<BusinessContactInput>;
  /** Information about the employees at the business location. */
  employeeInfo?: InputMaybe<BusinessEmployeeInfoInput>;
  /** The Federal Employer Identification Number (FEIN) of the business. */
  fein?: InputMaybe<Scalars['String']['input']>;
  /** The desired effective date for the insurance policy. */
  insuranceEffectiveAt?: InputMaybe<Scalars['Time']['input']>;
  /** The insurance types the business is interested in. */
  insuranceTypes?: InputMaybe<Array<InsuranceType>>;
  /** The legal entity type of the business. */
  legalEntityType?: InputMaybe<BusinessLegalEntityType>;
  /** The mailing address of the business. */
  mailingAddress?: InputMaybe<AddressInput>;
  /** The NAICS classification code for the business. */
  naicsCode?: InputMaybe<Scalars['String']['input']>;
  /** The owners of the business. */
  owners?: InputMaybe<Array<BusinessOwnerInput>>;
  /** The past policy losses of the business. */
  pastPolicyLosses?: InputMaybe<Array<PastPolicyLossInput>>;
  /** The carriers that this business wants quotes from */
  selectedCarriers?: InputMaybe<Array<BusinessApplicationCarrier>>;
  /** The selected insurance limits for the business. */
  selectedLimits?: InputMaybe<BusinessApplicationInsuranceLimitsInput>;
  /** The underwriting answers for the business. */
  underwritingAnswers?: InputMaybe<Array<UnderwritingAnswerInput>>;
  /** The year the business was founded. */
  yearOfFounding?: InputMaybe<Scalars['String']['input']>;
  /** The years of management experience of the business. */
  yearsOfManagementExperience?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating an existing business record */
export type UpdateBusinessInput = {
  /** New 'Doing Business As' (DBA) name for the business */
  dba?: InputMaybe<Scalars['String']['input']>;
  /** New mailing address for the business */
  mailingAddress?: InputMaybe<AddressInput>;
  /** New NAICS code for the business */
  naics?: InputMaybe<Scalars['String']['input']>;
  /** New legal name for the business */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New website URL for the business */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing business policy */
export type UpdateBusinessPolicyInput = {
  /** Additional fees collected by the agency as revenue. */
  agencyFees?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the agency user who sourced the policy */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Fees collected by the wholesale broker */
  brokerFees?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the broker */
  brokerId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the insurance carrier */
  carrierId?: InputMaybe<Scalars['String']['input']>;
  /** Estimated commission percentage */
  estimatedCommission?: InputMaybe<Scalars['Float']['input']>;
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy goes into effect */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Insurance market the policy is written in */
  market?: InputMaybe<InsuranceMarket>;
  /** Minimum earned premium for the policy */
  minimumEarnedPremium?: InputMaybe<Scalars['Float']['input']>;
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees?: InputMaybe<Scalars['Float']['input']>;
  /** Fees collected by the carrier to administer the policy or program */
  policyFees?: InputMaybe<Scalars['Float']['input']>;
  /** Policy number once issued */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium?: InputMaybe<Scalars['Float']['input']>;
  /** Quote number from carrier */
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the policy */
  state?: InputMaybe<PolicyState>;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes?: InputMaybe<Scalars['Float']['input']>;
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total?: InputMaybe<Scalars['Float']['input']>;
  /** Type of insurance policy */
  type?: InputMaybe<InsuranceType>;
  /** Reason for updating the policy */
  updateReason: Scalars['String']['input'];
};

/** Input for updating a Cara workspace */
export type UpdateCaraWorkspaceInput = {
  /** Whether to archive the Cara workspace */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The title of the Cara workspace */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing client record */
export type UpdateClientInput = {
  /** The updated business details for the client */
  business?: InputMaybe<UpdateBusinessInput>;
  /** New email address for the client */
  email?: InputMaybe<Scalars['String']['input']>;
  /** New name for the client */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New phone number for the client */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateHawksoftIntegrationInput contains the input for updating a Hawksoft integration */
export type UpdateHawksoftIntegrationInput = {
  /** If enabled, will sync call notes to the appropriate contact based on the caller's number. */
  enableSyncCallNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will allow Cara to write attachments to Hawksoft in Copilot workspaces. */
  enableSyncCopilotAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync service requests as tasks to the agent. */
  enableSyncServiceRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

/** UpdateHubSpotIntegrationInput contains the input for updating a HubSpot integration */
export type UpdateHubSpotIntegrationInput = {
  /** Field mappings for call syncing. Required fields depend on callSyncType. */
  callFieldMappings?: InputMaybe<HubSpotCallFieldMappingsInput>;
  /** The pipeline ID to use when syncing calls as tickets or deals. Required when callSyncType is TICKET or DEAL. */
  callPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing calls as tickets or deals. Required when callSyncType is TICKET or DEAL. */
  callStageId?: InputMaybe<Scalars['String']['input']>;
  /** How calls should be synced to HubSpot. When set to TICKET or DEAL, corresponding field mappings must be provided. */
  callSyncType?: InputMaybe<HubSpotCallSyncType>;
  /** If enabled, will sync calls from Cara to HubSpot. When enabled, callSyncType and appropriate field mappings must be provided. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to HubSpot. When enabled, taskSyncType and appropriate field mappings must be provided. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field mappings for task syncing. Required fields depend on taskSyncType. */
  taskFieldMappings?: InputMaybe<HubSpotTaskFieldMappingsInput>;
  /** The pipeline ID to use when syncing tasks as tickets or deals. Required when taskSyncType is TICKET or DEAL. */
  taskPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing tasks as tickets or deals. Required when taskSyncType is TICKET or DEAL. */
  taskStageId?: InputMaybe<Scalars['String']['input']>;
  /** How tasks should be synced to HubSpot. When set to TICKET or DEAL, corresponding field mappings must be provided. */
  taskSyncType?: InputMaybe<HubSpotTaskSyncType>;
};

/** Describes the type of entity that initiated an update */
export enum UpdateInitiatorType {
  /** Agency client indicates an authenticated agency client */
  AgencyClient = 'AGENCY_CLIENT',
  /** Agency user indicates an authenticated agency user */
  AgencyUser = 'AGENCY_USER',
  /** Anonymous indicates an unauthenticated external user */
  Anonymous = 'ANONYMOUS',
  /** Cronjob indicates a scheduled automated job */
  Cronjob = 'CRONJOB',
  /** Oyster indicates an internal employee at Oyster */
  Oyster = 'OYSTER',
  /** Workflow indicates a Temporal workflow */
  Workflow = 'WORKFLOW'
}

/** UpdateIntegrationInput contains the input for updating an integration */
export type UpdateIntegrationInput = {
  /** Configuration for the Hawksoft integration */
  hawksoft?: InputMaybe<UpdateHawksoftIntegrationInput>;
  /** Configuration for the HubSpot integration */
  hubspot?: InputMaybe<UpdateHubSpotIntegrationInput>;
  /** Configuration for the NowCerts integration */
  nowcerts?: InputMaybe<UpdateNowCertsIntegrationInput>;
  /** Current state of the integration */
  state?: InputMaybe<IntegrationState>;
};

/** Input for updating a document in the knowledge base */
export type UpdateKnowledgeBaseDocumentInput = {
  /** The content of the document, if this is a text document */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The title of the document */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateNowCertsIntegrationInput contains the input for updating a NowCerts integration */
export type UpdateNowCertsIntegrationInput = {
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for updating a service request */
export type UpdateServiceRequestInput = {
  /** The ID of the agency user that is assigned to this service request */
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  /** The date and time that this service request is due */
  dueAt?: InputMaybe<Scalars['Time']['input']>;
};

/** UploadFileInput represents a file upload request */
export type UploadFileInput = {
  /** The file to upload */
  file: Scalars['Upload']['input'];
  /** The notes associated with the file */
  notes: Scalars['String']['input'];
  /** The type of the file */
  type: FileType;
  /** Whether the file is visible to the user */
  visible: Scalars['Boolean']['input'];
};

/** Input for uploading a new file document in the knowledge base */
export type UploadKnowledgeBaseFileDocumentInput = {
  /** The files to upload */
  files: Array<Scalars['Upload']['input']>;
};

/**
 * Represents a tool for writing to an integration.
 * Used when the LLM needs to write to an integration.
 */
export type WriteIntegrationTool = {
  __typename?: 'WriteIntegrationTool';
  /** The input arguments for the integration write */
  input: WriteIntegrationToolInput;
  /** The result of the integration write operation */
  output: WriteIntegrationToolOutput;
};

export type WriteIntegrationToolAccount = {
  __typename?: 'WriteIntegrationToolAccount';
  address: Address;
  businessName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type WriteIntegrationToolCreateNoteInput = {
  __typename?: 'WriteIntegrationToolCreateNoteInput';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WriteIntegrationToolCreateTaskInput = {
  __typename?: 'WriteIntegrationToolCreateTaskInput';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input arguments for the WriteIntegrationTool. */
export type WriteIntegrationToolInput = {
  __typename?: 'WriteIntegrationToolInput';
  account: WriteIntegrationToolAccount;
  /**
   * The type of entity to write. This must be one of the following values:
   * - CREATE_NOTE
   * - CREATE_TASK
   * - UPLOAD_DOCUMENT
   * - UPSERT_ACCOUNT
   */
  action: Scalars['String']['output'];
  agentName: Scalars['String']['output'];
  createNote?: Maybe<WriteIntegrationToolCreateNoteInput>;
  createTask?: Maybe<WriteIntegrationToolCreateTaskInput>;
  uploadDocument?: Maybe<WriteIntegrationToolUploadDocumentInput>;
};

export type WriteIntegrationToolOutput = {
  __typename?: 'WriteIntegrationToolOutput';
  /** The ID of the entity that was created or updated */
  id: Scalars['String']['output'];
  /** The message from the integration write operation */
  message: Scalars['String']['output'];
  /** The result of the integration write operation */
  success: Scalars['Boolean']['output'];
};

export type WriteIntegrationToolUploadDocumentInput = {
  __typename?: 'WriteIntegrationToolUploadDocumentInput';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type AccountFieldsFragment = {
  __typename?: 'Account';
  createdAt: Date;
  id: string;
  type: AccountType;
  account:
    | {
        __typename?: 'BusinessAccount';
        dba: string;
        website: string;
        email: string;
        name: string;
        phone: string;
        mailingAddress: {
          __typename?: 'Address';
          line1: string;
          line2?: string | null | undefined;
          city: string;
          zone: string;
          postalCode: string;
        };
      }
    | {
        __typename?: 'IndividualAccount';
        email: string;
        name: string;
        phone: string;
        mailingAddress: {
          __typename?: 'Address';
          line1: string;
          line2?: string | null | undefined;
          city: string;
          zone: string;
          postalCode: string;
        };
      };
};

export type AccountBusinessApplicationFieldsFragment = {
  __typename?: 'Account';
  businessApplications: Array<{
    __typename?: 'BusinessApplication';
    annualRevenue: number;
    businessDba: string;
    businessName: string;
    fein: string;
    id: string;
    insuranceEffectiveAt?: Date | null | undefined;
    insuranceTypes: Array<InsuranceType>;
    legalEntityType?: BusinessLegalEntityType | null | undefined;
    naicsCode: string;
    selectedCarriers: Array<BusinessApplicationCarrier>;
    state: BusinessApplicationState;
    yearOfFounding: string;
    yearsOfManagementExperience: number;
    contact: { __typename?: 'BusinessContact'; fullName: string; email: string; phone: string };
    employeeInfo: {
      __typename?: 'BusinessEmployeeInfo';
      numFullTimeEmployees: number;
      numPartTimeEmployees: number;
      totalEmployeePayroll: number;
    };
    locations: Array<{
      __typename?: 'BusinessLocation';
      id: string;
      isPrimary: boolean;
      address: {
        __typename?: 'Address';
        line1: string;
        line2?: string | null | undefined;
        city: string;
        zone: string;
        postalCode: string;
      };
      buildingInfo: {
        __typename?: 'BusinessLocationBuildingInfo';
        annualSales: number;
        areaOccupiedByBusiness: number;
        buildingCoverage: number;
        burglarAlarmType?: BurglarAlarmType | null | undefined;
        constructionType?: BuildingConstructionType | null | undefined;
        ownershipType?: BuildingOwnershipType | null | undefined;
        personalPropertyCoverage: number;
        sprinkleredPercentage: number;
        totalArea: number;
        totalStories: number;
        yearBuilt: string;
      };
      employeeInfo: {
        __typename?: 'BusinessEmployeeInfo';
        numPartTimeEmployees: number;
        numFullTimeEmployees: number;
        totalEmployeePayroll: number;
        jobCode: string;
      };
    }>;
    mailingAddress: {
      __typename?: 'Address';
      line1: string;
      line2?: string | null | undefined;
      city: string;
      zone: string;
      postalCode: string;
    };
    owners: Array<{
      __typename?: 'BusinessOwner';
      fullName: string;
      annualPayroll: number;
      dateOfBirth?: Date | null | undefined;
      jobCode?: string | null | undefined;
    }>;
    pastPolicyLosses: Array<{
      __typename?: 'PastPolicyLoss';
      claimDate?: Date | null | undefined;
      claimStatus?: PastPolicyLossClaimStatus | null | undefined;
      lossDate?: Date | null | undefined;
      lossDescription: string;
      lossState: string;
      lossType?: PastPolicyLossType | null | undefined;
      policyEffectiveDate?: Date | null | undefined;
      policyExpirationDate?: Date | null | undefined;
      policyType?: InsuranceType | null | undefined;
      totalPaidAmount: number;
      totalReservedAmount: number;
    }>;
    selectedLimits: {
      __typename?: 'BusinessApplicationInsuranceLimits';
      coverageState: string;
      wcPerAccidentLimit?: number | null | undefined;
      wcPerDiseaseEmployeeLimit?: number | null | undefined;
      wcPerDiseasePolicyLimit?: number | null | undefined;
      glPerOccurrenceLimit?: number | null | undefined;
      glAggregateLimit?: number | null | undefined;
      bopPerOccurrenceLimit?: number | null | undefined;
      bopAggregateLimit?: number | null | undefined;
      cyberRetentionLimit?: number | null | undefined;
      cyberAggregateLimit?: number | null | undefined;
    };
    underwritingAnswers: Array<{
      __typename?: 'UnderwritingAnswer';
      answer: string;
      locationId?: string | null | undefined;
      questionId: string;
    }>;
    underwritingQuestions: Array<{
      __typename?: 'UnderwritingQuestion';
      id: string;
      carriers: Array<BusinessApplicationCarrier>;
      defaultAnswer?: string | null | undefined;
      hasParentQuestion: boolean;
      locationId?: string | null | undefined;
      question: string;
      tooltip: string;
      type: UnderwritingQuestionType;
      answerOptions?:
        | Array<{ __typename?: 'UnderwritingAnswerOption'; displayText: string; value: string }>
        | null
        | undefined;
      dependentQuestions: Array<{
        __typename?: 'UnderwritingQuestionDependency';
        condition?: string | null | undefined;
        dependentQuestionIds: Array<string>;
        type: UnderwritingQuestionDependencyType;
      }>;
    }>;
    underwritingStatements: Array<{
      __typename?: 'UnderwritingStatement';
      carrier: BusinessApplicationCarrier;
      markdown: string;
    }>;
  }>;
};

export type AccountBusinessPolicyFieldsFragment = {
  __typename?: 'Account';
  businessPolicies: Array<{
    __typename?: 'BusinessPolicy';
    expiresAt?: Date | null | undefined;
    id: string;
    inforceAt?: Date | null | undefined;
    issuedAt?: Date | null | undefined;
    policyNumber: string;
    state: PolicyState;
    type: InsuranceType;
    account: {
      __typename?: 'Account';
      id: string;
      account:
        | { __typename?: 'BusinessAccount'; email: string; name: string }
        | { __typename?: 'IndividualAccount'; email: string; name: string };
    };
    carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
  }>;
};

export type AccountCertificateOfLiabilityInsuranceFieldsFragment = {
  __typename?: 'Account';
  certificatesOfLiabilityInsurance: Array<{
    __typename?: 'CertificateOfLiabilityInsurance';
    id: string;
    certificateNumber: string;
    viewUrl: string;
    downloadUrl: string;
    createdAt: Date;
    holder: {
      __typename?: 'CertificateEntity';
      name: string;
      address: {
        __typename?: 'Address';
        line1: string;
        city: string;
        zone: string;
        postalCode: string;
      };
    };
  }>;
};

export type AccountContactFieldsFragment = {
  __typename?: 'Account';
  contacts: Array<{
    __typename?: 'AccountContact';
    email: string;
    id: string;
    name: string;
    phone: string;
  }>;
};

export type AccountServiceRequestFieldsFragment = {
  __typename?: 'Account';
  serviceRequests: Array<{
    __typename?: 'ServiceRequest';
    id: string;
    type: ServiceRequestType;
    state: ServiceRequestState;
    clientEmail?: string | null | undefined;
    clientName?: string | null | undefined;
    clientPhone?: string | null | undefined;
    details: string;
    dueAt?: Date | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          type: AccountType;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
    addAdditionalInsured?:
      | {
          __typename?: 'AddAdditionalInsuredRequest';
          name: string;
          relationship: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    businessPolicy?:
      | {
          __typename?: 'BusinessPolicy';
          id: string;
          type: InsuranceType;
          carrier: { __typename?: 'InsuranceCarrier'; name: string };
        }
      | null
      | undefined;
    cancelPolicy?:
      | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
      | null
      | undefined;
    createCertificate?:
      | {
          __typename?: 'CreateCertificateRequest';
          name: string;
          additionalInsured: boolean;
          additionalInsuredRelationship?: string | null | undefined;
          additionalInsuredRelationshipDescription?: string | null | undefined;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    documentRequest?:
      | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
      | null
      | undefined;
    endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
    question?:
      | {
          __typename?: 'QuestionRequest';
          policyId?: string | null | undefined;
          question: string;
          type: QuestionRequestType;
        }
      | null
      | undefined;
    resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
  }>;
};

export type GetAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountsQuery = {
  __typename?: 'Query';
  accounts: Array<{
    __typename?: 'Account';
    createdAt: Date;
    id: string;
    type: AccountType;
    account:
      | {
          __typename?: 'BusinessAccount';
          dba: string;
          website: string;
          email: string;
          name: string;
          phone: string;
          mailingAddress: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | {
          __typename?: 'IndividualAccount';
          email: string;
          name: string;
          phone: string;
          mailingAddress: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
        };
  }>;
};

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetAccountQuery = {
  __typename?: 'Query';
  account?:
    | {
        __typename?: 'Account';
        createdAt: Date;
        id: string;
        type: AccountType;
        account:
          | {
              __typename?: 'BusinessAccount';
              dba: string;
              website: string;
              email: string;
              name: string;
              phone: string;
              mailingAddress: {
                __typename?: 'Address';
                line1: string;
                line2?: string | null | undefined;
                city: string;
                zone: string;
                postalCode: string;
              };
            }
          | {
              __typename?: 'IndividualAccount';
              email: string;
              name: string;
              phone: string;
              mailingAddress: {
                __typename?: 'Address';
                line1: string;
                line2?: string | null | undefined;
                city: string;
                zone: string;
                postalCode: string;
              };
            };
        businessApplications: Array<{
          __typename?: 'BusinessApplication';
          annualRevenue: number;
          businessDba: string;
          businessName: string;
          fein: string;
          id: string;
          insuranceEffectiveAt?: Date | null | undefined;
          insuranceTypes: Array<InsuranceType>;
          legalEntityType?: BusinessLegalEntityType | null | undefined;
          naicsCode: string;
          selectedCarriers: Array<BusinessApplicationCarrier>;
          state: BusinessApplicationState;
          yearOfFounding: string;
          yearsOfManagementExperience: number;
          contact: {
            __typename?: 'BusinessContact';
            fullName: string;
            email: string;
            phone: string;
          };
          employeeInfo: {
            __typename?: 'BusinessEmployeeInfo';
            numFullTimeEmployees: number;
            numPartTimeEmployees: number;
            totalEmployeePayroll: number;
          };
          locations: Array<{
            __typename?: 'BusinessLocation';
            id: string;
            isPrimary: boolean;
            address: {
              __typename?: 'Address';
              line1: string;
              line2?: string | null | undefined;
              city: string;
              zone: string;
              postalCode: string;
            };
            buildingInfo: {
              __typename?: 'BusinessLocationBuildingInfo';
              annualSales: number;
              areaOccupiedByBusiness: number;
              buildingCoverage: number;
              burglarAlarmType?: BurglarAlarmType | null | undefined;
              constructionType?: BuildingConstructionType | null | undefined;
              ownershipType?: BuildingOwnershipType | null | undefined;
              personalPropertyCoverage: number;
              sprinkleredPercentage: number;
              totalArea: number;
              totalStories: number;
              yearBuilt: string;
            };
            employeeInfo: {
              __typename?: 'BusinessEmployeeInfo';
              numPartTimeEmployees: number;
              numFullTimeEmployees: number;
              totalEmployeePayroll: number;
              jobCode: string;
            };
          }>;
          mailingAddress: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
          owners: Array<{
            __typename?: 'BusinessOwner';
            fullName: string;
            annualPayroll: number;
            dateOfBirth?: Date | null | undefined;
            jobCode?: string | null | undefined;
          }>;
          pastPolicyLosses: Array<{
            __typename?: 'PastPolicyLoss';
            claimDate?: Date | null | undefined;
            claimStatus?: PastPolicyLossClaimStatus | null | undefined;
            lossDate?: Date | null | undefined;
            lossDescription: string;
            lossState: string;
            lossType?: PastPolicyLossType | null | undefined;
            policyEffectiveDate?: Date | null | undefined;
            policyExpirationDate?: Date | null | undefined;
            policyType?: InsuranceType | null | undefined;
            totalPaidAmount: number;
            totalReservedAmount: number;
          }>;
          selectedLimits: {
            __typename?: 'BusinessApplicationInsuranceLimits';
            coverageState: string;
            wcPerAccidentLimit?: number | null | undefined;
            wcPerDiseaseEmployeeLimit?: number | null | undefined;
            wcPerDiseasePolicyLimit?: number | null | undefined;
            glPerOccurrenceLimit?: number | null | undefined;
            glAggregateLimit?: number | null | undefined;
            bopPerOccurrenceLimit?: number | null | undefined;
            bopAggregateLimit?: number | null | undefined;
            cyberRetentionLimit?: number | null | undefined;
            cyberAggregateLimit?: number | null | undefined;
          };
          underwritingAnswers: Array<{
            __typename?: 'UnderwritingAnswer';
            answer: string;
            locationId?: string | null | undefined;
            questionId: string;
          }>;
          underwritingQuestions: Array<{
            __typename?: 'UnderwritingQuestion';
            id: string;
            carriers: Array<BusinessApplicationCarrier>;
            defaultAnswer?: string | null | undefined;
            hasParentQuestion: boolean;
            locationId?: string | null | undefined;
            question: string;
            tooltip: string;
            type: UnderwritingQuestionType;
            answerOptions?:
              | Array<{
                  __typename?: 'UnderwritingAnswerOption';
                  displayText: string;
                  value: string;
                }>
              | null
              | undefined;
            dependentQuestions: Array<{
              __typename?: 'UnderwritingQuestionDependency';
              condition?: string | null | undefined;
              dependentQuestionIds: Array<string>;
              type: UnderwritingQuestionDependencyType;
            }>;
          }>;
          underwritingStatements: Array<{
            __typename?: 'UnderwritingStatement';
            carrier: BusinessApplicationCarrier;
            markdown: string;
          }>;
        }>;
        businessPolicies: Array<{
          __typename?: 'BusinessPolicy';
          expiresAt?: Date | null | undefined;
          id: string;
          inforceAt?: Date | null | undefined;
          issuedAt?: Date | null | undefined;
          policyNumber: string;
          state: PolicyState;
          type: InsuranceType;
          account: {
            __typename?: 'Account';
            id: string;
            account:
              | { __typename?: 'BusinessAccount'; email: string; name: string }
              | { __typename?: 'IndividualAccount'; email: string; name: string };
          };
          carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
        }>;
        certificatesOfLiabilityInsurance: Array<{
          __typename?: 'CertificateOfLiabilityInsurance';
          id: string;
          certificateNumber: string;
          viewUrl: string;
          downloadUrl: string;
          createdAt: Date;
          holder: {
            __typename?: 'CertificateEntity';
            name: string;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          };
        }>;
        contacts: Array<{
          __typename?: 'AccountContact';
          email: string;
          id: string;
          name: string;
          phone: string;
        }>;
        serviceRequests: Array<{
          __typename?: 'ServiceRequest';
          id: string;
          type: ServiceRequestType;
          state: ServiceRequestState;
          clientEmail?: string | null | undefined;
          clientName?: string | null | undefined;
          clientPhone?: string | null | undefined;
          details: string;
          dueAt?: Date | null | undefined;
          createdAt: Date;
          updatedAt: Date;
          account?:
            | {
                __typename?: 'Account';
                type: AccountType;
                account:
                  | { __typename?: 'BusinessAccount'; name: string }
                  | { __typename?: 'IndividualAccount'; name: string };
              }
            | null
            | undefined;
          assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
          addAdditionalInsured?:
            | {
                __typename?: 'AddAdditionalInsuredRequest';
                name: string;
                relationship: string;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          businessPolicy?:
            | {
                __typename?: 'BusinessPolicy';
                id: string;
                type: InsuranceType;
                carrier: { __typename?: 'InsuranceCarrier'; name: string };
              }
            | null
            | undefined;
          cancelPolicy?:
            | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
            | null
            | undefined;
          createCertificate?:
            | {
                __typename?: 'CreateCertificateRequest';
                name: string;
                additionalInsured: boolean;
                additionalInsuredRelationship?: string | null | undefined;
                additionalInsuredRelationshipDescription?: string | null | undefined;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          documentRequest?:
            | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
            | null
            | undefined;
          endorsePolicy?:
            | { __typename?: 'EndorsePolicyRequest'; policyId: string }
            | null
            | undefined;
          question?:
            | {
                __typename?: 'QuestionRequest';
                policyId?: string | null | undefined;
                question: string;
                type: QuestionRequestType;
              }
            | null
            | undefined;
          resolution?:
            | { __typename?: 'ServiceRequestResolution'; notes: string }
            | null
            | undefined;
        }>;
      }
    | null
    | undefined;
};

export type ContactFieldsFragment = {
  __typename?: 'AccountContact';
  email: string;
  id: string;
  name: string;
  phone: string;
};

export type GetContactsQueryVariables = Exact<{ [key: string]: never }>;

export type GetContactsQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'AccountContact';
    email: string;
    id: string;
    name: string;
    phone: string;
  }>;
};

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;

export type CreateAccountMutation = {
  __typename?: 'Mutation';
  createAccount: {
    __typename?: 'Account';
    createdAt: Date;
    id: string;
    type: AccountType;
    account:
      | {
          __typename?: 'BusinessAccount';
          dba: string;
          website: string;
          email: string;
          name: string;
          phone: string;
          mailingAddress: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | {
          __typename?: 'IndividualAccount';
          email: string;
          name: string;
          phone: string;
          mailingAddress: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
        };
  };
};

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
}>;

export type UpdateAccountMutation = {
  __typename?: 'Mutation';
  updateAccount: {
    __typename?: 'Account';
    createdAt: Date;
    id: string;
    type: AccountType;
    account:
      | {
          __typename?: 'BusinessAccount';
          dba: string;
          website: string;
          email: string;
          name: string;
          phone: string;
          mailingAddress: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | {
          __typename?: 'IndividualAccount';
          email: string;
          name: string;
          phone: string;
          mailingAddress: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
        };
  };
};

export type AgencySubscriptionFieldsFragment = {
  __typename?: 'AgencySubscription';
  nextBillingAmount?: number | null | undefined;
  nextBillingDate?: Date | null | undefined;
  numSeats: number;
  numSeatsActive: number;
  period?: SubscriptionPeriod | null | undefined;
  plan?: SubscriptionPlan | null | undefined;
  state: SubscriptionState;
  trialEndDate?: Date | null | undefined;
};

export type AgencyFieldsFragment = {
  __typename?: 'Agency';
  id: string;
  name: string;
  subscription?:
    | {
        __typename?: 'AgencySubscription';
        nextBillingAmount?: number | null | undefined;
        nextBillingDate?: Date | null | undefined;
        numSeats: number;
        numSeatsActive: number;
        period?: SubscriptionPeriod | null | undefined;
        plan?: SubscriptionPlan | null | undefined;
        state: SubscriptionState;
        trialEndDate?: Date | null | undefined;
      }
    | null
    | undefined;
};

export type AgencyUserFieldsFragment = {
  __typename?: 'AgencyUser';
  id: string;
  email: string;
  name: string;
  state: AgencyUserState;
};

export type LoggedInAgencyUserFieldsFragment = {
  __typename?: 'AgencyUser';
  id: string;
  email: string;
  name: string;
  state: AgencyUserState;
  preferences: {
    __typename?: 'AgencyUserPreferences';
    favoritePresets: {
      __typename?: 'AgencyUserPreferencesFavoritePresets';
      presets: Array<CaraWorkspacePreset>;
      customPresets: Array<{
        __typename?: 'CustomPreset';
        id: string;
        title: string;
        description: string;
      }>;
    };
  };
  agency: {
    __typename?: 'Agency';
    id: string;
    name: string;
    subscription?:
      | {
          __typename?: 'AgencySubscription';
          nextBillingAmount?: number | null | undefined;
          nextBillingDate?: Date | null | undefined;
          numSeats: number;
          numSeatsActive: number;
          period?: SubscriptionPeriod | null | undefined;
          plan?: SubscriptionPlan | null | undefined;
          state: SubscriptionState;
          trialEndDate?: Date | null | undefined;
        }
      | null
      | undefined;
  };
};

export type GetAgencyUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetAgencyUserQuery = {
  __typename?: 'Query';
  agencyUser?:
    | {
        __typename?: 'AgencyUser';
        id: string;
        email: string;
        name: string;
        state: AgencyUserState;
        preferences: {
          __typename?: 'AgencyUserPreferences';
          favoritePresets: {
            __typename?: 'AgencyUserPreferencesFavoritePresets';
            presets: Array<CaraWorkspacePreset>;
            customPresets: Array<{
              __typename?: 'CustomPreset';
              id: string;
              title: string;
              description: string;
            }>;
          };
        };
        agency: {
          __typename?: 'Agency';
          id: string;
          name: string;
          subscription?:
            | {
                __typename?: 'AgencySubscription';
                nextBillingAmount?: number | null | undefined;
                nextBillingDate?: Date | null | undefined;
                numSeats: number;
                numSeatsActive: number;
                period?: SubscriptionPeriod | null | undefined;
                plan?: SubscriptionPlan | null | undefined;
                state: SubscriptionState;
                trialEndDate?: Date | null | undefined;
              }
            | null
            | undefined;
        };
      }
    | null
    | undefined;
};

export type GetAgencyUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAgencyUsersQuery = {
  __typename?: 'Query';
  agencyUsers: Array<{
    __typename?: 'AgencyUser';
    id: string;
    email: string;
    name: string;
    state: AgencyUserState;
  }>;
};

export type UpdateAgencyUserPreferencesMutationVariables = Exact<{
  input: AgencyUserPreferencesInput;
}>;

export type UpdateAgencyUserPreferencesMutation = {
  __typename?: 'Mutation';
  updateAgencyUserPreferences: {
    __typename?: 'AgencyUser';
    id: string;
    email: string;
    name: string;
    state: AgencyUserState;
  };
};

export type CreateAgencyUserMutationVariables = Exact<{
  input: AgencyUserInput;
}>;

export type CreateAgencyUserMutation = {
  __typename?: 'Mutation';
  createAgencyUser: {
    __typename?: 'AgencyUser';
    id: string;
    email: string;
    name: string;
    state: AgencyUserState;
  };
};

export type DisableAgencyUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DisableAgencyUserMutation = {
  __typename?: 'Mutation';
  disableAgencyUser: {
    __typename?: 'AgencyUser';
    id: string;
    email: string;
    name: string;
    state: AgencyUserState;
  };
};

export type EnableAgencyUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type EnableAgencyUserMutation = {
  __typename?: 'Mutation';
  enableAgencyUser: {
    __typename?: 'AgencyUser';
    id: string;
    email: string;
    name: string;
    state: AgencyUserState;
  };
};

export type GetSubscriptionBillingPortalLinkQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubscriptionBillingPortalLinkQuery = {
  __typename?: 'Query';
  subscriptionManagementLinks?:
    | { __typename?: 'SubscriptionManagementLinks'; billingPortalUrl: string }
    | null
    | undefined;
};

export type GetSubscriptionUpdateLinkQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubscriptionUpdateLinkQuery = {
  __typename?: 'Query';
  subscriptionManagementLinks?:
    | { __typename?: 'SubscriptionManagementLinks'; updateSubscriptionUrl: string }
    | null
    | undefined;
};

export type GetSubscriptionUpdatePaymentLinkQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubscriptionUpdatePaymentLinkQuery = {
  __typename?: 'Query';
  subscriptionManagementLinks?:
    | { __typename?: 'SubscriptionManagementLinks'; updatePaymentMethodUrl: string }
    | null
    | undefined;
};

export type AgencySignInFieldsFragment = {
  __typename?: 'AgencySignInResponse';
  agencyUser: {
    __typename?: 'AgencyUser';
    id: string;
    email: string;
    name: string;
    agency: { __typename?: 'Agency'; id: string; name: string };
  };
};

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type SignInMutation = {
  __typename?: 'Mutation';
  agencySignIn?:
    | {
        __typename?: 'AgencySignInResponse';
        agencyUser: {
          __typename?: 'AgencyUser';
          id: string;
          email: string;
          name: string;
          agency: { __typename?: 'Agency'; id: string; name: string };
        };
      }
    | null
    | undefined;
};

export type SignInCompleteMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type SignInCompleteMutation = {
  __typename?: 'Mutation';
  agencySignIn?:
    | {
        __typename?: 'AgencySignInResponse';
        agencyUser: {
          __typename?: 'AgencyUser';
          id: string;
          email: string;
          name: string;
          agency: { __typename?: 'Agency'; id: string; name: string };
        };
      }
    | null
    | undefined;
};

export type SignOutMutationVariables = Exact<{ [key: string]: never }>;

export type SignOutMutation = { __typename?: 'Mutation'; agencySignOut: boolean };

export type BusinessApplicationFieldsFragment = {
  __typename?: 'BusinessApplication';
  annualRevenue: number;
  businessDba: string;
  businessName: string;
  fein: string;
  id: string;
  insuranceEffectiveAt?: Date | null | undefined;
  insuranceTypes: Array<InsuranceType>;
  legalEntityType?: BusinessLegalEntityType | null | undefined;
  naicsCode: string;
  selectedCarriers: Array<BusinessApplicationCarrier>;
  state: BusinessApplicationState;
  yearOfFounding: string;
  yearsOfManagementExperience: number;
  contact: { __typename?: 'BusinessContact'; fullName: string; email: string; phone: string };
  employeeInfo: {
    __typename?: 'BusinessEmployeeInfo';
    numFullTimeEmployees: number;
    numPartTimeEmployees: number;
    totalEmployeePayroll: number;
  };
  locations: Array<{
    __typename?: 'BusinessLocation';
    id: string;
    isPrimary: boolean;
    address: {
      __typename?: 'Address';
      line1: string;
      line2?: string | null | undefined;
      city: string;
      zone: string;
      postalCode: string;
    };
    buildingInfo: {
      __typename?: 'BusinessLocationBuildingInfo';
      annualSales: number;
      areaOccupiedByBusiness: number;
      buildingCoverage: number;
      burglarAlarmType?: BurglarAlarmType | null | undefined;
      constructionType?: BuildingConstructionType | null | undefined;
      ownershipType?: BuildingOwnershipType | null | undefined;
      personalPropertyCoverage: number;
      sprinkleredPercentage: number;
      totalArea: number;
      totalStories: number;
      yearBuilt: string;
    };
    employeeInfo: {
      __typename?: 'BusinessEmployeeInfo';
      numPartTimeEmployees: number;
      numFullTimeEmployees: number;
      totalEmployeePayroll: number;
      jobCode: string;
    };
  }>;
  mailingAddress: {
    __typename?: 'Address';
    line1: string;
    line2?: string | null | undefined;
    city: string;
    zone: string;
    postalCode: string;
  };
  owners: Array<{
    __typename?: 'BusinessOwner';
    fullName: string;
    annualPayroll: number;
    dateOfBirth?: Date | null | undefined;
    jobCode?: string | null | undefined;
  }>;
  pastPolicyLosses: Array<{
    __typename?: 'PastPolicyLoss';
    claimDate?: Date | null | undefined;
    claimStatus?: PastPolicyLossClaimStatus | null | undefined;
    lossDate?: Date | null | undefined;
    lossDescription: string;
    lossState: string;
    lossType?: PastPolicyLossType | null | undefined;
    policyEffectiveDate?: Date | null | undefined;
    policyExpirationDate?: Date | null | undefined;
    policyType?: InsuranceType | null | undefined;
    totalPaidAmount: number;
    totalReservedAmount: number;
  }>;
  selectedLimits: {
    __typename?: 'BusinessApplicationInsuranceLimits';
    coverageState: string;
    wcPerAccidentLimit?: number | null | undefined;
    wcPerDiseaseEmployeeLimit?: number | null | undefined;
    wcPerDiseasePolicyLimit?: number | null | undefined;
    glPerOccurrenceLimit?: number | null | undefined;
    glAggregateLimit?: number | null | undefined;
    bopPerOccurrenceLimit?: number | null | undefined;
    bopAggregateLimit?: number | null | undefined;
    cyberRetentionLimit?: number | null | undefined;
    cyberAggregateLimit?: number | null | undefined;
  };
  underwritingAnswers: Array<{
    __typename?: 'UnderwritingAnswer';
    answer: string;
    locationId?: string | null | undefined;
    questionId: string;
  }>;
  underwritingQuestions: Array<{
    __typename?: 'UnderwritingQuestion';
    id: string;
    carriers: Array<BusinessApplicationCarrier>;
    defaultAnswer?: string | null | undefined;
    hasParentQuestion: boolean;
    locationId?: string | null | undefined;
    question: string;
    tooltip: string;
    type: UnderwritingQuestionType;
    answerOptions?:
      | Array<{ __typename?: 'UnderwritingAnswerOption'; displayText: string; value: string }>
      | null
      | undefined;
    dependentQuestions: Array<{
      __typename?: 'UnderwritingQuestionDependency';
      condition?: string | null | undefined;
      dependentQuestionIds: Array<string>;
      type: UnderwritingQuestionDependencyType;
    }>;
  }>;
  underwritingStatements: Array<{
    __typename?: 'UnderwritingStatement';
    carrier: BusinessApplicationCarrier;
    markdown: string;
  }>;
};

export type BusinessPolicyDetailFieldsFragment = {
  __typename?: 'BusinessPolicy';
  market: InsuranceMarket;
  quoteNumber: string;
  account: {
    __typename?: 'Account';
    contacts: Array<{
      __typename?: 'AccountContact';
      email: string;
      id: string;
      name: string;
      phone: string;
    }>;
  };
  agencyUser: { __typename?: 'AgencyUser'; id: string; name: string };
  broker?: { __typename?: 'InsuranceCarrier'; id: string; name: string } | null | undefined;
  cancellation?:
    | {
        __typename?: 'BusinessPolicyCancellation';
        canceledAt: Date;
        canceledBy: BusinessPolicyCancellationSource;
        effectiveAt: Date;
        type: BusinessPolicyCancellationType;
        reason: BusinessPolicyCancellationReason;
        reasonDescription: string;
        returnCommission: number;
        returnPremium: number;
      }
    | null
    | undefined;
  details?:
    | {
        __typename?: 'BusinessPolicyExtractedDetails';
        deductible?: number | null | undefined;
        policyNumber?: string | null | undefined;
        summary?: string | null | undefined;
        blanketAdditionalInsureds: Array<{
          __typename?: 'BusinessPolicyBlanketAdditionalInsured';
          type: string;
          description: string;
        }>;
        carrier?:
          | {
              __typename?: 'BusinessPolicyEntity';
              name: string;
              address: {
                __typename?: 'Address';
                line1: string;
                line2?: string | null | undefined;
                city: string;
                zone: string;
                postalCode: string;
              };
            }
          | null
          | undefined;
        coverageDescriptions: Array<{
          __typename?: 'BusinessPolicyCoverageOrExclusionDescription';
          description: string;
          policyQuotes: Array<string>;
          title: string;
        }>;
        exclusionDescriptions: Array<{
          __typename?: 'BusinessPolicyCoverageOrExclusionDescription';
          description: string;
          policyQuotes: Array<string>;
          title: string;
        }>;
        extraLimits: Array<{
          __typename?: 'BusinessPolicyExtraInsuranceLimit';
          limit: number;
          name: string;
        }>;
        insured?:
          | {
              __typename?: 'BusinessPolicyEntity';
              name: string;
              address: {
                __typename?: 'Address';
                line1: string;
                line2?: string | null | undefined;
                city: string;
                zone: string;
                postalCode: string;
              };
            }
          | null
          | undefined;
        limits: {
          __typename?: 'BusinessPolicyInsuranceLimits';
          cyberAggregateLimit?: number | null | undefined;
          cyberRetentionLimit?: number | null | undefined;
          glAggregateLimit?: number | null | undefined;
          glMedicalPerOccurrenceLimit?: number | null | undefined;
          glMedicalPerPersonLimit?: number | null | undefined;
          glPerOccurrenceLimit?: number | null | undefined;
          glPersonalAndAdvertisingInjuryLimit?: number | null | undefined;
          glProductsAndCompletedOperationsLimit?: number | null | undefined;
          glRentedPremisesDamageLimit?: number | null | undefined;
          propertyBuildingLimit?: number | null | undefined;
          propertyContentsLimit?: number | null | undefined;
          umbrellaOrExcessAggregateLimit?: number | null | undefined;
          umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined;
          wcPerAccidentLimit?: number | null | undefined;
          wcPerDiseaseEmployeeLimit?: number | null | undefined;
          wcPerDiseasePolicyLimit?: number | null | undefined;
        };
        locations: Array<{
          __typename?: 'BusinessPolicyLocation';
          address: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
          limits: {
            __typename?: 'BusinessPolicyInsuranceLimits';
            cyberAggregateLimit?: number | null | undefined;
            cyberRetentionLimit?: number | null | undefined;
            glAggregateLimit?: number | null | undefined;
            glMedicalPerOccurrenceLimit?: number | null | undefined;
            glMedicalPerPersonLimit?: number | null | undefined;
            glPerOccurrenceLimit?: number | null | undefined;
            glPersonalAndAdvertisingInjuryLimit?: number | null | undefined;
            glProductsAndCompletedOperationsLimit?: number | null | undefined;
            glRentedPremisesDamageLimit?: number | null | undefined;
            propertyBuildingLimit?: number | null | undefined;
            propertyContentsLimit?: number | null | undefined;
            umbrellaOrExcessAggregateLimit?: number | null | undefined;
            umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined;
            wcPerAccidentLimit?: number | null | undefined;
            wcPerDiseaseEmployeeLimit?: number | null | undefined;
            wcPerDiseasePolicyLimit?: number | null | undefined;
          };
        }>;
        namedAdditionalInsureds: Array<{
          __typename?: 'BusinessPolicyNamedAdditionalInsured';
          name: string;
          address: {
            __typename?: 'Address';
            line1: string;
            line2?: string | null | undefined;
            city: string;
            zone: string;
            postalCode: string;
          };
        }>;
      }
    | null
    | undefined;
  pricing: {
    __typename?: 'BusinessPolicyPricing';
    billingType: BusinessPolicyBillingType;
    premium: number;
    agencyFees: number;
    brokerFees: number;
    policyFees: number;
    otherFees: number;
    taxes: number;
    total: number;
    intervalType?: PaymentIntervalType | null | undefined;
    estimatedCommission: number;
  };
  reinstatement?:
    | {
        __typename?: 'BusinessPolicyReinstatement';
        reinstatedAt: Date;
        effectiveAt: Date;
        reasonDescription: string;
      }
    | null
    | undefined;
  renewal?:
    | {
        __typename?: 'BusinessPolicyRenewal';
        nextPolicies: Array<{ __typename?: 'BusinessPolicy'; id: string }>;
        previousPolicies: Array<{ __typename?: 'BusinessPolicy'; id: string }>;
      }
    | null
    | undefined;
};

export type BusinessPolicyFileFieldsFragment = {
  __typename?: 'BusinessPolicy';
  files: Array<{
    __typename?: 'File';
    createdAt: Date;
    id: string;
    mimeType: string;
    name: string;
    notes: string;
    type: FileType;
    url?: string | null | undefined;
  }>;
};

export type BusinessPolicyFieldsFragment = {
  __typename?: 'BusinessPolicy';
  expiresAt?: Date | null | undefined;
  id: string;
  inforceAt?: Date | null | undefined;
  issuedAt?: Date | null | undefined;
  policyNumber: string;
  state: PolicyState;
  type: InsuranceType;
  account: {
    __typename?: 'Account';
    id: string;
    account:
      | { __typename?: 'BusinessAccount'; email: string; name: string }
      | { __typename?: 'IndividualAccount'; email: string; name: string };
  };
  carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
};

export type InsuranceCarrierFieldsFragment = {
  __typename?: 'InsuranceCarrier';
  id: string;
  name: string;
  isCarrier: boolean;
  isBroker: boolean;
};

export type GetInsuranceCarriersQueryVariables = Exact<{ [key: string]: never }>;

export type GetInsuranceCarriersQuery = {
  __typename?: 'Query';
  carriers: Array<{
    __typename?: 'InsuranceCarrier';
    id: string;
    name: string;
    isCarrier: boolean;
    isBroker: boolean;
  }>;
};

export type GetBusinessPoliciesQueryVariables = Exact<{ [key: string]: never }>;

export type GetBusinessPoliciesQuery = {
  __typename?: 'Query';
  businessPolicies: Array<{
    __typename?: 'BusinessPolicy';
    expiresAt?: Date | null | undefined;
    id: string;
    inforceAt?: Date | null | undefined;
    issuedAt?: Date | null | undefined;
    policyNumber: string;
    state: PolicyState;
    type: InsuranceType;
    account: {
      __typename?: 'Account';
      id: string;
      account:
        | { __typename?: 'BusinessAccount'; email: string; name: string }
        | { __typename?: 'IndividualAccount'; email: string; name: string };
    };
    carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
  }>;
};

export type GetBusinessPolicyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetBusinessPolicyQuery = {
  __typename?: 'Query';
  businessPolicy?:
    | {
        __typename?: 'BusinessPolicy';
        expiresAt?: Date | null | undefined;
        id: string;
        inforceAt?: Date | null | undefined;
        issuedAt?: Date | null | undefined;
        policyNumber: string;
        state: PolicyState;
        type: InsuranceType;
        market: InsuranceMarket;
        quoteNumber: string;
        account: {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; email: string; name: string }
            | { __typename?: 'IndividualAccount'; email: string; name: string };
          contacts: Array<{
            __typename?: 'AccountContact';
            email: string;
            id: string;
            name: string;
            phone: string;
          }>;
        };
        carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
        agencyUser: { __typename?: 'AgencyUser'; id: string; name: string };
        broker?: { __typename?: 'InsuranceCarrier'; id: string; name: string } | null | undefined;
        cancellation?:
          | {
              __typename?: 'BusinessPolicyCancellation';
              canceledAt: Date;
              canceledBy: BusinessPolicyCancellationSource;
              effectiveAt: Date;
              type: BusinessPolicyCancellationType;
              reason: BusinessPolicyCancellationReason;
              reasonDescription: string;
              returnCommission: number;
              returnPremium: number;
            }
          | null
          | undefined;
        details?:
          | {
              __typename?: 'BusinessPolicyExtractedDetails';
              deductible?: number | null | undefined;
              policyNumber?: string | null | undefined;
              summary?: string | null | undefined;
              blanketAdditionalInsureds: Array<{
                __typename?: 'BusinessPolicyBlanketAdditionalInsured';
                type: string;
                description: string;
              }>;
              carrier?:
                | {
                    __typename?: 'BusinessPolicyEntity';
                    name: string;
                    address: {
                      __typename?: 'Address';
                      line1: string;
                      line2?: string | null | undefined;
                      city: string;
                      zone: string;
                      postalCode: string;
                    };
                  }
                | null
                | undefined;
              coverageDescriptions: Array<{
                __typename?: 'BusinessPolicyCoverageOrExclusionDescription';
                description: string;
                policyQuotes: Array<string>;
                title: string;
              }>;
              exclusionDescriptions: Array<{
                __typename?: 'BusinessPolicyCoverageOrExclusionDescription';
                description: string;
                policyQuotes: Array<string>;
                title: string;
              }>;
              extraLimits: Array<{
                __typename?: 'BusinessPolicyExtraInsuranceLimit';
                limit: number;
                name: string;
              }>;
              insured?:
                | {
                    __typename?: 'BusinessPolicyEntity';
                    name: string;
                    address: {
                      __typename?: 'Address';
                      line1: string;
                      line2?: string | null | undefined;
                      city: string;
                      zone: string;
                      postalCode: string;
                    };
                  }
                | null
                | undefined;
              limits: {
                __typename?: 'BusinessPolicyInsuranceLimits';
                cyberAggregateLimit?: number | null | undefined;
                cyberRetentionLimit?: number | null | undefined;
                glAggregateLimit?: number | null | undefined;
                glMedicalPerOccurrenceLimit?: number | null | undefined;
                glMedicalPerPersonLimit?: number | null | undefined;
                glPerOccurrenceLimit?: number | null | undefined;
                glPersonalAndAdvertisingInjuryLimit?: number | null | undefined;
                glProductsAndCompletedOperationsLimit?: number | null | undefined;
                glRentedPremisesDamageLimit?: number | null | undefined;
                propertyBuildingLimit?: number | null | undefined;
                propertyContentsLimit?: number | null | undefined;
                umbrellaOrExcessAggregateLimit?: number | null | undefined;
                umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined;
                wcPerAccidentLimit?: number | null | undefined;
                wcPerDiseaseEmployeeLimit?: number | null | undefined;
                wcPerDiseasePolicyLimit?: number | null | undefined;
              };
              locations: Array<{
                __typename?: 'BusinessPolicyLocation';
                address: {
                  __typename?: 'Address';
                  line1: string;
                  line2?: string | null | undefined;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
                limits: {
                  __typename?: 'BusinessPolicyInsuranceLimits';
                  cyberAggregateLimit?: number | null | undefined;
                  cyberRetentionLimit?: number | null | undefined;
                  glAggregateLimit?: number | null | undefined;
                  glMedicalPerOccurrenceLimit?: number | null | undefined;
                  glMedicalPerPersonLimit?: number | null | undefined;
                  glPerOccurrenceLimit?: number | null | undefined;
                  glPersonalAndAdvertisingInjuryLimit?: number | null | undefined;
                  glProductsAndCompletedOperationsLimit?: number | null | undefined;
                  glRentedPremisesDamageLimit?: number | null | undefined;
                  propertyBuildingLimit?: number | null | undefined;
                  propertyContentsLimit?: number | null | undefined;
                  umbrellaOrExcessAggregateLimit?: number | null | undefined;
                  umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined;
                  wcPerAccidentLimit?: number | null | undefined;
                  wcPerDiseaseEmployeeLimit?: number | null | undefined;
                  wcPerDiseasePolicyLimit?: number | null | undefined;
                };
              }>;
              namedAdditionalInsureds: Array<{
                __typename?: 'BusinessPolicyNamedAdditionalInsured';
                name: string;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  line2?: string | null | undefined;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }>;
            }
          | null
          | undefined;
        pricing: {
          __typename?: 'BusinessPolicyPricing';
          billingType: BusinessPolicyBillingType;
          premium: number;
          agencyFees: number;
          brokerFees: number;
          policyFees: number;
          otherFees: number;
          taxes: number;
          total: number;
          intervalType?: PaymentIntervalType | null | undefined;
          estimatedCommission: number;
        };
        reinstatement?:
          | {
              __typename?: 'BusinessPolicyReinstatement';
              reinstatedAt: Date;
              effectiveAt: Date;
              reasonDescription: string;
            }
          | null
          | undefined;
        renewal?:
          | {
              __typename?: 'BusinessPolicyRenewal';
              nextPolicies: Array<{ __typename?: 'BusinessPolicy'; id: string }>;
              previousPolicies: Array<{ __typename?: 'BusinessPolicy'; id: string }>;
            }
          | null
          | undefined;
        files: Array<{
          __typename?: 'File';
          createdAt: Date;
          id: string;
          mimeType: string;
          name: string;
          notes: string;
          type: FileType;
          url?: string | null | undefined;
        }>;
      }
    | null
    | undefined;
};

export type CreateBusinessPoliciesMutationVariables = Exact<{
  input: CreateBusinessPoliciesInput;
}>;

export type CreateBusinessPoliciesMutation = {
  __typename?: 'Mutation';
  createBusinessPolicies: Array<{
    __typename?: 'BusinessPolicy';
    expiresAt?: Date | null | undefined;
    id: string;
    inforceAt?: Date | null | undefined;
    issuedAt?: Date | null | undefined;
    policyNumber: string;
    state: PolicyState;
    type: InsuranceType;
    account: {
      __typename?: 'Account';
      id: string;
      account:
        | { __typename?: 'BusinessAccount'; email: string; name: string }
        | { __typename?: 'IndividualAccount'; email: string; name: string };
    };
    carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
  }>;
};

export type UpdateBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateBusinessPolicyInput;
}>;

export type UpdateBusinessPolicyMutation = {
  __typename?: 'Mutation';
  updateBusinessPolicy: {
    __typename?: 'BusinessPolicy';
    expiresAt?: Date | null | undefined;
    id: string;
    inforceAt?: Date | null | undefined;
    issuedAt?: Date | null | undefined;
    policyNumber: string;
    state: PolicyState;
    type: InsuranceType;
    account: {
      __typename?: 'Account';
      id: string;
      account:
        | { __typename?: 'BusinessAccount'; email: string; name: string }
        | { __typename?: 'IndividualAccount'; email: string; name: string };
    };
    carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
  };
};

export type DeleteBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteBusinessPolicyMutation = {
  __typename?: 'Mutation';
  deleteBusinessPolicy?:
    | {
        __typename?: 'BusinessPolicy';
        expiresAt?: Date | null | undefined;
        id: string;
        inforceAt?: Date | null | undefined;
        issuedAt?: Date | null | undefined;
        policyNumber: string;
        state: PolicyState;
        type: InsuranceType;
        account: {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; email: string; name: string }
            | { __typename?: 'IndividualAccount'; email: string; name: string };
        };
        carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
      }
    | null
    | undefined;
};

export type CancelBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CancelBusinessPolicyInput;
}>;

export type CancelBusinessPolicyMutation = {
  __typename?: 'Mutation';
  cancelBusinessPolicy: {
    __typename?: 'BusinessPolicy';
    expiresAt?: Date | null | undefined;
    id: string;
    inforceAt?: Date | null | undefined;
    issuedAt?: Date | null | undefined;
    policyNumber: string;
    state: PolicyState;
    type: InsuranceType;
    account: {
      __typename?: 'Account';
      id: string;
      account:
        | { __typename?: 'BusinessAccount'; email: string; name: string }
        | { __typename?: 'IndividualAccount'; email: string; name: string };
    };
    carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
  };
};

export type RenewBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RenewBusinessPolicyInput;
}>;

export type RenewBusinessPolicyMutation = {
  __typename?: 'Mutation';
  renewBusinessPolicy: {
    __typename?: 'BusinessPolicy';
    expiresAt?: Date | null | undefined;
    id: string;
    inforceAt?: Date | null | undefined;
    issuedAt?: Date | null | undefined;
    policyNumber: string;
    state: PolicyState;
    type: InsuranceType;
    account: {
      __typename?: 'Account';
      id: string;
      account:
        | { __typename?: 'BusinessAccount'; email: string; name: string }
        | { __typename?: 'IndividualAccount'; email: string; name: string };
    };
    carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
  };
};

export type ReinstateBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ReinstateBusinessPolicyInput;
}>;

export type ReinstateBusinessPolicyMutation = {
  __typename?: 'Mutation';
  reinstateBusinessPolicy: {
    __typename?: 'BusinessPolicy';
    expiresAt?: Date | null | undefined;
    id: string;
    inforceAt?: Date | null | undefined;
    issuedAt?: Date | null | undefined;
    policyNumber: string;
    state: PolicyState;
    type: InsuranceType;
    account: {
      __typename?: 'Account';
      id: string;
      account:
        | { __typename?: 'BusinessAccount'; email: string; name: string }
        | { __typename?: 'IndividualAccount'; email: string; name: string };
    };
    carrier: { __typename?: 'InsuranceCarrier'; id: string; name: string };
  };
};

export type UploadPolicyFileMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
  file: UploadFileInput;
}>;

export type UploadPolicyFileMutation = {
  __typename?: 'Mutation';
  uploadPolicyFile: {
    __typename?: 'File';
    createdAt: Date;
    id: string;
    mimeType: string;
    name: string;
    notes: string;
    type: FileType;
    url?: string | null | undefined;
  };
};

export type CallFieldsFragment = {
  __typename?: 'Call';
  id: string;
  disconnectionReason?: CallDisconnectionReason | null | undefined;
  endedAt?: Date | null | undefined;
  fromName?: string | null | undefined;
  fromNumber: string;
  startedAt: Date;
  status: CallStatus;
  account?:
    | {
        __typename?: 'Account';
        id: string;
        account:
          | { __typename?: 'BusinessAccount'; name: string }
          | { __typename?: 'IndividualAccount'; name: string };
      }
    | null
    | undefined;
};

export type CallTranscriptFieldsFragment = {
  __typename?: 'Call';
  recordingUrl?: string | null | undefined;
  sentiment?: CallSentiment | null | undefined;
  successful?: boolean | null | undefined;
  summary?: string | null | undefined;
  serviceRequests: Array<{
    __typename?: 'ServiceRequest';
    id: string;
    type: ServiceRequestType;
    state: ServiceRequestState;
    clientEmail?: string | null | undefined;
    clientName?: string | null | undefined;
    clientPhone?: string | null | undefined;
    details: string;
    dueAt?: Date | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          type: AccountType;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
    addAdditionalInsured?:
      | {
          __typename?: 'AddAdditionalInsuredRequest';
          name: string;
          relationship: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    businessPolicy?:
      | {
          __typename?: 'BusinessPolicy';
          id: string;
          type: InsuranceType;
          carrier: { __typename?: 'InsuranceCarrier'; name: string };
        }
      | null
      | undefined;
    cancelPolicy?:
      | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
      | null
      | undefined;
    createCertificate?:
      | {
          __typename?: 'CreateCertificateRequest';
          name: string;
          additionalInsured: boolean;
          additionalInsuredRelationship?: string | null | undefined;
          additionalInsuredRelationshipDescription?: string | null | undefined;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    documentRequest?:
      | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
      | null
      | undefined;
    endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
    question?:
      | {
          __typename?: 'QuestionRequest';
          policyId?: string | null | undefined;
          question: string;
          type: QuestionRequestType;
        }
      | null
      | undefined;
    resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
  }>;
  transcript: Array<{
    __typename?: 'CallTranscriptObject';
    role: CallTranscriptRole;
    content: string;
    toolCallId?: string | null | undefined;
    toolName?: string | null | undefined;
    toolArgumentsJson?: string | null | undefined;
  }>;
};

export type GetCallsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCallsQuery = {
  __typename?: 'Query';
  calls: Array<{
    __typename?: 'Call';
    id: string;
    disconnectionReason?: CallDisconnectionReason | null | undefined;
    endedAt?: Date | null | undefined;
    fromName?: string | null | undefined;
    fromNumber: string;
    startedAt: Date;
    status: CallStatus;
    account?:
      | {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
  }>;
};

export type GetCallQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCallQuery = {
  __typename?: 'Query';
  call: {
    __typename?: 'Call';
    id: string;
    disconnectionReason?: CallDisconnectionReason | null | undefined;
    endedAt?: Date | null | undefined;
    fromName?: string | null | undefined;
    fromNumber: string;
    startedAt: Date;
    status: CallStatus;
    recordingUrl?: string | null | undefined;
    sentiment?: CallSentiment | null | undefined;
    successful?: boolean | null | undefined;
    summary?: string | null | undefined;
    account?:
      | {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    serviceRequests: Array<{
      __typename?: 'ServiceRequest';
      id: string;
      type: ServiceRequestType;
      state: ServiceRequestState;
      clientEmail?: string | null | undefined;
      clientName?: string | null | undefined;
      clientPhone?: string | null | undefined;
      details: string;
      dueAt?: Date | null | undefined;
      createdAt: Date;
      updatedAt: Date;
      account?:
        | {
            __typename?: 'Account';
            type: AccountType;
            account:
              | { __typename?: 'BusinessAccount'; name: string }
              | { __typename?: 'IndividualAccount'; name: string };
          }
        | null
        | undefined;
      assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
      addAdditionalInsured?:
        | {
            __typename?: 'AddAdditionalInsuredRequest';
            name: string;
            relationship: string;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      businessPolicy?:
        | {
            __typename?: 'BusinessPolicy';
            id: string;
            type: InsuranceType;
            carrier: { __typename?: 'InsuranceCarrier'; name: string };
          }
        | null
        | undefined;
      cancelPolicy?:
        | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
        | null
        | undefined;
      createCertificate?:
        | {
            __typename?: 'CreateCertificateRequest';
            name: string;
            additionalInsured: boolean;
            additionalInsuredRelationship?: string | null | undefined;
            additionalInsuredRelationshipDescription?: string | null | undefined;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      documentRequest?:
        | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
        | null
        | undefined;
      endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
      question?:
        | {
            __typename?: 'QuestionRequest';
            policyId?: string | null | undefined;
            question: string;
            type: QuestionRequestType;
          }
        | null
        | undefined;
      resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
    }>;
    transcript: Array<{
      __typename?: 'CallTranscriptObject';
      role: CallTranscriptRole;
      content: string;
      toolCallId?: string | null | undefined;
      toolName?: string | null | undefined;
      toolArgumentsJson?: string | null | undefined;
    }>;
  };
};

export type DocumentDataFieldsFragment = {
  __typename?: 'DocumentData';
  acord25?:
    | { __typename?: 'Acord25Data'; holder: { __typename?: 'CertificateEntity'; name: string } }
    | null
    | undefined;
  acord125?:
    | {
        __typename?: 'Acord125Data';
        applicant1: { __typename?: 'Acord125Applicant'; name: string };
      }
    | null
    | undefined;
  acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
  acord130?:
    | {
        __typename?: 'Acord130Data';
        namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
      }
    | null
    | undefined;
  acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
  acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
};

export type TemplateDataFieldsFragment = {
  __typename?: 'FillTemplateToolInput';
  acord24?:
    | {
        __typename?: 'Acord24Data';
        certificateHolder: { __typename?: 'Acord24CertificateHolder'; fullName: string };
        namedInsured: { __typename?: 'Acord24NamedInsured'; fullName: string };
      }
    | null
    | undefined;
  acord25?:
    | {
        __typename?: 'Acord25Data';
        holder: { __typename?: 'CertificateEntity'; name: string };
        insured: { __typename?: 'CertificateEntity'; name: string };
      }
    | null
    | undefined;
  acord27?:
    | {
        __typename?: 'Acord27Data';
        additionalInterest: { __typename?: 'Acord27AdditionalInterest'; fullName: string };
        namedInsured: { __typename?: 'Acord27NamedInsured'; fullName: string };
      }
    | null
    | undefined;
  acord28?:
    | {
        __typename?: 'Acord28Data';
        additionalInterest: { __typename?: 'Acord28AdditionalInterest'; fullName: string };
        insured: { __typename?: 'Acord28Insured'; fullName: string };
      }
    | null
    | undefined;
  acord35?:
    | {
        __typename?: 'Acord35Data';
        namedInsured: { __typename?: 'Acord35NamedInsured'; fullName: string };
      }
    | null
    | undefined;
  acord36?:
    | {
        __typename?: 'Acord36Data';
        agencies: {
          __typename?: 'Acord36Agencies';
          newAgency: { __typename?: 'Acord36Agency'; fullName: string };
        };
      }
    | null
    | undefined;
  acord75?:
    | {
        __typename?: 'Acord75Data';
        namedInsured: { __typename?: 'Acord75NamedInsured'; fullName: string };
      }
    | null
    | undefined;
  acord125?:
    | {
        __typename?: 'Acord125Data';
        applicant1: { __typename?: 'Acord125Applicant'; name: string };
      }
    | null
    | undefined;
  acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
  acord130?:
    | {
        __typename?: 'Acord130Data';
        namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
      }
    | null
    | undefined;
  acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
  acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
};

export type FillTemplateToolFieldsFragment = {
  __typename?: 'FillTemplateTool';
  input: {
    __typename?: 'FillTemplateToolInput';
    templateId: DocumentType;
    acord24?:
      | {
          __typename?: 'Acord24Data';
          certificateHolder: { __typename?: 'Acord24CertificateHolder'; fullName: string };
          namedInsured: { __typename?: 'Acord24NamedInsured'; fullName: string };
        }
      | null
      | undefined;
    acord25?:
      | {
          __typename?: 'Acord25Data';
          holder: { __typename?: 'CertificateEntity'; name: string };
          insured: { __typename?: 'CertificateEntity'; name: string };
        }
      | null
      | undefined;
    acord27?:
      | {
          __typename?: 'Acord27Data';
          additionalInterest: { __typename?: 'Acord27AdditionalInterest'; fullName: string };
          namedInsured: { __typename?: 'Acord27NamedInsured'; fullName: string };
        }
      | null
      | undefined;
    acord28?:
      | {
          __typename?: 'Acord28Data';
          additionalInterest: { __typename?: 'Acord28AdditionalInterest'; fullName: string };
          insured: { __typename?: 'Acord28Insured'; fullName: string };
        }
      | null
      | undefined;
    acord35?:
      | {
          __typename?: 'Acord35Data';
          namedInsured: { __typename?: 'Acord35NamedInsured'; fullName: string };
        }
      | null
      | undefined;
    acord36?:
      | {
          __typename?: 'Acord36Data';
          agencies: {
            __typename?: 'Acord36Agencies';
            newAgency: { __typename?: 'Acord36Agency'; fullName: string };
          };
        }
      | null
      | undefined;
    acord75?:
      | {
          __typename?: 'Acord75Data';
          namedInsured: { __typename?: 'Acord75NamedInsured'; fullName: string };
        }
      | null
      | undefined;
    acord125?:
      | {
          __typename?: 'Acord125Data';
          applicant1: { __typename?: 'Acord125Applicant'; name: string };
        }
      | null
      | undefined;
    acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
    acord130?:
      | {
          __typename?: 'Acord130Data';
          namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
        }
      | null
      | undefined;
    acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
    acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
  };
  output: { __typename?: 'FillTemplateToolOutput'; artifactId: string };
};

export type CaraWorkspaceOverviewFieldsFragment = {
  __typename?: 'CaraWorkspace';
  createdAt: Date;
  id: string;
  preset?: CaraWorkspacePreset | null | undefined;
  state: CaraWorkspaceState;
  title: string;
  updatedAt: Date;
  agencyUser: { __typename?: 'AgencyUser'; email: string; id: string; name: string };
  customPreset?: { __typename?: 'CustomPreset'; id: string; title: string } | null | undefined;
  metadata: {
    __typename?: 'CaraWorkspaceMetadata';
    clientName?: string | null | undefined;
    keywords: Array<string>;
  };
};

export type CaraWorkspaceFieldsFragment = {
  __typename?: 'CaraWorkspace';
  schemaVersion: CaraWorkspaceSchemaVersion;
  createdAt: Date;
  id: string;
  preset?: CaraWorkspacePreset | null | undefined;
  state: CaraWorkspaceState;
  title: string;
  updatedAt: Date;
  artifacts: Array<{
    __typename?: 'CaraWorkspaceArtifact';
    createdAt: Date;
    id: string;
    type: CaraWorkspaceArtifactType;
    document?:
      | {
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          downloadUrl: string;
          data: {
            __typename?: 'DocumentData';
            acord25?:
              | {
                  __typename?: 'Acord25Data';
                  holder: { __typename?: 'CertificateEntity'; name: string };
                }
              | null
              | undefined;
            acord125?:
              | {
                  __typename?: 'Acord125Data';
                  applicant1: { __typename?: 'Acord125Applicant'; name: string };
                }
              | null
              | undefined;
            acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
            acord130?:
              | {
                  __typename?: 'Acord130Data';
                  namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                }
              | null
              | undefined;
            acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
            acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
          };
        }
      | null
      | undefined;
    email?:
      | {
          __typename?: 'EmailDraft';
          body: string;
          subject: string;
          from: { __typename?: 'EmailParticipant'; name: string; email: string };
          to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
        }
      | null
      | undefined;
    htmlDocument?:
      | { __typename?: 'HtmlDocument'; content: string; title: string }
      | null
      | undefined;
  }>;
  files: Array<{ __typename?: 'File'; id: string; name: string; url?: string | null | undefined }>;
  planStages: Array<{
    __typename?: 'CaraWorkspacePlanStage';
    createdAt: Date;
    endedAt?: Date | null | undefined;
    id: string;
    initiatedByMessageId: string;
    result: string;
    startedAt?: Date | null | undefined;
    state: CaraWorkspacePlanStageState;
    type: CaraWorkspacePlanStageType;
    events: Array<{
      __typename?: 'CaraWorkspacePlanStageEvent';
      content?: string | null | undefined;
      endedAt?: Date | null | undefined;
      error?: string | null | undefined;
      id: string;
      startedAt: Date;
      title?: string | null | undefined;
      type: CaraWorkspacePlanStageEventType;
      toolCall?:
        | {
            __typename?: 'CaraWorkspaceToolCall';
            argumentsJson: string;
            name: string;
            result: string;
            type?: CaraWorkspaceTool | null | undefined;
            thinkTool?:
              | {
                  __typename?: 'ThinkTool';
                  input: { __typename?: 'ThinkToolInput'; title: string; thought: string };
                  output: { __typename?: 'ThinkToolOutput'; success: boolean };
                }
              | null
              | undefined;
            completeTaskTool?:
              | {
                  __typename?: 'CompleteTaskTool';
                  input: {
                    __typename?: 'CompleteTaskToolInput';
                    clientName: string;
                    keywords: Array<string>;
                    needsAgentInput: boolean;
                  };
                  output: { __typename?: 'CompleteTaskToolOutput'; success: boolean };
                }
              | null
              | undefined;
            draftEmailTool?:
              | {
                  __typename?: 'DraftEmailTool';
                  input: {
                    __typename?: 'DraftEmailToolInput';
                    artifactId: string;
                    body: string;
                    subject: string;
                    toEmail: string;
                    toName: string;
                  };
                }
              | null
              | undefined;
            draftDocumentTool?:
              | {
                  __typename?: 'DraftDocumentTool';
                  input: {
                    __typename?: 'DraftDocumentToolInput';
                    artifactId: string;
                    title: string;
                    htmlContent: string;
                  };
                }
              | null
              | undefined;
            fillTemplateTool?:
              | {
                  __typename?: 'FillTemplateTool';
                  input: {
                    __typename?: 'FillTemplateToolInput';
                    templateId: DocumentType;
                    acord24?:
                      | {
                          __typename?: 'Acord24Data';
                          certificateHolder: {
                            __typename?: 'Acord24CertificateHolder';
                            fullName: string;
                          };
                          namedInsured: { __typename?: 'Acord24NamedInsured'; fullName: string };
                        }
                      | null
                      | undefined;
                    acord25?:
                      | {
                          __typename?: 'Acord25Data';
                          holder: { __typename?: 'CertificateEntity'; name: string };
                          insured: { __typename?: 'CertificateEntity'; name: string };
                        }
                      | null
                      | undefined;
                    acord27?:
                      | {
                          __typename?: 'Acord27Data';
                          additionalInterest: {
                            __typename?: 'Acord27AdditionalInterest';
                            fullName: string;
                          };
                          namedInsured: { __typename?: 'Acord27NamedInsured'; fullName: string };
                        }
                      | null
                      | undefined;
                    acord28?:
                      | {
                          __typename?: 'Acord28Data';
                          additionalInterest: {
                            __typename?: 'Acord28AdditionalInterest';
                            fullName: string;
                          };
                          insured: { __typename?: 'Acord28Insured'; fullName: string };
                        }
                      | null
                      | undefined;
                    acord35?:
                      | {
                          __typename?: 'Acord35Data';
                          namedInsured: { __typename?: 'Acord35NamedInsured'; fullName: string };
                        }
                      | null
                      | undefined;
                    acord36?:
                      | {
                          __typename?: 'Acord36Data';
                          agencies: {
                            __typename?: 'Acord36Agencies';
                            newAgency: { __typename?: 'Acord36Agency'; fullName: string };
                          };
                        }
                      | null
                      | undefined;
                    acord75?:
                      | {
                          __typename?: 'Acord75Data';
                          namedInsured: { __typename?: 'Acord75NamedInsured'; fullName: string };
                        }
                      | null
                      | undefined;
                    acord125?:
                      | {
                          __typename?: 'Acord125Data';
                          applicant1: { __typename?: 'Acord125Applicant'; name: string };
                        }
                      | null
                      | undefined;
                    acord126?:
                      | { __typename?: 'Acord126Data'; namedInsured: string }
                      | null
                      | undefined;
                    acord130?:
                      | {
                          __typename?: 'Acord130Data';
                          namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                        }
                      | null
                      | undefined;
                    acord131?:
                      | { __typename?: 'Acord131Data'; namedInsured: string }
                      | null
                      | undefined;
                    acord140?:
                      | { __typename?: 'Acord140Data'; namedInsured: string }
                      | null
                      | undefined;
                  };
                  output: { __typename?: 'FillTemplateToolOutput'; artifactId: string };
                }
              | null
              | undefined;
            searchFileTool?:
              | {
                  __typename?: 'SearchFileTool';
                  input: {
                    __typename?: 'SearchFileToolInput';
                    queries: Array<{
                      __typename?: 'SearchFileToolQuery';
                      fileId: string;
                      query: string;
                      keywords: string;
                    }>;
                  };
                  output: {
                    __typename?: 'SearchFileToolOutput';
                    results: Array<{
                      __typename?: 'SearchFileToolResult';
                      fileId: string;
                      query: string;
                      answer: string;
                      citations: Array<{
                        __typename?: 'SearchFileToolResultCitation';
                        link: string;
                      }>;
                    }>;
                  };
                }
              | null
              | undefined;
            searchKnowledgeBaseTool?:
              | {
                  __typename?: 'SearchKnowledgeBaseTool';
                  input: {
                    __typename?: 'SearchKnowledgeBaseToolInput';
                    queries: Array<{ __typename?: 'SearchKnowledgeBaseToolQuery'; query: string }>;
                  };
                  output: {
                    __typename?: 'SearchKnowledgeBaseToolOutput';
                    documents: Array<{
                      __typename?: 'SearchKnowledgeBaseToolResultDocument';
                      metadata: { __typename?: 'KnowledgeBaseDocumentMetadata'; title: string };
                      relevantPages: Array<{
                        __typename?: 'SearchKnowledgeBaseToolResultPage';
                        pageIndex: number;
                        citation: {
                          __typename?: 'SearchKnowledgeBaseToolResultCitation';
                          link: string;
                        };
                      }>;
                    }>;
                  };
                }
              | null
              | undefined;
            searchKnowledgeGraphTool?:
              | {
                  __typename?: 'SearchKnowledgeGraphTool';
                  input: {
                    __typename?: 'SearchKnowledgeGraphToolInput';
                    queries: Array<{ __typename?: 'SearchKnowledgeGraphToolQuery'; query: string }>;
                  };
                  output: {
                    __typename?: 'SearchKnowledgeGraphToolOutput';
                    entities: Array<{
                      __typename?: 'KnowledgeGraphEntity';
                      type: KnowledgeGraphEntityType;
                      displayName: string;
                    }>;
                  };
                }
              | null
              | undefined;
            searchWebTool?:
              | {
                  __typename?: 'SearchWebTool';
                  input: {
                    __typename?: 'SearchWebToolInput';
                    queries: Array<{
                      __typename?: 'SearchWebToolQuery';
                      query: string;
                      keywords: string;
                    }>;
                  };
                  output: {
                    __typename?: 'SearchWebToolOutput';
                    results: Array<{
                      __typename?: 'SearchWebToolResult';
                      query: string;
                      answer: string;
                      citations: Array<{
                        __typename?: 'SearchWebToolResultCitation';
                        url: string;
                        title: string;
                      }>;
                    }>;
                  };
                }
              | null
              | undefined;
            writeIntegrationTool?:
              | {
                  __typename?: 'WriteIntegrationTool';
                  input: {
                    __typename?: 'WriteIntegrationToolInput';
                    action: string;
                    agentName: string;
                    account: {
                      __typename?: 'WriteIntegrationToolAccount';
                      firstName: string;
                      lastName: string;
                      businessName: string;
                      email: string;
                      phone: string;
                      address: {
                        __typename?: 'Address';
                        line1: string;
                        line2?: string | null | undefined;
                        city: string;
                        zone: string;
                        postalCode: string;
                      };
                    };
                    uploadDocument?:
                      | {
                          __typename?: 'WriteIntegrationToolUploadDocumentInput';
                          source: string;
                          description: string;
                          note: string;
                          id: string;
                        }
                      | null
                      | undefined;
                    createNote?:
                      | {
                          __typename?: 'WriteIntegrationToolCreateNoteInput';
                          title: string;
                          body: string;
                        }
                      | null
                      | undefined;
                    createTask?:
                      | {
                          __typename?: 'WriteIntegrationToolCreateTaskInput';
                          title: string;
                          description: string;
                          dueDate?: string | null | undefined;
                          assigneeEmail?: string | null | undefined;
                        }
                      | null
                      | undefined;
                  };
                  output: {
                    __typename?: 'WriteIntegrationToolOutput';
                    success: boolean;
                    message: string;
                  };
                }
              | null
              | undefined;
          }
        | null
        | undefined;
    }>;
    processAttachmentsDetails?:
      | {
          __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
          progress: Array<{
            __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
            progress: number;
            file: { __typename?: 'File'; name: string };
          }>;
        }
      | null
      | undefined;
  }>;
  messages: Array<{
    __typename?: 'CaraWorkspaceMessage';
    content: string;
    id: string;
    role: CaraWorkspaceMessageRole;
    timestamp: Date;
    files: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      url?: string | null | undefined;
    }>;
  }>;
  serviceRequest?:
    | {
        __typename?: 'ServiceRequest';
        id: string;
        type: ServiceRequestType;
        state: ServiceRequestState;
        clientEmail?: string | null | undefined;
        clientName?: string | null | undefined;
        clientPhone?: string | null | undefined;
        details: string;
        dueAt?: Date | null | undefined;
        createdAt: Date;
        updatedAt: Date;
        account?:
          | {
              __typename?: 'Account';
              type: AccountType;
              account:
                | { __typename?: 'BusinessAccount'; name: string }
                | { __typename?: 'IndividualAccount'; name: string };
            }
          | null
          | undefined;
        assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
        addAdditionalInsured?:
          | {
              __typename?: 'AddAdditionalInsuredRequest';
              name: string;
              relationship: string;
              address: {
                __typename?: 'Address';
                line1: string;
                city: string;
                zone: string;
                postalCode: string;
              };
            }
          | null
          | undefined;
        businessPolicy?:
          | {
              __typename?: 'BusinessPolicy';
              id: string;
              type: InsuranceType;
              carrier: { __typename?: 'InsuranceCarrier'; name: string };
            }
          | null
          | undefined;
        cancelPolicy?:
          | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
          | null
          | undefined;
        createCertificate?:
          | {
              __typename?: 'CreateCertificateRequest';
              name: string;
              additionalInsured: boolean;
              additionalInsuredRelationship?: string | null | undefined;
              additionalInsuredRelationshipDescription?: string | null | undefined;
              address: {
                __typename?: 'Address';
                line1: string;
                city: string;
                zone: string;
                postalCode: string;
              };
            }
          | null
          | undefined;
        documentRequest?:
          | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
          | null
          | undefined;
        endorsePolicy?:
          | { __typename?: 'EndorsePolicyRequest'; policyId: string }
          | null
          | undefined;
        question?:
          | {
              __typename?: 'QuestionRequest';
              policyId?: string | null | undefined;
              question: string;
              type: QuestionRequestType;
            }
          | null
          | undefined;
        resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
      }
    | null
    | undefined;
  agencyUser: { __typename?: 'AgencyUser'; email: string; id: string; name: string };
  customPreset?: { __typename?: 'CustomPreset'; id: string; title: string } | null | undefined;
  metadata: {
    __typename?: 'CaraWorkspaceMetadata';
    clientName?: string | null | undefined;
    keywords: Array<string>;
  };
};

export type CustomPresetFieldsFragment = {
  __typename?: 'CustomPreset';
  allowFileUpload: boolean;
  basePrompt: string;
  createdAt: Date;
  description: string;
  id: string;
  inheritFromPreset?: CaraWorkspacePreset | null | undefined;
  title: string;
  updatedAt: Date;
  createdBy: { __typename?: 'AgencyUser'; id: string; name: string };
  files: Array<{
    __typename?: 'File';
    id: string;
    name: string;
    mimeType: string;
    url?: string | null | undefined;
  }>;
};

export type HtmlDocumentTemplateFieldsFragment = {
  __typename?: 'HtmlDocumentTemplate';
  baseStyleId?: string | null | undefined;
  description: string;
  id: string;
  title: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: { __typename?: 'AgencyUser'; name: string };
  prefixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
  suffixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
};

export type GetCaraWorkspaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCaraWorkspaceQuery = {
  __typename?: 'Query';
  caraWorkspace: {
    __typename?: 'CaraWorkspace';
    schemaVersion: CaraWorkspaceSchemaVersion;
    createdAt: Date;
    id: string;
    preset?: CaraWorkspacePreset | null | undefined;
    state: CaraWorkspaceState;
    title: string;
    updatedAt: Date;
    artifacts: Array<{
      __typename?: 'CaraWorkspaceArtifact';
      createdAt: Date;
      id: string;
      type: CaraWorkspaceArtifactType;
      document?:
        | {
            __typename?: 'Document';
            id: string;
            type: DocumentType;
            downloadUrl: string;
            data: {
              __typename?: 'DocumentData';
              acord25?:
                | {
                    __typename?: 'Acord25Data';
                    holder: { __typename?: 'CertificateEntity'; name: string };
                  }
                | null
                | undefined;
              acord125?:
                | {
                    __typename?: 'Acord125Data';
                    applicant1: { __typename?: 'Acord125Applicant'; name: string };
                  }
                | null
                | undefined;
              acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
              acord130?:
                | {
                    __typename?: 'Acord130Data';
                    namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                  }
                | null
                | undefined;
              acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
              acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
            };
          }
        | null
        | undefined;
      email?:
        | {
            __typename?: 'EmailDraft';
            body: string;
            subject: string;
            from: { __typename?: 'EmailParticipant'; name: string; email: string };
            to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
          }
        | null
        | undefined;
      htmlDocument?:
        | { __typename?: 'HtmlDocument'; content: string; title: string }
        | null
        | undefined;
    }>;
    files: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      url?: string | null | undefined;
    }>;
    planStages: Array<{
      __typename?: 'CaraWorkspacePlanStage';
      createdAt: Date;
      endedAt?: Date | null | undefined;
      id: string;
      initiatedByMessageId: string;
      result: string;
      startedAt?: Date | null | undefined;
      state: CaraWorkspacePlanStageState;
      type: CaraWorkspacePlanStageType;
      events: Array<{
        __typename?: 'CaraWorkspacePlanStageEvent';
        content?: string | null | undefined;
        endedAt?: Date | null | undefined;
        error?: string | null | undefined;
        id: string;
        startedAt: Date;
        title?: string | null | undefined;
        type: CaraWorkspacePlanStageEventType;
        toolCall?:
          | {
              __typename?: 'CaraWorkspaceToolCall';
              argumentsJson: string;
              name: string;
              result: string;
              type?: CaraWorkspaceTool | null | undefined;
              thinkTool?:
                | {
                    __typename?: 'ThinkTool';
                    input: { __typename?: 'ThinkToolInput'; title: string; thought: string };
                    output: { __typename?: 'ThinkToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              completeTaskTool?:
                | {
                    __typename?: 'CompleteTaskTool';
                    input: {
                      __typename?: 'CompleteTaskToolInput';
                      clientName: string;
                      keywords: Array<string>;
                      needsAgentInput: boolean;
                    };
                    output: { __typename?: 'CompleteTaskToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              draftEmailTool?:
                | {
                    __typename?: 'DraftEmailTool';
                    input: {
                      __typename?: 'DraftEmailToolInput';
                      artifactId: string;
                      body: string;
                      subject: string;
                      toEmail: string;
                      toName: string;
                    };
                  }
                | null
                | undefined;
              draftDocumentTool?:
                | {
                    __typename?: 'DraftDocumentTool';
                    input: {
                      __typename?: 'DraftDocumentToolInput';
                      artifactId: string;
                      title: string;
                      htmlContent: string;
                    };
                  }
                | null
                | undefined;
              fillTemplateTool?:
                | {
                    __typename?: 'FillTemplateTool';
                    input: {
                      __typename?: 'FillTemplateToolInput';
                      templateId: DocumentType;
                      acord24?:
                        | {
                            __typename?: 'Acord24Data';
                            certificateHolder: {
                              __typename?: 'Acord24CertificateHolder';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord24NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord25?:
                        | {
                            __typename?: 'Acord25Data';
                            holder: { __typename?: 'CertificateEntity'; name: string };
                            insured: { __typename?: 'CertificateEntity'; name: string };
                          }
                        | null
                        | undefined;
                      acord27?:
                        | {
                            __typename?: 'Acord27Data';
                            additionalInterest: {
                              __typename?: 'Acord27AdditionalInterest';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord27NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord28?:
                        | {
                            __typename?: 'Acord28Data';
                            additionalInterest: {
                              __typename?: 'Acord28AdditionalInterest';
                              fullName: string;
                            };
                            insured: { __typename?: 'Acord28Insured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord35?:
                        | {
                            __typename?: 'Acord35Data';
                            namedInsured: { __typename?: 'Acord35NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord36?:
                        | {
                            __typename?: 'Acord36Data';
                            agencies: {
                              __typename?: 'Acord36Agencies';
                              newAgency: { __typename?: 'Acord36Agency'; fullName: string };
                            };
                          }
                        | null
                        | undefined;
                      acord75?:
                        | {
                            __typename?: 'Acord75Data';
                            namedInsured: { __typename?: 'Acord75NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord125?:
                        | {
                            __typename?: 'Acord125Data';
                            applicant1: { __typename?: 'Acord125Applicant'; name: string };
                          }
                        | null
                        | undefined;
                      acord126?:
                        | { __typename?: 'Acord126Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord130?:
                        | {
                            __typename?: 'Acord130Data';
                            namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord131?:
                        | { __typename?: 'Acord131Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord140?:
                        | { __typename?: 'Acord140Data'; namedInsured: string }
                        | null
                        | undefined;
                    };
                    output: { __typename?: 'FillTemplateToolOutput'; artifactId: string };
                  }
                | null
                | undefined;
              searchFileTool?:
                | {
                    __typename?: 'SearchFileTool';
                    input: {
                      __typename?: 'SearchFileToolInput';
                      queries: Array<{
                        __typename?: 'SearchFileToolQuery';
                        fileId: string;
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchFileToolOutput';
                      results: Array<{
                        __typename?: 'SearchFileToolResult';
                        fileId: string;
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchFileToolResultCitation';
                          link: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeBaseTool?:
                | {
                    __typename?: 'SearchKnowledgeBaseTool';
                    input: {
                      __typename?: 'SearchKnowledgeBaseToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeBaseToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeBaseToolOutput';
                      documents: Array<{
                        __typename?: 'SearchKnowledgeBaseToolResultDocument';
                        metadata: { __typename?: 'KnowledgeBaseDocumentMetadata'; title: string };
                        relevantPages: Array<{
                          __typename?: 'SearchKnowledgeBaseToolResultPage';
                          pageIndex: number;
                          citation: {
                            __typename?: 'SearchKnowledgeBaseToolResultCitation';
                            link: string;
                          };
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeGraphTool?:
                | {
                    __typename?: 'SearchKnowledgeGraphTool';
                    input: {
                      __typename?: 'SearchKnowledgeGraphToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeGraphToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeGraphToolOutput';
                      entities: Array<{
                        __typename?: 'KnowledgeGraphEntity';
                        type: KnowledgeGraphEntityType;
                        displayName: string;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchWebTool?:
                | {
                    __typename?: 'SearchWebTool';
                    input: {
                      __typename?: 'SearchWebToolInput';
                      queries: Array<{
                        __typename?: 'SearchWebToolQuery';
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchWebToolOutput';
                      results: Array<{
                        __typename?: 'SearchWebToolResult';
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchWebToolResultCitation';
                          url: string;
                          title: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              writeIntegrationTool?:
                | {
                    __typename?: 'WriteIntegrationTool';
                    input: {
                      __typename?: 'WriteIntegrationToolInput';
                      action: string;
                      agentName: string;
                      account: {
                        __typename?: 'WriteIntegrationToolAccount';
                        firstName: string;
                        lastName: string;
                        businessName: string;
                        email: string;
                        phone: string;
                        address: {
                          __typename?: 'Address';
                          line1: string;
                          line2?: string | null | undefined;
                          city: string;
                          zone: string;
                          postalCode: string;
                        };
                      };
                      uploadDocument?:
                        | {
                            __typename?: 'WriteIntegrationToolUploadDocumentInput';
                            source: string;
                            description: string;
                            note: string;
                            id: string;
                          }
                        | null
                        | undefined;
                      createNote?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateNoteInput';
                            title: string;
                            body: string;
                          }
                        | null
                        | undefined;
                      createTask?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateTaskInput';
                            title: string;
                            description: string;
                            dueDate?: string | null | undefined;
                            assigneeEmail?: string | null | undefined;
                          }
                        | null
                        | undefined;
                    };
                    output: {
                      __typename?: 'WriteIntegrationToolOutput';
                      success: boolean;
                      message: string;
                    };
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }>;
      processAttachmentsDetails?:
        | {
            __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
            progress: Array<{
              __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
              progress: number;
              file: { __typename?: 'File'; name: string };
            }>;
          }
        | null
        | undefined;
    }>;
    messages: Array<{
      __typename?: 'CaraWorkspaceMessage';
      content: string;
      id: string;
      role: CaraWorkspaceMessageRole;
      timestamp: Date;
      files: Array<{
        __typename?: 'File';
        id: string;
        name: string;
        url?: string | null | undefined;
      }>;
    }>;
    serviceRequest?:
      | {
          __typename?: 'ServiceRequest';
          id: string;
          type: ServiceRequestType;
          state: ServiceRequestState;
          clientEmail?: string | null | undefined;
          clientName?: string | null | undefined;
          clientPhone?: string | null | undefined;
          details: string;
          dueAt?: Date | null | undefined;
          createdAt: Date;
          updatedAt: Date;
          account?:
            | {
                __typename?: 'Account';
                type: AccountType;
                account:
                  | { __typename?: 'BusinessAccount'; name: string }
                  | { __typename?: 'IndividualAccount'; name: string };
              }
            | null
            | undefined;
          assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
          addAdditionalInsured?:
            | {
                __typename?: 'AddAdditionalInsuredRequest';
                name: string;
                relationship: string;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          businessPolicy?:
            | {
                __typename?: 'BusinessPolicy';
                id: string;
                type: InsuranceType;
                carrier: { __typename?: 'InsuranceCarrier'; name: string };
              }
            | null
            | undefined;
          cancelPolicy?:
            | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
            | null
            | undefined;
          createCertificate?:
            | {
                __typename?: 'CreateCertificateRequest';
                name: string;
                additionalInsured: boolean;
                additionalInsuredRelationship?: string | null | undefined;
                additionalInsuredRelationshipDescription?: string | null | undefined;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          documentRequest?:
            | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
            | null
            | undefined;
          endorsePolicy?:
            | { __typename?: 'EndorsePolicyRequest'; policyId: string }
            | null
            | undefined;
          question?:
            | {
                __typename?: 'QuestionRequest';
                policyId?: string | null | undefined;
                question: string;
                type: QuestionRequestType;
              }
            | null
            | undefined;
          resolution?:
            | { __typename?: 'ServiceRequestResolution'; notes: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    agencyUser: { __typename?: 'AgencyUser'; email: string; id: string; name: string };
    customPreset?: { __typename?: 'CustomPreset'; id: string; title: string } | null | undefined;
    metadata: {
      __typename?: 'CaraWorkspaceMetadata';
      clientName?: string | null | undefined;
      keywords: Array<string>;
    };
  };
};

export type GetCaraWorkspacesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCaraWorkspacesQuery = {
  __typename?: 'Query';
  caraWorkspaces: Array<{
    __typename?: 'CaraWorkspace';
    createdAt: Date;
    id: string;
    preset?: CaraWorkspacePreset | null | undefined;
    state: CaraWorkspaceState;
    title: string;
    updatedAt: Date;
    agencyUser: { __typename?: 'AgencyUser'; email: string; id: string; name: string };
    customPreset?: { __typename?: 'CustomPreset'; id: string; title: string } | null | undefined;
    metadata: {
      __typename?: 'CaraWorkspaceMetadata';
      clientName?: string | null | undefined;
      keywords: Array<string>;
    };
  }>;
};

export type GetCustomPresetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomPresetsQuery = {
  __typename?: 'Query';
  customPresets: Array<{
    __typename?: 'CustomPreset';
    allowFileUpload: boolean;
    basePrompt: string;
    createdAt: Date;
    description: string;
    id: string;
    inheritFromPreset?: CaraWorkspacePreset | null | undefined;
    title: string;
    updatedAt: Date;
    createdBy: { __typename?: 'AgencyUser'; id: string; name: string };
    files: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      mimeType: string;
      url?: string | null | undefined;
    }>;
  }>;
};

export type GetCustomPresetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCustomPresetQuery = {
  __typename?: 'Query';
  customPreset: {
    __typename?: 'CustomPreset';
    allowFileUpload: boolean;
    basePrompt: string;
    createdAt: Date;
    description: string;
    id: string;
    inheritFromPreset?: CaraWorkspacePreset | null | undefined;
    title: string;
    updatedAt: Date;
    createdBy: { __typename?: 'AgencyUser'; id: string; name: string };
    files: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      mimeType: string;
      url?: string | null | undefined;
    }>;
  };
};

export type GetHtmlDocumentTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetHtmlDocumentTemplatesQuery = {
  __typename?: 'Query';
  htmlDocumentTemplates: Array<{
    __typename?: 'HtmlDocumentTemplate';
    baseStyleId?: string | null | undefined;
    description: string;
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: { __typename?: 'AgencyUser'; name: string };
    prefixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
    suffixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
  }>;
};

export type GetHtmlDocumentTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetHtmlDocumentTemplateQuery = {
  __typename?: 'Query';
  htmlDocumentTemplate: {
    __typename?: 'HtmlDocumentTemplate';
    baseStyleId?: string | null | undefined;
    description: string;
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: { __typename?: 'AgencyUser'; name: string };
    prefixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
    suffixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
  };
};

export type CreateCaraWorkspaceMutationVariables = Exact<{
  input: CaraWorkspaceMessageInput;
}>;

export type CreateCaraWorkspaceMutation = {
  __typename?: 'Mutation';
  createCaraWorkspace: { __typename?: 'CaraWorkspace'; id: string };
};

export type AddCaraWorkspaceMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CaraWorkspaceMessageInput;
}>;

export type AddCaraWorkspaceMessageMutation = {
  __typename?: 'Mutation';
  addCaraWorkspaceMessage: {
    __typename?: 'CaraWorkspace';
    schemaVersion: CaraWorkspaceSchemaVersion;
    createdAt: Date;
    id: string;
    preset?: CaraWorkspacePreset | null | undefined;
    state: CaraWorkspaceState;
    title: string;
    updatedAt: Date;
    artifacts: Array<{
      __typename?: 'CaraWorkspaceArtifact';
      createdAt: Date;
      id: string;
      type: CaraWorkspaceArtifactType;
      document?:
        | {
            __typename?: 'Document';
            id: string;
            type: DocumentType;
            downloadUrl: string;
            data: {
              __typename?: 'DocumentData';
              acord25?:
                | {
                    __typename?: 'Acord25Data';
                    holder: { __typename?: 'CertificateEntity'; name: string };
                  }
                | null
                | undefined;
              acord125?:
                | {
                    __typename?: 'Acord125Data';
                    applicant1: { __typename?: 'Acord125Applicant'; name: string };
                  }
                | null
                | undefined;
              acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
              acord130?:
                | {
                    __typename?: 'Acord130Data';
                    namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                  }
                | null
                | undefined;
              acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
              acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
            };
          }
        | null
        | undefined;
      email?:
        | {
            __typename?: 'EmailDraft';
            body: string;
            subject: string;
            from: { __typename?: 'EmailParticipant'; name: string; email: string };
            to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
          }
        | null
        | undefined;
      htmlDocument?:
        | { __typename?: 'HtmlDocument'; content: string; title: string }
        | null
        | undefined;
    }>;
    files: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      url?: string | null | undefined;
    }>;
    planStages: Array<{
      __typename?: 'CaraWorkspacePlanStage';
      createdAt: Date;
      endedAt?: Date | null | undefined;
      id: string;
      initiatedByMessageId: string;
      result: string;
      startedAt?: Date | null | undefined;
      state: CaraWorkspacePlanStageState;
      type: CaraWorkspacePlanStageType;
      events: Array<{
        __typename?: 'CaraWorkspacePlanStageEvent';
        content?: string | null | undefined;
        endedAt?: Date | null | undefined;
        error?: string | null | undefined;
        id: string;
        startedAt: Date;
        title?: string | null | undefined;
        type: CaraWorkspacePlanStageEventType;
        toolCall?:
          | {
              __typename?: 'CaraWorkspaceToolCall';
              argumentsJson: string;
              name: string;
              result: string;
              type?: CaraWorkspaceTool | null | undefined;
              thinkTool?:
                | {
                    __typename?: 'ThinkTool';
                    input: { __typename?: 'ThinkToolInput'; title: string; thought: string };
                    output: { __typename?: 'ThinkToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              completeTaskTool?:
                | {
                    __typename?: 'CompleteTaskTool';
                    input: {
                      __typename?: 'CompleteTaskToolInput';
                      clientName: string;
                      keywords: Array<string>;
                      needsAgentInput: boolean;
                    };
                    output: { __typename?: 'CompleteTaskToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              draftEmailTool?:
                | {
                    __typename?: 'DraftEmailTool';
                    input: {
                      __typename?: 'DraftEmailToolInput';
                      artifactId: string;
                      body: string;
                      subject: string;
                      toEmail: string;
                      toName: string;
                    };
                  }
                | null
                | undefined;
              draftDocumentTool?:
                | {
                    __typename?: 'DraftDocumentTool';
                    input: {
                      __typename?: 'DraftDocumentToolInput';
                      artifactId: string;
                      title: string;
                      htmlContent: string;
                    };
                  }
                | null
                | undefined;
              fillTemplateTool?:
                | {
                    __typename?: 'FillTemplateTool';
                    input: {
                      __typename?: 'FillTemplateToolInput';
                      templateId: DocumentType;
                      acord24?:
                        | {
                            __typename?: 'Acord24Data';
                            certificateHolder: {
                              __typename?: 'Acord24CertificateHolder';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord24NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord25?:
                        | {
                            __typename?: 'Acord25Data';
                            holder: { __typename?: 'CertificateEntity'; name: string };
                            insured: { __typename?: 'CertificateEntity'; name: string };
                          }
                        | null
                        | undefined;
                      acord27?:
                        | {
                            __typename?: 'Acord27Data';
                            additionalInterest: {
                              __typename?: 'Acord27AdditionalInterest';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord27NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord28?:
                        | {
                            __typename?: 'Acord28Data';
                            additionalInterest: {
                              __typename?: 'Acord28AdditionalInterest';
                              fullName: string;
                            };
                            insured: { __typename?: 'Acord28Insured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord35?:
                        | {
                            __typename?: 'Acord35Data';
                            namedInsured: { __typename?: 'Acord35NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord36?:
                        | {
                            __typename?: 'Acord36Data';
                            agencies: {
                              __typename?: 'Acord36Agencies';
                              newAgency: { __typename?: 'Acord36Agency'; fullName: string };
                            };
                          }
                        | null
                        | undefined;
                      acord75?:
                        | {
                            __typename?: 'Acord75Data';
                            namedInsured: { __typename?: 'Acord75NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord125?:
                        | {
                            __typename?: 'Acord125Data';
                            applicant1: { __typename?: 'Acord125Applicant'; name: string };
                          }
                        | null
                        | undefined;
                      acord126?:
                        | { __typename?: 'Acord126Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord130?:
                        | {
                            __typename?: 'Acord130Data';
                            namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord131?:
                        | { __typename?: 'Acord131Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord140?:
                        | { __typename?: 'Acord140Data'; namedInsured: string }
                        | null
                        | undefined;
                    };
                    output: { __typename?: 'FillTemplateToolOutput'; artifactId: string };
                  }
                | null
                | undefined;
              searchFileTool?:
                | {
                    __typename?: 'SearchFileTool';
                    input: {
                      __typename?: 'SearchFileToolInput';
                      queries: Array<{
                        __typename?: 'SearchFileToolQuery';
                        fileId: string;
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchFileToolOutput';
                      results: Array<{
                        __typename?: 'SearchFileToolResult';
                        fileId: string;
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchFileToolResultCitation';
                          link: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeBaseTool?:
                | {
                    __typename?: 'SearchKnowledgeBaseTool';
                    input: {
                      __typename?: 'SearchKnowledgeBaseToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeBaseToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeBaseToolOutput';
                      documents: Array<{
                        __typename?: 'SearchKnowledgeBaseToolResultDocument';
                        metadata: { __typename?: 'KnowledgeBaseDocumentMetadata'; title: string };
                        relevantPages: Array<{
                          __typename?: 'SearchKnowledgeBaseToolResultPage';
                          pageIndex: number;
                          citation: {
                            __typename?: 'SearchKnowledgeBaseToolResultCitation';
                            link: string;
                          };
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeGraphTool?:
                | {
                    __typename?: 'SearchKnowledgeGraphTool';
                    input: {
                      __typename?: 'SearchKnowledgeGraphToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeGraphToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeGraphToolOutput';
                      entities: Array<{
                        __typename?: 'KnowledgeGraphEntity';
                        type: KnowledgeGraphEntityType;
                        displayName: string;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchWebTool?:
                | {
                    __typename?: 'SearchWebTool';
                    input: {
                      __typename?: 'SearchWebToolInput';
                      queries: Array<{
                        __typename?: 'SearchWebToolQuery';
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchWebToolOutput';
                      results: Array<{
                        __typename?: 'SearchWebToolResult';
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchWebToolResultCitation';
                          url: string;
                          title: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              writeIntegrationTool?:
                | {
                    __typename?: 'WriteIntegrationTool';
                    input: {
                      __typename?: 'WriteIntegrationToolInput';
                      action: string;
                      agentName: string;
                      account: {
                        __typename?: 'WriteIntegrationToolAccount';
                        firstName: string;
                        lastName: string;
                        businessName: string;
                        email: string;
                        phone: string;
                        address: {
                          __typename?: 'Address';
                          line1: string;
                          line2?: string | null | undefined;
                          city: string;
                          zone: string;
                          postalCode: string;
                        };
                      };
                      uploadDocument?:
                        | {
                            __typename?: 'WriteIntegrationToolUploadDocumentInput';
                            source: string;
                            description: string;
                            note: string;
                            id: string;
                          }
                        | null
                        | undefined;
                      createNote?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateNoteInput';
                            title: string;
                            body: string;
                          }
                        | null
                        | undefined;
                      createTask?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateTaskInput';
                            title: string;
                            description: string;
                            dueDate?: string | null | undefined;
                            assigneeEmail?: string | null | undefined;
                          }
                        | null
                        | undefined;
                    };
                    output: {
                      __typename?: 'WriteIntegrationToolOutput';
                      success: boolean;
                      message: string;
                    };
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }>;
      processAttachmentsDetails?:
        | {
            __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
            progress: Array<{
              __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
              progress: number;
              file: { __typename?: 'File'; name: string };
            }>;
          }
        | null
        | undefined;
    }>;
    messages: Array<{
      __typename?: 'CaraWorkspaceMessage';
      content: string;
      id: string;
      role: CaraWorkspaceMessageRole;
      timestamp: Date;
      files: Array<{
        __typename?: 'File';
        id: string;
        name: string;
        url?: string | null | undefined;
      }>;
    }>;
    serviceRequest?:
      | {
          __typename?: 'ServiceRequest';
          id: string;
          type: ServiceRequestType;
          state: ServiceRequestState;
          clientEmail?: string | null | undefined;
          clientName?: string | null | undefined;
          clientPhone?: string | null | undefined;
          details: string;
          dueAt?: Date | null | undefined;
          createdAt: Date;
          updatedAt: Date;
          account?:
            | {
                __typename?: 'Account';
                type: AccountType;
                account:
                  | { __typename?: 'BusinessAccount'; name: string }
                  | { __typename?: 'IndividualAccount'; name: string };
              }
            | null
            | undefined;
          assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
          addAdditionalInsured?:
            | {
                __typename?: 'AddAdditionalInsuredRequest';
                name: string;
                relationship: string;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          businessPolicy?:
            | {
                __typename?: 'BusinessPolicy';
                id: string;
                type: InsuranceType;
                carrier: { __typename?: 'InsuranceCarrier'; name: string };
              }
            | null
            | undefined;
          cancelPolicy?:
            | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
            | null
            | undefined;
          createCertificate?:
            | {
                __typename?: 'CreateCertificateRequest';
                name: string;
                additionalInsured: boolean;
                additionalInsuredRelationship?: string | null | undefined;
                additionalInsuredRelationshipDescription?: string | null | undefined;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          documentRequest?:
            | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
            | null
            | undefined;
          endorsePolicy?:
            | { __typename?: 'EndorsePolicyRequest'; policyId: string }
            | null
            | undefined;
          question?:
            | {
                __typename?: 'QuestionRequest';
                policyId?: string | null | undefined;
                question: string;
                type: QuestionRequestType;
              }
            | null
            | undefined;
          resolution?:
            | { __typename?: 'ServiceRequestResolution'; notes: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    agencyUser: { __typename?: 'AgencyUser'; email: string; id: string; name: string };
    customPreset?: { __typename?: 'CustomPreset'; id: string; title: string } | null | undefined;
    metadata: {
      __typename?: 'CaraWorkspaceMetadata';
      clientName?: string | null | undefined;
      keywords: Array<string>;
    };
  };
};

export type UpdateCaraWorkspacesMutationVariables = Exact<{
  workspaceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateCaraWorkspaceInput;
}>;

export type UpdateCaraWorkspacesMutation = {
  __typename?: 'Mutation';
  updateCaraWorkspaces: Array<{
    __typename?: 'CaraWorkspace';
    schemaVersion: CaraWorkspaceSchemaVersion;
    createdAt: Date;
    id: string;
    preset?: CaraWorkspacePreset | null | undefined;
    state: CaraWorkspaceState;
    title: string;
    updatedAt: Date;
    artifacts: Array<{
      __typename?: 'CaraWorkspaceArtifact';
      createdAt: Date;
      id: string;
      type: CaraWorkspaceArtifactType;
      document?:
        | {
            __typename?: 'Document';
            id: string;
            type: DocumentType;
            downloadUrl: string;
            data: {
              __typename?: 'DocumentData';
              acord25?:
                | {
                    __typename?: 'Acord25Data';
                    holder: { __typename?: 'CertificateEntity'; name: string };
                  }
                | null
                | undefined;
              acord125?:
                | {
                    __typename?: 'Acord125Data';
                    applicant1: { __typename?: 'Acord125Applicant'; name: string };
                  }
                | null
                | undefined;
              acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
              acord130?:
                | {
                    __typename?: 'Acord130Data';
                    namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                  }
                | null
                | undefined;
              acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
              acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
            };
          }
        | null
        | undefined;
      email?:
        | {
            __typename?: 'EmailDraft';
            body: string;
            subject: string;
            from: { __typename?: 'EmailParticipant'; name: string; email: string };
            to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
          }
        | null
        | undefined;
      htmlDocument?:
        | { __typename?: 'HtmlDocument'; content: string; title: string }
        | null
        | undefined;
    }>;
    files: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      url?: string | null | undefined;
    }>;
    planStages: Array<{
      __typename?: 'CaraWorkspacePlanStage';
      createdAt: Date;
      endedAt?: Date | null | undefined;
      id: string;
      initiatedByMessageId: string;
      result: string;
      startedAt?: Date | null | undefined;
      state: CaraWorkspacePlanStageState;
      type: CaraWorkspacePlanStageType;
      events: Array<{
        __typename?: 'CaraWorkspacePlanStageEvent';
        content?: string | null | undefined;
        endedAt?: Date | null | undefined;
        error?: string | null | undefined;
        id: string;
        startedAt: Date;
        title?: string | null | undefined;
        type: CaraWorkspacePlanStageEventType;
        toolCall?:
          | {
              __typename?: 'CaraWorkspaceToolCall';
              argumentsJson: string;
              name: string;
              result: string;
              type?: CaraWorkspaceTool | null | undefined;
              thinkTool?:
                | {
                    __typename?: 'ThinkTool';
                    input: { __typename?: 'ThinkToolInput'; title: string; thought: string };
                    output: { __typename?: 'ThinkToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              completeTaskTool?:
                | {
                    __typename?: 'CompleteTaskTool';
                    input: {
                      __typename?: 'CompleteTaskToolInput';
                      clientName: string;
                      keywords: Array<string>;
                      needsAgentInput: boolean;
                    };
                    output: { __typename?: 'CompleteTaskToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              draftEmailTool?:
                | {
                    __typename?: 'DraftEmailTool';
                    input: {
                      __typename?: 'DraftEmailToolInput';
                      artifactId: string;
                      body: string;
                      subject: string;
                      toEmail: string;
                      toName: string;
                    };
                  }
                | null
                | undefined;
              draftDocumentTool?:
                | {
                    __typename?: 'DraftDocumentTool';
                    input: {
                      __typename?: 'DraftDocumentToolInput';
                      artifactId: string;
                      title: string;
                      htmlContent: string;
                    };
                  }
                | null
                | undefined;
              fillTemplateTool?:
                | {
                    __typename?: 'FillTemplateTool';
                    input: {
                      __typename?: 'FillTemplateToolInput';
                      templateId: DocumentType;
                      acord24?:
                        | {
                            __typename?: 'Acord24Data';
                            certificateHolder: {
                              __typename?: 'Acord24CertificateHolder';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord24NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord25?:
                        | {
                            __typename?: 'Acord25Data';
                            holder: { __typename?: 'CertificateEntity'; name: string };
                            insured: { __typename?: 'CertificateEntity'; name: string };
                          }
                        | null
                        | undefined;
                      acord27?:
                        | {
                            __typename?: 'Acord27Data';
                            additionalInterest: {
                              __typename?: 'Acord27AdditionalInterest';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord27NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord28?:
                        | {
                            __typename?: 'Acord28Data';
                            additionalInterest: {
                              __typename?: 'Acord28AdditionalInterest';
                              fullName: string;
                            };
                            insured: { __typename?: 'Acord28Insured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord35?:
                        | {
                            __typename?: 'Acord35Data';
                            namedInsured: { __typename?: 'Acord35NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord36?:
                        | {
                            __typename?: 'Acord36Data';
                            agencies: {
                              __typename?: 'Acord36Agencies';
                              newAgency: { __typename?: 'Acord36Agency'; fullName: string };
                            };
                          }
                        | null
                        | undefined;
                      acord75?:
                        | {
                            __typename?: 'Acord75Data';
                            namedInsured: { __typename?: 'Acord75NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord125?:
                        | {
                            __typename?: 'Acord125Data';
                            applicant1: { __typename?: 'Acord125Applicant'; name: string };
                          }
                        | null
                        | undefined;
                      acord126?:
                        | { __typename?: 'Acord126Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord130?:
                        | {
                            __typename?: 'Acord130Data';
                            namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord131?:
                        | { __typename?: 'Acord131Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord140?:
                        | { __typename?: 'Acord140Data'; namedInsured: string }
                        | null
                        | undefined;
                    };
                    output: { __typename?: 'FillTemplateToolOutput'; artifactId: string };
                  }
                | null
                | undefined;
              searchFileTool?:
                | {
                    __typename?: 'SearchFileTool';
                    input: {
                      __typename?: 'SearchFileToolInput';
                      queries: Array<{
                        __typename?: 'SearchFileToolQuery';
                        fileId: string;
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchFileToolOutput';
                      results: Array<{
                        __typename?: 'SearchFileToolResult';
                        fileId: string;
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchFileToolResultCitation';
                          link: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeBaseTool?:
                | {
                    __typename?: 'SearchKnowledgeBaseTool';
                    input: {
                      __typename?: 'SearchKnowledgeBaseToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeBaseToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeBaseToolOutput';
                      documents: Array<{
                        __typename?: 'SearchKnowledgeBaseToolResultDocument';
                        metadata: { __typename?: 'KnowledgeBaseDocumentMetadata'; title: string };
                        relevantPages: Array<{
                          __typename?: 'SearchKnowledgeBaseToolResultPage';
                          pageIndex: number;
                          citation: {
                            __typename?: 'SearchKnowledgeBaseToolResultCitation';
                            link: string;
                          };
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeGraphTool?:
                | {
                    __typename?: 'SearchKnowledgeGraphTool';
                    input: {
                      __typename?: 'SearchKnowledgeGraphToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeGraphToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeGraphToolOutput';
                      entities: Array<{
                        __typename?: 'KnowledgeGraphEntity';
                        type: KnowledgeGraphEntityType;
                        displayName: string;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchWebTool?:
                | {
                    __typename?: 'SearchWebTool';
                    input: {
                      __typename?: 'SearchWebToolInput';
                      queries: Array<{
                        __typename?: 'SearchWebToolQuery';
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchWebToolOutput';
                      results: Array<{
                        __typename?: 'SearchWebToolResult';
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchWebToolResultCitation';
                          url: string;
                          title: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              writeIntegrationTool?:
                | {
                    __typename?: 'WriteIntegrationTool';
                    input: {
                      __typename?: 'WriteIntegrationToolInput';
                      action: string;
                      agentName: string;
                      account: {
                        __typename?: 'WriteIntegrationToolAccount';
                        firstName: string;
                        lastName: string;
                        businessName: string;
                        email: string;
                        phone: string;
                        address: {
                          __typename?: 'Address';
                          line1: string;
                          line2?: string | null | undefined;
                          city: string;
                          zone: string;
                          postalCode: string;
                        };
                      };
                      uploadDocument?:
                        | {
                            __typename?: 'WriteIntegrationToolUploadDocumentInput';
                            source: string;
                            description: string;
                            note: string;
                            id: string;
                          }
                        | null
                        | undefined;
                      createNote?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateNoteInput';
                            title: string;
                            body: string;
                          }
                        | null
                        | undefined;
                      createTask?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateTaskInput';
                            title: string;
                            description: string;
                            dueDate?: string | null | undefined;
                            assigneeEmail?: string | null | undefined;
                          }
                        | null
                        | undefined;
                    };
                    output: {
                      __typename?: 'WriteIntegrationToolOutput';
                      success: boolean;
                      message: string;
                    };
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }>;
      processAttachmentsDetails?:
        | {
            __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
            progress: Array<{
              __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
              progress: number;
              file: { __typename?: 'File'; name: string };
            }>;
          }
        | null
        | undefined;
    }>;
    messages: Array<{
      __typename?: 'CaraWorkspaceMessage';
      content: string;
      id: string;
      role: CaraWorkspaceMessageRole;
      timestamp: Date;
      files: Array<{
        __typename?: 'File';
        id: string;
        name: string;
        url?: string | null | undefined;
      }>;
    }>;
    serviceRequest?:
      | {
          __typename?: 'ServiceRequest';
          id: string;
          type: ServiceRequestType;
          state: ServiceRequestState;
          clientEmail?: string | null | undefined;
          clientName?: string | null | undefined;
          clientPhone?: string | null | undefined;
          details: string;
          dueAt?: Date | null | undefined;
          createdAt: Date;
          updatedAt: Date;
          account?:
            | {
                __typename?: 'Account';
                type: AccountType;
                account:
                  | { __typename?: 'BusinessAccount'; name: string }
                  | { __typename?: 'IndividualAccount'; name: string };
              }
            | null
            | undefined;
          assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
          addAdditionalInsured?:
            | {
                __typename?: 'AddAdditionalInsuredRequest';
                name: string;
                relationship: string;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          businessPolicy?:
            | {
                __typename?: 'BusinessPolicy';
                id: string;
                type: InsuranceType;
                carrier: { __typename?: 'InsuranceCarrier'; name: string };
              }
            | null
            | undefined;
          cancelPolicy?:
            | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
            | null
            | undefined;
          createCertificate?:
            | {
                __typename?: 'CreateCertificateRequest';
                name: string;
                additionalInsured: boolean;
                additionalInsuredRelationship?: string | null | undefined;
                additionalInsuredRelationshipDescription?: string | null | undefined;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          documentRequest?:
            | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
            | null
            | undefined;
          endorsePolicy?:
            | { __typename?: 'EndorsePolicyRequest'; policyId: string }
            | null
            | undefined;
          question?:
            | {
                __typename?: 'QuestionRequest';
                policyId?: string | null | undefined;
                question: string;
                type: QuestionRequestType;
              }
            | null
            | undefined;
          resolution?:
            | { __typename?: 'ServiceRequestResolution'; notes: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    agencyUser: { __typename?: 'AgencyUser'; email: string; id: string; name: string };
    customPreset?: { __typename?: 'CustomPreset'; id: string; title: string } | null | undefined;
    metadata: {
      __typename?: 'CaraWorkspaceMetadata';
      clientName?: string | null | undefined;
      keywords: Array<string>;
    };
  }>;
};

export type CreateCustomPresetMutationVariables = Exact<{
  input: CustomPresetInput;
}>;

export type CreateCustomPresetMutation = {
  __typename?: 'Mutation';
  createCustomPreset: { __typename?: 'CustomPreset'; id: string };
};

export type UpdateCustomPresetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomPresetInput;
}>;

export type UpdateCustomPresetMutation = {
  __typename?: 'Mutation';
  updateCustomPreset: { __typename?: 'CustomPreset'; id: string };
};

export type CreateHtmlDocumentTemplateMutationVariables = Exact<{
  input: HtmlDocumentTemplateInput;
}>;

export type CreateHtmlDocumentTemplateMutation = {
  __typename?: 'Mutation';
  createHtmlDocumentTemplate: {
    __typename?: 'HtmlDocumentTemplate';
    baseStyleId?: string | null | undefined;
    description: string;
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: { __typename?: 'AgencyUser'; name: string };
    prefixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
    suffixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
  };
};

export type UpdateHtmlDocumentTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: HtmlDocumentTemplateInput;
}>;

export type UpdateHtmlDocumentTemplateMutation = {
  __typename?: 'Mutation';
  updateHtmlDocumentTemplate: {
    __typename?: 'HtmlDocumentTemplate';
    baseStyleId?: string | null | undefined;
    description: string;
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: { __typename?: 'AgencyUser'; name: string };
    prefixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
    suffixFiles: Array<{ __typename?: 'File'; id: string; name: string; mimeType: string }>;
  };
};

export type WatchCaraWorkspaceSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type WatchCaraWorkspaceSubscription = {
  __typename?: 'Subscription';
  watchCaraWorkspace: {
    __typename?: 'CaraWorkspace';
    schemaVersion: CaraWorkspaceSchemaVersion;
    createdAt: Date;
    id: string;
    preset?: CaraWorkspacePreset | null | undefined;
    state: CaraWorkspaceState;
    title: string;
    updatedAt: Date;
    artifacts: Array<{
      __typename?: 'CaraWorkspaceArtifact';
      createdAt: Date;
      id: string;
      type: CaraWorkspaceArtifactType;
      document?:
        | {
            __typename?: 'Document';
            id: string;
            type: DocumentType;
            downloadUrl: string;
            data: {
              __typename?: 'DocumentData';
              acord25?:
                | {
                    __typename?: 'Acord25Data';
                    holder: { __typename?: 'CertificateEntity'; name: string };
                  }
                | null
                | undefined;
              acord125?:
                | {
                    __typename?: 'Acord125Data';
                    applicant1: { __typename?: 'Acord125Applicant'; name: string };
                  }
                | null
                | undefined;
              acord126?: { __typename?: 'Acord126Data'; namedInsured: string } | null | undefined;
              acord130?:
                | {
                    __typename?: 'Acord130Data';
                    namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                  }
                | null
                | undefined;
              acord131?: { __typename?: 'Acord131Data'; namedInsured: string } | null | undefined;
              acord140?: { __typename?: 'Acord140Data'; namedInsured: string } | null | undefined;
            };
          }
        | null
        | undefined;
      email?:
        | {
            __typename?: 'EmailDraft';
            body: string;
            subject: string;
            from: { __typename?: 'EmailParticipant'; name: string; email: string };
            to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
          }
        | null
        | undefined;
      htmlDocument?:
        | { __typename?: 'HtmlDocument'; content: string; title: string }
        | null
        | undefined;
    }>;
    files: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      url?: string | null | undefined;
    }>;
    planStages: Array<{
      __typename?: 'CaraWorkspacePlanStage';
      createdAt: Date;
      endedAt?: Date | null | undefined;
      id: string;
      initiatedByMessageId: string;
      result: string;
      startedAt?: Date | null | undefined;
      state: CaraWorkspacePlanStageState;
      type: CaraWorkspacePlanStageType;
      events: Array<{
        __typename?: 'CaraWorkspacePlanStageEvent';
        content?: string | null | undefined;
        endedAt?: Date | null | undefined;
        error?: string | null | undefined;
        id: string;
        startedAt: Date;
        title?: string | null | undefined;
        type: CaraWorkspacePlanStageEventType;
        toolCall?:
          | {
              __typename?: 'CaraWorkspaceToolCall';
              argumentsJson: string;
              name: string;
              result: string;
              type?: CaraWorkspaceTool | null | undefined;
              thinkTool?:
                | {
                    __typename?: 'ThinkTool';
                    input: { __typename?: 'ThinkToolInput'; title: string; thought: string };
                    output: { __typename?: 'ThinkToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              completeTaskTool?:
                | {
                    __typename?: 'CompleteTaskTool';
                    input: {
                      __typename?: 'CompleteTaskToolInput';
                      clientName: string;
                      keywords: Array<string>;
                      needsAgentInput: boolean;
                    };
                    output: { __typename?: 'CompleteTaskToolOutput'; success: boolean };
                  }
                | null
                | undefined;
              draftEmailTool?:
                | {
                    __typename?: 'DraftEmailTool';
                    input: {
                      __typename?: 'DraftEmailToolInput';
                      artifactId: string;
                      body: string;
                      subject: string;
                      toEmail: string;
                      toName: string;
                    };
                  }
                | null
                | undefined;
              draftDocumentTool?:
                | {
                    __typename?: 'DraftDocumentTool';
                    input: {
                      __typename?: 'DraftDocumentToolInput';
                      artifactId: string;
                      title: string;
                      htmlContent: string;
                    };
                  }
                | null
                | undefined;
              fillTemplateTool?:
                | {
                    __typename?: 'FillTemplateTool';
                    input: {
                      __typename?: 'FillTemplateToolInput';
                      templateId: DocumentType;
                      acord24?:
                        | {
                            __typename?: 'Acord24Data';
                            certificateHolder: {
                              __typename?: 'Acord24CertificateHolder';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord24NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord25?:
                        | {
                            __typename?: 'Acord25Data';
                            holder: { __typename?: 'CertificateEntity'; name: string };
                            insured: { __typename?: 'CertificateEntity'; name: string };
                          }
                        | null
                        | undefined;
                      acord27?:
                        | {
                            __typename?: 'Acord27Data';
                            additionalInterest: {
                              __typename?: 'Acord27AdditionalInterest';
                              fullName: string;
                            };
                            namedInsured: { __typename?: 'Acord27NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord28?:
                        | {
                            __typename?: 'Acord28Data';
                            additionalInterest: {
                              __typename?: 'Acord28AdditionalInterest';
                              fullName: string;
                            };
                            insured: { __typename?: 'Acord28Insured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord35?:
                        | {
                            __typename?: 'Acord35Data';
                            namedInsured: { __typename?: 'Acord35NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord36?:
                        | {
                            __typename?: 'Acord36Data';
                            agencies: {
                              __typename?: 'Acord36Agencies';
                              newAgency: { __typename?: 'Acord36Agency'; fullName: string };
                            };
                          }
                        | null
                        | undefined;
                      acord75?:
                        | {
                            __typename?: 'Acord75Data';
                            namedInsured: { __typename?: 'Acord75NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord125?:
                        | {
                            __typename?: 'Acord125Data';
                            applicant1: { __typename?: 'Acord125Applicant'; name: string };
                          }
                        | null
                        | undefined;
                      acord126?:
                        | { __typename?: 'Acord126Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord130?:
                        | {
                            __typename?: 'Acord130Data';
                            namedInsured: { __typename?: 'Acord130NamedInsured'; fullName: string };
                          }
                        | null
                        | undefined;
                      acord131?:
                        | { __typename?: 'Acord131Data'; namedInsured: string }
                        | null
                        | undefined;
                      acord140?:
                        | { __typename?: 'Acord140Data'; namedInsured: string }
                        | null
                        | undefined;
                    };
                    output: { __typename?: 'FillTemplateToolOutput'; artifactId: string };
                  }
                | null
                | undefined;
              searchFileTool?:
                | {
                    __typename?: 'SearchFileTool';
                    input: {
                      __typename?: 'SearchFileToolInput';
                      queries: Array<{
                        __typename?: 'SearchFileToolQuery';
                        fileId: string;
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchFileToolOutput';
                      results: Array<{
                        __typename?: 'SearchFileToolResult';
                        fileId: string;
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchFileToolResultCitation';
                          link: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeBaseTool?:
                | {
                    __typename?: 'SearchKnowledgeBaseTool';
                    input: {
                      __typename?: 'SearchKnowledgeBaseToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeBaseToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeBaseToolOutput';
                      documents: Array<{
                        __typename?: 'SearchKnowledgeBaseToolResultDocument';
                        metadata: { __typename?: 'KnowledgeBaseDocumentMetadata'; title: string };
                        relevantPages: Array<{
                          __typename?: 'SearchKnowledgeBaseToolResultPage';
                          pageIndex: number;
                          citation: {
                            __typename?: 'SearchKnowledgeBaseToolResultCitation';
                            link: string;
                          };
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchKnowledgeGraphTool?:
                | {
                    __typename?: 'SearchKnowledgeGraphTool';
                    input: {
                      __typename?: 'SearchKnowledgeGraphToolInput';
                      queries: Array<{
                        __typename?: 'SearchKnowledgeGraphToolQuery';
                        query: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchKnowledgeGraphToolOutput';
                      entities: Array<{
                        __typename?: 'KnowledgeGraphEntity';
                        type: KnowledgeGraphEntityType;
                        displayName: string;
                      }>;
                    };
                  }
                | null
                | undefined;
              searchWebTool?:
                | {
                    __typename?: 'SearchWebTool';
                    input: {
                      __typename?: 'SearchWebToolInput';
                      queries: Array<{
                        __typename?: 'SearchWebToolQuery';
                        query: string;
                        keywords: string;
                      }>;
                    };
                    output: {
                      __typename?: 'SearchWebToolOutput';
                      results: Array<{
                        __typename?: 'SearchWebToolResult';
                        query: string;
                        answer: string;
                        citations: Array<{
                          __typename?: 'SearchWebToolResultCitation';
                          url: string;
                          title: string;
                        }>;
                      }>;
                    };
                  }
                | null
                | undefined;
              writeIntegrationTool?:
                | {
                    __typename?: 'WriteIntegrationTool';
                    input: {
                      __typename?: 'WriteIntegrationToolInput';
                      action: string;
                      agentName: string;
                      account: {
                        __typename?: 'WriteIntegrationToolAccount';
                        firstName: string;
                        lastName: string;
                        businessName: string;
                        email: string;
                        phone: string;
                        address: {
                          __typename?: 'Address';
                          line1: string;
                          line2?: string | null | undefined;
                          city: string;
                          zone: string;
                          postalCode: string;
                        };
                      };
                      uploadDocument?:
                        | {
                            __typename?: 'WriteIntegrationToolUploadDocumentInput';
                            source: string;
                            description: string;
                            note: string;
                            id: string;
                          }
                        | null
                        | undefined;
                      createNote?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateNoteInput';
                            title: string;
                            body: string;
                          }
                        | null
                        | undefined;
                      createTask?:
                        | {
                            __typename?: 'WriteIntegrationToolCreateTaskInput';
                            title: string;
                            description: string;
                            dueDate?: string | null | undefined;
                            assigneeEmail?: string | null | undefined;
                          }
                        | null
                        | undefined;
                    };
                    output: {
                      __typename?: 'WriteIntegrationToolOutput';
                      success: boolean;
                      message: string;
                    };
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }>;
      processAttachmentsDetails?:
        | {
            __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
            progress: Array<{
              __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
              progress: number;
              file: { __typename?: 'File'; name: string };
            }>;
          }
        | null
        | undefined;
    }>;
    messages: Array<{
      __typename?: 'CaraWorkspaceMessage';
      content: string;
      id: string;
      role: CaraWorkspaceMessageRole;
      timestamp: Date;
      files: Array<{
        __typename?: 'File';
        id: string;
        name: string;
        url?: string | null | undefined;
      }>;
    }>;
    serviceRequest?:
      | {
          __typename?: 'ServiceRequest';
          id: string;
          type: ServiceRequestType;
          state: ServiceRequestState;
          clientEmail?: string | null | undefined;
          clientName?: string | null | undefined;
          clientPhone?: string | null | undefined;
          details: string;
          dueAt?: Date | null | undefined;
          createdAt: Date;
          updatedAt: Date;
          account?:
            | {
                __typename?: 'Account';
                type: AccountType;
                account:
                  | { __typename?: 'BusinessAccount'; name: string }
                  | { __typename?: 'IndividualAccount'; name: string };
              }
            | null
            | undefined;
          assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
          addAdditionalInsured?:
            | {
                __typename?: 'AddAdditionalInsuredRequest';
                name: string;
                relationship: string;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          businessPolicy?:
            | {
                __typename?: 'BusinessPolicy';
                id: string;
                type: InsuranceType;
                carrier: { __typename?: 'InsuranceCarrier'; name: string };
              }
            | null
            | undefined;
          cancelPolicy?:
            | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
            | null
            | undefined;
          createCertificate?:
            | {
                __typename?: 'CreateCertificateRequest';
                name: string;
                additionalInsured: boolean;
                additionalInsuredRelationship?: string | null | undefined;
                additionalInsuredRelationshipDescription?: string | null | undefined;
                address: {
                  __typename?: 'Address';
                  line1: string;
                  city: string;
                  zone: string;
                  postalCode: string;
                };
              }
            | null
            | undefined;
          documentRequest?:
            | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
            | null
            | undefined;
          endorsePolicy?:
            | { __typename?: 'EndorsePolicyRequest'; policyId: string }
            | null
            | undefined;
          question?:
            | {
                __typename?: 'QuestionRequest';
                policyId?: string | null | undefined;
                question: string;
                type: QuestionRequestType;
              }
            | null
            | undefined;
          resolution?:
            | { __typename?: 'ServiceRequestResolution'; notes: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    agencyUser: { __typename?: 'AgencyUser'; email: string; id: string; name: string };
    customPreset?: { __typename?: 'CustomPreset'; id: string; title: string } | null | undefined;
    metadata: {
      __typename?: 'CaraWorkspaceMetadata';
      clientName?: string | null | undefined;
      keywords: Array<string>;
    };
  };
};

export type CertificateOfLiabilityInsuranceFieldsFragment = {
  __typename?: 'CertificateOfLiabilityInsurance';
  id: string;
  certificateNumber: string;
  viewUrl: string;
  downloadUrl: string;
  createdAt: Date;
  holder: {
    __typename?: 'CertificateEntity';
    name: string;
    address: {
      __typename?: 'Address';
      line1: string;
      city: string;
      zone: string;
      postalCode: string;
    };
  };
};

export type GetCertificateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCertificateQuery = {
  __typename?: 'Query';
  certificate?:
    | {
        __typename?: 'CertificateOfLiabilityInsurance';
        id: string;
        certificateNumber: string;
        viewUrl: string;
        downloadUrl: string;
        createdAt: Date;
        holder: {
          __typename?: 'CertificateEntity';
          name: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        };
      }
    | null
    | undefined;
};

export type CreateCertificateMutationVariables = Exact<{
  input: CreateCertificateInput;
}>;

export type CreateCertificateMutation = {
  __typename?: 'Mutation';
  createCertificate?:
    | {
        __typename?: 'CertificateOfLiabilityInsurance';
        id: string;
        certificateNumber: string;
        viewUrl: string;
        downloadUrl: string;
        createdAt: Date;
        holder: {
          __typename?: 'CertificateEntity';
          name: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        };
      }
    | null
    | undefined;
};

export type EmailFieldsFragment = {
  __typename?: 'Email';
  body: string;
  id: string;
  senderRole: EmailSenderRole;
  sentAt: Date;
  subject: string;
  from: { __typename?: 'EmailParticipant'; name: string; email: string };
  to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
};

export type EmailThreadFieldsFragment = {
  __typename?: 'EmailThread';
  fromEmail: string;
  fromName: string;
  id: string;
  state: EmailThreadState;
  subject: string;
  waitingFor?: EmailSenderRole | null | undefined;
  createdAt: Date;
  updatedAt: Date;
  account?:
    | {
        __typename?: 'Account';
        id: string;
        account:
          | { __typename?: 'BusinessAccount'; name: string }
          | { __typename?: 'IndividualAccount'; name: string };
      }
    | null
    | undefined;
};

export type EmailThreadConversationFieldsFragment = {
  __typename?: 'EmailThread';
  summary: string;
  attachments: Array<{
    __typename?: 'File';
    id: string;
    name: string;
    url?: string | null | undefined;
  }>;
  participantEmails: Array<{
    __typename?: 'Email';
    body: string;
    id: string;
    senderRole: EmailSenderRole;
    sentAt: Date;
    subject: string;
    from: { __typename?: 'EmailParticipant'; name: string; email: string };
    to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
  }>;
  serviceRequests: Array<{
    __typename?: 'ServiceRequest';
    id: string;
    type: ServiceRequestType;
    state: ServiceRequestState;
    clientEmail?: string | null | undefined;
    clientName?: string | null | undefined;
    clientPhone?: string | null | undefined;
    details: string;
    dueAt?: Date | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          type: AccountType;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
    addAdditionalInsured?:
      | {
          __typename?: 'AddAdditionalInsuredRequest';
          name: string;
          relationship: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    businessPolicy?:
      | {
          __typename?: 'BusinessPolicy';
          id: string;
          type: InsuranceType;
          carrier: { __typename?: 'InsuranceCarrier'; name: string };
        }
      | null
      | undefined;
    cancelPolicy?:
      | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
      | null
      | undefined;
    createCertificate?:
      | {
          __typename?: 'CreateCertificateRequest';
          name: string;
          additionalInsured: boolean;
          additionalInsuredRelationship?: string | null | undefined;
          additionalInsuredRelationshipDescription?: string | null | undefined;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    documentRequest?:
      | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
      | null
      | undefined;
    endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
    question?:
      | {
          __typename?: 'QuestionRequest';
          policyId?: string | null | undefined;
          question: string;
          type: QuestionRequestType;
        }
      | null
      | undefined;
    resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
  }>;
  workspace?:
    | { __typename?: 'CaraWorkspace'; id: string; title: string; state: CaraWorkspaceState }
    | null
    | undefined;
};

export type GetEmailThreadsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEmailThreadsQuery = {
  __typename?: 'Query';
  emailThreads: Array<{
    __typename?: 'EmailThread';
    fromEmail: string;
    fromName: string;
    id: string;
    state: EmailThreadState;
    subject: string;
    waitingFor?: EmailSenderRole | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
  }>;
};

export type GetEmailThreadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetEmailThreadQuery = {
  __typename?: 'Query';
  emailThread: {
    __typename?: 'EmailThread';
    fromEmail: string;
    fromName: string;
    id: string;
    state: EmailThreadState;
    subject: string;
    waitingFor?: EmailSenderRole | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    summary: string;
    account?:
      | {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    attachments: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      url?: string | null | undefined;
    }>;
    participantEmails: Array<{
      __typename?: 'Email';
      body: string;
      id: string;
      senderRole: EmailSenderRole;
      sentAt: Date;
      subject: string;
      from: { __typename?: 'EmailParticipant'; name: string; email: string };
      to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
    }>;
    serviceRequests: Array<{
      __typename?: 'ServiceRequest';
      id: string;
      type: ServiceRequestType;
      state: ServiceRequestState;
      clientEmail?: string | null | undefined;
      clientName?: string | null | undefined;
      clientPhone?: string | null | undefined;
      details: string;
      dueAt?: Date | null | undefined;
      createdAt: Date;
      updatedAt: Date;
      account?:
        | {
            __typename?: 'Account';
            type: AccountType;
            account:
              | { __typename?: 'BusinessAccount'; name: string }
              | { __typename?: 'IndividualAccount'; name: string };
          }
        | null
        | undefined;
      assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
      addAdditionalInsured?:
        | {
            __typename?: 'AddAdditionalInsuredRequest';
            name: string;
            relationship: string;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      businessPolicy?:
        | {
            __typename?: 'BusinessPolicy';
            id: string;
            type: InsuranceType;
            carrier: { __typename?: 'InsuranceCarrier'; name: string };
          }
        | null
        | undefined;
      cancelPolicy?:
        | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
        | null
        | undefined;
      createCertificate?:
        | {
            __typename?: 'CreateCertificateRequest';
            name: string;
            additionalInsured: boolean;
            additionalInsuredRelationship?: string | null | undefined;
            additionalInsuredRelationshipDescription?: string | null | undefined;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      documentRequest?:
        | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
        | null
        | undefined;
      endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
      question?:
        | {
            __typename?: 'QuestionRequest';
            policyId?: string | null | undefined;
            question: string;
            type: QuestionRequestType;
          }
        | null
        | undefined;
      resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
    }>;
    workspace?:
      | { __typename?: 'CaraWorkspace'; id: string; title: string; state: CaraWorkspaceState }
      | null
      | undefined;
  };
};

export type FileFieldsFragment = {
  __typename?: 'File';
  createdAt: Date;
  id: string;
  mimeType: string;
  name: string;
  notes: string;
  type: FileType;
  url?: string | null | undefined;
};

export type DeleteFileMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;

export type DeleteFileMutation = {
  __typename?: 'Mutation';
  deleteFile?:
    | {
        __typename?: 'File';
        createdAt: Date;
        id: string;
        mimeType: string;
        name: string;
        notes: string;
        type: FileType;
        url?: string | null | undefined;
      }
    | null
    | undefined;
};

export type IntegrationFieldsFragment = {
  __typename?: 'Integration';
  id: string;
  type: IntegrationType;
  state: IntegrationState;
  createdAt: Date;
  updatedAt: Date;
};

export type IntegrationSyncLogFieldsFragment = {
  __typename?: 'IntegrationSyncLog';
  completedAt?: Date | null | undefined;
  entitiesSynced: number;
  id: string;
  initiatorType: UpdateInitiatorType;
  initiatorId: string;
  lastError?: string | null | undefined;
  startedAt: Date;
  state: IntegrationSyncState;
  type: IntegrationSyncType;
};

export type IntegrationDetailFieldsFragment = {
  __typename?: 'Integration';
  lastSyncedAt?: Date | null | undefined;
  id: string;
  type: IntegrationType;
  state: IntegrationState;
  createdAt: Date;
  updatedAt: Date;
  configuration: {
    __typename?: 'IntegrationConfiguration';
    hawksoft?:
      | {
          __typename?: 'HawksoftConfiguration';
          agencyId: string;
          enableSyncCallNotes: boolean;
          enableSyncServiceRequests: boolean;
        }
      | null
      | undefined;
    nowcerts?:
      | {
          __typename?: 'NowCertsConfiguration';
          username: string;
          enableSyncTasks: boolean;
          enableSyncCalls: boolean;
        }
      | null
      | undefined;
    hubspot?:
      | {
          __typename?: 'HubSpotConfiguration';
          accessToken: string;
          enableSyncTasks: boolean;
          taskSyncType?: HubSpotTaskSyncType | null | undefined;
          taskPipelineId?: string | null | undefined;
          taskStageId?: string | null | undefined;
          enableSyncCalls: boolean;
          callSyncType?: HubSpotCallSyncType | null | undefined;
          callPipelineId?: string | null | undefined;
          callStageId?: string | null | undefined;
          callFieldMappings?:
            | {
                __typename?: 'HubSpotCallFieldMappings';
                ticketFields: Array<{
                  __typename?: 'HubSpotFieldMapping';
                  hubspotField: string;
                  caraField: string;
                }>;
                dealFields: Array<{
                  __typename?: 'HubSpotFieldMapping';
                  hubspotField: string;
                  caraField: string;
                }>;
              }
            | null
            | undefined;
          taskFieldMappings?:
            | {
                __typename?: 'HubSpotTaskFieldMappings';
                ticketFields: Array<{
                  __typename?: 'HubSpotFieldMapping';
                  hubspotField: string;
                  caraField: string;
                }>;
                dealFields: Array<{
                  __typename?: 'HubSpotFieldMapping';
                  hubspotField: string;
                  caraField: string;
                }>;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
  syncLogs: Array<{
    __typename?: 'IntegrationSyncLog';
    completedAt?: Date | null | undefined;
    entitiesSynced: number;
    id: string;
    initiatorType: UpdateInitiatorType;
    initiatorId: string;
    lastError?: string | null | undefined;
    startedAt: Date;
    state: IntegrationSyncState;
    type: IntegrationSyncType;
  }>;
};

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetIntegrationsQuery = {
  __typename?: 'Query';
  integrations: Array<{
    __typename?: 'Integration';
    id: string;
    type: IntegrationType;
    state: IntegrationState;
    createdAt: Date;
    updatedAt: Date;
  }>;
};

export type GetIntegrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetIntegrationQuery = {
  __typename?: 'Query';
  integration?:
    | {
        __typename?: 'Integration';
        lastSyncedAt?: Date | null | undefined;
        id: string;
        type: IntegrationType;
        state: IntegrationState;
        createdAt: Date;
        updatedAt: Date;
        configuration: {
          __typename?: 'IntegrationConfiguration';
          hawksoft?:
            | {
                __typename?: 'HawksoftConfiguration';
                agencyId: string;
                enableSyncCallNotes: boolean;
                enableSyncServiceRequests: boolean;
              }
            | null
            | undefined;
          nowcerts?:
            | {
                __typename?: 'NowCertsConfiguration';
                username: string;
                enableSyncTasks: boolean;
                enableSyncCalls: boolean;
              }
            | null
            | undefined;
          hubspot?:
            | {
                __typename?: 'HubSpotConfiguration';
                accessToken: string;
                enableSyncTasks: boolean;
                taskSyncType?: HubSpotTaskSyncType | null | undefined;
                taskPipelineId?: string | null | undefined;
                taskStageId?: string | null | undefined;
                enableSyncCalls: boolean;
                callSyncType?: HubSpotCallSyncType | null | undefined;
                callPipelineId?: string | null | undefined;
                callStageId?: string | null | undefined;
                callFieldMappings?:
                  | {
                      __typename?: 'HubSpotCallFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
                taskFieldMappings?:
                  | {
                      __typename?: 'HubSpotTaskFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
              }
            | null
            | undefined;
        };
        syncLogs: Array<{
          __typename?: 'IntegrationSyncLog';
          completedAt?: Date | null | undefined;
          entitiesSynced: number;
          id: string;
          initiatorType: UpdateInitiatorType;
          initiatorId: string;
          lastError?: string | null | undefined;
          startedAt: Date;
          state: IntegrationSyncState;
          type: IntegrationSyncType;
        }>;
      }
    | null
    | undefined;
};

export type CreateIntegrationMutationVariables = Exact<{
  input: CreateIntegrationInput;
}>;

export type CreateIntegrationMutation = {
  __typename?: 'Mutation';
  createIntegration?:
    | {
        __typename?: 'Integration';
        lastSyncedAt?: Date | null | undefined;
        id: string;
        type: IntegrationType;
        state: IntegrationState;
        createdAt: Date;
        updatedAt: Date;
        configuration: {
          __typename?: 'IntegrationConfiguration';
          hawksoft?:
            | {
                __typename?: 'HawksoftConfiguration';
                agencyId: string;
                enableSyncCallNotes: boolean;
                enableSyncServiceRequests: boolean;
              }
            | null
            | undefined;
          nowcerts?:
            | {
                __typename?: 'NowCertsConfiguration';
                username: string;
                enableSyncTasks: boolean;
                enableSyncCalls: boolean;
              }
            | null
            | undefined;
          hubspot?:
            | {
                __typename?: 'HubSpotConfiguration';
                accessToken: string;
                enableSyncTasks: boolean;
                taskSyncType?: HubSpotTaskSyncType | null | undefined;
                taskPipelineId?: string | null | undefined;
                taskStageId?: string | null | undefined;
                enableSyncCalls: boolean;
                callSyncType?: HubSpotCallSyncType | null | undefined;
                callPipelineId?: string | null | undefined;
                callStageId?: string | null | undefined;
                callFieldMappings?:
                  | {
                      __typename?: 'HubSpotCallFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
                taskFieldMappings?:
                  | {
                      __typename?: 'HubSpotTaskFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
              }
            | null
            | undefined;
        };
        syncLogs: Array<{
          __typename?: 'IntegrationSyncLog';
          completedAt?: Date | null | undefined;
          entitiesSynced: number;
          id: string;
          initiatorType: UpdateInitiatorType;
          initiatorId: string;
          lastError?: string | null | undefined;
          startedAt: Date;
          state: IntegrationSyncState;
          type: IntegrationSyncType;
        }>;
      }
    | null
    | undefined;
};

export type UpdateIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateIntegrationInput;
}>;

export type UpdateIntegrationMutation = {
  __typename?: 'Mutation';
  updateIntegration?:
    | {
        __typename?: 'Integration';
        lastSyncedAt?: Date | null | undefined;
        id: string;
        type: IntegrationType;
        state: IntegrationState;
        createdAt: Date;
        updatedAt: Date;
        configuration: {
          __typename?: 'IntegrationConfiguration';
          hawksoft?:
            | {
                __typename?: 'HawksoftConfiguration';
                agencyId: string;
                enableSyncCallNotes: boolean;
                enableSyncServiceRequests: boolean;
              }
            | null
            | undefined;
          nowcerts?:
            | {
                __typename?: 'NowCertsConfiguration';
                username: string;
                enableSyncTasks: boolean;
                enableSyncCalls: boolean;
              }
            | null
            | undefined;
          hubspot?:
            | {
                __typename?: 'HubSpotConfiguration';
                accessToken: string;
                enableSyncTasks: boolean;
                taskSyncType?: HubSpotTaskSyncType | null | undefined;
                taskPipelineId?: string | null | undefined;
                taskStageId?: string | null | undefined;
                enableSyncCalls: boolean;
                callSyncType?: HubSpotCallSyncType | null | undefined;
                callPipelineId?: string | null | undefined;
                callStageId?: string | null | undefined;
                callFieldMappings?:
                  | {
                      __typename?: 'HubSpotCallFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
                taskFieldMappings?:
                  | {
                      __typename?: 'HubSpotTaskFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
              }
            | null
            | undefined;
        };
        syncLogs: Array<{
          __typename?: 'IntegrationSyncLog';
          completedAt?: Date | null | undefined;
          entitiesSynced: number;
          id: string;
          initiatorType: UpdateInitiatorType;
          initiatorId: string;
          lastError?: string | null | undefined;
          startedAt: Date;
          state: IntegrationSyncState;
          type: IntegrationSyncType;
        }>;
      }
    | null
    | undefined;
};

export type SyncIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SyncIntegrationMutation = {
  __typename?: 'Mutation';
  syncIntegration?:
    | {
        __typename?: 'Integration';
        lastSyncedAt?: Date | null | undefined;
        id: string;
        type: IntegrationType;
        state: IntegrationState;
        createdAt: Date;
        updatedAt: Date;
        configuration: {
          __typename?: 'IntegrationConfiguration';
          hawksoft?:
            | {
                __typename?: 'HawksoftConfiguration';
                agencyId: string;
                enableSyncCallNotes: boolean;
                enableSyncServiceRequests: boolean;
              }
            | null
            | undefined;
          nowcerts?:
            | {
                __typename?: 'NowCertsConfiguration';
                username: string;
                enableSyncTasks: boolean;
                enableSyncCalls: boolean;
              }
            | null
            | undefined;
          hubspot?:
            | {
                __typename?: 'HubSpotConfiguration';
                accessToken: string;
                enableSyncTasks: boolean;
                taskSyncType?: HubSpotTaskSyncType | null | undefined;
                taskPipelineId?: string | null | undefined;
                taskStageId?: string | null | undefined;
                enableSyncCalls: boolean;
                callSyncType?: HubSpotCallSyncType | null | undefined;
                callPipelineId?: string | null | undefined;
                callStageId?: string | null | undefined;
                callFieldMappings?:
                  | {
                      __typename?: 'HubSpotCallFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
                taskFieldMappings?:
                  | {
                      __typename?: 'HubSpotTaskFieldMappings';
                      ticketFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                      dealFields: Array<{
                        __typename?: 'HubSpotFieldMapping';
                        hubspotField: string;
                        caraField: string;
                      }>;
                    }
                  | null
                  | undefined;
              }
            | null
            | undefined;
        };
        syncLogs: Array<{
          __typename?: 'IntegrationSyncLog';
          completedAt?: Date | null | undefined;
          entitiesSynced: number;
          id: string;
          initiatorType: UpdateInitiatorType;
          initiatorId: string;
          lastError?: string | null | undefined;
          startedAt: Date;
          state: IntegrationSyncState;
          type: IntegrationSyncType;
        }>;
      }
    | null
    | undefined;
};

export type GetHubSpotTicketPipelinesQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
}>;

export type GetHubSpotTicketPipelinesQuery = {
  __typename?: 'Query';
  hubspotTicketPipelines: Array<{
    __typename?: 'HubSpotTicketPipeline';
    id: string;
    label: string;
    displayOrder: number;
    createdAt: string;
    updatedAt: string;
    archived: boolean;
    stages: Array<{
      __typename?: 'HubSpotTicketPipelineStage';
      id: string;
      label: string;
      displayOrder: number;
      archived: boolean;
      ticketState: string;
    }>;
  }>;
};

export type GetIntegrationStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetIntegrationStateQuery = {
  __typename?: 'Query';
  integration?:
    | { __typename?: 'Integration'; id: string; state: IntegrationState }
    | null
    | undefined;
};

export type KnowledgeBaseFieldsFragment = {
  __typename?: 'KnowledgeBase';
  id: string;
  title: string;
};

export type KnowledgeBaseDetailFieldsFragment = {
  __typename?: 'KnowledgeBase';
  id: string;
  title: string;
  documents: Array<{
    __typename?: 'KnowledgeBaseDocument';
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: { __typename?: 'AgencyUser'; name: string };
    indexingStatus: {
      __typename?: 'KnowledgeBaseDocumentIndexingStatus';
      status: IndexingStatus;
      error?: string | null | undefined;
      progress?: number | null | undefined;
      startedAt?: Date | null | undefined;
      completedAt?: Date | null | undefined;
    };
    file?:
      | {
          __typename?: 'KnowledgeBaseDocumentFile';
          mimeType: string;
          name: string;
          size: number;
          url?: string | null | undefined;
        }
      | null
      | undefined;
    metadata?:
      | {
          __typename?: 'KnowledgeBaseDocumentMetadata';
          title: string;
          summary: string;
          purpose: string;
        }
      | null
      | undefined;
    text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
  }>;
};

export type KnowledgeBaseDocumentFieldsFragment = {
  __typename?: 'KnowledgeBaseDocument';
  id: string;
  title: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: { __typename?: 'AgencyUser'; name: string };
  indexingStatus: {
    __typename?: 'KnowledgeBaseDocumentIndexingStatus';
    status: IndexingStatus;
    error?: string | null | undefined;
    progress?: number | null | undefined;
    startedAt?: Date | null | undefined;
    completedAt?: Date | null | undefined;
  };
  file?:
    | {
        __typename?: 'KnowledgeBaseDocumentFile';
        mimeType: string;
        name: string;
        size: number;
        url?: string | null | undefined;
      }
    | null
    | undefined;
  metadata?:
    | {
        __typename?: 'KnowledgeBaseDocumentMetadata';
        title: string;
        summary: string;
        purpose: string;
      }
    | null
    | undefined;
  text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
};

export type KnowledgeBaseDocumentDetailFieldsFragment = {
  __typename?: 'KnowledgeBaseDocument';
  id: string;
  title: string;
  createdAt: Date;
  updatedAt: Date;
  file?:
    | {
        __typename?: 'KnowledgeBaseDocumentFile';
        mimeType: string;
        name: string;
        size: number;
        url?: string | null | undefined;
      }
    | null
    | undefined;
  text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
  createdBy: { __typename?: 'AgencyUser'; name: string };
  indexingStatus: {
    __typename?: 'KnowledgeBaseDocumentIndexingStatus';
    status: IndexingStatus;
    error?: string | null | undefined;
    progress?: number | null | undefined;
    startedAt?: Date | null | undefined;
    completedAt?: Date | null | undefined;
  };
  metadata?:
    | {
        __typename?: 'KnowledgeBaseDocumentMetadata';
        title: string;
        summary: string;
        purpose: string;
      }
    | null
    | undefined;
};

export type GetKnowledgeBasesQueryVariables = Exact<{ [key: string]: never }>;

export type GetKnowledgeBasesQuery = {
  __typename?: 'Query';
  knowledgeBases: Array<{ __typename?: 'KnowledgeBase'; id: string; title: string }>;
};

export type GetKnowledgeBaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetKnowledgeBaseQuery = {
  __typename?: 'Query';
  knowledgeBase?:
    | {
        __typename?: 'KnowledgeBase';
        id: string;
        title: string;
        documents: Array<{
          __typename?: 'KnowledgeBaseDocument';
          id: string;
          title: string;
          createdAt: Date;
          updatedAt: Date;
          createdBy: { __typename?: 'AgencyUser'; name: string };
          indexingStatus: {
            __typename?: 'KnowledgeBaseDocumentIndexingStatus';
            status: IndexingStatus;
            error?: string | null | undefined;
            progress?: number | null | undefined;
            startedAt?: Date | null | undefined;
            completedAt?: Date | null | undefined;
          };
          file?:
            | {
                __typename?: 'KnowledgeBaseDocumentFile';
                mimeType: string;
                name: string;
                size: number;
                url?: string | null | undefined;
              }
            | null
            | undefined;
          metadata?:
            | {
                __typename?: 'KnowledgeBaseDocumentMetadata';
                title: string;
                summary: string;
                purpose: string;
              }
            | null
            | undefined;
          text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
        }>;
      }
    | null
    | undefined;
};

export type GetKnowledgeBaseDocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetKnowledgeBaseDocumentQuery = {
  __typename?: 'Query';
  knowledgeBaseDocument?:
    | {
        __typename?: 'KnowledgeBaseDocument';
        id: string;
        title: string;
        createdAt: Date;
        updatedAt: Date;
        file?:
          | {
              __typename?: 'KnowledgeBaseDocumentFile';
              mimeType: string;
              name: string;
              size: number;
              url?: string | null | undefined;
            }
          | null
          | undefined;
        text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
        createdBy: { __typename?: 'AgencyUser'; name: string };
        indexingStatus: {
          __typename?: 'KnowledgeBaseDocumentIndexingStatus';
          status: IndexingStatus;
          error?: string | null | undefined;
          progress?: number | null | undefined;
          startedAt?: Date | null | undefined;
          completedAt?: Date | null | undefined;
        };
        metadata?:
          | {
              __typename?: 'KnowledgeBaseDocumentMetadata';
              title: string;
              summary: string;
              purpose: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateKnowledgeBaseTextDocumentMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  input: CreateKnowledgeBaseTextDocumentInput;
}>;

export type CreateKnowledgeBaseTextDocumentMutation = {
  __typename?: 'Mutation';
  createKnowledgeBaseTextDocument: {
    __typename?: 'KnowledgeBaseDocument';
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    file?:
      | {
          __typename?: 'KnowledgeBaseDocumentFile';
          mimeType: string;
          name: string;
          size: number;
          url?: string | null | undefined;
        }
      | null
      | undefined;
    text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
    createdBy: { __typename?: 'AgencyUser'; name: string };
    indexingStatus: {
      __typename?: 'KnowledgeBaseDocumentIndexingStatus';
      status: IndexingStatus;
      error?: string | null | undefined;
      progress?: number | null | undefined;
      startedAt?: Date | null | undefined;
      completedAt?: Date | null | undefined;
    };
    metadata?:
      | {
          __typename?: 'KnowledgeBaseDocumentMetadata';
          title: string;
          summary: string;
          purpose: string;
        }
      | null
      | undefined;
  };
};

export type UploadKnowledgeBaseFileDocumentMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  input: UploadKnowledgeBaseFileDocumentInput;
}>;

export type UploadKnowledgeBaseFileDocumentMutation = {
  __typename?: 'Mutation';
  uploadKnowledgeBaseFileDocument: Array<{
    __typename?: 'KnowledgeBaseDocument';
    id: string;
    title: string;
    createdAt: Date;
    updatedAt: Date;
    file?:
      | {
          __typename?: 'KnowledgeBaseDocumentFile';
          mimeType: string;
          name: string;
          size: number;
          url?: string | null | undefined;
        }
      | null
      | undefined;
    text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
    createdBy: { __typename?: 'AgencyUser'; name: string };
    indexingStatus: {
      __typename?: 'KnowledgeBaseDocumentIndexingStatus';
      status: IndexingStatus;
      error?: string | null | undefined;
      progress?: number | null | undefined;
      startedAt?: Date | null | undefined;
      completedAt?: Date | null | undefined;
    };
    metadata?:
      | {
          __typename?: 'KnowledgeBaseDocumentMetadata';
          title: string;
          summary: string;
          purpose: string;
        }
      | null
      | undefined;
  }>;
};

export type UpdateKnowledgeBaseDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseDocumentInput;
}>;

export type UpdateKnowledgeBaseDocumentMutation = {
  __typename?: 'Mutation';
  updateKnowledgeBaseDocument?:
    | {
        __typename?: 'KnowledgeBaseDocument';
        id: string;
        title: string;
        createdAt: Date;
        updatedAt: Date;
        file?:
          | {
              __typename?: 'KnowledgeBaseDocumentFile';
              mimeType: string;
              name: string;
              size: number;
              url?: string | null | undefined;
            }
          | null
          | undefined;
        text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
        createdBy: { __typename?: 'AgencyUser'; name: string };
        indexingStatus: {
          __typename?: 'KnowledgeBaseDocumentIndexingStatus';
          status: IndexingStatus;
          error?: string | null | undefined;
          progress?: number | null | undefined;
          startedAt?: Date | null | undefined;
          completedAt?: Date | null | undefined;
        };
        metadata?:
          | {
              __typename?: 'KnowledgeBaseDocumentMetadata';
              title: string;
              summary: string;
              purpose: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteKnowledgeBaseDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteKnowledgeBaseDocumentMutation = {
  __typename?: 'Mutation';
  deleteKnowledgeBaseDocument?:
    | {
        __typename?: 'KnowledgeBaseDocument';
        id: string;
        title: string;
        createdAt: Date;
        updatedAt: Date;
        file?:
          | {
              __typename?: 'KnowledgeBaseDocumentFile';
              mimeType: string;
              name: string;
              size: number;
              url?: string | null | undefined;
            }
          | null
          | undefined;
        text?: { __typename?: 'KnowledgeBaseDocumentText'; content: string } | null | undefined;
        createdBy: { __typename?: 'AgencyUser'; name: string };
        indexingStatus: {
          __typename?: 'KnowledgeBaseDocumentIndexingStatus';
          status: IndexingStatus;
          error?: string | null | undefined;
          progress?: number | null | undefined;
          startedAt?: Date | null | undefined;
          completedAt?: Date | null | undefined;
        };
        metadata?:
          | {
              __typename?: 'KnowledgeBaseDocumentMetadata';
              title: string;
              summary: string;
              purpose: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PolicyExplorerConversationMessageFieldsFragment = {
  __typename?: 'PolicyExplorerConversationMessage';
  content: string;
  id: string;
  role: PolicyExplorerConversationMessageRole;
  timestamp: Date;
  attachments: Array<{
    __typename?: 'PolicyExplorerConversationMessageAttachment';
    content: string;
    type: PolicyExplorerConversationMessageAttachmentType;
  }>;
};

export type GetPolicyExplorerConversationQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;

export type GetPolicyExplorerConversationQuery = {
  __typename?: 'Query';
  policyExplorerConversation: Array<{
    __typename?: 'PolicyExplorerConversationMessage';
    content: string;
    id: string;
    role: PolicyExplorerConversationMessageRole;
    timestamp: Date;
    attachments: Array<{
      __typename?: 'PolicyExplorerConversationMessageAttachment';
      content: string;
      type: PolicyExplorerConversationMessageAttachmentType;
    }>;
  }>;
};

export type AddPolicyExplorerConversationMessageMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;

export type AddPolicyExplorerConversationMessageMutation = {
  __typename?: 'Mutation';
  addPolicyExplorerConversationMessage: Array<{
    __typename?: 'PolicyExplorerConversationMessage';
    content: string;
    id: string;
    role: PolicyExplorerConversationMessageRole;
    timestamp: Date;
    attachments: Array<{
      __typename?: 'PolicyExplorerConversationMessageAttachment';
      content: string;
      type: PolicyExplorerConversationMessageAttachmentType;
    }>;
  }>;
};

export type ServiceRequestFieldsFragment = {
  __typename?: 'ServiceRequest';
  id: string;
  type: ServiceRequestType;
  state: ServiceRequestState;
  clientEmail?: string | null | undefined;
  clientName?: string | null | undefined;
  clientPhone?: string | null | undefined;
  details: string;
  dueAt?: Date | null | undefined;
  createdAt: Date;
  updatedAt: Date;
  account?:
    | {
        __typename?: 'Account';
        type: AccountType;
        account:
          | { __typename?: 'BusinessAccount'; name: string }
          | { __typename?: 'IndividualAccount'; name: string };
      }
    | null
    | undefined;
  assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
  addAdditionalInsured?:
    | {
        __typename?: 'AddAdditionalInsuredRequest';
        name: string;
        relationship: string;
        address: {
          __typename?: 'Address';
          line1: string;
          city: string;
          zone: string;
          postalCode: string;
        };
      }
    | null
    | undefined;
  businessPolicy?:
    | {
        __typename?: 'BusinessPolicy';
        id: string;
        type: InsuranceType;
        carrier: { __typename?: 'InsuranceCarrier'; name: string };
      }
    | null
    | undefined;
  cancelPolicy?:
    | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
    | null
    | undefined;
  createCertificate?:
    | {
        __typename?: 'CreateCertificateRequest';
        name: string;
        additionalInsured: boolean;
        additionalInsuredRelationship?: string | null | undefined;
        additionalInsuredRelationshipDescription?: string | null | undefined;
        address: {
          __typename?: 'Address';
          line1: string;
          city: string;
          zone: string;
          postalCode: string;
        };
      }
    | null
    | undefined;
  documentRequest?:
    | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
    | null
    | undefined;
  endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
  question?:
    | {
        __typename?: 'QuestionRequest';
        policyId?: string | null | undefined;
        question: string;
        type: QuestionRequestType;
      }
    | null
    | undefined;
  resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
};

export type ServiceRequestCallFieldsFragment = {
  __typename?: 'ServiceRequest';
  calls: Array<{
    __typename?: 'Call';
    id: string;
    disconnectionReason?: CallDisconnectionReason | null | undefined;
    endedAt?: Date | null | undefined;
    fromName?: string | null | undefined;
    fromNumber: string;
    startedAt: Date;
    status: CallStatus;
    recordingUrl?: string | null | undefined;
    sentiment?: CallSentiment | null | undefined;
    successful?: boolean | null | undefined;
    summary?: string | null | undefined;
    account?:
      | {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    serviceRequests: Array<{
      __typename?: 'ServiceRequest';
      id: string;
      type: ServiceRequestType;
      state: ServiceRequestState;
      clientEmail?: string | null | undefined;
      clientName?: string | null | undefined;
      clientPhone?: string | null | undefined;
      details: string;
      dueAt?: Date | null | undefined;
      createdAt: Date;
      updatedAt: Date;
      account?:
        | {
            __typename?: 'Account';
            type: AccountType;
            account:
              | { __typename?: 'BusinessAccount'; name: string }
              | { __typename?: 'IndividualAccount'; name: string };
          }
        | null
        | undefined;
      assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
      addAdditionalInsured?:
        | {
            __typename?: 'AddAdditionalInsuredRequest';
            name: string;
            relationship: string;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      businessPolicy?:
        | {
            __typename?: 'BusinessPolicy';
            id: string;
            type: InsuranceType;
            carrier: { __typename?: 'InsuranceCarrier'; name: string };
          }
        | null
        | undefined;
      cancelPolicy?:
        | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
        | null
        | undefined;
      createCertificate?:
        | {
            __typename?: 'CreateCertificateRequest';
            name: string;
            additionalInsured: boolean;
            additionalInsuredRelationship?: string | null | undefined;
            additionalInsuredRelationshipDescription?: string | null | undefined;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      documentRequest?:
        | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
        | null
        | undefined;
      endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
      question?:
        | {
            __typename?: 'QuestionRequest';
            policyId?: string | null | undefined;
            question: string;
            type: QuestionRequestType;
          }
        | null
        | undefined;
      resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
    }>;
    transcript: Array<{
      __typename?: 'CallTranscriptObject';
      role: CallTranscriptRole;
      content: string;
      toolCallId?: string | null | undefined;
      toolName?: string | null | undefined;
      toolArgumentsJson?: string | null | undefined;
    }>;
  }>;
  comments: Array<{
    __typename?: 'ServiceRequestComment';
    id: string;
    content: string;
    createdAt: Date;
    agencyUser: { __typename?: 'AgencyUser'; name: string };
  }>;
  emailThreads: Array<{
    __typename?: 'EmailThread';
    fromEmail: string;
    fromName: string;
    id: string;
    state: EmailThreadState;
    subject: string;
    waitingFor?: EmailSenderRole | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    summary: string;
    account?:
      | {
          __typename?: 'Account';
          id: string;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    attachments: Array<{
      __typename?: 'File';
      id: string;
      name: string;
      url?: string | null | undefined;
    }>;
    participantEmails: Array<{
      __typename?: 'Email';
      body: string;
      id: string;
      senderRole: EmailSenderRole;
      sentAt: Date;
      subject: string;
      from: { __typename?: 'EmailParticipant'; name: string; email: string };
      to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
    }>;
    serviceRequests: Array<{
      __typename?: 'ServiceRequest';
      id: string;
      type: ServiceRequestType;
      state: ServiceRequestState;
      clientEmail?: string | null | undefined;
      clientName?: string | null | undefined;
      clientPhone?: string | null | undefined;
      details: string;
      dueAt?: Date | null | undefined;
      createdAt: Date;
      updatedAt: Date;
      account?:
        | {
            __typename?: 'Account';
            type: AccountType;
            account:
              | { __typename?: 'BusinessAccount'; name: string }
              | { __typename?: 'IndividualAccount'; name: string };
          }
        | null
        | undefined;
      assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
      addAdditionalInsured?:
        | {
            __typename?: 'AddAdditionalInsuredRequest';
            name: string;
            relationship: string;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      businessPolicy?:
        | {
            __typename?: 'BusinessPolicy';
            id: string;
            type: InsuranceType;
            carrier: { __typename?: 'InsuranceCarrier'; name: string };
          }
        | null
        | undefined;
      cancelPolicy?:
        | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
        | null
        | undefined;
      createCertificate?:
        | {
            __typename?: 'CreateCertificateRequest';
            name: string;
            additionalInsured: boolean;
            additionalInsuredRelationship?: string | null | undefined;
            additionalInsuredRelationshipDescription?: string | null | undefined;
            address: {
              __typename?: 'Address';
              line1: string;
              city: string;
              zone: string;
              postalCode: string;
            };
          }
        | null
        | undefined;
      documentRequest?:
        | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
        | null
        | undefined;
      endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
      question?:
        | {
            __typename?: 'QuestionRequest';
            policyId?: string | null | undefined;
            question: string;
            type: QuestionRequestType;
          }
        | null
        | undefined;
      resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
    }>;
    workspace?:
      | { __typename?: 'CaraWorkspace'; id: string; title: string; state: CaraWorkspaceState }
      | null
      | undefined;
  }>;
  versionHistory?:
    | Array<{
        __typename?: 'ServiceRequestVersion';
        createdAt: Date;
        version: number;
        updateTypes: Array<ServiceRequestUpdateType>;
        updateInitiatorType: UpdateInitiatorType;
        updateInitiatorId: string;
        serviceRequest: {
          __typename?: 'ServiceRequest';
          dueAt?: Date | null | undefined;
          assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
          resolution?:
            | { __typename?: 'ServiceRequestResolution'; notes: string }
            | null
            | undefined;
        };
      }>
    | null
    | undefined;
};

export type GetServiceRequestsQueryVariables = Exact<{ [key: string]: never }>;

export type GetServiceRequestsQuery = {
  __typename?: 'Query';
  serviceRequests: Array<{
    __typename?: 'ServiceRequest';
    id: string;
    type: ServiceRequestType;
    state: ServiceRequestState;
    clientEmail?: string | null | undefined;
    clientName?: string | null | undefined;
    clientPhone?: string | null | undefined;
    details: string;
    dueAt?: Date | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          type: AccountType;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
    addAdditionalInsured?:
      | {
          __typename?: 'AddAdditionalInsuredRequest';
          name: string;
          relationship: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    businessPolicy?:
      | {
          __typename?: 'BusinessPolicy';
          id: string;
          type: InsuranceType;
          carrier: { __typename?: 'InsuranceCarrier'; name: string };
        }
      | null
      | undefined;
    cancelPolicy?:
      | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
      | null
      | undefined;
    createCertificate?:
      | {
          __typename?: 'CreateCertificateRequest';
          name: string;
          additionalInsured: boolean;
          additionalInsuredRelationship?: string | null | undefined;
          additionalInsuredRelationshipDescription?: string | null | undefined;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    documentRequest?:
      | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
      | null
      | undefined;
    endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
    question?:
      | {
          __typename?: 'QuestionRequest';
          policyId?: string | null | undefined;
          question: string;
          type: QuestionRequestType;
        }
      | null
      | undefined;
    resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
  }>;
};

export type GetServiceRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetServiceRequestQuery = {
  __typename?: 'Query';
  serviceRequest?:
    | {
        __typename?: 'ServiceRequest';
        id: string;
        type: ServiceRequestType;
        state: ServiceRequestState;
        clientEmail?: string | null | undefined;
        clientName?: string | null | undefined;
        clientPhone?: string | null | undefined;
        details: string;
        dueAt?: Date | null | undefined;
        createdAt: Date;
        updatedAt: Date;
        account?:
          | {
              __typename?: 'Account';
              type: AccountType;
              account:
                | { __typename?: 'BusinessAccount'; name: string }
                | { __typename?: 'IndividualAccount'; name: string };
            }
          | null
          | undefined;
        assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
        addAdditionalInsured?:
          | {
              __typename?: 'AddAdditionalInsuredRequest';
              name: string;
              relationship: string;
              address: {
                __typename?: 'Address';
                line1: string;
                city: string;
                zone: string;
                postalCode: string;
              };
            }
          | null
          | undefined;
        businessPolicy?:
          | {
              __typename?: 'BusinessPolicy';
              id: string;
              type: InsuranceType;
              carrier: { __typename?: 'InsuranceCarrier'; name: string };
            }
          | null
          | undefined;
        cancelPolicy?:
          | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
          | null
          | undefined;
        createCertificate?:
          | {
              __typename?: 'CreateCertificateRequest';
              name: string;
              additionalInsured: boolean;
              additionalInsuredRelationship?: string | null | undefined;
              additionalInsuredRelationshipDescription?: string | null | undefined;
              address: {
                __typename?: 'Address';
                line1: string;
                city: string;
                zone: string;
                postalCode: string;
              };
            }
          | null
          | undefined;
        documentRequest?:
          | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
          | null
          | undefined;
        endorsePolicy?:
          | { __typename?: 'EndorsePolicyRequest'; policyId: string }
          | null
          | undefined;
        question?:
          | {
              __typename?: 'QuestionRequest';
              policyId?: string | null | undefined;
              question: string;
              type: QuestionRequestType;
            }
          | null
          | undefined;
        resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
        calls: Array<{
          __typename?: 'Call';
          id: string;
          disconnectionReason?: CallDisconnectionReason | null | undefined;
          endedAt?: Date | null | undefined;
          fromName?: string | null | undefined;
          fromNumber: string;
          startedAt: Date;
          status: CallStatus;
          recordingUrl?: string | null | undefined;
          sentiment?: CallSentiment | null | undefined;
          successful?: boolean | null | undefined;
          summary?: string | null | undefined;
          account?:
            | {
                __typename?: 'Account';
                id: string;
                account:
                  | { __typename?: 'BusinessAccount'; name: string }
                  | { __typename?: 'IndividualAccount'; name: string };
              }
            | null
            | undefined;
          serviceRequests: Array<{
            __typename?: 'ServiceRequest';
            id: string;
            type: ServiceRequestType;
            state: ServiceRequestState;
            clientEmail?: string | null | undefined;
            clientName?: string | null | undefined;
            clientPhone?: string | null | undefined;
            details: string;
            dueAt?: Date | null | undefined;
            createdAt: Date;
            updatedAt: Date;
            account?:
              | {
                  __typename?: 'Account';
                  type: AccountType;
                  account:
                    | { __typename?: 'BusinessAccount'; name: string }
                    | { __typename?: 'IndividualAccount'; name: string };
                }
              | null
              | undefined;
            assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
            addAdditionalInsured?:
              | {
                  __typename?: 'AddAdditionalInsuredRequest';
                  name: string;
                  relationship: string;
                  address: {
                    __typename?: 'Address';
                    line1: string;
                    city: string;
                    zone: string;
                    postalCode: string;
                  };
                }
              | null
              | undefined;
            businessPolicy?:
              | {
                  __typename?: 'BusinessPolicy';
                  id: string;
                  type: InsuranceType;
                  carrier: { __typename?: 'InsuranceCarrier'; name: string };
                }
              | null
              | undefined;
            cancelPolicy?:
              | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
              | null
              | undefined;
            createCertificate?:
              | {
                  __typename?: 'CreateCertificateRequest';
                  name: string;
                  additionalInsured: boolean;
                  additionalInsuredRelationship?: string | null | undefined;
                  additionalInsuredRelationshipDescription?: string | null | undefined;
                  address: {
                    __typename?: 'Address';
                    line1: string;
                    city: string;
                    zone: string;
                    postalCode: string;
                  };
                }
              | null
              | undefined;
            documentRequest?:
              | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
              | null
              | undefined;
            endorsePolicy?:
              | { __typename?: 'EndorsePolicyRequest'; policyId: string }
              | null
              | undefined;
            question?:
              | {
                  __typename?: 'QuestionRequest';
                  policyId?: string | null | undefined;
                  question: string;
                  type: QuestionRequestType;
                }
              | null
              | undefined;
            resolution?:
              | { __typename?: 'ServiceRequestResolution'; notes: string }
              | null
              | undefined;
          }>;
          transcript: Array<{
            __typename?: 'CallTranscriptObject';
            role: CallTranscriptRole;
            content: string;
            toolCallId?: string | null | undefined;
            toolName?: string | null | undefined;
            toolArgumentsJson?: string | null | undefined;
          }>;
        }>;
        comments: Array<{
          __typename?: 'ServiceRequestComment';
          id: string;
          content: string;
          createdAt: Date;
          agencyUser: { __typename?: 'AgencyUser'; name: string };
        }>;
        emailThreads: Array<{
          __typename?: 'EmailThread';
          fromEmail: string;
          fromName: string;
          id: string;
          state: EmailThreadState;
          subject: string;
          waitingFor?: EmailSenderRole | null | undefined;
          createdAt: Date;
          updatedAt: Date;
          summary: string;
          account?:
            | {
                __typename?: 'Account';
                id: string;
                account:
                  | { __typename?: 'BusinessAccount'; name: string }
                  | { __typename?: 'IndividualAccount'; name: string };
              }
            | null
            | undefined;
          attachments: Array<{
            __typename?: 'File';
            id: string;
            name: string;
            url?: string | null | undefined;
          }>;
          participantEmails: Array<{
            __typename?: 'Email';
            body: string;
            id: string;
            senderRole: EmailSenderRole;
            sentAt: Date;
            subject: string;
            from: { __typename?: 'EmailParticipant'; name: string; email: string };
            to: Array<{ __typename?: 'EmailParticipant'; name: string; email: string }>;
          }>;
          serviceRequests: Array<{
            __typename?: 'ServiceRequest';
            id: string;
            type: ServiceRequestType;
            state: ServiceRequestState;
            clientEmail?: string | null | undefined;
            clientName?: string | null | undefined;
            clientPhone?: string | null | undefined;
            details: string;
            dueAt?: Date | null | undefined;
            createdAt: Date;
            updatedAt: Date;
            account?:
              | {
                  __typename?: 'Account';
                  type: AccountType;
                  account:
                    | { __typename?: 'BusinessAccount'; name: string }
                    | { __typename?: 'IndividualAccount'; name: string };
                }
              | null
              | undefined;
            assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
            addAdditionalInsured?:
              | {
                  __typename?: 'AddAdditionalInsuredRequest';
                  name: string;
                  relationship: string;
                  address: {
                    __typename?: 'Address';
                    line1: string;
                    city: string;
                    zone: string;
                    postalCode: string;
                  };
                }
              | null
              | undefined;
            businessPolicy?:
              | {
                  __typename?: 'BusinessPolicy';
                  id: string;
                  type: InsuranceType;
                  carrier: { __typename?: 'InsuranceCarrier'; name: string };
                }
              | null
              | undefined;
            cancelPolicy?:
              | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
              | null
              | undefined;
            createCertificate?:
              | {
                  __typename?: 'CreateCertificateRequest';
                  name: string;
                  additionalInsured: boolean;
                  additionalInsuredRelationship?: string | null | undefined;
                  additionalInsuredRelationshipDescription?: string | null | undefined;
                  address: {
                    __typename?: 'Address';
                    line1: string;
                    city: string;
                    zone: string;
                    postalCode: string;
                  };
                }
              | null
              | undefined;
            documentRequest?:
              | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
              | null
              | undefined;
            endorsePolicy?:
              | { __typename?: 'EndorsePolicyRequest'; policyId: string }
              | null
              | undefined;
            question?:
              | {
                  __typename?: 'QuestionRequest';
                  policyId?: string | null | undefined;
                  question: string;
                  type: QuestionRequestType;
                }
              | null
              | undefined;
            resolution?:
              | { __typename?: 'ServiceRequestResolution'; notes: string }
              | null
              | undefined;
          }>;
          workspace?:
            | { __typename?: 'CaraWorkspace'; id: string; title: string; state: CaraWorkspaceState }
            | null
            | undefined;
        }>;
        versionHistory?:
          | Array<{
              __typename?: 'ServiceRequestVersion';
              createdAt: Date;
              version: number;
              updateTypes: Array<ServiceRequestUpdateType>;
              updateInitiatorType: UpdateInitiatorType;
              updateInitiatorId: string;
              serviceRequest: {
                __typename?: 'ServiceRequest';
                dueAt?: Date | null | undefined;
                assignee?:
                  | { __typename?: 'AgencyUser'; id: string; name: string }
                  | null
                  | undefined;
                resolution?:
                  | { __typename?: 'ServiceRequestResolution'; notes: string }
                  | null
                  | undefined;
              };
            }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ResolveServiceRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ResolveServiceRequestInput;
}>;

export type ResolveServiceRequestMutation = {
  __typename?: 'Mutation';
  resolveServiceRequest: {
    __typename?: 'ServiceRequest';
    id: string;
    type: ServiceRequestType;
    state: ServiceRequestState;
    clientEmail?: string | null | undefined;
    clientName?: string | null | undefined;
    clientPhone?: string | null | undefined;
    details: string;
    dueAt?: Date | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          type: AccountType;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
    addAdditionalInsured?:
      | {
          __typename?: 'AddAdditionalInsuredRequest';
          name: string;
          relationship: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    businessPolicy?:
      | {
          __typename?: 'BusinessPolicy';
          id: string;
          type: InsuranceType;
          carrier: { __typename?: 'InsuranceCarrier'; name: string };
        }
      | null
      | undefined;
    cancelPolicy?:
      | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
      | null
      | undefined;
    createCertificate?:
      | {
          __typename?: 'CreateCertificateRequest';
          name: string;
          additionalInsured: boolean;
          additionalInsuredRelationship?: string | null | undefined;
          additionalInsuredRelationshipDescription?: string | null | undefined;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    documentRequest?:
      | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
      | null
      | undefined;
    endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
    question?:
      | {
          __typename?: 'QuestionRequest';
          policyId?: string | null | undefined;
          question: string;
          type: QuestionRequestType;
        }
      | null
      | undefined;
    resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
  };
};

export type UpdateServiceRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateServiceRequestInput;
}>;

export type UpdateServiceRequestMutation = {
  __typename?: 'Mutation';
  updateServiceRequest: {
    __typename?: 'ServiceRequest';
    id: string;
    type: ServiceRequestType;
    state: ServiceRequestState;
    clientEmail?: string | null | undefined;
    clientName?: string | null | undefined;
    clientPhone?: string | null | undefined;
    details: string;
    dueAt?: Date | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          type: AccountType;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
    addAdditionalInsured?:
      | {
          __typename?: 'AddAdditionalInsuredRequest';
          name: string;
          relationship: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    businessPolicy?:
      | {
          __typename?: 'BusinessPolicy';
          id: string;
          type: InsuranceType;
          carrier: { __typename?: 'InsuranceCarrier'; name: string };
        }
      | null
      | undefined;
    cancelPolicy?:
      | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
      | null
      | undefined;
    createCertificate?:
      | {
          __typename?: 'CreateCertificateRequest';
          name: string;
          additionalInsured: boolean;
          additionalInsuredRelationship?: string | null | undefined;
          additionalInsuredRelationshipDescription?: string | null | undefined;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    documentRequest?:
      | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
      | null
      | undefined;
    endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
    question?:
      | {
          __typename?: 'QuestionRequest';
          policyId?: string | null | undefined;
          question: string;
          type: QuestionRequestType;
        }
      | null
      | undefined;
    resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
  };
};

export type AddServiceRequestCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AddServiceRequestCommentInput;
}>;

export type AddServiceRequestCommentMutation = {
  __typename?: 'Mutation';
  addServiceRequestComment: {
    __typename?: 'ServiceRequest';
    id: string;
    type: ServiceRequestType;
    state: ServiceRequestState;
    clientEmail?: string | null | undefined;
    clientName?: string | null | undefined;
    clientPhone?: string | null | undefined;
    details: string;
    dueAt?: Date | null | undefined;
    createdAt: Date;
    updatedAt: Date;
    account?:
      | {
          __typename?: 'Account';
          type: AccountType;
          account:
            | { __typename?: 'BusinessAccount'; name: string }
            | { __typename?: 'IndividualAccount'; name: string };
        }
      | null
      | undefined;
    assignee?: { __typename?: 'AgencyUser'; id: string; name: string } | null | undefined;
    addAdditionalInsured?:
      | {
          __typename?: 'AddAdditionalInsuredRequest';
          name: string;
          relationship: string;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    businessPolicy?:
      | {
          __typename?: 'BusinessPolicy';
          id: string;
          type: InsuranceType;
          carrier: { __typename?: 'InsuranceCarrier'; name: string };
        }
      | null
      | undefined;
    cancelPolicy?:
      | { __typename?: 'CancelPolicyRequest'; policyId: string; reason: string }
      | null
      | undefined;
    createCertificate?:
      | {
          __typename?: 'CreateCertificateRequest';
          name: string;
          additionalInsured: boolean;
          additionalInsuredRelationship?: string | null | undefined;
          additionalInsuredRelationshipDescription?: string | null | undefined;
          address: {
            __typename?: 'Address';
            line1: string;
            city: string;
            zone: string;
            postalCode: string;
          };
        }
      | null
      | undefined;
    documentRequest?:
      | { __typename?: 'DocumentRequest'; type: DocumentRequestType }
      | null
      | undefined;
    endorsePolicy?: { __typename?: 'EndorsePolicyRequest'; policyId: string } | null | undefined;
    question?:
      | {
          __typename?: 'QuestionRequest';
          policyId?: string | null | undefined;
          question: string;
          type: QuestionRequestType;
        }
      | null
      | undefined;
    resolution?: { __typename?: 'ServiceRequestResolution'; notes: string } | null | undefined;
  };
};

export const AccountFieldsFragmentDoc = gql`
  fragment AccountFields on Account {
    account {
      email
      mailingAddress {
        line1
        line2
        city
        zone
        postalCode
      }
      name
      phone
      ... on BusinessAccount {
        dba
        website
      }
    }
    createdAt
    id
    type
  }
`;
export const BusinessApplicationFieldsFragmentDoc = gql`
  fragment BusinessApplicationFields on BusinessApplication {
    annualRevenue
    businessDba
    businessName
    contact {
      fullName
      email
      phone
    }
    employeeInfo {
      numFullTimeEmployees
      numPartTimeEmployees
      totalEmployeePayroll
    }
    fein
    id
    insuranceEffectiveAt
    insuranceTypes
    legalEntityType
    locations {
      id
      address {
        line1
        line2
        city
        zone
        postalCode
      }
      buildingInfo {
        annualSales
        areaOccupiedByBusiness
        buildingCoverage
        burglarAlarmType
        constructionType
        ownershipType
        personalPropertyCoverage
        sprinkleredPercentage
        totalArea
        totalStories
        yearBuilt
      }
      employeeInfo {
        numPartTimeEmployees
        numFullTimeEmployees
        totalEmployeePayroll
        jobCode
      }
      isPrimary
    }
    mailingAddress {
      line1
      line2
      city
      zone
      postalCode
    }
    naicsCode
    owners {
      fullName
      annualPayroll
      dateOfBirth
      jobCode
    }
    pastPolicyLosses {
      claimDate
      claimStatus
      lossDate
      lossDescription
      lossState
      lossType
      policyEffectiveDate
      policyExpirationDate
      policyType
      totalPaidAmount
      totalReservedAmount
    }
    selectedCarriers
    selectedLimits {
      coverageState
      wcPerAccidentLimit
      wcPerDiseaseEmployeeLimit
      wcPerDiseasePolicyLimit
      glPerOccurrenceLimit
      glAggregateLimit
      bopPerOccurrenceLimit
      bopAggregateLimit
      cyberRetentionLimit
      cyberAggregateLimit
    }
    state
    underwritingAnswers {
      answer
      locationId
      questionId
    }
    underwritingQuestions {
      id
      answerOptions {
        displayText
        value
      }
      carriers
      defaultAnswer
      dependentQuestions {
        condition
        dependentQuestionIds
        type
      }
      hasParentQuestion
      locationId
      question
      tooltip
      type
    }
    underwritingStatements {
      carrier
      markdown
    }
    yearOfFounding
    yearsOfManagementExperience
  }
`;
export const AccountBusinessApplicationFieldsFragmentDoc = gql`
  fragment AccountBusinessApplicationFields on Account {
    businessApplications {
      ...BusinessApplicationFields
    }
  }
  ${BusinessApplicationFieldsFragmentDoc}
`;
export const BusinessPolicyFieldsFragmentDoc = gql`
  fragment BusinessPolicyFields on BusinessPolicy {
    account {
      account {
        email
        name
      }
      id
    }
    carrier {
      id
      name
    }
    expiresAt
    id
    inforceAt
    issuedAt
    policyNumber
    state
    type
  }
`;
export const AccountBusinessPolicyFieldsFragmentDoc = gql`
  fragment AccountBusinessPolicyFields on Account {
    businessPolicies {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;
export const CertificateOfLiabilityInsuranceFieldsFragmentDoc = gql`
  fragment CertificateOfLiabilityInsuranceFields on CertificateOfLiabilityInsurance {
    id
    certificateNumber
    holder {
      name
      address {
        line1
        city
        zone
        postalCode
      }
    }
    viewUrl
    downloadUrl
    createdAt
  }
`;
export const AccountCertificateOfLiabilityInsuranceFieldsFragmentDoc = gql`
  fragment AccountCertificateOfLiabilityInsuranceFields on Account {
    certificatesOfLiabilityInsurance {
      ...CertificateOfLiabilityInsuranceFields
    }
  }
  ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}
`;
export const ContactFieldsFragmentDoc = gql`
  fragment ContactFields on AccountContact {
    email
    id
    name
    phone
  }
`;
export const AccountContactFieldsFragmentDoc = gql`
  fragment AccountContactFields on Account {
    contacts {
      ...ContactFields
    }
  }
  ${ContactFieldsFragmentDoc}
`;
export const ServiceRequestFieldsFragmentDoc = gql`
  fragment ServiceRequestFields on ServiceRequest {
    id
    type
    state
    clientEmail
    clientName
    clientPhone
    details
    account {
      type
      account {
        name
      }
    }
    assignee {
      id
      name
    }
    dueAt
    addAdditionalInsured {
      address {
        line1
        city
        zone
        postalCode
      }
      name
      relationship
    }
    businessPolicy {
      id
      type
      carrier {
        name
      }
    }
    cancelPolicy {
      policyId
      reason
    }
    createCertificate {
      name
      address {
        line1
        city
        zone
        postalCode
      }
      additionalInsured
      additionalInsuredRelationship
      additionalInsuredRelationshipDescription
    }
    documentRequest {
      type
    }
    endorsePolicy {
      policyId
    }
    question {
      policyId
      question
      type
    }
    resolution {
      notes
    }
    createdAt
    updatedAt
  }
`;
export const AccountServiceRequestFieldsFragmentDoc = gql`
  fragment AccountServiceRequestFields on Account {
    serviceRequests {
      ...ServiceRequestFields
    }
  }
  ${ServiceRequestFieldsFragmentDoc}
`;
export const AgencyUserFieldsFragmentDoc = gql`
  fragment AgencyUserFields on AgencyUser {
    id
    email
    name
    state
  }
`;
export const AgencySubscriptionFieldsFragmentDoc = gql`
  fragment AgencySubscriptionFields on AgencySubscription {
    nextBillingAmount
    nextBillingDate
    numSeats
    numSeatsActive
    period
    plan
    state
    trialEndDate
  }
`;
export const AgencyFieldsFragmentDoc = gql`
  fragment AgencyFields on Agency {
    id
    name
    subscription {
      ...AgencySubscriptionFields
    }
  }
  ${AgencySubscriptionFieldsFragmentDoc}
`;
export const LoggedInAgencyUserFieldsFragmentDoc = gql`
  fragment LoggedInAgencyUserFields on AgencyUser {
    ...AgencyUserFields
    preferences {
      favoritePresets {
        presets
        customPresets {
          id
          title
          description
        }
      }
    }
    agency {
      ...AgencyFields
    }
  }
  ${AgencyUserFieldsFragmentDoc}
  ${AgencyFieldsFragmentDoc}
`;
export const AgencySignInFieldsFragmentDoc = gql`
  fragment AgencySignInFields on AgencySignInResponse {
    agencyUser {
      id
      email
      name
      agency {
        id
        name
      }
    }
  }
`;
export const BusinessPolicyDetailFieldsFragmentDoc = gql`
  fragment BusinessPolicyDetailFields on BusinessPolicy {
    account {
      contacts {
        ...ContactFields
      }
    }
    agencyUser {
      id
      name
    }
    broker {
      id
      name
    }
    cancellation {
      canceledAt
      canceledBy
      effectiveAt
      type
      reason
      reasonDescription
      returnCommission
      returnPremium
    }
    details {
      blanketAdditionalInsureds {
        type
        description
      }
      carrier {
        name
        address {
          line1
          line2
          city
          zone
          postalCode
        }
      }
      coverageDescriptions {
        description
        policyQuotes
        title
      }
      deductible
      exclusionDescriptions {
        description
        policyQuotes
        title
      }
      extraLimits {
        limit
        name
      }
      insured {
        name
        address {
          line1
          line2
          city
          zone
          postalCode
        }
      }
      limits {
        cyberAggregateLimit
        cyberRetentionLimit
        glAggregateLimit
        glMedicalPerOccurrenceLimit
        glMedicalPerPersonLimit
        glPerOccurrenceLimit
        glPersonalAndAdvertisingInjuryLimit
        glProductsAndCompletedOperationsLimit
        glRentedPremisesDamageLimit
        propertyBuildingLimit
        propertyContentsLimit
        umbrellaOrExcessAggregateLimit
        umbrellaOrExcessPerOccurrenceLimit
        wcPerAccidentLimit
        wcPerDiseaseEmployeeLimit
        wcPerDiseasePolicyLimit
      }
      locations {
        address {
          line1
          line2
          city
          zone
          postalCode
        }
        limits {
          cyberAggregateLimit
          cyberRetentionLimit
          glAggregateLimit
          glMedicalPerOccurrenceLimit
          glMedicalPerPersonLimit
          glPerOccurrenceLimit
          glPersonalAndAdvertisingInjuryLimit
          glProductsAndCompletedOperationsLimit
          glRentedPremisesDamageLimit
          propertyBuildingLimit
          propertyContentsLimit
          umbrellaOrExcessAggregateLimit
          umbrellaOrExcessPerOccurrenceLimit
          wcPerAccidentLimit
          wcPerDiseaseEmployeeLimit
          wcPerDiseasePolicyLimit
        }
      }
      namedAdditionalInsureds {
        name
        address {
          line1
          line2
          city
          zone
          postalCode
        }
      }
      policyNumber
      summary
    }
    market
    pricing {
      billingType
      premium
      agencyFees
      brokerFees
      policyFees
      otherFees
      taxes
      total
      intervalType
      estimatedCommission
    }
    quoteNumber
    reinstatement {
      reinstatedAt
      effectiveAt
      reasonDescription
    }
    renewal {
      nextPolicies {
        id
      }
      previousPolicies {
        id
      }
    }
  }
  ${ContactFieldsFragmentDoc}
`;
export const FileFieldsFragmentDoc = gql`
  fragment FileFields on File {
    createdAt
    id
    mimeType
    name
    notes
    type
    url
  }
`;
export const BusinessPolicyFileFieldsFragmentDoc = gql`
  fragment BusinessPolicyFileFields on BusinessPolicy {
    files {
      ...FileFields
    }
  }
  ${FileFieldsFragmentDoc}
`;
export const InsuranceCarrierFieldsFragmentDoc = gql`
  fragment InsuranceCarrierFields on InsuranceCarrier {
    id
    name
    isCarrier
    isBroker
  }
`;
export const CaraWorkspaceOverviewFieldsFragmentDoc = gql`
  fragment CaraWorkspaceOverviewFields on CaraWorkspace {
    agencyUser {
      email
      id
      name
    }
    createdAt
    customPreset {
      id
      title
    }
    id
    metadata {
      clientName
      keywords
    }
    preset
    state
    title
    updatedAt
  }
`;
export const DocumentDataFieldsFragmentDoc = gql`
  fragment DocumentDataFields on DocumentData {
    acord25 {
      holder {
        name
      }
    }
    acord125 {
      applicant1 {
        name
      }
    }
    acord126 {
      namedInsured
    }
    acord130 {
      namedInsured {
        fullName
      }
    }
    acord131 {
      namedInsured
    }
    acord140 {
      namedInsured
    }
  }
`;
export const TemplateDataFieldsFragmentDoc = gql`
  fragment TemplateDataFields on FillTemplateToolInput {
    acord24 {
      certificateHolder {
        fullName
      }
      namedInsured {
        fullName
      }
    }
    acord25 {
      holder {
        name
      }
      insured {
        name
      }
    }
    acord27 {
      additionalInterest {
        fullName
      }
      namedInsured {
        fullName
      }
    }
    acord28 {
      additionalInterest {
        fullName
      }
      insured {
        fullName
      }
    }
    acord35 {
      namedInsured {
        fullName
      }
    }
    acord36 {
      agencies {
        newAgency {
          fullName
        }
      }
    }
    acord75 {
      namedInsured {
        fullName
      }
    }
    acord125 {
      applicant1 {
        name
      }
    }
    acord126 {
      namedInsured
    }
    acord130 {
      namedInsured {
        fullName
      }
    }
    acord131 {
      namedInsured
    }
    acord140 {
      namedInsured
    }
  }
`;
export const FillTemplateToolFieldsFragmentDoc = gql`
  fragment FillTemplateToolFields on FillTemplateTool {
    input {
      templateId
      ...TemplateDataFields
    }
    output {
      artifactId
    }
  }
  ${TemplateDataFieldsFragmentDoc}
`;
export const CaraWorkspaceFieldsFragmentDoc = gql`
  fragment CaraWorkspaceFields on CaraWorkspace {
    ...CaraWorkspaceOverviewFields
    artifacts {
      createdAt
      document {
        id
        type
        downloadUrl
        data {
          ...DocumentDataFields
        }
      }
      email {
        body
        from {
          name
          email
        }
        subject
        to {
          name
          email
        }
      }
      htmlDocument {
        content
        title
      }
      id
      type
    }
    files {
      id
      name
      url
    }
    planStages {
      createdAt
      endedAt
      events {
        content
        endedAt
        error
        id
        startedAt
        title
        toolCall {
          argumentsJson
          name
          result
          type
          thinkTool {
            input {
              title
              thought
            }
            output {
              success
            }
          }
          completeTaskTool {
            input {
              clientName
              keywords
              needsAgentInput
            }
            output {
              success
            }
          }
          draftEmailTool {
            input {
              artifactId
              body
              subject
              toEmail
              toName
            }
          }
          draftDocumentTool {
            input {
              artifactId
              title
              htmlContent
            }
          }
          fillTemplateTool {
            ...FillTemplateToolFields
          }
          searchFileTool {
            input {
              queries {
                fileId
                query
                keywords
              }
            }
            output {
              results {
                fileId
                query
                answer
                citations {
                  link
                }
              }
            }
          }
          searchKnowledgeBaseTool {
            input {
              queries {
                query
              }
            }
            output {
              documents {
                metadata {
                  title
                }
                relevantPages {
                  pageIndex
                  citation {
                    link
                  }
                }
              }
            }
          }
          searchKnowledgeGraphTool {
            input {
              queries {
                query
              }
            }
            output {
              entities {
                type
                displayName
              }
            }
          }
          searchWebTool {
            input {
              queries {
                query
                keywords
              }
            }
            output {
              results {
                query
                answer
                citations {
                  url
                  title
                }
              }
            }
          }
          writeIntegrationTool {
            input {
              action
              account {
                firstName
                lastName
                businessName
                email
                phone
                address {
                  line1
                  line2
                  city
                  zone
                  postalCode
                }
              }
              agentName
              uploadDocument {
                source
                description
                note
                id
              }
              createNote {
                title
                body
              }
              createTask {
                title
                description
                dueDate
                assigneeEmail
              }
            }
            output {
              success
              message
            }
          }
        }
        type
      }
      id
      initiatedByMessageId
      processAttachmentsDetails {
        progress {
          file {
            name
          }
          progress
        }
      }
      result
      startedAt
      state
      type
    }
    messages {
      content
      id
      role
      timestamp
      files {
        id
        name
        url
      }
    }
    schemaVersion
    serviceRequest {
      ...ServiceRequestFields
    }
  }
  ${CaraWorkspaceOverviewFieldsFragmentDoc}
  ${DocumentDataFieldsFragmentDoc}
  ${FillTemplateToolFieldsFragmentDoc}
  ${ServiceRequestFieldsFragmentDoc}
`;
export const CustomPresetFieldsFragmentDoc = gql`
  fragment CustomPresetFields on CustomPreset {
    allowFileUpload
    basePrompt
    createdAt
    createdBy {
      id
      name
    }
    description
    files {
      id
      name
      mimeType
      url
    }
    id
    inheritFromPreset
    title
    updatedAt
  }
`;
export const HtmlDocumentTemplateFieldsFragmentDoc = gql`
  fragment HtmlDocumentTemplateFields on HtmlDocumentTemplate {
    baseStyleId
    createdBy {
      name
    }
    prefixFiles {
      id
      name
      mimeType
    }
    suffixFiles {
      id
      name
      mimeType
    }
    description
    id
    title
    createdAt
    updatedAt
  }
`;
export const IntegrationFieldsFragmentDoc = gql`
  fragment IntegrationFields on Integration {
    id
    type
    state
    createdAt
    updatedAt
  }
`;
export const IntegrationSyncLogFieldsFragmentDoc = gql`
  fragment IntegrationSyncLogFields on IntegrationSyncLog {
    completedAt
    entitiesSynced
    id
    initiatorType
    initiatorId
    lastError
    startedAt
    state
    type
  }
`;
export const IntegrationDetailFieldsFragmentDoc = gql`
  fragment IntegrationDetailFields on Integration {
    ...IntegrationFields
    lastSyncedAt
    configuration {
      hawksoft {
        agencyId
        enableSyncCallNotes
        enableSyncServiceRequests
      }
      nowcerts {
        username
        enableSyncTasks
        enableSyncCalls
      }
      hubspot {
        accessToken
        enableSyncTasks
        taskSyncType
        taskPipelineId
        taskStageId
        enableSyncCalls
        callSyncType
        callPipelineId
        callStageId
        callFieldMappings {
          ticketFields {
            hubspotField
            caraField
          }
          dealFields {
            hubspotField
            caraField
          }
        }
        taskFieldMappings {
          ticketFields {
            hubspotField
            caraField
          }
          dealFields {
            hubspotField
            caraField
          }
        }
      }
    }
    syncLogs {
      ...IntegrationSyncLogFields
    }
  }
  ${IntegrationFieldsFragmentDoc}
  ${IntegrationSyncLogFieldsFragmentDoc}
`;
export const KnowledgeBaseFieldsFragmentDoc = gql`
  fragment KnowledgeBaseFields on KnowledgeBase {
    id
    title
  }
`;
export const KnowledgeBaseDocumentFieldsFragmentDoc = gql`
  fragment KnowledgeBaseDocumentFields on KnowledgeBaseDocument {
    createdBy {
      name
    }
    indexingStatus {
      status
      error
      progress
      startedAt
      completedAt
    }
    file {
      mimeType
      name
      size
      url
    }
    metadata {
      title
      summary
      purpose
    }
    text {
      content
    }
    id
    title
    createdAt
    updatedAt
  }
`;
export const KnowledgeBaseDetailFieldsFragmentDoc = gql`
  fragment KnowledgeBaseDetailFields on KnowledgeBase {
    ...KnowledgeBaseFields
    documents {
      ...KnowledgeBaseDocumentFields
    }
  }
  ${KnowledgeBaseFieldsFragmentDoc}
  ${KnowledgeBaseDocumentFieldsFragmentDoc}
`;
export const KnowledgeBaseDocumentDetailFieldsFragmentDoc = gql`
  fragment KnowledgeBaseDocumentDetailFields on KnowledgeBaseDocument {
    ...KnowledgeBaseDocumentFields
    file {
      mimeType
      name
      size
      url
    }
    text {
      content
    }
  }
  ${KnowledgeBaseDocumentFieldsFragmentDoc}
`;
export const PolicyExplorerConversationMessageFieldsFragmentDoc = gql`
  fragment PolicyExplorerConversationMessageFields on PolicyExplorerConversationMessage {
    attachments {
      content
      type
    }
    content
    id
    role
    timestamp
  }
`;
export const CallFieldsFragmentDoc = gql`
  fragment CallFields on Call {
    id
    account {
      id
      account {
        name
      }
    }
    disconnectionReason
    endedAt
    fromName
    fromNumber
    startedAt
    status
  }
`;
export const CallTranscriptFieldsFragmentDoc = gql`
  fragment CallTranscriptFields on Call {
    recordingUrl
    sentiment
    serviceRequests {
      ...ServiceRequestFields
    }
    successful
    summary
    transcript {
      role
      content
      toolCallId
      toolName
      toolArgumentsJson
    }
  }
  ${ServiceRequestFieldsFragmentDoc}
`;
export const EmailThreadFieldsFragmentDoc = gql`
  fragment EmailThreadFields on EmailThread {
    account {
      id
      account {
        name
      }
    }
    fromEmail
    fromName
    id
    state
    subject
    waitingFor
    createdAt
    updatedAt
  }
`;
export const EmailFieldsFragmentDoc = gql`
  fragment EmailFields on Email {
    body
    from {
      name
      email
    }
    id
    senderRole
    sentAt
    subject
    to {
      name
      email
    }
  }
`;
export const EmailThreadConversationFieldsFragmentDoc = gql`
  fragment EmailThreadConversationFields on EmailThread {
    attachments {
      id
      name
      url
    }
    participantEmails {
      ...EmailFields
    }
    serviceRequests {
      ...ServiceRequestFields
    }
    summary
    workspace {
      id
      title
      state
    }
  }
  ${EmailFieldsFragmentDoc}
  ${ServiceRequestFieldsFragmentDoc}
`;
export const ServiceRequestCallFieldsFragmentDoc = gql`
  fragment ServiceRequestCallFields on ServiceRequest {
    calls {
      ...CallFields
      ...CallTranscriptFields
    }
    comments {
      id
      content
      agencyUser {
        name
      }
      createdAt
    }
    emailThreads {
      ...EmailThreadFields
      ...EmailThreadConversationFields
    }
    versionHistory {
      createdAt
      version
      updateTypes
      updateInitiatorType
      updateInitiatorId
      serviceRequest {
        assignee {
          id
          name
        }
        resolution {
          notes
        }
        dueAt
      }
    }
  }
  ${CallFieldsFragmentDoc}
  ${CallTranscriptFieldsFragmentDoc}
  ${EmailThreadFieldsFragmentDoc}
  ${EmailThreadConversationFieldsFragmentDoc}
`;
export const GetAccountsDocument = gql`
  query GetAccounts {
    accounts {
      ...AccountFields
    }
  }
  ${AccountFieldsFragmentDoc}
`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
}
export function useGetAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(
    GetAccountsDocument,
    options
  );
}
export function useGetAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAccountsQuery, GetAccountsQueryVariables>(
    GetAccountsDocument,
    options
  );
}
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<
  GetAccountsQuery,
  GetAccountsQueryVariables
>;
export const GetAccountDocument = gql`
  query GetAccount($id: ID!) {
    account(id: $id) {
      ...AccountFields
      ...AccountBusinessApplicationFields
      ...AccountBusinessPolicyFields
      ...AccountCertificateOfLiabilityInsuranceFields
      ...AccountContactFields
      ...AccountServiceRequestFields
    }
  }
  ${AccountFieldsFragmentDoc}
  ${AccountBusinessApplicationFieldsFragmentDoc}
  ${AccountBusinessPolicyFieldsFragmentDoc}
  ${AccountCertificateOfLiabilityInsuranceFieldsFragmentDoc}
  ${AccountContactFieldsFragmentDoc}
  ${AccountServiceRequestFieldsFragmentDoc}
`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(
  baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables> &
    ({ variables: GetAccountQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
}
export function useGetAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(
    GetAccountDocument,
    options
  );
}
export function useGetAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(
    GetAccountDocument,
    options
  );
}
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetContactsDocument = gql`
  query GetContacts {
    contacts {
      ...ContactFields
    }
  }
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
}
export function useGetContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(
    GetContactsDocument,
    options
  );
}
export function useGetContactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContactsQuery, GetContactsQueryVariables>(
    GetContactsDocument,
    options
  );
}
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsSuspenseQueryHookResult = ReturnType<typeof useGetContactsSuspenseQuery>;
export type GetContactsQueryResult = Apollo.QueryResult<
  GetContactsQuery,
  GetContactsQueryVariables
>;
export const CreateAccountDocument = gql`
  mutation CreateAccount($input: CreateAccountInput!) {
    createAccount(input: $input) {
      ...AccountFields
    }
  }
  ${AccountFieldsFragmentDoc}
`;
export type CreateAccountMutationFn = Apollo.MutationFunction<
  CreateAccountMutation,
  CreateAccountMutationVariables
>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(
    CreateAccountDocument,
    options
  );
}
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<
  CreateAccountMutation,
  CreateAccountMutationVariables
>;
export const UpdateAccountDocument = gql`
  mutation UpdateAccount($id: ID!, $input: UpdateAccountInput!) {
    updateAccount(id: $id, input: $input) {
      ...AccountFields
    }
  }
  ${AccountFieldsFragmentDoc}
`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<
  UpdateAccountMutation,
  UpdateAccountMutationVariables
>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(
    UpdateAccountDocument,
    options
  );
}
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountMutation,
  UpdateAccountMutationVariables
>;
export const GetAgencyUserDocument = gql`
  query GetAgencyUser {
    agencyUser {
      ...LoggedInAgencyUserFields
    }
  }
  ${LoggedInAgencyUserFieldsFragmentDoc}
`;

/**
 * __useGetAgencyUserQuery__
 *
 * To run a query within a React component, call `useGetAgencyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAgencyUserQuery, GetAgencyUserQueryVariables>(
    GetAgencyUserDocument,
    options
  );
}
export function useGetAgencyUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAgencyUserQuery, GetAgencyUserQueryVariables>(
    GetAgencyUserDocument,
    options
  );
}
export function useGetAgencyUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAgencyUserQuery, GetAgencyUserQueryVariables>(
    GetAgencyUserDocument,
    options
  );
}
export type GetAgencyUserQueryHookResult = ReturnType<typeof useGetAgencyUserQuery>;
export type GetAgencyUserLazyQueryHookResult = ReturnType<typeof useGetAgencyUserLazyQuery>;
export type GetAgencyUserSuspenseQueryHookResult = ReturnType<typeof useGetAgencyUserSuspenseQuery>;
export type GetAgencyUserQueryResult = Apollo.QueryResult<
  GetAgencyUserQuery,
  GetAgencyUserQueryVariables
>;
export const GetAgencyUsersDocument = gql`
  query GetAgencyUsers {
    agencyUsers {
      ...AgencyUserFields
    }
  }
  ${AgencyUserFieldsFragmentDoc}
`;

/**
 * __useGetAgencyUsersQuery__
 *
 * To run a query within a React component, call `useGetAgencyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>(
    GetAgencyUsersDocument,
    options
  );
}
export function useGetAgencyUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>(
    GetAgencyUsersDocument,
    options
  );
}
export function useGetAgencyUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>(
    GetAgencyUsersDocument,
    options
  );
}
export type GetAgencyUsersQueryHookResult = ReturnType<typeof useGetAgencyUsersQuery>;
export type GetAgencyUsersLazyQueryHookResult = ReturnType<typeof useGetAgencyUsersLazyQuery>;
export type GetAgencyUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetAgencyUsersSuspenseQuery
>;
export type GetAgencyUsersQueryResult = Apollo.QueryResult<
  GetAgencyUsersQuery,
  GetAgencyUsersQueryVariables
>;
export const UpdateAgencyUserPreferencesDocument = gql`
  mutation UpdateAgencyUserPreferences($input: AgencyUserPreferencesInput!) {
    updateAgencyUserPreferences(input: $input) {
      ...AgencyUserFields
    }
  }
  ${AgencyUserFieldsFragmentDoc}
`;
export type UpdateAgencyUserPreferencesMutationFn = Apollo.MutationFunction<
  UpdateAgencyUserPreferencesMutation,
  UpdateAgencyUserPreferencesMutationVariables
>;

/**
 * __useUpdateAgencyUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyUserPreferencesMutation, { data, loading, error }] = useUpdateAgencyUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyUserPreferencesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAgencyUserPreferencesMutation,
    UpdateAgencyUserPreferencesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAgencyUserPreferencesMutation,
    UpdateAgencyUserPreferencesMutationVariables
  >(UpdateAgencyUserPreferencesDocument, options);
}
export type UpdateAgencyUserPreferencesMutationHookResult = ReturnType<
  typeof useUpdateAgencyUserPreferencesMutation
>;
export type UpdateAgencyUserPreferencesMutationResult =
  Apollo.MutationResult<UpdateAgencyUserPreferencesMutation>;
export type UpdateAgencyUserPreferencesMutationOptions = Apollo.BaseMutationOptions<
  UpdateAgencyUserPreferencesMutation,
  UpdateAgencyUserPreferencesMutationVariables
>;
export const CreateAgencyUserDocument = gql`
  mutation CreateAgencyUser($input: AgencyUserInput!) {
    createAgencyUser(agencyId: "", input: $input) {
      ...AgencyUserFields
    }
  }
  ${AgencyUserFieldsFragmentDoc}
`;
export type CreateAgencyUserMutationFn = Apollo.MutationFunction<
  CreateAgencyUserMutation,
  CreateAgencyUserMutationVariables
>;

/**
 * __useCreateAgencyUserMutation__
 *
 * To run a mutation, you first call `useCreateAgencyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyUserMutation, { data, loading, error }] = useCreateAgencyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAgencyUserMutation,
    CreateAgencyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAgencyUserMutation, CreateAgencyUserMutationVariables>(
    CreateAgencyUserDocument,
    options
  );
}
export type CreateAgencyUserMutationHookResult = ReturnType<typeof useCreateAgencyUserMutation>;
export type CreateAgencyUserMutationResult = Apollo.MutationResult<CreateAgencyUserMutation>;
export type CreateAgencyUserMutationOptions = Apollo.BaseMutationOptions<
  CreateAgencyUserMutation,
  CreateAgencyUserMutationVariables
>;
export const DisableAgencyUserDocument = gql`
  mutation DisableAgencyUser($id: ID!) {
    disableAgencyUser(id: $id) {
      ...AgencyUserFields
    }
  }
  ${AgencyUserFieldsFragmentDoc}
`;
export type DisableAgencyUserMutationFn = Apollo.MutationFunction<
  DisableAgencyUserMutation,
  DisableAgencyUserMutationVariables
>;

/**
 * __useDisableAgencyUserMutation__
 *
 * To run a mutation, you first call `useDisableAgencyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAgencyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAgencyUserMutation, { data, loading, error }] = useDisableAgencyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableAgencyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableAgencyUserMutation,
    DisableAgencyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisableAgencyUserMutation, DisableAgencyUserMutationVariables>(
    DisableAgencyUserDocument,
    options
  );
}
export type DisableAgencyUserMutationHookResult = ReturnType<typeof useDisableAgencyUserMutation>;
export type DisableAgencyUserMutationResult = Apollo.MutationResult<DisableAgencyUserMutation>;
export type DisableAgencyUserMutationOptions = Apollo.BaseMutationOptions<
  DisableAgencyUserMutation,
  DisableAgencyUserMutationVariables
>;
export const EnableAgencyUserDocument = gql`
  mutation EnableAgencyUser($id: ID!) {
    enableAgencyUser(id: $id) {
      ...AgencyUserFields
    }
  }
  ${AgencyUserFieldsFragmentDoc}
`;
export type EnableAgencyUserMutationFn = Apollo.MutationFunction<
  EnableAgencyUserMutation,
  EnableAgencyUserMutationVariables
>;

/**
 * __useEnableAgencyUserMutation__
 *
 * To run a mutation, you first call `useEnableAgencyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAgencyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAgencyUserMutation, { data, loading, error }] = useEnableAgencyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableAgencyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableAgencyUserMutation,
    EnableAgencyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EnableAgencyUserMutation, EnableAgencyUserMutationVariables>(
    EnableAgencyUserDocument,
    options
  );
}
export type EnableAgencyUserMutationHookResult = ReturnType<typeof useEnableAgencyUserMutation>;
export type EnableAgencyUserMutationResult = Apollo.MutationResult<EnableAgencyUserMutation>;
export type EnableAgencyUserMutationOptions = Apollo.BaseMutationOptions<
  EnableAgencyUserMutation,
  EnableAgencyUserMutationVariables
>;
export const GetSubscriptionBillingPortalLinkDocument = gql`
  query GetSubscriptionBillingPortalLink {
    subscriptionManagementLinks {
      billingPortalUrl
    }
  }
`;

/**
 * __useGetSubscriptionBillingPortalLinkQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionBillingPortalLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionBillingPortalLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionBillingPortalLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionBillingPortalLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSubscriptionBillingPortalLinkQuery,
    GetSubscriptionBillingPortalLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubscriptionBillingPortalLinkQuery,
    GetSubscriptionBillingPortalLinkQueryVariables
  >(GetSubscriptionBillingPortalLinkDocument, options);
}
export function useGetSubscriptionBillingPortalLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionBillingPortalLinkQuery,
    GetSubscriptionBillingPortalLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionBillingPortalLinkQuery,
    GetSubscriptionBillingPortalLinkQueryVariables
  >(GetSubscriptionBillingPortalLinkDocument, options);
}
export function useGetSubscriptionBillingPortalLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSubscriptionBillingPortalLinkQuery,
        GetSubscriptionBillingPortalLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSubscriptionBillingPortalLinkQuery,
    GetSubscriptionBillingPortalLinkQueryVariables
  >(GetSubscriptionBillingPortalLinkDocument, options);
}
export type GetSubscriptionBillingPortalLinkQueryHookResult = ReturnType<
  typeof useGetSubscriptionBillingPortalLinkQuery
>;
export type GetSubscriptionBillingPortalLinkLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionBillingPortalLinkLazyQuery
>;
export type GetSubscriptionBillingPortalLinkSuspenseQueryHookResult = ReturnType<
  typeof useGetSubscriptionBillingPortalLinkSuspenseQuery
>;
export type GetSubscriptionBillingPortalLinkQueryResult = Apollo.QueryResult<
  GetSubscriptionBillingPortalLinkQuery,
  GetSubscriptionBillingPortalLinkQueryVariables
>;
export const GetSubscriptionUpdateLinkDocument = gql`
  query GetSubscriptionUpdateLink {
    subscriptionManagementLinks {
      updateSubscriptionUrl
    }
  }
`;

/**
 * __useGetSubscriptionUpdateLinkQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionUpdateLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionUpdateLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionUpdateLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionUpdateLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSubscriptionUpdateLinkQuery,
    GetSubscriptionUpdateLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>(
    GetSubscriptionUpdateLinkDocument,
    options
  );
}
export function useGetSubscriptionUpdateLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionUpdateLinkQuery,
    GetSubscriptionUpdateLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionUpdateLinkQuery,
    GetSubscriptionUpdateLinkQueryVariables
  >(GetSubscriptionUpdateLinkDocument, options);
}
export function useGetSubscriptionUpdateLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSubscriptionUpdateLinkQuery,
        GetSubscriptionUpdateLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSubscriptionUpdateLinkQuery,
    GetSubscriptionUpdateLinkQueryVariables
  >(GetSubscriptionUpdateLinkDocument, options);
}
export type GetSubscriptionUpdateLinkQueryHookResult = ReturnType<
  typeof useGetSubscriptionUpdateLinkQuery
>;
export type GetSubscriptionUpdateLinkLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionUpdateLinkLazyQuery
>;
export type GetSubscriptionUpdateLinkSuspenseQueryHookResult = ReturnType<
  typeof useGetSubscriptionUpdateLinkSuspenseQuery
>;
export type GetSubscriptionUpdateLinkQueryResult = Apollo.QueryResult<
  GetSubscriptionUpdateLinkQuery,
  GetSubscriptionUpdateLinkQueryVariables
>;
export const GetSubscriptionUpdatePaymentLinkDocument = gql`
  query GetSubscriptionUpdatePaymentLink {
    subscriptionManagementLinks {
      updatePaymentMethodUrl
    }
  }
`;

/**
 * __useGetSubscriptionUpdatePaymentLinkQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionUpdatePaymentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionUpdatePaymentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionUpdatePaymentLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionUpdatePaymentLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSubscriptionUpdatePaymentLinkQuery,
    GetSubscriptionUpdatePaymentLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubscriptionUpdatePaymentLinkQuery,
    GetSubscriptionUpdatePaymentLinkQueryVariables
  >(GetSubscriptionUpdatePaymentLinkDocument, options);
}
export function useGetSubscriptionUpdatePaymentLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionUpdatePaymentLinkQuery,
    GetSubscriptionUpdatePaymentLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionUpdatePaymentLinkQuery,
    GetSubscriptionUpdatePaymentLinkQueryVariables
  >(GetSubscriptionUpdatePaymentLinkDocument, options);
}
export function useGetSubscriptionUpdatePaymentLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSubscriptionUpdatePaymentLinkQuery,
        GetSubscriptionUpdatePaymentLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSubscriptionUpdatePaymentLinkQuery,
    GetSubscriptionUpdatePaymentLinkQueryVariables
  >(GetSubscriptionUpdatePaymentLinkDocument, options);
}
export type GetSubscriptionUpdatePaymentLinkQueryHookResult = ReturnType<
  typeof useGetSubscriptionUpdatePaymentLinkQuery
>;
export type GetSubscriptionUpdatePaymentLinkLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionUpdatePaymentLinkLazyQuery
>;
export type GetSubscriptionUpdatePaymentLinkSuspenseQueryHookResult = ReturnType<
  typeof useGetSubscriptionUpdatePaymentLinkSuspenseQuery
>;
export type GetSubscriptionUpdatePaymentLinkQueryResult = Apollo.QueryResult<
  GetSubscriptionUpdatePaymentLinkQuery,
  GetSubscriptionUpdatePaymentLinkQueryVariables
>;
export const SignInDocument = gql`
  mutation SignIn($email: String!) {
    agencySignIn(email: $email) {
      ...AgencySignInFields
    }
  }
  ${AgencySignInFieldsFragmentDoc}
`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSignInMutation(
  baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<
  SignInMutation,
  SignInMutationVariables
>;
export const SignInCompleteDocument = gql`
  mutation SignInComplete($email: String!, $code: String!) {
    agencySignIn(email: $email, code: $code) {
      ...AgencySignInFields
    }
  }
  ${AgencySignInFieldsFragmentDoc}
`;
export type SignInCompleteMutationFn = Apollo.MutationFunction<
  SignInCompleteMutation,
  SignInCompleteMutationVariables
>;

/**
 * __useSignInCompleteMutation__
 *
 * To run a mutation, you first call `useSignInCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInCompleteMutation, { data, loading, error }] = useSignInCompleteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignInCompleteMutation(
  baseOptions?: Apollo.MutationHookOptions<SignInCompleteMutation, SignInCompleteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignInCompleteMutation, SignInCompleteMutationVariables>(
    SignInCompleteDocument,
    options
  );
}
export type SignInCompleteMutationHookResult = ReturnType<typeof useSignInCompleteMutation>;
export type SignInCompleteMutationResult = Apollo.MutationResult<SignInCompleteMutation>;
export type SignInCompleteMutationOptions = Apollo.BaseMutationOptions<
  SignInCompleteMutation,
  SignInCompleteMutationVariables
>;
export const SignOutDocument = gql`
  mutation SignOut {
    agencySignOut
  }
`;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
}
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<
  SignOutMutation,
  SignOutMutationVariables
>;
export const GetInsuranceCarriersDocument = gql`
  query GetInsuranceCarriers {
    carriers {
      ...InsuranceCarrierFields
    }
  }
  ${InsuranceCarrierFieldsFragmentDoc}
`;

/**
 * __useGetInsuranceCarriersQuery__
 *
 * To run a query within a React component, call `useGetInsuranceCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsuranceCarriersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInsuranceCarriersQuery,
    GetInsuranceCarriersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>(
    GetInsuranceCarriersDocument,
    options
  );
}
export function useGetInsuranceCarriersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInsuranceCarriersQuery,
    GetInsuranceCarriersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>(
    GetInsuranceCarriersDocument,
    options
  );
}
export function useGetInsuranceCarriersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>(
    GetInsuranceCarriersDocument,
    options
  );
}
export type GetInsuranceCarriersQueryHookResult = ReturnType<typeof useGetInsuranceCarriersQuery>;
export type GetInsuranceCarriersLazyQueryHookResult = ReturnType<
  typeof useGetInsuranceCarriersLazyQuery
>;
export type GetInsuranceCarriersSuspenseQueryHookResult = ReturnType<
  typeof useGetInsuranceCarriersSuspenseQuery
>;
export type GetInsuranceCarriersQueryResult = Apollo.QueryResult<
  GetInsuranceCarriersQuery,
  GetInsuranceCarriersQueryVariables
>;
export const GetBusinessPoliciesDocument = gql`
  query GetBusinessPolicies {
    businessPolicies {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;

/**
 * __useGetBusinessPoliciesQuery__
 *
 * To run a query within a React component, call `useGetBusinessPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessPoliciesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(
    GetBusinessPoliciesDocument,
    options
  );
}
export function useGetBusinessPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBusinessPoliciesQuery,
    GetBusinessPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(
    GetBusinessPoliciesDocument,
    options
  );
}
export function useGetBusinessPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(
    GetBusinessPoliciesDocument,
    options
  );
}
export type GetBusinessPoliciesQueryHookResult = ReturnType<typeof useGetBusinessPoliciesQuery>;
export type GetBusinessPoliciesLazyQueryHookResult = ReturnType<
  typeof useGetBusinessPoliciesLazyQuery
>;
export type GetBusinessPoliciesSuspenseQueryHookResult = ReturnType<
  typeof useGetBusinessPoliciesSuspenseQuery
>;
export type GetBusinessPoliciesQueryResult = Apollo.QueryResult<
  GetBusinessPoliciesQuery,
  GetBusinessPoliciesQueryVariables
>;
export const GetBusinessPolicyDocument = gql`
  query GetBusinessPolicy($id: ID!) {
    businessPolicy(id: $id) {
      ...BusinessPolicyFields
      ...BusinessPolicyDetailFields
      ...BusinessPolicyFileFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
  ${BusinessPolicyDetailFieldsFragmentDoc}
  ${BusinessPolicyFileFieldsFragmentDoc}
`;

/**
 * __useGetBusinessPolicyQuery__
 *
 * To run a query within a React component, call `useGetBusinessPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessPolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBusinessPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables> &
    ({ variables: GetBusinessPolicyQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(
    GetBusinessPolicyDocument,
    options
  );
}
export function useGetBusinessPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(
    GetBusinessPolicyDocument,
    options
  );
}
export function useGetBusinessPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(
    GetBusinessPolicyDocument,
    options
  );
}
export type GetBusinessPolicyQueryHookResult = ReturnType<typeof useGetBusinessPolicyQuery>;
export type GetBusinessPolicyLazyQueryHookResult = ReturnType<typeof useGetBusinessPolicyLazyQuery>;
export type GetBusinessPolicySuspenseQueryHookResult = ReturnType<
  typeof useGetBusinessPolicySuspenseQuery
>;
export type GetBusinessPolicyQueryResult = Apollo.QueryResult<
  GetBusinessPolicyQuery,
  GetBusinessPolicyQueryVariables
>;
export const CreateBusinessPoliciesDocument = gql`
  mutation CreateBusinessPolicies($input: CreateBusinessPoliciesInput!) {
    createBusinessPolicies(req: $input) {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;
export type CreateBusinessPoliciesMutationFn = Apollo.MutationFunction<
  CreateBusinessPoliciesMutation,
  CreateBusinessPoliciesMutationVariables
>;

/**
 * __useCreateBusinessPoliciesMutation__
 *
 * To run a mutation, you first call `useCreateBusinessPoliciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessPoliciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessPoliciesMutation, { data, loading, error }] = useCreateBusinessPoliciesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessPoliciesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBusinessPoliciesMutation,
    CreateBusinessPoliciesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBusinessPoliciesMutation,
    CreateBusinessPoliciesMutationVariables
  >(CreateBusinessPoliciesDocument, options);
}
export type CreateBusinessPoliciesMutationHookResult = ReturnType<
  typeof useCreateBusinessPoliciesMutation
>;
export type CreateBusinessPoliciesMutationResult =
  Apollo.MutationResult<CreateBusinessPoliciesMutation>;
export type CreateBusinessPoliciesMutationOptions = Apollo.BaseMutationOptions<
  CreateBusinessPoliciesMutation,
  CreateBusinessPoliciesMutationVariables
>;
export const UpdateBusinessPolicyDocument = gql`
  mutation UpdateBusinessPolicy($id: ID!, $input: UpdateBusinessPolicyInput!) {
    updateBusinessPolicy(id: $id, req: $input) {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;
export type UpdateBusinessPolicyMutationFn = Apollo.MutationFunction<
  UpdateBusinessPolicyMutation,
  UpdateBusinessPolicyMutationVariables
>;

/**
 * __useUpdateBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessPolicyMutation, { data, loading, error }] = useUpdateBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBusinessPolicyMutation,
    UpdateBusinessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBusinessPolicyMutation, UpdateBusinessPolicyMutationVariables>(
    UpdateBusinessPolicyDocument,
    options
  );
}
export type UpdateBusinessPolicyMutationHookResult = ReturnType<
  typeof useUpdateBusinessPolicyMutation
>;
export type UpdateBusinessPolicyMutationResult =
  Apollo.MutationResult<UpdateBusinessPolicyMutation>;
export type UpdateBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<
  UpdateBusinessPolicyMutation,
  UpdateBusinessPolicyMutationVariables
>;
export const DeleteBusinessPolicyDocument = gql`
  mutation DeleteBusinessPolicy($id: ID!) {
    deleteBusinessPolicy(id: $id) {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;
export type DeleteBusinessPolicyMutationFn = Apollo.MutationFunction<
  DeleteBusinessPolicyMutation,
  DeleteBusinessPolicyMutationVariables
>;

/**
 * __useDeleteBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessPolicyMutation, { data, loading, error }] = useDeleteBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBusinessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBusinessPolicyMutation,
    DeleteBusinessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteBusinessPolicyMutation, DeleteBusinessPolicyMutationVariables>(
    DeleteBusinessPolicyDocument,
    options
  );
}
export type DeleteBusinessPolicyMutationHookResult = ReturnType<
  typeof useDeleteBusinessPolicyMutation
>;
export type DeleteBusinessPolicyMutationResult =
  Apollo.MutationResult<DeleteBusinessPolicyMutation>;
export type DeleteBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<
  DeleteBusinessPolicyMutation,
  DeleteBusinessPolicyMutationVariables
>;
export const CancelBusinessPolicyDocument = gql`
  mutation CancelBusinessPolicy($id: ID!, $input: CancelBusinessPolicyInput!) {
    cancelBusinessPolicy(id: $id, req: $input) {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;
export type CancelBusinessPolicyMutationFn = Apollo.MutationFunction<
  CancelBusinessPolicyMutation,
  CancelBusinessPolicyMutationVariables
>;

/**
 * __useCancelBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useCancelBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBusinessPolicyMutation, { data, loading, error }] = useCancelBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelBusinessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelBusinessPolicyMutation,
    CancelBusinessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelBusinessPolicyMutation, CancelBusinessPolicyMutationVariables>(
    CancelBusinessPolicyDocument,
    options
  );
}
export type CancelBusinessPolicyMutationHookResult = ReturnType<
  typeof useCancelBusinessPolicyMutation
>;
export type CancelBusinessPolicyMutationResult =
  Apollo.MutationResult<CancelBusinessPolicyMutation>;
export type CancelBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<
  CancelBusinessPolicyMutation,
  CancelBusinessPolicyMutationVariables
>;
export const RenewBusinessPolicyDocument = gql`
  mutation RenewBusinessPolicy($id: ID!, $input: RenewBusinessPolicyInput!) {
    renewBusinessPolicy(id: $id, req: $input) {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;
export type RenewBusinessPolicyMutationFn = Apollo.MutationFunction<
  RenewBusinessPolicyMutation,
  RenewBusinessPolicyMutationVariables
>;

/**
 * __useRenewBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useRenewBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewBusinessPolicyMutation, { data, loading, error }] = useRenewBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenewBusinessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenewBusinessPolicyMutation,
    RenewBusinessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenewBusinessPolicyMutation, RenewBusinessPolicyMutationVariables>(
    RenewBusinessPolicyDocument,
    options
  );
}
export type RenewBusinessPolicyMutationHookResult = ReturnType<
  typeof useRenewBusinessPolicyMutation
>;
export type RenewBusinessPolicyMutationResult = Apollo.MutationResult<RenewBusinessPolicyMutation>;
export type RenewBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<
  RenewBusinessPolicyMutation,
  RenewBusinessPolicyMutationVariables
>;
export const ReinstateBusinessPolicyDocument = gql`
  mutation ReinstateBusinessPolicy($id: ID!, $input: ReinstateBusinessPolicyInput!) {
    reinstateBusinessPolicy(id: $id, req: $input) {
      ...BusinessPolicyFields
    }
  }
  ${BusinessPolicyFieldsFragmentDoc}
`;
export type ReinstateBusinessPolicyMutationFn = Apollo.MutationFunction<
  ReinstateBusinessPolicyMutation,
  ReinstateBusinessPolicyMutationVariables
>;

/**
 * __useReinstateBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useReinstateBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinstateBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinstateBusinessPolicyMutation, { data, loading, error }] = useReinstateBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReinstateBusinessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReinstateBusinessPolicyMutation,
    ReinstateBusinessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReinstateBusinessPolicyMutation,
    ReinstateBusinessPolicyMutationVariables
  >(ReinstateBusinessPolicyDocument, options);
}
export type ReinstateBusinessPolicyMutationHookResult = ReturnType<
  typeof useReinstateBusinessPolicyMutation
>;
export type ReinstateBusinessPolicyMutationResult =
  Apollo.MutationResult<ReinstateBusinessPolicyMutation>;
export type ReinstateBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<
  ReinstateBusinessPolicyMutation,
  ReinstateBusinessPolicyMutationVariables
>;
export const UploadPolicyFileDocument = gql`
  mutation UploadPolicyFile($policyId: ID!, $file: UploadFileInput!) {
    uploadPolicyFile(policyId: $policyId, file: $file) {
      ...FileFields
    }
  }
  ${FileFieldsFragmentDoc}
`;
export type UploadPolicyFileMutationFn = Apollo.MutationFunction<
  UploadPolicyFileMutation,
  UploadPolicyFileMutationVariables
>;

/**
 * __useUploadPolicyFileMutation__
 *
 * To run a mutation, you first call `useUploadPolicyFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPolicyFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPolicyFileMutation, { data, loading, error }] = useUploadPolicyFileMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadPolicyFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadPolicyFileMutation,
    UploadPolicyFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadPolicyFileMutation, UploadPolicyFileMutationVariables>(
    UploadPolicyFileDocument,
    options
  );
}
export type UploadPolicyFileMutationHookResult = ReturnType<typeof useUploadPolicyFileMutation>;
export type UploadPolicyFileMutationResult = Apollo.MutationResult<UploadPolicyFileMutation>;
export type UploadPolicyFileMutationOptions = Apollo.BaseMutationOptions<
  UploadPolicyFileMutation,
  UploadPolicyFileMutationVariables
>;
export const GetCallsDocument = gql`
  query GetCalls {
    calls {
      ...CallFields
    }
  }
  ${CallFieldsFragmentDoc}
`;

/**
 * __useGetCallsQuery__
 *
 * To run a query within a React component, call `useGetCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCallsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCallsQuery, GetCallsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
}
export function useGetCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
}
export function useGetCallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
}
export type GetCallsQueryHookResult = ReturnType<typeof useGetCallsQuery>;
export type GetCallsLazyQueryHookResult = ReturnType<typeof useGetCallsLazyQuery>;
export type GetCallsSuspenseQueryHookResult = ReturnType<typeof useGetCallsSuspenseQuery>;
export type GetCallsQueryResult = Apollo.QueryResult<GetCallsQuery, GetCallsQueryVariables>;
export const GetCallDocument = gql`
  query GetCall($id: ID!) {
    call(id: $id) {
      ...CallFields
      ...CallTranscriptFields
    }
  }
  ${CallFieldsFragmentDoc}
  ${CallTranscriptFieldsFragmentDoc}
`;

/**
 * __useGetCallQuery__
 *
 * To run a query within a React component, call `useGetCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCallQuery(
  baseOptions: Apollo.QueryHookOptions<GetCallQuery, GetCallQueryVariables> &
    ({ variables: GetCallQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallQuery, GetCallQueryVariables>(GetCallDocument, options);
}
export function useGetCallLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallQuery, GetCallQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallQuery, GetCallQueryVariables>(GetCallDocument, options);
}
export function useGetCallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCallQuery, GetCallQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCallQuery, GetCallQueryVariables>(GetCallDocument, options);
}
export type GetCallQueryHookResult = ReturnType<typeof useGetCallQuery>;
export type GetCallLazyQueryHookResult = ReturnType<typeof useGetCallLazyQuery>;
export type GetCallSuspenseQueryHookResult = ReturnType<typeof useGetCallSuspenseQuery>;
export type GetCallQueryResult = Apollo.QueryResult<GetCallQuery, GetCallQueryVariables>;
export const GetCaraWorkspaceDocument = gql`
  query GetCaraWorkspace($id: ID!) {
    caraWorkspace(id: $id) {
      ...CaraWorkspaceFields
    }
  }
  ${CaraWorkspaceFieldsFragmentDoc}
`;

/**
 * __useGetCaraWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaraWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables> &
    ({ variables: GetCaraWorkspaceQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>(
    GetCaraWorkspaceDocument,
    options
  );
}
export function useGetCaraWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>(
    GetCaraWorkspaceDocument,
    options
  );
}
export function useGetCaraWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>(
    GetCaraWorkspaceDocument,
    options
  );
}
export type GetCaraWorkspaceQueryHookResult = ReturnType<typeof useGetCaraWorkspaceQuery>;
export type GetCaraWorkspaceLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceLazyQuery>;
export type GetCaraWorkspaceSuspenseQueryHookResult = ReturnType<
  typeof useGetCaraWorkspaceSuspenseQuery
>;
export type GetCaraWorkspaceQueryResult = Apollo.QueryResult<
  GetCaraWorkspaceQuery,
  GetCaraWorkspaceQueryVariables
>;
export const GetCaraWorkspacesDocument = gql`
  query GetCaraWorkspaces {
    caraWorkspaces {
      ...CaraWorkspaceOverviewFields
    }
  }
  ${CaraWorkspaceOverviewFieldsFragmentDoc}
`;

/**
 * __useGetCaraWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaraWorkspacesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>(
    GetCaraWorkspacesDocument,
    options
  );
}
export function useGetCaraWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>(
    GetCaraWorkspacesDocument,
    options
  );
}
export function useGetCaraWorkspacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>(
    GetCaraWorkspacesDocument,
    options
  );
}
export type GetCaraWorkspacesQueryHookResult = ReturnType<typeof useGetCaraWorkspacesQuery>;
export type GetCaraWorkspacesLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspacesLazyQuery>;
export type GetCaraWorkspacesSuspenseQueryHookResult = ReturnType<
  typeof useGetCaraWorkspacesSuspenseQuery
>;
export type GetCaraWorkspacesQueryResult = Apollo.QueryResult<
  GetCaraWorkspacesQuery,
  GetCaraWorkspacesQueryVariables
>;
export const GetCustomPresetsDocument = gql`
  query GetCustomPresets {
    customPresets {
      ...CustomPresetFields
    }
  }
  ${CustomPresetFieldsFragmentDoc}
`;

/**
 * __useGetCustomPresetsQuery__
 *
 * To run a query within a React component, call `useGetCustomPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomPresetsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>(
    GetCustomPresetsDocument,
    options
  );
}
export function useGetCustomPresetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>(
    GetCustomPresetsDocument,
    options
  );
}
export function useGetCustomPresetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>(
    GetCustomPresetsDocument,
    options
  );
}
export type GetCustomPresetsQueryHookResult = ReturnType<typeof useGetCustomPresetsQuery>;
export type GetCustomPresetsLazyQueryHookResult = ReturnType<typeof useGetCustomPresetsLazyQuery>;
export type GetCustomPresetsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomPresetsSuspenseQuery
>;
export type GetCustomPresetsQueryResult = Apollo.QueryResult<
  GetCustomPresetsQuery,
  GetCustomPresetsQueryVariables
>;
export const GetCustomPresetDocument = gql`
  query GetCustomPreset($id: ID!) {
    customPreset(id: $id) {
      ...CustomPresetFields
    }
  }
  ${CustomPresetFieldsFragmentDoc}
`;

/**
 * __useGetCustomPresetQuery__
 *
 * To run a query within a React component, call `useGetCustomPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomPresetQuery(
  baseOptions: Apollo.QueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables> &
    ({ variables: GetCustomPresetQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomPresetQuery, GetCustomPresetQueryVariables>(
    GetCustomPresetDocument,
    options
  );
}
export function useGetCustomPresetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomPresetQuery, GetCustomPresetQueryVariables>(
    GetCustomPresetDocument,
    options
  );
}
export function useGetCustomPresetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomPresetQuery, GetCustomPresetQueryVariables>(
    GetCustomPresetDocument,
    options
  );
}
export type GetCustomPresetQueryHookResult = ReturnType<typeof useGetCustomPresetQuery>;
export type GetCustomPresetLazyQueryHookResult = ReturnType<typeof useGetCustomPresetLazyQuery>;
export type GetCustomPresetSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomPresetSuspenseQuery
>;
export type GetCustomPresetQueryResult = Apollo.QueryResult<
  GetCustomPresetQuery,
  GetCustomPresetQueryVariables
>;
export const GetHtmlDocumentTemplatesDocument = gql`
  query GetHtmlDocumentTemplates {
    htmlDocumentTemplates {
      ...HtmlDocumentTemplateFields
    }
  }
  ${HtmlDocumentTemplateFieldsFragmentDoc}
`;

/**
 * __useGetHtmlDocumentTemplatesQuery__
 *
 * To run a query within a React component, call `useGetHtmlDocumentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHtmlDocumentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHtmlDocumentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHtmlDocumentTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHtmlDocumentTemplatesQuery,
    GetHtmlDocumentTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>(
    GetHtmlDocumentTemplatesDocument,
    options
  );
}
export function useGetHtmlDocumentTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHtmlDocumentTemplatesQuery,
    GetHtmlDocumentTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>(
    GetHtmlDocumentTemplatesDocument,
    options
  );
}
export function useGetHtmlDocumentTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHtmlDocumentTemplatesQuery,
        GetHtmlDocumentTemplatesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHtmlDocumentTemplatesQuery,
    GetHtmlDocumentTemplatesQueryVariables
  >(GetHtmlDocumentTemplatesDocument, options);
}
export type GetHtmlDocumentTemplatesQueryHookResult = ReturnType<
  typeof useGetHtmlDocumentTemplatesQuery
>;
export type GetHtmlDocumentTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetHtmlDocumentTemplatesLazyQuery
>;
export type GetHtmlDocumentTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useGetHtmlDocumentTemplatesSuspenseQuery
>;
export type GetHtmlDocumentTemplatesQueryResult = Apollo.QueryResult<
  GetHtmlDocumentTemplatesQuery,
  GetHtmlDocumentTemplatesQueryVariables
>;
export const GetHtmlDocumentTemplateDocument = gql`
  query GetHtmlDocumentTemplate($id: ID!) {
    htmlDocumentTemplate(id: $id) {
      ...HtmlDocumentTemplateFields
    }
  }
  ${HtmlDocumentTemplateFieldsFragmentDoc}
`;

/**
 * __useGetHtmlDocumentTemplateQuery__
 *
 * To run a query within a React component, call `useGetHtmlDocumentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHtmlDocumentTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHtmlDocumentTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHtmlDocumentTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHtmlDocumentTemplateQuery,
    GetHtmlDocumentTemplateQueryVariables
  > &
    ({ variables: GetHtmlDocumentTemplateQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>(
    GetHtmlDocumentTemplateDocument,
    options
  );
}
export function useGetHtmlDocumentTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHtmlDocumentTemplateQuery,
    GetHtmlDocumentTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>(
    GetHtmlDocumentTemplateDocument,
    options
  );
}
export function useGetHtmlDocumentTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHtmlDocumentTemplateQuery,
        GetHtmlDocumentTemplateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHtmlDocumentTemplateQuery,
    GetHtmlDocumentTemplateQueryVariables
  >(GetHtmlDocumentTemplateDocument, options);
}
export type GetHtmlDocumentTemplateQueryHookResult = ReturnType<
  typeof useGetHtmlDocumentTemplateQuery
>;
export type GetHtmlDocumentTemplateLazyQueryHookResult = ReturnType<
  typeof useGetHtmlDocumentTemplateLazyQuery
>;
export type GetHtmlDocumentTemplateSuspenseQueryHookResult = ReturnType<
  typeof useGetHtmlDocumentTemplateSuspenseQuery
>;
export type GetHtmlDocumentTemplateQueryResult = Apollo.QueryResult<
  GetHtmlDocumentTemplateQuery,
  GetHtmlDocumentTemplateQueryVariables
>;
export const CreateCaraWorkspaceDocument = gql`
  mutation CreateCaraWorkspace($input: CaraWorkspaceMessageInput!) {
    createCaraWorkspace(input: $input) {
      id
    }
  }
`;
export type CreateCaraWorkspaceMutationFn = Apollo.MutationFunction<
  CreateCaraWorkspaceMutation,
  CreateCaraWorkspaceMutationVariables
>;

/**
 * __useCreateCaraWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateCaraWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaraWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaraWorkspaceMutation, { data, loading, error }] = useCreateCaraWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaraWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCaraWorkspaceMutation,
    CreateCaraWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCaraWorkspaceMutation, CreateCaraWorkspaceMutationVariables>(
    CreateCaraWorkspaceDocument,
    options
  );
}
export type CreateCaraWorkspaceMutationHookResult = ReturnType<
  typeof useCreateCaraWorkspaceMutation
>;
export type CreateCaraWorkspaceMutationResult = Apollo.MutationResult<CreateCaraWorkspaceMutation>;
export type CreateCaraWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  CreateCaraWorkspaceMutation,
  CreateCaraWorkspaceMutationVariables
>;
export const AddCaraWorkspaceMessageDocument = gql`
  mutation AddCaraWorkspaceMessage($id: ID!, $input: CaraWorkspaceMessageInput!) {
    addCaraWorkspaceMessage(id: $id, input: $input) {
      ...CaraWorkspaceFields
    }
  }
  ${CaraWorkspaceFieldsFragmentDoc}
`;
export type AddCaraWorkspaceMessageMutationFn = Apollo.MutationFunction<
  AddCaraWorkspaceMessageMutation,
  AddCaraWorkspaceMessageMutationVariables
>;

/**
 * __useAddCaraWorkspaceMessageMutation__
 *
 * To run a mutation, you first call `useAddCaraWorkspaceMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaraWorkspaceMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaraWorkspaceMessageMutation, { data, loading, error }] = useAddCaraWorkspaceMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCaraWorkspaceMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCaraWorkspaceMessageMutation,
    AddCaraWorkspaceMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCaraWorkspaceMessageMutation,
    AddCaraWorkspaceMessageMutationVariables
  >(AddCaraWorkspaceMessageDocument, options);
}
export type AddCaraWorkspaceMessageMutationHookResult = ReturnType<
  typeof useAddCaraWorkspaceMessageMutation
>;
export type AddCaraWorkspaceMessageMutationResult =
  Apollo.MutationResult<AddCaraWorkspaceMessageMutation>;
export type AddCaraWorkspaceMessageMutationOptions = Apollo.BaseMutationOptions<
  AddCaraWorkspaceMessageMutation,
  AddCaraWorkspaceMessageMutationVariables
>;
export const UpdateCaraWorkspacesDocument = gql`
  mutation UpdateCaraWorkspaces($workspaceIds: [ID!]!, $input: UpdateCaraWorkspaceInput!) {
    updateCaraWorkspaces(workspaceIds: $workspaceIds, input: $input) {
      ...CaraWorkspaceFields
    }
  }
  ${CaraWorkspaceFieldsFragmentDoc}
`;
export type UpdateCaraWorkspacesMutationFn = Apollo.MutationFunction<
  UpdateCaraWorkspacesMutation,
  UpdateCaraWorkspacesMutationVariables
>;

/**
 * __useUpdateCaraWorkspacesMutation__
 *
 * To run a mutation, you first call `useUpdateCaraWorkspacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaraWorkspacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaraWorkspacesMutation, { data, loading, error }] = useUpdateCaraWorkspacesMutation({
 *   variables: {
 *      workspaceIds: // value for 'workspaceIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaraWorkspacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCaraWorkspacesMutation,
    UpdateCaraWorkspacesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCaraWorkspacesMutation, UpdateCaraWorkspacesMutationVariables>(
    UpdateCaraWorkspacesDocument,
    options
  );
}
export type UpdateCaraWorkspacesMutationHookResult = ReturnType<
  typeof useUpdateCaraWorkspacesMutation
>;
export type UpdateCaraWorkspacesMutationResult =
  Apollo.MutationResult<UpdateCaraWorkspacesMutation>;
export type UpdateCaraWorkspacesMutationOptions = Apollo.BaseMutationOptions<
  UpdateCaraWorkspacesMutation,
  UpdateCaraWorkspacesMutationVariables
>;
export const CreateCustomPresetDocument = gql`
  mutation CreateCustomPreset($input: CustomPresetInput!) {
    createCustomPreset(input: $input) {
      id
    }
  }
`;
export type CreateCustomPresetMutationFn = Apollo.MutationFunction<
  CreateCustomPresetMutation,
  CreateCustomPresetMutationVariables
>;

/**
 * __useCreateCustomPresetMutation__
 *
 * To run a mutation, you first call `useCreateCustomPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomPresetMutation, { data, loading, error }] = useCreateCustomPresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomPresetMutation,
    CreateCustomPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCustomPresetMutation, CreateCustomPresetMutationVariables>(
    CreateCustomPresetDocument,
    options
  );
}
export type CreateCustomPresetMutationHookResult = ReturnType<typeof useCreateCustomPresetMutation>;
export type CreateCustomPresetMutationResult = Apollo.MutationResult<CreateCustomPresetMutation>;
export type CreateCustomPresetMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomPresetMutation,
  CreateCustomPresetMutationVariables
>;
export const UpdateCustomPresetDocument = gql`
  mutation UpdateCustomPreset($id: ID!, $input: CustomPresetInput!) {
    updateCustomPreset(id: $id, input: $input) {
      id
    }
  }
`;
export type UpdateCustomPresetMutationFn = Apollo.MutationFunction<
  UpdateCustomPresetMutation,
  UpdateCustomPresetMutationVariables
>;

/**
 * __useUpdateCustomPresetMutation__
 *
 * To run a mutation, you first call `useUpdateCustomPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomPresetMutation, { data, loading, error }] = useUpdateCustomPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomPresetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomPresetMutation,
    UpdateCustomPresetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCustomPresetMutation, UpdateCustomPresetMutationVariables>(
    UpdateCustomPresetDocument,
    options
  );
}
export type UpdateCustomPresetMutationHookResult = ReturnType<typeof useUpdateCustomPresetMutation>;
export type UpdateCustomPresetMutationResult = Apollo.MutationResult<UpdateCustomPresetMutation>;
export type UpdateCustomPresetMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomPresetMutation,
  UpdateCustomPresetMutationVariables
>;
export const CreateHtmlDocumentTemplateDocument = gql`
  mutation CreateHtmlDocumentTemplate($input: HtmlDocumentTemplateInput!) {
    createHtmlDocumentTemplate(input: $input) {
      ...HtmlDocumentTemplateFields
    }
  }
  ${HtmlDocumentTemplateFieldsFragmentDoc}
`;
export type CreateHtmlDocumentTemplateMutationFn = Apollo.MutationFunction<
  CreateHtmlDocumentTemplateMutation,
  CreateHtmlDocumentTemplateMutationVariables
>;

/**
 * __useCreateHtmlDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useCreateHtmlDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHtmlDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHtmlDocumentTemplateMutation, { data, loading, error }] = useCreateHtmlDocumentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHtmlDocumentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateHtmlDocumentTemplateMutation,
    CreateHtmlDocumentTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateHtmlDocumentTemplateMutation,
    CreateHtmlDocumentTemplateMutationVariables
  >(CreateHtmlDocumentTemplateDocument, options);
}
export type CreateHtmlDocumentTemplateMutationHookResult = ReturnType<
  typeof useCreateHtmlDocumentTemplateMutation
>;
export type CreateHtmlDocumentTemplateMutationResult =
  Apollo.MutationResult<CreateHtmlDocumentTemplateMutation>;
export type CreateHtmlDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateHtmlDocumentTemplateMutation,
  CreateHtmlDocumentTemplateMutationVariables
>;
export const UpdateHtmlDocumentTemplateDocument = gql`
  mutation UpdateHtmlDocumentTemplate($id: ID!, $input: HtmlDocumentTemplateInput!) {
    updateHtmlDocumentTemplate(id: $id, input: $input) {
      ...HtmlDocumentTemplateFields
    }
  }
  ${HtmlDocumentTemplateFieldsFragmentDoc}
`;
export type UpdateHtmlDocumentTemplateMutationFn = Apollo.MutationFunction<
  UpdateHtmlDocumentTemplateMutation,
  UpdateHtmlDocumentTemplateMutationVariables
>;

/**
 * __useUpdateHtmlDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateHtmlDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHtmlDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHtmlDocumentTemplateMutation, { data, loading, error }] = useUpdateHtmlDocumentTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHtmlDocumentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHtmlDocumentTemplateMutation,
    UpdateHtmlDocumentTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHtmlDocumentTemplateMutation,
    UpdateHtmlDocumentTemplateMutationVariables
  >(UpdateHtmlDocumentTemplateDocument, options);
}
export type UpdateHtmlDocumentTemplateMutationHookResult = ReturnType<
  typeof useUpdateHtmlDocumentTemplateMutation
>;
export type UpdateHtmlDocumentTemplateMutationResult =
  Apollo.MutationResult<UpdateHtmlDocumentTemplateMutation>;
export type UpdateHtmlDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateHtmlDocumentTemplateMutation,
  UpdateHtmlDocumentTemplateMutationVariables
>;
export const WatchCaraWorkspaceDocument = gql`
  subscription WatchCaraWorkspace($id: ID!) {
    watchCaraWorkspace(id: $id) {
      ...CaraWorkspaceFields
    }
  }
  ${CaraWorkspaceFieldsFragmentDoc}
`;

/**
 * __useWatchCaraWorkspaceSubscription__
 *
 * To run a query within a React component, call `useWatchCaraWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchCaraWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchCaraWorkspaceSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWatchCaraWorkspaceSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchCaraWorkspaceSubscription,
    WatchCaraWorkspaceSubscriptionVariables
  > &
    ({ variables: WatchCaraWorkspaceSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchCaraWorkspaceSubscription,
    WatchCaraWorkspaceSubscriptionVariables
  >(WatchCaraWorkspaceDocument, options);
}
export type WatchCaraWorkspaceSubscriptionHookResult = ReturnType<
  typeof useWatchCaraWorkspaceSubscription
>;
export type WatchCaraWorkspaceSubscriptionResult =
  Apollo.SubscriptionResult<WatchCaraWorkspaceSubscription>;
export const GetCertificateDocument = gql`
  query GetCertificate($id: ID!) {
    certificate(id: $id) {
      ...CertificateOfLiabilityInsuranceFields
    }
  }
  ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}
`;

/**
 * __useGetCertificateQuery__
 *
 * To run a query within a React component, call `useGetCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCertificateQuery(
  baseOptions: Apollo.QueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables> &
    ({ variables: GetCertificateQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCertificateQuery, GetCertificateQueryVariables>(
    GetCertificateDocument,
    options
  );
}
export function useGetCertificateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCertificateQuery, GetCertificateQueryVariables>(
    GetCertificateDocument,
    options
  );
}
export function useGetCertificateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCertificateQuery, GetCertificateQueryVariables>(
    GetCertificateDocument,
    options
  );
}
export type GetCertificateQueryHookResult = ReturnType<typeof useGetCertificateQuery>;
export type GetCertificateLazyQueryHookResult = ReturnType<typeof useGetCertificateLazyQuery>;
export type GetCertificateSuspenseQueryHookResult = ReturnType<
  typeof useGetCertificateSuspenseQuery
>;
export type GetCertificateQueryResult = Apollo.QueryResult<
  GetCertificateQuery,
  GetCertificateQueryVariables
>;
export const CreateCertificateDocument = gql`
  mutation CreateCertificate($input: CreateCertificateInput!) {
    createCertificate(input: $input) {
      ...CertificateOfLiabilityInsuranceFields
    }
  }
  ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}
`;
export type CreateCertificateMutationFn = Apollo.MutationFunction<
  CreateCertificateMutation,
  CreateCertificateMutationVariables
>;

/**
 * __useCreateCertificateMutation__
 *
 * To run a mutation, you first call `useCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificateMutation, { data, loading, error }] = useCreateCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCertificateMutation,
    CreateCertificateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCertificateMutation, CreateCertificateMutationVariables>(
    CreateCertificateDocument,
    options
  );
}
export type CreateCertificateMutationHookResult = ReturnType<typeof useCreateCertificateMutation>;
export type CreateCertificateMutationResult = Apollo.MutationResult<CreateCertificateMutation>;
export type CreateCertificateMutationOptions = Apollo.BaseMutationOptions<
  CreateCertificateMutation,
  CreateCertificateMutationVariables
>;
export const GetEmailThreadsDocument = gql`
  query GetEmailThreads {
    emailThreads {
      ...EmailThreadFields
    }
  }
  ${EmailThreadFieldsFragmentDoc}
`;

/**
 * __useGetEmailThreadsQuery__
 *
 * To run a query within a React component, call `useGetEmailThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailThreadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailThreadsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>(
    GetEmailThreadsDocument,
    options
  );
}
export function useGetEmailThreadsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>(
    GetEmailThreadsDocument,
    options
  );
}
export function useGetEmailThreadsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>(
    GetEmailThreadsDocument,
    options
  );
}
export type GetEmailThreadsQueryHookResult = ReturnType<typeof useGetEmailThreadsQuery>;
export type GetEmailThreadsLazyQueryHookResult = ReturnType<typeof useGetEmailThreadsLazyQuery>;
export type GetEmailThreadsSuspenseQueryHookResult = ReturnType<
  typeof useGetEmailThreadsSuspenseQuery
>;
export type GetEmailThreadsQueryResult = Apollo.QueryResult<
  GetEmailThreadsQuery,
  GetEmailThreadsQueryVariables
>;
export const GetEmailThreadDocument = gql`
  query GetEmailThread($id: ID!) {
    emailThread(id: $id) {
      ...EmailThreadFields
      ...EmailThreadConversationFields
    }
  }
  ${EmailThreadFieldsFragmentDoc}
  ${EmailThreadConversationFieldsFragmentDoc}
`;

/**
 * __useGetEmailThreadQuery__
 *
 * To run a query within a React component, call `useGetEmailThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailThreadQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables> &
    ({ variables: GetEmailThreadQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(
    GetEmailThreadDocument,
    options
  );
}
export function useGetEmailThreadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(
    GetEmailThreadDocument,
    options
  );
}
export function useGetEmailThreadSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(
    GetEmailThreadDocument,
    options
  );
}
export type GetEmailThreadQueryHookResult = ReturnType<typeof useGetEmailThreadQuery>;
export type GetEmailThreadLazyQueryHookResult = ReturnType<typeof useGetEmailThreadLazyQuery>;
export type GetEmailThreadSuspenseQueryHookResult = ReturnType<
  typeof useGetEmailThreadSuspenseQuery
>;
export type GetEmailThreadQueryResult = Apollo.QueryResult<
  GetEmailThreadQuery,
  GetEmailThreadQueryVariables
>;
export const DeleteFileDocument = gql`
  mutation DeleteFile($fileId: ID!) {
    deleteFile(fileId: $fileId) {
      ...FileFields
    }
  }
  ${FileFieldsFragmentDoc}
`;
export type DeleteFileMutationFn = Apollo.MutationFunction<
  DeleteFileMutation,
  DeleteFileMutationVariables
>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteFileMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(
    DeleteFileDocument,
    options
  );
}
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<
  DeleteFileMutation,
  DeleteFileMutationVariables
>;
export const GetIntegrationsDocument = gql`
  query GetIntegrations {
    integrations {
      ...IntegrationFields
    }
  }
  ${IntegrationFieldsFragmentDoc}
`;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(
    GetIntegrationsDocument,
    options
  );
}
export function useGetIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(
    GetIntegrationsDocument,
    options
  );
}
export function useGetIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(
    GetIntegrationsDocument,
    options
  );
}
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationsSuspenseQuery
>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<
  GetIntegrationsQuery,
  GetIntegrationsQueryVariables
>;
export const GetIntegrationDocument = gql`
  query GetIntegration($id: ID!) {
    integration(id: $id) {
      ...IntegrationDetailFields
    }
  }
  ${IntegrationDetailFieldsFragmentDoc}
`;

/**
 * __useGetIntegrationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables> &
    ({ variables: GetIntegrationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(
    GetIntegrationDocument,
    options
  );
}
export function useGetIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(
    GetIntegrationDocument,
    options
  );
}
export function useGetIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(
    GetIntegrationDocument,
    options
  );
}
export type GetIntegrationQueryHookResult = ReturnType<typeof useGetIntegrationQuery>;
export type GetIntegrationLazyQueryHookResult = ReturnType<typeof useGetIntegrationLazyQuery>;
export type GetIntegrationSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationSuspenseQuery
>;
export type GetIntegrationQueryResult = Apollo.QueryResult<
  GetIntegrationQuery,
  GetIntegrationQueryVariables
>;
export const CreateIntegrationDocument = gql`
  mutation CreateIntegration($input: CreateIntegrationInput!) {
    createIntegration(input: $input) {
      ...IntegrationDetailFields
    }
  }
  ${IntegrationDetailFieldsFragmentDoc}
`;
export type CreateIntegrationMutationFn = Apollo.MutationFunction<
  CreateIntegrationMutation,
  CreateIntegrationMutationVariables
>;

/**
 * __useCreateIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationMutation, { data, loading, error }] = useCreateIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIntegrationMutation,
    CreateIntegrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateIntegrationMutation, CreateIntegrationMutationVariables>(
    CreateIntegrationDocument,
    options
  );
}
export type CreateIntegrationMutationHookResult = ReturnType<typeof useCreateIntegrationMutation>;
export type CreateIntegrationMutationResult = Apollo.MutationResult<CreateIntegrationMutation>;
export type CreateIntegrationMutationOptions = Apollo.BaseMutationOptions<
  CreateIntegrationMutation,
  CreateIntegrationMutationVariables
>;
export const UpdateIntegrationDocument = gql`
  mutation UpdateIntegration($id: ID!, $input: UpdateIntegrationInput!) {
    updateIntegration(id: $id, input: $input) {
      ...IntegrationDetailFields
    }
  }
  ${IntegrationDetailFieldsFragmentDoc}
`;
export type UpdateIntegrationMutationFn = Apollo.MutationFunction<
  UpdateIntegrationMutation,
  UpdateIntegrationMutationVariables
>;

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIntegrationMutation,
    UpdateIntegrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(
    UpdateIntegrationDocument,
    options
  );
}
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>;
export type UpdateIntegrationMutationResult = Apollo.MutationResult<UpdateIntegrationMutation>;
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<
  UpdateIntegrationMutation,
  UpdateIntegrationMutationVariables
>;
export const SyncIntegrationDocument = gql`
  mutation SyncIntegration($id: ID!) {
    syncIntegration(id: $id) {
      ...IntegrationDetailFields
    }
  }
  ${IntegrationDetailFieldsFragmentDoc}
`;
export type SyncIntegrationMutationFn = Apollo.MutationFunction<
  SyncIntegrationMutation,
  SyncIntegrationMutationVariables
>;

/**
 * __useSyncIntegrationMutation__
 *
 * To run a mutation, you first call `useSyncIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncIntegrationMutation, { data, loading, error }] = useSyncIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncIntegrationMutation,
    SyncIntegrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SyncIntegrationMutation, SyncIntegrationMutationVariables>(
    SyncIntegrationDocument,
    options
  );
}
export type SyncIntegrationMutationHookResult = ReturnType<typeof useSyncIntegrationMutation>;
export type SyncIntegrationMutationResult = Apollo.MutationResult<SyncIntegrationMutation>;
export type SyncIntegrationMutationOptions = Apollo.BaseMutationOptions<
  SyncIntegrationMutation,
  SyncIntegrationMutationVariables
>;
export const GetHubSpotTicketPipelinesDocument = gql`
  query GetHubSpotTicketPipelines($integrationId: ID!) {
    hubspotTicketPipelines(integrationId: $integrationId) {
      id
      label
      displayOrder
      stages {
        id
        label
        displayOrder
        archived
        ticketState
      }
      createdAt
      updatedAt
      archived
    }
  }
`;

/**
 * __useGetHubSpotTicketPipelinesQuery__
 *
 * To run a query within a React component, call `useGetHubSpotTicketPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubSpotTicketPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubSpotTicketPipelinesQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetHubSpotTicketPipelinesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHubSpotTicketPipelinesQuery,
    GetHubSpotTicketPipelinesQueryVariables
  > &
    ({ variables: GetHubSpotTicketPipelinesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>(
    GetHubSpotTicketPipelinesDocument,
    options
  );
}
export function useGetHubSpotTicketPipelinesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHubSpotTicketPipelinesQuery,
    GetHubSpotTicketPipelinesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHubSpotTicketPipelinesQuery,
    GetHubSpotTicketPipelinesQueryVariables
  >(GetHubSpotTicketPipelinesDocument, options);
}
export function useGetHubSpotTicketPipelinesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHubSpotTicketPipelinesQuery,
        GetHubSpotTicketPipelinesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHubSpotTicketPipelinesQuery,
    GetHubSpotTicketPipelinesQueryVariables
  >(GetHubSpotTicketPipelinesDocument, options);
}
export type GetHubSpotTicketPipelinesQueryHookResult = ReturnType<
  typeof useGetHubSpotTicketPipelinesQuery
>;
export type GetHubSpotTicketPipelinesLazyQueryHookResult = ReturnType<
  typeof useGetHubSpotTicketPipelinesLazyQuery
>;
export type GetHubSpotTicketPipelinesSuspenseQueryHookResult = ReturnType<
  typeof useGetHubSpotTicketPipelinesSuspenseQuery
>;
export type GetHubSpotTicketPipelinesQueryResult = Apollo.QueryResult<
  GetHubSpotTicketPipelinesQuery,
  GetHubSpotTicketPipelinesQueryVariables
>;
export const GetIntegrationStateDocument = gql`
  query GetIntegrationState($id: ID!) {
    integration(id: $id) {
      id
      state
    }
  }
`;

/**
 * __useGetIntegrationStateQuery__
 *
 * To run a query within a React component, call `useGetIntegrationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntegrationStateQuery,
    GetIntegrationStateQueryVariables
  > &
    ({ variables: GetIntegrationStateQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(
    GetIntegrationStateDocument,
    options
  );
}
export function useGetIntegrationStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationStateQuery,
    GetIntegrationStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(
    GetIntegrationStateDocument,
    options
  );
}
export function useGetIntegrationStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(
    GetIntegrationStateDocument,
    options
  );
}
export type GetIntegrationStateQueryHookResult = ReturnType<typeof useGetIntegrationStateQuery>;
export type GetIntegrationStateLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationStateLazyQuery
>;
export type GetIntegrationStateSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationStateSuspenseQuery
>;
export type GetIntegrationStateQueryResult = Apollo.QueryResult<
  GetIntegrationStateQuery,
  GetIntegrationStateQueryVariables
>;
export const GetKnowledgeBasesDocument = gql`
  query GetKnowledgeBases {
    knowledgeBases {
      ...KnowledgeBaseFields
    }
  }
  ${KnowledgeBaseFieldsFragmentDoc}
`;

/**
 * __useGetKnowledgeBasesQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKnowledgeBasesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(
    GetKnowledgeBasesDocument,
    options
  );
}
export function useGetKnowledgeBasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(
    GetKnowledgeBasesDocument,
    options
  );
}
export function useGetKnowledgeBasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(
    GetKnowledgeBasesDocument,
    options
  );
}
export type GetKnowledgeBasesQueryHookResult = ReturnType<typeof useGetKnowledgeBasesQuery>;
export type GetKnowledgeBasesLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBasesLazyQuery>;
export type GetKnowledgeBasesSuspenseQueryHookResult = ReturnType<
  typeof useGetKnowledgeBasesSuspenseQuery
>;
export type GetKnowledgeBasesQueryResult = Apollo.QueryResult<
  GetKnowledgeBasesQuery,
  GetKnowledgeBasesQueryVariables
>;
export const GetKnowledgeBaseDocument = gql`
  query GetKnowledgeBase($id: ID!) {
    knowledgeBase(id: $id) {
      ...KnowledgeBaseDetailFields
    }
  }
  ${KnowledgeBaseDetailFieldsFragmentDoc}
`;

/**
 * __useGetKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKnowledgeBaseQuery(
  baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables> &
    ({ variables: GetKnowledgeBaseQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(
    GetKnowledgeBaseDocument,
    options
  );
}
export function useGetKnowledgeBaseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(
    GetKnowledgeBaseDocument,
    options
  );
}
export function useGetKnowledgeBaseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(
    GetKnowledgeBaseDocument,
    options
  );
}
export type GetKnowledgeBaseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseQuery>;
export type GetKnowledgeBaseLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBaseLazyQuery>;
export type GetKnowledgeBaseSuspenseQueryHookResult = ReturnType<
  typeof useGetKnowledgeBaseSuspenseQuery
>;
export type GetKnowledgeBaseQueryResult = Apollo.QueryResult<
  GetKnowledgeBaseQuery,
  GetKnowledgeBaseQueryVariables
>;
export const GetKnowledgeBaseDocumentDocument = gql`
  query GetKnowledgeBaseDocument($id: ID!) {
    knowledgeBaseDocument(id: $id) {
      ...KnowledgeBaseDocumentDetailFields
    }
  }
  ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}
`;

/**
 * __useGetKnowledgeBaseDocumentQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKnowledgeBaseDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetKnowledgeBaseDocumentQuery,
    GetKnowledgeBaseDocumentQueryVariables
  > &
    ({ variables: GetKnowledgeBaseDocumentQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>(
    GetKnowledgeBaseDocumentDocument,
    options
  );
}
export function useGetKnowledgeBaseDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetKnowledgeBaseDocumentQuery,
    GetKnowledgeBaseDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>(
    GetKnowledgeBaseDocumentDocument,
    options
  );
}
export function useGetKnowledgeBaseDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetKnowledgeBaseDocumentQuery,
        GetKnowledgeBaseDocumentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetKnowledgeBaseDocumentQuery,
    GetKnowledgeBaseDocumentQueryVariables
  >(GetKnowledgeBaseDocumentDocument, options);
}
export type GetKnowledgeBaseDocumentQueryHookResult = ReturnType<
  typeof useGetKnowledgeBaseDocumentQuery
>;
export type GetKnowledgeBaseDocumentLazyQueryHookResult = ReturnType<
  typeof useGetKnowledgeBaseDocumentLazyQuery
>;
export type GetKnowledgeBaseDocumentSuspenseQueryHookResult = ReturnType<
  typeof useGetKnowledgeBaseDocumentSuspenseQuery
>;
export type GetKnowledgeBaseDocumentQueryResult = Apollo.QueryResult<
  GetKnowledgeBaseDocumentQuery,
  GetKnowledgeBaseDocumentQueryVariables
>;
export const CreateKnowledgeBaseTextDocumentDocument = gql`
  mutation CreateKnowledgeBaseTextDocument(
    $knowledgeBaseId: ID!
    $input: CreateKnowledgeBaseTextDocumentInput!
  ) {
    createKnowledgeBaseTextDocument(knowledgeBaseId: $knowledgeBaseId, input: $input) {
      ...KnowledgeBaseDocumentDetailFields
    }
  }
  ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}
`;
export type CreateKnowledgeBaseTextDocumentMutationFn = Apollo.MutationFunction<
  CreateKnowledgeBaseTextDocumentMutation,
  CreateKnowledgeBaseTextDocumentMutationVariables
>;

/**
 * __useCreateKnowledgeBaseTextDocumentMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseTextDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseTextDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseTextDocumentMutation, { data, loading, error }] = useCreateKnowledgeBaseTextDocumentMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKnowledgeBaseTextDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateKnowledgeBaseTextDocumentMutation,
    CreateKnowledgeBaseTextDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateKnowledgeBaseTextDocumentMutation,
    CreateKnowledgeBaseTextDocumentMutationVariables
  >(CreateKnowledgeBaseTextDocumentDocument, options);
}
export type CreateKnowledgeBaseTextDocumentMutationHookResult = ReturnType<
  typeof useCreateKnowledgeBaseTextDocumentMutation
>;
export type CreateKnowledgeBaseTextDocumentMutationResult =
  Apollo.MutationResult<CreateKnowledgeBaseTextDocumentMutation>;
export type CreateKnowledgeBaseTextDocumentMutationOptions = Apollo.BaseMutationOptions<
  CreateKnowledgeBaseTextDocumentMutation,
  CreateKnowledgeBaseTextDocumentMutationVariables
>;
export const UploadKnowledgeBaseFileDocumentDocument = gql`
  mutation UploadKnowledgeBaseFileDocument(
    $knowledgeBaseId: ID!
    $input: UploadKnowledgeBaseFileDocumentInput!
  ) {
    uploadKnowledgeBaseFileDocument(knowledgeBaseId: $knowledgeBaseId, input: $input) {
      ...KnowledgeBaseDocumentDetailFields
    }
  }
  ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}
`;
export type UploadKnowledgeBaseFileDocumentMutationFn = Apollo.MutationFunction<
  UploadKnowledgeBaseFileDocumentMutation,
  UploadKnowledgeBaseFileDocumentMutationVariables
>;

/**
 * __useUploadKnowledgeBaseFileDocumentMutation__
 *
 * To run a mutation, you first call `useUploadKnowledgeBaseFileDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadKnowledgeBaseFileDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadKnowledgeBaseFileDocumentMutation, { data, loading, error }] = useUploadKnowledgeBaseFileDocumentMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadKnowledgeBaseFileDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadKnowledgeBaseFileDocumentMutation,
    UploadKnowledgeBaseFileDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadKnowledgeBaseFileDocumentMutation,
    UploadKnowledgeBaseFileDocumentMutationVariables
  >(UploadKnowledgeBaseFileDocumentDocument, options);
}
export type UploadKnowledgeBaseFileDocumentMutationHookResult = ReturnType<
  typeof useUploadKnowledgeBaseFileDocumentMutation
>;
export type UploadKnowledgeBaseFileDocumentMutationResult =
  Apollo.MutationResult<UploadKnowledgeBaseFileDocumentMutation>;
export type UploadKnowledgeBaseFileDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadKnowledgeBaseFileDocumentMutation,
  UploadKnowledgeBaseFileDocumentMutationVariables
>;
export const UpdateKnowledgeBaseDocumentDocument = gql`
  mutation UpdateKnowledgeBaseDocument($id: ID!, $input: UpdateKnowledgeBaseDocumentInput!) {
    updateKnowledgeBaseDocument(id: $id, input: $input) {
      ...KnowledgeBaseDocumentDetailFields
    }
  }
  ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}
`;
export type UpdateKnowledgeBaseDocumentMutationFn = Apollo.MutationFunction<
  UpdateKnowledgeBaseDocumentMutation,
  UpdateKnowledgeBaseDocumentMutationVariables
>;

/**
 * __useUpdateKnowledgeBaseDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseDocumentMutation, { data, loading, error }] = useUpdateKnowledgeBaseDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateKnowledgeBaseDocumentMutation,
    UpdateKnowledgeBaseDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateKnowledgeBaseDocumentMutation,
    UpdateKnowledgeBaseDocumentMutationVariables
  >(UpdateKnowledgeBaseDocumentDocument, options);
}
export type UpdateKnowledgeBaseDocumentMutationHookResult = ReturnType<
  typeof useUpdateKnowledgeBaseDocumentMutation
>;
export type UpdateKnowledgeBaseDocumentMutationResult =
  Apollo.MutationResult<UpdateKnowledgeBaseDocumentMutation>;
export type UpdateKnowledgeBaseDocumentMutationOptions = Apollo.BaseMutationOptions<
  UpdateKnowledgeBaseDocumentMutation,
  UpdateKnowledgeBaseDocumentMutationVariables
>;
export const DeleteKnowledgeBaseDocumentDocument = gql`
  mutation DeleteKnowledgeBaseDocument($id: ID!) {
    deleteKnowledgeBaseDocument(id: $id) {
      ...KnowledgeBaseDocumentDetailFields
    }
  }
  ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}
`;
export type DeleteKnowledgeBaseDocumentMutationFn = Apollo.MutationFunction<
  DeleteKnowledgeBaseDocumentMutation,
  DeleteKnowledgeBaseDocumentMutationVariables
>;

/**
 * __useDeleteKnowledgeBaseDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseDocumentMutation, { data, loading, error }] = useDeleteKnowledgeBaseDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteKnowledgeBaseDocumentMutation,
    DeleteKnowledgeBaseDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteKnowledgeBaseDocumentMutation,
    DeleteKnowledgeBaseDocumentMutationVariables
  >(DeleteKnowledgeBaseDocumentDocument, options);
}
export type DeleteKnowledgeBaseDocumentMutationHookResult = ReturnType<
  typeof useDeleteKnowledgeBaseDocumentMutation
>;
export type DeleteKnowledgeBaseDocumentMutationResult =
  Apollo.MutationResult<DeleteKnowledgeBaseDocumentMutation>;
export type DeleteKnowledgeBaseDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteKnowledgeBaseDocumentMutation,
  DeleteKnowledgeBaseDocumentMutationVariables
>;
export const GetPolicyExplorerConversationDocument = gql`
  query GetPolicyExplorerConversation($policyId: ID!) {
    policyExplorerConversation(policyId: $policyId) {
      ...PolicyExplorerConversationMessageFields
    }
  }
  ${PolicyExplorerConversationMessageFieldsFragmentDoc}
`;

/**
 * __useGetPolicyExplorerConversationQuery__
 *
 * To run a query within a React component, call `useGetPolicyExplorerConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyExplorerConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyExplorerConversationQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetPolicyExplorerConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPolicyExplorerConversationQuery,
    GetPolicyExplorerConversationQueryVariables
  > &
    ({ variables: GetPolicyExplorerConversationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPolicyExplorerConversationQuery,
    GetPolicyExplorerConversationQueryVariables
  >(GetPolicyExplorerConversationDocument, options);
}
export function useGetPolicyExplorerConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPolicyExplorerConversationQuery,
    GetPolicyExplorerConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPolicyExplorerConversationQuery,
    GetPolicyExplorerConversationQueryVariables
  >(GetPolicyExplorerConversationDocument, options);
}
export function useGetPolicyExplorerConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPolicyExplorerConversationQuery,
        GetPolicyExplorerConversationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPolicyExplorerConversationQuery,
    GetPolicyExplorerConversationQueryVariables
  >(GetPolicyExplorerConversationDocument, options);
}
export type GetPolicyExplorerConversationQueryHookResult = ReturnType<
  typeof useGetPolicyExplorerConversationQuery
>;
export type GetPolicyExplorerConversationLazyQueryHookResult = ReturnType<
  typeof useGetPolicyExplorerConversationLazyQuery
>;
export type GetPolicyExplorerConversationSuspenseQueryHookResult = ReturnType<
  typeof useGetPolicyExplorerConversationSuspenseQuery
>;
export type GetPolicyExplorerConversationQueryResult = Apollo.QueryResult<
  GetPolicyExplorerConversationQuery,
  GetPolicyExplorerConversationQueryVariables
>;
export const AddPolicyExplorerConversationMessageDocument = gql`
  mutation AddPolicyExplorerConversationMessage($policyId: ID!, $message: String!) {
    addPolicyExplorerConversationMessage(policyId: $policyId, message: $message) {
      ...PolicyExplorerConversationMessageFields
    }
  }
  ${PolicyExplorerConversationMessageFieldsFragmentDoc}
`;
export type AddPolicyExplorerConversationMessageMutationFn = Apollo.MutationFunction<
  AddPolicyExplorerConversationMessageMutation,
  AddPolicyExplorerConversationMessageMutationVariables
>;

/**
 * __useAddPolicyExplorerConversationMessageMutation__
 *
 * To run a mutation, you first call `useAddPolicyExplorerConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPolicyExplorerConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPolicyExplorerConversationMessageMutation, { data, loading, error }] = useAddPolicyExplorerConversationMessageMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useAddPolicyExplorerConversationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPolicyExplorerConversationMessageMutation,
    AddPolicyExplorerConversationMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddPolicyExplorerConversationMessageMutation,
    AddPolicyExplorerConversationMessageMutationVariables
  >(AddPolicyExplorerConversationMessageDocument, options);
}
export type AddPolicyExplorerConversationMessageMutationHookResult = ReturnType<
  typeof useAddPolicyExplorerConversationMessageMutation
>;
export type AddPolicyExplorerConversationMessageMutationResult =
  Apollo.MutationResult<AddPolicyExplorerConversationMessageMutation>;
export type AddPolicyExplorerConversationMessageMutationOptions = Apollo.BaseMutationOptions<
  AddPolicyExplorerConversationMessageMutation,
  AddPolicyExplorerConversationMessageMutationVariables
>;
export const GetServiceRequestsDocument = gql`
  query GetServiceRequests {
    serviceRequests {
      ...ServiceRequestFields
    }
  }
  ${ServiceRequestFieldsFragmentDoc}
`;

/**
 * __useGetServiceRequestsQuery__
 *
 * To run a query within a React component, call `useGetServiceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>(
    GetServiceRequestsDocument,
    options
  );
}
export function useGetServiceRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceRequestsQuery,
    GetServiceRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>(
    GetServiceRequestsDocument,
    options
  );
}
export function useGetServiceRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>(
    GetServiceRequestsDocument,
    options
  );
}
export type GetServiceRequestsQueryHookResult = ReturnType<typeof useGetServiceRequestsQuery>;
export type GetServiceRequestsLazyQueryHookResult = ReturnType<
  typeof useGetServiceRequestsLazyQuery
>;
export type GetServiceRequestsSuspenseQueryHookResult = ReturnType<
  typeof useGetServiceRequestsSuspenseQuery
>;
export type GetServiceRequestsQueryResult = Apollo.QueryResult<
  GetServiceRequestsQuery,
  GetServiceRequestsQueryVariables
>;
export const GetServiceRequestDocument = gql`
  query GetServiceRequest($id: ID!) {
    serviceRequest(id: $id) {
      ...ServiceRequestFields
      ...ServiceRequestCallFields
    }
  }
  ${ServiceRequestFieldsFragmentDoc}
  ${ServiceRequestCallFieldsFragmentDoc}
`;

/**
 * __useGetServiceRequestQuery__
 *
 * To run a query within a React component, call `useGetServiceRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceRequestQuery(
  baseOptions: Apollo.QueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables> &
    ({ variables: GetServiceRequestQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(
    GetServiceRequestDocument,
    options
  );
}
export function useGetServiceRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(
    GetServiceRequestDocument,
    options
  );
}
export function useGetServiceRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(
    GetServiceRequestDocument,
    options
  );
}
export type GetServiceRequestQueryHookResult = ReturnType<typeof useGetServiceRequestQuery>;
export type GetServiceRequestLazyQueryHookResult = ReturnType<typeof useGetServiceRequestLazyQuery>;
export type GetServiceRequestSuspenseQueryHookResult = ReturnType<
  typeof useGetServiceRequestSuspenseQuery
>;
export type GetServiceRequestQueryResult = Apollo.QueryResult<
  GetServiceRequestQuery,
  GetServiceRequestQueryVariables
>;
export const ResolveServiceRequestDocument = gql`
  mutation ResolveServiceRequest($id: ID!, $input: ResolveServiceRequestInput!) {
    resolveServiceRequest(id: $id, input: $input) {
      ...ServiceRequestFields
    }
  }
  ${ServiceRequestFieldsFragmentDoc}
`;
export type ResolveServiceRequestMutationFn = Apollo.MutationFunction<
  ResolveServiceRequestMutation,
  ResolveServiceRequestMutationVariables
>;

/**
 * __useResolveServiceRequestMutation__
 *
 * To run a mutation, you first call `useResolveServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveServiceRequestMutation, { data, loading, error }] = useResolveServiceRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveServiceRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResolveServiceRequestMutation,
    ResolveServiceRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResolveServiceRequestMutation, ResolveServiceRequestMutationVariables>(
    ResolveServiceRequestDocument,
    options
  );
}
export type ResolveServiceRequestMutationHookResult = ReturnType<
  typeof useResolveServiceRequestMutation
>;
export type ResolveServiceRequestMutationResult =
  Apollo.MutationResult<ResolveServiceRequestMutation>;
export type ResolveServiceRequestMutationOptions = Apollo.BaseMutationOptions<
  ResolveServiceRequestMutation,
  ResolveServiceRequestMutationVariables
>;
export const UpdateServiceRequestDocument = gql`
  mutation UpdateServiceRequest($id: ID!, $input: UpdateServiceRequestInput!) {
    updateServiceRequest(id: $id, input: $input) {
      ...ServiceRequestFields
    }
  }
  ${ServiceRequestFieldsFragmentDoc}
`;
export type UpdateServiceRequestMutationFn = Apollo.MutationFunction<
  UpdateServiceRequestMutation,
  UpdateServiceRequestMutationVariables
>;

/**
 * __useUpdateServiceRequestMutation__
 *
 * To run a mutation, you first call `useUpdateServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceRequestMutation, { data, loading, error }] = useUpdateServiceRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateServiceRequestMutation,
    UpdateServiceRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables>(
    UpdateServiceRequestDocument,
    options
  );
}
export type UpdateServiceRequestMutationHookResult = ReturnType<
  typeof useUpdateServiceRequestMutation
>;
export type UpdateServiceRequestMutationResult =
  Apollo.MutationResult<UpdateServiceRequestMutation>;
export type UpdateServiceRequestMutationOptions = Apollo.BaseMutationOptions<
  UpdateServiceRequestMutation,
  UpdateServiceRequestMutationVariables
>;
export const AddServiceRequestCommentDocument = gql`
  mutation AddServiceRequestComment($id: ID!, $input: AddServiceRequestCommentInput!) {
    addServiceRequestComment(id: $id, input: $input) {
      ...ServiceRequestFields
    }
  }
  ${ServiceRequestFieldsFragmentDoc}
`;
export type AddServiceRequestCommentMutationFn = Apollo.MutationFunction<
  AddServiceRequestCommentMutation,
  AddServiceRequestCommentMutationVariables
>;

/**
 * __useAddServiceRequestCommentMutation__
 *
 * To run a mutation, you first call `useAddServiceRequestCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceRequestCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceRequestCommentMutation, { data, loading, error }] = useAddServiceRequestCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddServiceRequestCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddServiceRequestCommentMutation,
    AddServiceRequestCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddServiceRequestCommentMutation,
    AddServiceRequestCommentMutationVariables
  >(AddServiceRequestCommentDocument, options);
}
export type AddServiceRequestCommentMutationHookResult = ReturnType<
  typeof useAddServiceRequestCommentMutation
>;
export type AddServiceRequestCommentMutationResult =
  Apollo.MutationResult<AddServiceRequestCommentMutation>;
export type AddServiceRequestCommentMutationOptions = Apollo.BaseMutationOptions<
  AddServiceRequestCommentMutation,
  AddServiceRequestCommentMutationVariables
>;
